  function initOsbLiveChess(scope = document) {
    const selector = '[data-osb-live-chess]:not([data-osb-live-ready])';
    const sections = [];
    if (scope instanceof Element && scope.matches(selector)) sections.push(scope);
    if (typeof scope?.querySelectorAll === 'function') {
      sections.push(...scope.querySelectorAll(selector));
    }
    [...new Set(sections)].forEach((section) => {
      section.setAttribute('data-osb-live-ready', '');

      const serverUrl = (section.dataset.serverUrl || '').replace(/\/$/, '');
      const embedded = section.dataset.embedded === 'true';
      if (embedded) {
        const slot = document.querySelector('[data-osb-live-slot]');
        if (slot && section.parentElement !== slot) slot.appendChild(section);
      }
      const finder = section.closest('[data-osb-finder]');
      const status = section.querySelector('[data-osb-live-status]');
      const arena = section.querySelector('[data-osb-arena]');
      const boardShell = section.querySelector('.osb-live__board-shell');
      const board = section.querySelector('[data-osb-board]');
      const lessonMovement = section.querySelector('[data-osb-lesson-movement]');
      const liveList = section.querySelector('[data-osb-live-list]');
      const liveLobby = section.querySelector('[data-osb-live-lobby]');
      const livePlayers = section.querySelector('[data-osb-live-players]');
      const liveMoreButton = section.querySelector('[data-osb-live-more]');
      const desktopLiveToggle = section.querySelector('[data-osb-desktop-live-toggle]');
      const desktopLiveCount = section.querySelector('[data-osb-desktop-live-count]');
      const desktopGameMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      const controls = section.querySelector('[data-osb-live-controls]');
      const matchCancelButton = section.querySelector('[data-osb-match-cancel]');
      const matchContinueButton = section.querySelector('[data-osb-match-continue]');
      const computerButton = section.querySelector('[data-osb-computer]');
      const drawButton = section.querySelector('[data-osb-draw]');
      const resignButton = section.querySelector('[data-osb-resign]');
      const computerEndButton = section.querySelector('[data-osb-computer-end]');
      const liveEndButton = section.querySelector('[data-osb-live-end]');
      const chatPrototype = section.querySelector('[data-osb-chat-prototype]');
      const chatPrototypeCommunication = section.querySelector('[data-osb-chat-prototype-communication]');
      const chatPrototypeDraw = section.querySelector('[data-osb-chat-prototype-draw]');
      const chatPrototypeResign = section.querySelector('[data-osb-chat-prototype-resign]');
      const chatPrototypeVoice = section.querySelector('[data-osb-chat-prototype-voice]');
      const chatPrototypeFeed = section.querySelector('[data-osb-chat-prototype-feed]');
      const chatPrototypeInput = section.querySelector('[data-osb-chat-prototype-input]');
      const rematchButton = section.querySelector('[data-osb-rematch]');
      const placementStatus = section.querySelector('[data-osb-placement-status]');
      const challengeHandover = section.querySelector('[data-osb-challenge-handover]');
      const challengeHandoverCopy = section.querySelector('[data-osb-challenge-handover-copy]');
      const challengeHandoverConfirm = section.querySelector('[data-osb-challenge-handover-confirm]');
      const challengeHandoverKeep = section.querySelector('[data-osb-challenge-handover-keep]');
      const voiceButton = section.querySelector('[data-osb-voice]');
      const voiceHearButton = section.querySelector('[data-osb-voice-hear]');
      const voiceMuteButton = section.querySelector('[data-osb-voice-mute]');
      const voiceLeaveButton = section.querySelector('[data-osb-voice-leave]');
      const remoteAudio = section.querySelector('[data-osb-remote-audio]');
      const you = section.querySelector('[data-osb-you]');
      const opponent = section.querySelector('[data-osb-opponent]');
      const opponentName = section.querySelector('[data-osb-opponent-name]');
      const computerLevel = section.querySelector('[data-osb-computer-level]');
      const computerLevelMenu = section.querySelector('[data-osb-computer-levels]');
      const computerLevelOptions = Array.from(section.querySelectorAll('[data-osb-computer-level-option]'));
      const yourSignal = section.querySelector('[data-osb-your-signal]');
      const opponentSignal = section.querySelector('[data-osb-opponent-signal]');
      const yourClock = section.querySelector('[data-osb-your-clock]');
      const opponentClock = section.querySelector('[data-osb-opponent-clock]');
      const turnSquare = section.querySelector('[data-osb-turn-square]');
      const humanTurnMarker = section.querySelector('[data-osb-human-turn-marker]');
      const mobileHumanTurnMarker = section.querySelector('[data-osb-mobile-human-turn-marker]');
      const cursor = section.querySelector('[data-osb-square-cursor]');
      const secretEntrance = section.querySelector('[data-osb-secret-entrance]');
      const promotionPanel = section.querySelector('[data-osb-promotion]');
      const promotionButtons = Array.from(section.querySelectorAll('[data-osb-promote]'));
      const gameChat = section.querySelector('[data-osb-game-chat]');
      const chatPeer = section.querySelector('[data-osb-chat-peer]');
      const chatMessages = section.querySelector('[data-osb-chat-messages]');
      const chatForm = section.querySelector('[data-osb-chat-form]');
      const chatInput = section.querySelector('[data-osb-chat-input]');
      const learnLibrary = section.querySelector('[data-osb-learn-library]');
      const learnLibraryProgress = section.querySelector('[data-osb-learn-library-progress]');
      const learnLibraryCourses = section.querySelector('[data-osb-learn-library-courses]');
      const learnLibraryLevelButtons = Array.from(
        section.querySelectorAll('[data-osb-learn-library-level]')
      );
      const learnLibraryTrackButtons = Array.from(
        section.querySelectorAll('[data-osb-learn-library-track]')
      );
      const learnOpeningGroups = section.querySelector('[data-osb-learn-opening-groups]');
      const learnOpeningGroupButtons = Array.from(
        section.querySelectorAll('[data-osb-learn-opening-group]')
      );
      const learnModeButtons = Array.from(section.querySelectorAll('[data-osb-learn-mode]'));
      const courseLibrary = section.querySelector('[data-osb-course-library]');
      const puzzleLibrary = section.querySelector('[data-osb-puzzle-library]');
      const puzzleSolved = section.querySelector('[data-osb-puzzle-solved]');
      const puzzleAccuracy = section.querySelector('[data-osb-puzzle-accuracy]');
      const puzzleRating = section.querySelector('[data-osb-puzzle-rating]');
      const puzzlePracticeButton = section.querySelector('[data-osb-puzzle-practice]');
      const puzzleDailyButton = section.querySelector('[data-osb-puzzle-daily]');
      const puzzleDailyProgress = section.querySelector('[data-osb-puzzle-daily-progress]');
      const puzzleWeeklyButton = section.querySelector('[data-osb-puzzle-weekly]');
      const puzzleWeeklyProgress = section.querySelector('[data-osb-puzzle-weekly-progress]');
      const puzzleReviewButton = section.querySelector('[data-osb-puzzle-review]');
      const puzzleMistakes = section.querySelector('[data-osb-puzzle-mistakes]');
      const puzzleHistory = section.querySelector('[data-osb-puzzle-history]');
      const puzzleHistoryEmpty = section.querySelector('[data-osb-puzzle-history-empty]');
      const puzzleHistoryMore = section.querySelector('[data-osb-puzzle-history-more]');
      const puzzleLibraryStatus = section.querySelector('[data-osb-puzzle-library-status]');
      const reviewLibrary = section.querySelector('[data-osb-review-library]');
      const reviewDueCount = section.querySelector('[data-osb-review-due-count]');
      const reviewGameCount = section.querySelector('[data-osb-review-game-count]');
      const reviewPuzzleCount = section.querySelector('[data-osb-review-puzzle-count]');
      const reviewDueButton = section.querySelector('[data-osb-review-due]');
      const reviewDueLabel = section.querySelector('[data-osb-review-due-label]');
      const reviewPuzzlesButton = section.querySelector('[data-osb-review-puzzles]');
      const reviewPuzzleLabel = section.querySelector('[data-osb-review-puzzle-label]');
      const reviewGames = section.querySelector('[data-osb-review-games]');
      const reviewStatus = section.querySelector('[data-osb-review-status]');
      const learnPlacementButton = section.querySelector('[data-osb-learn-placement]');
      const learnResumeButton = section.querySelector('[data-osb-learn-resume]');
      const learnResumeAction = section.querySelector('[data-osb-learn-resume-action]');
      const learnResumeLabel = section.querySelector('[data-osb-learn-resume-label]');
      const learnLibraryTrigger = section.querySelector('[data-osb-learn-library-trigger]');
      const lessonNav = section.querySelector('[data-osb-lesson-nav]');
      const lessonLevelTrigger = section.querySelector('[data-osb-lesson-level-trigger]');
      const lessonLevels = section.querySelector('[data-osb-lesson-levels]');
      const lessonProgress = section.querySelector('[data-osb-lesson-progress]');
      const lessonPathTrigger = section.querySelector('[data-osb-lesson-path-trigger]');
      const lessonPathLabel = section.querySelector('[data-osb-lesson-path-label]');
      const lessonPathAction = section.querySelector('[data-osb-lesson-path-action]');
      const lessonOutline = section.querySelector('[data-osb-lesson-outline]');
      const lessonCourseList = section.querySelector('[data-osb-course-list]');
      const lessonModule = section.querySelector('[data-osb-lesson-module]');
      const lessonList = section.querySelector('[data-osb-lesson-list]');
      const lesson = section.querySelector('[data-osb-lesson]');
      const lessonTitle = section.querySelector('[data-osb-lesson-title]');
      const lessonPhase = section.querySelector('[data-osb-lesson-phase]');
      const lessonCopy = section.querySelector('[data-osb-lesson-copy]');
      const lessonStatus = section.querySelector('[data-osb-lesson-status]');
      const lessonHintButton = section.querySelector('[data-osb-lesson-hint]');
      const lessonExplainButton = section.querySelector('[data-osb-lesson-explain]');
      const lessonContinueButton = section.querySelector('[data-osb-lesson-continue]');
      const lessonLevelButtons = Array.from(section.querySelectorAll('[data-osb-lesson-level]'));
      const gameLearningButton = section.querySelector('[data-osb-game-learning]');
      const gameShareButton = section.querySelector('[data-osb-game-share]');
      const feedback = () => window.__osbFeedback;
      const feedbackEnabled = () => feedback()?.enabled?.() === true;
      const feedbackCue = (kind = 'selection') => feedback()?.cue?.(kind);
      const feedbackHaptic = (pattern = 5) => feedback()?.haptic?.(pattern);
      const storageKey = `osb-live-session:${serverUrl}`;
      const liveChatDemoMode = new URLSearchParams(window.location.search).get('osb_chat_demo') === '1';
      const accountStorageKey = `${storageKey}:account`;
      const computerLevelStorageKey = `${storageKey}:computer-level`;
      const learnProgressStorageBaseKey = `${storageKey}:learn-progress`;
      const puzzleProgressStorageBaseKey = `${storageKey}:puzzle-progress`;
      const reviewProgressStorageBaseKey = `${storageKey}:review-progress`;
      const learnCurriculumVersion = 'learn-2026-07-28-audit-1';
      const pieces = {
        P: section.dataset.pieceWP,
        N: section.dataset.pieceWN,
        B: section.dataset.pieceWB,
        R: section.dataset.pieceWR,
        Q: section.dataset.pieceWQ,
        K: section.dataset.pieceWK,
        p: section.dataset.pieceBP,
        n: section.dataset.pieceBN,
        b: section.dataset.pieceBB,
        r: section.dataset.pieceBR,
        q: section.dataset.pieceBQ,
        k: section.dataset.pieceBK
      };
      const pieceNames = { p: 'pawn', n: 'knight', b: 'bishop', r: 'rook', q: 'queen', k: 'king' };
      const startingFen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
      const beginnerLessons = [
        {
          id: 'board',
          title: 'your first move',
          guided: true,
          intro: 'white moves first. every square has a name. let’s make your first move.',
          example: {
            fen: startingFen,
            prompt: 'white moves first. this pawn can begin with two squares.',
            after: 'it moved from e2 to e4.',
            moves: [{ from: 'e2', to: 'e4' }]
          },
          notice: {
            copy: 'moving the pawn opened space for two pieces.'
          },
          attempts: [
            {
              phase: 'try',
              fen: startingFen,
              prompt: 'your turn. move the pawn in front of the king two squares.',
              accepted: [{ from: 'e2', to: 'e4' }],
              success: 'correct. the pawn claims the centre and opens lines for the queen and bishop.',
              wrong: 'use the pawn in front of the king.',
              hints: [
                'look for the king, then the pawn directly in front of it.',
                'choose the pawn on e2.',
                'finish on e4.'
              ]
            },
            {
              phase: 'use',
              fen: startingFen,
              prompt: 'now move the pawn in front of the queen two squares.',
              accepted: [{ from: 'd2', to: 'd4' }],
              success: 'good. another way into the centre.',
              wrong: 'look directly in front of the queen.',
              hints: [
                'find the queen, then the pawn directly in front of it.',
                'choose the pawn on d2.',
                'finish on d4.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: startingFen,
              prompt: 'make a strong first move with either centre pawn.',
              accepted: [
                { from: 'e2', to: 'e4' },
                { from: 'd2', to: 'd4' }
              ],
              success: 'one square better. you have started the game.',
              wrong: 'use one of the two centre pawns.',
              hints: []
            }
          ]
        },
        {
          id: 'pawns',
          title: 'pawns take diagonally',
          guided: true,
          intro: 'pawns move straight ahead and capture one square diagonally forward.',
          example: {
            fen: '4k3/8/8/3p4/4P3/8/8/4K3 w - - 0 1',
            prompt: 'pawns move ahead, but take one square diagonally.',
            after: 'the white pawn moved forward and sideways to take.',
            moves: [{ from: 'e4', to: 'd5' }]
          },
          notice: {
            copy: 'one piece. two different rules: forward to move, diagonal to take.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '4k3/8/8/3p4/4P3/8/8/4K3 w - - 0 1',
              prompt: 'take the black pawn.',
              accepted: [{ from: 'e4', to: 'd5' }],
              success: 'yes. forward to move. diagonal to take.',
              wrong: 'a pawn captures one square diagonally forward.',
              hints: [
                'look one square diagonally ahead of the white pawn.',
                'start on e4.',
                'capture on d5.'
              ]
            },
            {
              phase: 'use',
              fen: '4k3/8/8/2p1p3/3P4/8/8/4K3 w - - 0 1',
              prompt: 'take the pawn on your right.',
              accepted: [{ from: 'd4', to: 'e5' }],
              success: 'that is the diagonal.',
              wrong: 'both diagonals can capture. this time, take the pawn on your right.',
              hints: [
                'look diagonally ahead and right.',
                'start on d4.',
                'capture on e5.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7k/1r1n4/2P5/8/8/8/8/7K w - - 0 1',
              prompt: 'the rook is on b7. take it with your pawn.',
              accepted: [{ from: 'c6', to: 'b7' }],
              success: 'one square better. your pawn won the rook.',
              wrong: 'look for the diagonal that reaches the rook on b7.',
              hints: []
            }
          ]
        },
        {
          id: 'straight-lines',
          title: 'straight lines',
          guided: true,
          intro: 'rooks and queens can travel as far as they like along a clear straight line.',
          example: {
            fen: '7k/8/p7/8/8/8/4K3/R2Q4 w - - 0 1',
            prompt: 'the rook and queen can both follow a clear straight line.',
            after: 'up, down, left or right. both can travel any clear distance.',
            moves: [
              { from: 'a1', to: 'a6' },
              { from: 'h8', to: 'g8' },
              { from: 'd1', to: 'd6' }
            ],
            movementGuide: {
              paths: [
                ['a1', 'a6'],
                ['a1', 'c1'],
                ['d1', 'd6']
              ]
            }
          },
          notice: {
            copy: 'rooks and queens own clear rows and files.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '7k/8/8/8/8/8/8/3QK3 w - - 0 1',
              prompt: 'keep the queen on the d-file. choose any clear square.',
              rule: {
                piece: 'q',
                movement: 'straight',
                sameFile: true,
                from: ['d1']
              },
              accepted: [
                { from: 'd1', to: 'd2' },
                { from: 'd1', to: 'd3' },
                { from: 'd1', to: 'd4' },
                { from: 'd1', to: 'd5' },
                { from: 'd1', to: 'd6' },
                { from: 'd1', to: 'd7' },
                { from: 'd1', to: 'd8' }
              ],
              success: 'yes. any clear distance on the same file is legal.',
              wrong: 'keep the queen on the d-file for this move.',
              hints: [
                'a file runs vertically.',
                'start with the queen on d1.',
                'choose any clear square from d2 to d8.'
              ]
            },
            {
              phase: 'use',
              fen: 'k7/8/8/7p/8/8/8/4K2R w - - 0 1',
              prompt: 'move the rook straight up and take the pawn.',
              accepted: [{ from: 'h1', to: 'h5' }],
              success: 'clear line. clean capture.',
              wrong: 'a rook moves horizontally or vertically, never diagonally.',
              hints: [
                'keep the rook on the h-file.',
                'start on h1.',
                'finish on h5.'
              ]
            },
            {
              phase: 'apply',
              fen: '7k/8/p7/8/8/P7/8/R3K3 w - - 0 1',
              prompt: 'your pawn blocks the way up. slide the rook across to d1.',
              accepted: [{ from: 'a1', to: 'd1' }],
              success: 'when one line closes, use another.',
              wrong: 'the pawn is in the way. rooks cannot jump.',
              hints: [
                'move sideways along the first rank.',
                'start on a1.',
                'finish on d1.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7k/8/2p5/8/8/2R2p2/8/7K w - - 0 1',
              prompt: 'take the pawn on f3.',
              accepted: [{ from: 'c3', to: 'f3' }],
              success: 'one square better. straight, clear, captured.',
              wrong: 'the rook needs a clear straight line to f3.',
              hints: []
            }
          ]
        },
        {
          id: 'diagonals',
          title: 'diagonals',
          intro: 'bishops move diagonally. queens can move diagonally too.',
          example: {
            fen: '7k/8/8/8/8/8/8/2BQK3 w - - 0 1',
            prompt: 'bishops and queens can follow a diagonal.',
            after: 'a diagonal keeps the same angle across the board.',
            moves: [
              { from: 'c1', to: 'g5' },
              { from: 'h8', to: 'g8' },
              { from: 'd1', to: 'a4' }
            ],
            movementGuide: {
              paths: [
                ['c1', 'g5'],
                ['d1', 'a4']
              ]
            }
          },
          attempts: [
            {
              fen: '7k/8/8/8/8/8/8/2B1K3 w - - 0 1',
              prompt: 'move the bishop along one diagonal.',
              rule: {
                piece: 'b',
                movement: 'diagonal',
                from: ['c1']
              },
              accepted: [
                { from: 'c1', to: 'b2' },
                { from: 'c1', to: 'a3' },
                { from: 'c1', to: 'd2' },
                { from: 'c1', to: 'e3' },
                { from: 'c1', to: 'f4' },
                { from: 'c1', to: 'g5' },
                { from: 'c1', to: 'h6' }
              ],
              success: 'good. a bishop always stays on the same colour.',
              wrong: 'follow one diagonal away from the bishop.',
              hints: [
                'follow either diagonal away from the bishop.',
                'start on c1.',
                'choose any clear square on that diagonal.'
              ]
            },
            {
              fen: '7k/8/8/8/8/8/8/3QK3 w - - 0 1',
              prompt: 'make a diagonal queen move.',
              rule: {
                piece: 'q',
                movement: 'diagonal',
                from: ['d1']
              },
              accepted: [
                { from: 'd1', to: 'c2' },
                { from: 'd1', to: 'b3' },
                { from: 'd1', to: 'a4' },
                { from: 'd1', to: 'e2' },
                { from: 'd1', to: 'f3' },
                { from: 'd1', to: 'g4' },
                { from: 'd1', to: 'h5' }
              ],
              success: 'right. the queen combines rook and bishop movement.',
              wrong: 'for this move, keep the queen on a diagonal.',
              hints: [
                'the queen can use the bishop line.',
                'start on d1.',
                'choose any clear square on a diagonal.'
              ]
            }
          ]
        },
        {
          id: 'knight',
          title: 'the knight',
          intro: 'knights move in an L-shape and can jump over other pieces.',
          example: {
            fen: startingFen,
            prompt: 'two squares, then one across. that makes a capital L.',
            after: 'the knight jumped over the pawn and landed at the end of the L.',
            moves: [{ from: 'g1', to: 'f3' }],
            movementGuide: {
              paths: [['g1', 'g3', 'f3']]
            }
          },
          attempts: [
            {
              fen: startingFen,
              prompt: 'move either knight in an L-shape.',
              rule: {
                piece: 'n',
                movement: 'knight',
                from: ['b1', 'g1']
              },
              accepted: [
                { from: 'b1', to: 'a3' },
                { from: 'b1', to: 'c3' },
                { from: 'g1', to: 'f3' },
                { from: 'g1', to: 'h3' }
              ],
              success: 'good. the knight jumped over the pawns.',
              wrong: 'a knight moves two squares one way, then one across.',
              hints: [
                'use one of the two knights.',
                'start on g1 or b1.',
                'finish at the end of a capital L.'
              ]
            },
            {
              fen: '7k/8/8/8/8/4N3/8/4K3 w - - 0 1',
              prompt: 'make another L-shaped move.',
              rule: {
                piece: 'n',
                movement: 'knight',
                from: ['e3']
              },
              accepted: [
                { from: 'e3', to: 'c2' },
                { from: 'e3', to: 'c4' },
                { from: 'e3', to: 'd1' },
                { from: 'e3', to: 'd5' },
                { from: 'e3', to: 'f1' },
                { from: 'e3', to: 'f5' },
                { from: 'e3', to: 'g2' },
                { from: 'e3', to: 'g4' }
              ],
              success: 'right. two squares, then one across.',
              wrong: 'trace a capital L from the knight.',
              hints: [
                'move two ranks and one file.',
                'start on e3.',
                'choose any square at the end of that L.'
              ]
            }
          ]
        },
        {
          id: 'king-check',
          title: 'king and check',
          intro: 'the king moves one square at a time and may never move into or remain in check.',
          example: {
            fen: '7k/8/8/8/8/8/4K3/8 w - - 0 1',
            prompt: 'the king can take one careful step in any direction.',
            after: 'one square only, and never onto an attacked square.',
            moves: [{ from: 'e2', to: 'e3' }],
            movementGuide: {
              paths: [
                ['e2', 'd1'],
                ['e2', 'e1'],
                ['e2', 'f1'],
                ['e2', 'd2'],
                ['e2', 'f2'],
                ['e2', 'd3'],
                ['e2', 'e3'],
                ['e2', 'f3']
              ]
            }
          },
          attempts: [
            {
              fen: '7k/8/8/8/8/8/4K3/8 w - - 0 1',
              prompt: 'move the king one square.',
              rule: {
                piece: 'k',
                movement: 'king-safe',
                from: ['e2']
              },
              accepted: [
                { from: 'e2', to: 'd1' },
                { from: 'e2', to: 'e1' },
                { from: 'e2', to: 'f1' },
                { from: 'e2', to: 'd2' },
                { from: 'e2', to: 'f2' },
                { from: 'e2', to: 'd3' },
                { from: 'e2', to: 'e3' },
                { from: 'e2', to: 'f3' }
              ],
              success: 'good. the king moves one square in any direction.',
              wrong: 'keep the king move to one neighbouring square.',
              hints: [
                'choose a square touching the king.',
                'start on e2.',
                'finish on any safe neighbouring square.'
              ]
            },
            {
              fen: '4r2k/8/8/8/8/8/8/4K3 w - - 0 1',
              prompt: 'the rook gives check. move the king to safety.',
              rule: {
                piece: 'k',
                movement: 'king-safe',
                from: ['e1']
              },
              accepted: [
                { from: 'e1', to: 'd1' },
                { from: 'e1', to: 'f1' },
                { from: 'e1', to: 'd2' },
                { from: 'e1', to: 'f2' }
              ],
              success: 'right. when checked, the king must become safe immediately.',
              wrong: 'leave the rook’s e-file and move to a safe neighbouring square.',
              hints: [
                'the rook attacks down the e-file.',
                'start with the king on e1.',
                'leave the e-file for any safe neighbouring square.'
              ]
            }
          ]
        },
        {
          id: 'castling',
          title: 'castling',
          guided: true,
          intro: 'castling is one move with two pieces. the king moves two squares towards a rook, then the rook crosses to the other side.',
          example: {
            fen: 'r3k2r/8/8/8/8/8/8/R3K2R w KQkq - 0 1',
            prompt: 'the path is clear and the king is safe. castle on the king side.',
            after: 'the king moved to g1 and the rook moved to f1 in the same turn.',
            moves: [{ from: 'e1', to: 'g1' }]
          },
          notice: {
            copy: 'you cannot castle out of check, through check, or after the king or rook has moved.'
          },
          attempts: [
            {
              phase: 'try',
              fen: 'r3k2r/8/8/8/8/8/8/R3K2R w KQkq - 0 1',
              prompt: 'castle on the king side.',
              accepted: [{ from: 'e1', to: 'g1' }],
              success: 'the king is safer and the rook is active. you made both moves at once.',
              wrong: 'move the king two squares towards the rook on h1.',
              hints: [
                'castling starts with the king, not the rook.',
                'choose the king on e1.',
                'move the king from e1 to g1.'
              ]
            },
            {
              phase: 'use',
              fen: 'r3k2r/ppp2ppp/2npbn2/8/8/2NPBN2/PPP2PPP/R3K2R w KQkq - 0 1',
              prompt: 'the centre is opening. put your king behind the pawns.',
              accepted: [{ from: 'e1', to: 'g1' }],
              success: 'castling completes development and connects the rook to the game.',
              wrong: 'the path to the king-side rook is clear.',
              hints: [
                'look for the safer side of the board.',
                'start with the king on e1.',
                'finish with the king on g1.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r3k2r/8/8/8/2b5/8/8/R3K2R w KQkq - 0 1',
              prompt: 'the bishop controls f1. castle on the safe side.',
              accepted: [{ from: 'e1', to: 'c1' }],
              success: 'one square better. you checked the route before castling.',
              wrong: 'the king cannot cross an attacked square. use the other rook.',
              hints: []
            }
          ]
        },
        {
          id: 'promotion',
          title: 'promotion',
          guided: true,
          intro: 'a pawn that reaches the far edge must become a queen, rook, bishop or knight. a queen is usually the strongest choice.',
          example: {
            fen: '7k/P7/8/8/8/8/8/7K w - - 0 1',
            prompt: 'the pawn is one move from the eighth rank.',
            after: 'the pawn reached a8 and became a queen.',
            moves: [{ from: 'a7', to: 'a8', promotion: 'q' }]
          },
          notice: {
            copy: 'promotion is earned by reaching the final rank. the pawn does not have to survive as a pawn.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '7k/P7/8/8/8/8/8/7K w - - 0 1',
              prompt: 'promote the pawn.',
              accepted: [{ from: 'a7', to: 'a8', promotion: 'q' }],
              success: 'the pawn crossed the board and became a queen.',
              wrong: 'move the pawn to the final rank.',
              hints: [
                'the final rank for white is rank 8.',
                'choose the pawn on a7.',
                'move from a7 to a8.'
              ]
            },
            {
              phase: 'use',
              fen: '1k6/6P1/8/8/8/8/8/7K w - - 0 1',
              prompt: 'create a new queen.',
              accepted: [{ from: 'g7', to: 'g8', promotion: 'q' }],
              success: 'the new queen can now help finish the game.',
              wrong: 'the pawn only needs one more step.',
              hints: [
                'look at the pawn on the seventh rank.',
                'choose g7.',
                'move from g7 to g8.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7K/8/8/8/8/8/1p6/7k b - - 0 1',
              prompt: 'black to move. promote the pawn.',
              accepted: [{ from: 'b2', to: 'b1', promotion: 'q' }],
              success: 'one square better. black promotes on the first rank.',
              wrong: 'black pawns travel towards rank 1.',
              hints: []
            }
          ]
        },
        {
          id: 'en-passant',
          title: 'en passant',
          guided: true,
          intro: 'when a pawn jumps two squares past your pawn, you may capture it as if it had moved only one square. you must do it immediately.',
          example: {
            fen: '7k/8/8/3pP3/8/8/8/7K w - d6 0 1',
            prompt: 'the black pawn has just moved from d7 to d5 beside your pawn.',
            after: 'the white pawn moved to d6 and removed the pawn from d5.',
            moves: [{ from: 'e5', to: 'd6' }]
          },
          notice: {
            copy: 'en passant only works on the move immediately after the two-square pawn move.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '7k/8/8/4pP2/8/8/8/7K w - e6 0 1',
              prompt: 'the pawn on e5 just jumped two squares. capture en passant.',
              accepted: [{ from: 'f5', to: 'e6' }],
              success: 'you captured on the square the pawn crossed.',
              wrong: 'move diagonally onto e6, not onto the pawn’s current square.',
              hints: [
                'the capture lands on the empty square behind the pawn.',
                'choose the pawn on f5.',
                'move from f5 to e6.'
              ]
            },
            {
              phase: 'use',
              fen: '7k/8/8/8/3Pp3/8/8/7K b - d3 0 1',
              prompt: 'black to move. capture the pawn that just jumped.',
              accepted: [{ from: 'e4', to: 'd3' }],
              success: 'black captures the same way, towards rank 1.',
              wrong: 'capture on the square the white pawn crossed.',
              hints: [
                'black moves down the board.',
                'choose the pawn on e4.',
                'move from e4 to d3.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7k/8/8/2pP4/8/8/8/7K w - c6 0 1',
              prompt: 'use the one-move opportunity.',
              accepted: [{ from: 'd5', to: 'c6' }],
              success: 'one square better. you recognised the temporary capture.',
              wrong: 'the chance disappears after this turn.',
              hints: []
            }
          ]
        },
        {
          id: 'files-and-ranks',
          title: 'files and ranks',
          guided: true,
          intro: 'every square has an address. the letter names the file. the number names the rank. letter first, number second.',
          example: {
            fen: '7k/8/8/8/8/8/8/3R2K1 w - - 0 1',
            prompt: 'd is the file. 5 is the rank. together, the square is d5.',
            after: 'file first, rank second: d5.',
            moves: [{ from: 'd1', to: 'd5' }]
          },
          notice: { copy: 'files run up the board. ranks run across it.' },
          attempts: [
            {
              phase: 'try',
              fen: '7k/8/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'find a4. move the rook there.',
              accepted: [{ from: 'a1', to: 'a4' }],
              success: 'yes. a is the file. 4 is the rank. a4.',
              wrong: 'find file a first, then rank 4.',
              hints: ['file a is the left edge.', 'rank 4 is the fourth row from white’s side.', 'move from a1 to a4.']
            },
            {
              phase: 'use',
              fen: '7k/8/8/8/8/8/8/2B3K1 w - - 0 1',
              prompt: 'find f4. move the bishop there.',
              accepted: [{ from: 'c1', to: 'f4' }],
              success: 'good. file f, rank 4: f4.',
              wrong: 'read the destination as a letter, then a number.',
              hints: ['find file f.', 'then find rank 4.', 'move from c1 to f4.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7k/8/8/8/8/8/8/4K1N1 w - - 0 1',
              prompt: 'move the knight to f3.',
              accepted: [{ from: 'g1', to: 'f3' }],
              success: 'one square better. you found f3.',
              wrong: 'letter first, number second: f3.',
              hints: []
            }
          ]
        },
        {
          id: 'piece-notation',
          title: 'piece notation',
          guided: true,
          intro: 'pieces use one capital letter: K king, Q queen, R rook, B bishop, N knight. pawns use no letter.',
          example: {
            fen: '7k/8/8/8/8/8/8/3Q2K1 w - - 0 1',
            prompt: 'the queen moves to d5.',
            after: 'Qd5. Q means queen. d5 is where it landed.',
            moves: [{ from: 'd1', to: 'd5' }]
          },
          notice: { copy: 'piece letter first, destination second. pawns simply name the destination.' },
          attempts: [
            {
              phase: 'try',
              fen: startingFen,
              prompt: 'move the knight to f3.',
              accepted: [{ from: 'g1', to: 'f3' }],
              success: 'Nf3. N means knight. f3 is the destination.',
              wrong: 'use the knight that can reach f3.',
              hints: ['knight is written with N.', 'choose the knight on g1.', 'move from g1 to f3.']
            },
            {
              phase: 'use',
              fen: '7k/8/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'move the rook to a4.',
              accepted: [{ from: 'a1', to: 'a4' }],
              success: 'Ra4. R means rook. a4 is the destination.',
              wrong: 'keep the rook on file a and finish on rank 4.',
              hints: ['rook is written with R.', 'choose the rook on a1.', 'move from a1 to a4.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: startingFen,
              prompt: 'move the king’s pawn to e4.',
              accepted: [{ from: 'e2', to: 'e4' }],
              success: 'e4. pawns use no piece letter.',
              wrong: 'pawns only name the square where they land.',
              hints: []
            }
          ]
        },
        {
          id: 'notation-symbols',
          title: 'captures, check, mate',
          guided: true,
          intro: 'x means capture. + means check. # means checkmate. the move comes first; the result goes at the end.',
          example: {
            fen: '7k/5p2/8/8/2B5/8/8/6K1 w - - 0 1',
            prompt: 'the bishop takes the pawn on f7.',
            after: 'Bxf7. B is bishop. x means capture. f7 is where it landed.',
            moves: [{ from: 'c4', to: 'f7' }]
          },
          notice: { copy: 'read left to right: piece, action, destination, result.' },
          attempts: [
            {
              phase: 'try',
              fen: '7k/8/p7/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'capture the pawn on a6 with the rook.',
              accepted: [{ from: 'a1', to: 'a6' }],
              success: 'Rxa6. R is rook, x is capture, a6 is the landing square.',
              wrong: 'take the pawn with the rook.',
              hints: ['the x records a capture.', 'choose the rook on a1.', 'move from a1 to a6.']
            },
            {
              phase: 'use',
              fen: '7k/8/8/4N3/8/8/8/6K1 w - - 0 1',
              prompt: 'move the knight to f7 and check the king.',
              accepted: [{ from: 'e5', to: 'f7' }],
              success: 'Nf7+. the + says the king is in check.',
              wrong: 'find the knight move that attacks the king.',
              hints: ['the + comes after the destination.', 'choose the knight on e5.', 'move from e5 to f7.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7k/8/5KQ1/8/8/8/8/8 w - - 0 1',
              prompt: 'find checkmate in one.',
              accepted: [{ from: 'g6', to: 'g7' }],
              success: 'Qg7#. the # says the game is over.',
              wrong: 'give check while taking away every escape square.',
              hints: []
            }
          ]
        },
        {
          id: 'centre',
          title: 'the centre',
          intro: 'centre pawns give more pieces room to move.',
          example: {
            fen: startingFen,
            moves: [{ from: 'e2', to: 'e4' }]
          },
          attempts: [
            {
              fen: startingFen,
              prompt: 'your turn: put a pawn in the centre.',
              accepted: [
                { from: 'e2', to: 'e4' },
                { from: 'd2', to: 'd4' }
              ],
              success: 'good. e4 and d4 both claim the centre.',
              wrong: 'start with a centre pawn so your pieces have room.',
              hints: [
                'look at the two pawns in front of your king and queen.',
                'choose the pawn on e2 or d2.',
                'move it two squares to e4 or d4.'
              ]
            },
            {
              fen: 'rnbqkbnr/1ppppppp/p7/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 2',
              prompt: 'same idea, new position: take the centre.',
              accepted: [
                { from: 'e2', to: 'e4' },
                { from: 'd2', to: 'd4' }
              ],
              success: 'right. the position changed, but the idea stayed the same.',
              wrong: 'ignore the edge pawn. the centre is still the priority.',
              hints: [
                'look at the middle files.',
                'choose e2 or d2.',
                'finish on e4 or d4.'
              ]
            }
          ]
        },
        {
          id: 'develop',
          title: 'develop a piece',
          intro: 'usually bring a new piece into the game before moving the same piece again.',
          example: {
            fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
            moves: [{ from: 'g1', to: 'f3' }]
          },
          attempts: [
            {
              fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
              prompt: 'your turn: develop a knight towards the centre.',
              accepted: [
                { from: 'g1', to: 'f3' },
                { from: 'b1', to: 'c3' }
              ],
              success: 'good. the knight is active and helps control the centre.',
              wrong: 'knights belong on c3 or f3, where they help control the centre.',
              hints: [
                'a knight can jump over the pawns.',
                'choose the knight on g1 or b1.',
                'move it to f3 or c3.'
              ]
            },
            {
              fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - 0 2',
              prompt: 'apply it again: develop a knight towards the centre.',
              accepted: [
                { from: 'g1', to: 'f3' },
                { from: 'b1', to: 'c3' }
              ],
              success: 'right. one more piece is working.',
              wrong: 'knights belong on c3 or f3, where they help control the centre.',
              hints: [
                'look for a piece that can enter the game now.',
                'choose g1 or b1.',
                'finish on f3 or c3.'
              ]
            }
          ]
        },
        {
          id: 'king-safety',
          title: 'make the king safe',
          intro: 'castling moves the king two squares towards a rook. you cannot castle out of, through or into check.',
          example: {
            fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 4 4',
            moves: [{ from: 'e1', to: 'g1' }]
          },
          attempts: [
            {
              fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 4 4',
              prompt: 'your turn: castle kingside.',
              accepted: [{ from: 'e1', to: 'g1' }],
              success: 'good. the king is safer and the rook joins the game.',
              wrong: 'the path is clear. move the king two squares toward the rook.',
              hints: [
                'castling is a king move.',
                'start with the king on e1.',
                'move the king to g1.'
              ]
            },
            {
              fen: 'rnbqkb1r/ppp2ppp/3ppn2/8/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 5',
              prompt: 'new position, same job: make the king safe.',
              accepted: [{ from: 'e1', to: 'g1' }],
              success: 'right. castle once the path is clear.',
              wrong: 'your pieces are developed; now finish the opening job.',
              hints: [
                'the king and rook can move together.',
                'select e1.',
                'finish on g1.'
              ]
            }
          ]
        },
        {
          id: 'opening-plan',
          title: 'one opening route',
          intro: 'here is one simple route: e4, knight out, bishop out, then castle.',
          example: {
            fen: startingFen,
            moves: [
              { from: 'e2', to: 'e4' },
              { from: 'e7', to: 'e5' },
              { from: 'g1', to: 'f3' },
              { from: 'b8', to: 'c6' },
              { from: 'f1', to: 'c4' },
              { from: 'g8', to: 'f6' },
              { from: 'e1', to: 'g1' }
            ]
          },
          attempts: [
            {
              fen: startingFen,
              prompt: 'step one in this route: play e4.',
              accepted: [{ from: 'e2', to: 'e4' }],
              success: 'centre first. black replies in the centre.',
              wrong: 'begin the plan in the centre.',
              hints: [
                'use the king pawn.',
                'choose e2.',
                'finish on e4.'
              ]
            },
            {
              fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
              prompt: 'black replies e5. develop the king knight.',
              accepted: [{ from: 'g1', to: 'f3' }],
              success: 'the knight is active. black develops too.',
              wrong: 'the centre is claimed. bring a piece out.',
              hints: [
                'develop the king knight.',
                'choose g1.',
                'finish on f3.'
              ]
            },
            {
              fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - 2 3',
              prompt: 'black develops. bring the king bishop to c4.',
              accepted: [{ from: 'f1', to: 'c4' }],
              success: 'the bishop is active. black develops once more.',
              wrong: 'make room to castle by developing the king bishop.',
              hints: [
                'look at the bishop beside your king.',
                'choose f1.',
                'finish on c4.'
              ]
            },
            {
              fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 4 4',
              prompt: 'finish this route by castling.',
              accepted: [{ from: 'e1', to: 'g1' }],
              success: 'that is the plan: centre, develop, castle.',
              wrong: 'finish the opening by protecting the king.',
              hints: [
                'castle now.',
                'select the king on e1.',
                'move it to g1.'
              ]
            }
          ]
        },
        {
          id: 'free-pieces',
          title: 'free pieces',
          intro: 'before every move, look for something you can take safely.',
          example: {
            fen: '6k1/8/8/3q4/2B5/8/8/6K1 w - - 0 1',
            prompt: 'the queen is unprotected. take it.',
            after: 'a free piece is material waiting to be won.',
            moves: [{ from: 'c4', to: 'd5' }]
          },
          attempts: [
            {
              fen: '6k1/8/q7/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'find the free piece.',
              accepted: [{ from: 'a1', to: 'a6' }],
              success: 'clean. the queen had no protection.',
              wrong: 'look for the most valuable undefended piece.',
              hints: [
                'scan every capture.',
                'the rook can take on a6.'
              ]
            },
            {
              fen: '7k/8/8/4r3/8/8/1B6/6K1 w - - 0 1',
              prompt: 'win material in one move.',
              accepted: [{ from: 'b2', to: 'e5' }],
              success: 'the bishop wins the rook with check.',
              wrong: 'follow the bishop’s diagonal.',
              hints: [
                'the rook on e5 is loose.',
                'bishop b2 takes e5.'
              ]
            }
          ]
        },
        {
          id: 'forks',
          title: 'forks',
          intro: 'one piece can attack two targets at once.',
          example: {
            fen: '3q3k/8/8/4N3/8/8/8/6K1 w - - 0 1',
            prompt: 'check the king and attack the queen.',
            after: 'the king must respond. the queen can be taken next.',
            moves: [{ from: 'e5', to: 'f7' }]
          },
          attempts: [
            {
              fen: '1q3k2/8/8/2N5/8/8/8/6K1 w - - 0 1',
              prompt: 'find the knight fork.',
              accepted: [{ from: 'c5', to: 'd7' }],
              success: 'check first, queen next.',
              wrong: 'find a square attacking both king and queen.',
              hints: [
                'look at d7.',
                'knight c5 to d7.'
              ]
            },
            {
              fen: '2q3k1/8/8/5N2/8/8/8/6K1 w - - 0 1',
              prompt: 'fork the two valuable targets.',
              accepted: [{ from: 'f5', to: 'e7' }],
              success: 'one knight, two problems.',
              wrong: 'look for a checking knight move.',
              hints: ['the target square is e7.']
            }
          ]
        },
        {
          id: 'pins',
          title: 'pins',
          intro: 'a pin lines up three pieces: your long-range piece, the pinned piece, then something more valuable.',
          example: {
            fen: '4k3/8/2n5/8/8/8/8/4KB2 w - - 0 1',
            prompt: 'watch the bishop line up with the knight and king.',
            after: 'bishop, knight, king: one line. moving the knight would expose the king.',
            moves: [{ from: 'f1', to: 'b5' }],
            movementGuide: {
              paths: [['f1', 'b5']]
            }
          },
          attempts: [
            {
              fen: '4k3/4n3/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'move the rook onto the knight’s file.',
              accepted: [{ from: 'a1', to: 'e1' }],
              success: 'rook, knight, king: one line. the knight cannot move.',
              wrong: 'put the rook on the same file as the knight and king.',
              hints: ['rook a1 to e1.']
            },
            {
              fen: '8/1k6/8/3n4/8/7B/8/6K1 w - - 0 1',
              prompt: 'move the bishop so the knight stands between it and the king.',
              accepted: [{ from: 'h3', to: 'g2' }],
              success: 'bishop, knight, king: one diagonal. the knight is pinned.',
              wrong: 'line up the bishop, knight and king on one diagonal.',
              hints: ['bishop h3 to g2.']
            }
          ]
        },
        {
          id: 'mate-in-one',
          title: 'mate in one',
          intro: 'check every escape square. if none remain, the game is over.',
          example: {
            fen: '7k/8/5KQ1/8/8/8/8/8 w - - 0 1',
            prompt: 'deliver checkmate.',
            after: 'the queen checks, covers every escape, and is protected.',
            moves: [{ from: 'g6', to: 'g7' }]
          },
          attempts: [
            {
              fen: '7k/5K1p/8/8/8/8/8/6R1 w - - 0 1',
              prompt: 'mate in one.',
              accepted: [{ from: 'g1', to: 'g8' }],
              success: 'checkmate. nowhere to go.',
              wrong: 'check the eighth rank.',
              hints: ['the rook belongs on g8.']
            },
            {
              fen: 'k7/8/2K5/1Q6/8/8/8/8 w - - 0 1',
              prompt: 'finish the game.',
              accepted: [{ from: 'b5', to: 'b7' }],
              success: 'checkmate. every square is covered.',
              wrong: 'the queen needs support from the king.',
              hints: ['queen b5 to b7.']
            }
          ]
        },
        {
          id: 'back-rank',
          title: 'the back rank',
          intro: 'a king trapped behind its own pawns can be finished by a rook.',
          example: {
            fen: '6k1/5ppp/8/8/8/8/8/3R2K1 w - - 0 1',
            prompt: 'use the open back rank.',
            after: 'the pawns became the king’s walls.',
            moves: [{ from: 'd1', to: 'd8' }]
          },
          attempts: [
            {
              fen: '6k1/5ppp/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'find the back-rank mate.',
              accepted: [{ from: 'a1', to: 'a8' }],
              success: 'checkmate along the back rank.',
              wrong: 'put the rook on the eighth rank.',
              hints: ['rook a1 to a8.']
            },
            {
              fen: '1k6/ppp5/8/8/8/8/8/6KR w - - 0 1',
              prompt: 'the pattern works from either side.',
              accepted: [{ from: 'h1', to: 'h8' }],
              success: 'same pattern, opposite side.',
              wrong: 'look at the open h-file.',
              hints: ['rook h1 to h8.']
            }
          ]
        },
        {
          id: 'active-king',
          title: 'the active king',
          intro: 'in the endgame, the king becomes a fighting piece.',
          example: {
            fen: '7k/8/8/3p4/8/8/4K3/8 w - - 0 1',
            prompt: 'bring the king towards the pawn.',
            after: 'central kings reach both sides of the board faster.',
            moves: [{ from: 'e2', to: 'e3' }]
          },
          attempts: [
            {
              fen: '7k/8/8/p7/8/8/2K5/8 w - - 0 1',
              prompt: 'approach the pawn.',
              accepted: [
                { from: 'c2', to: 'b3' },
                { from: 'c2', to: 'c3' }
              ],
              success: 'the king is close enough to stop it.',
              wrong: 'move towards the pawn, not away.',
              hints: ['king c2 to b3 or c3.']
            },
            {
              fen: 'k7/8/8/7p/8/8/5K2/8 w - - 0 1',
              prompt: 'centralise and approach.',
              accepted: [
                { from: 'f2', to: 'f3' },
                { from: 'f2', to: 'g3' }
              ],
              success: 'the king enters the action.',
              wrong: 'move closer while staying safe.',
              hints: ['king f2 to f3 or g3.']
            }
          ]
        },
        {
          id: 'opposition',
          title: 'opposition',
          intro: 'take the direct opposition: face the other king with one square between you, then make them move.',
          example: {
            fen: '8/2k5/8/8/1K6/8/8/8 w - - 0 1',
            prompt: 'take the opposition.',
            after: 'the other king must give way.',
            moves: [{ from: 'b4', to: 'c5' }]
          },
          attempts: [
            {
              fen: '8/5k2/8/8/6K1/8/8/8 w - - 0 1',
              prompt: 'stand directly opposite the king.',
              accepted: [{ from: 'g4', to: 'f5' }],
              success: 'opposition taken.',
              wrong: 'leave exactly one square between the kings.',
              hints: ['king g4 to f5.']
            },
            {
              fen: '8/3k4/8/8/2K5/8/8/8 w - - 0 1',
              prompt: 'make the other king move aside.',
              accepted: [{ from: 'c4', to: 'd5' }],
              success: 'now the other king must yield.',
              wrong: 'meet the king on the same file.',
              hints: ['king c4 to d5.']
            }
          ]
        },
        {
          id: 'passed-pawn',
          title: 'the passed pawn',
          intro: 'a passed pawn has no enemy pawn ahead on its file or either neighbouring file.',
          example: {
            fen: 'k7/8/4P3/8/4K3/8/8/8 w - - 0 1',
            prompt: 'push the passed pawn.',
            after: 'passed pawns become more dangerous with every step.',
            moves: [{ from: 'e6', to: 'e7' }]
          },
          attempts: [
            {
              fen: '7k/8/1P6/8/4K3/8/8/8 w - - 0 1',
              prompt: 'one step closer.',
              accepted: [{ from: 'b6', to: 'b7' }],
              success: 'the promotion square is close.',
              wrong: 'push the pawn while the path is clear.',
              hints: ['pawn b6 to b7.']
            },
            {
              fen: 'k7/8/8/6P1/5K2/8/8/8 w - - 0 1',
              prompt: 'advance the passer.',
              accepted: [{ from: 'g5', to: 'g6' }],
              success: 'keep it moving.',
              wrong: 'the passed pawn is your priority.',
              hints: ['pawn g5 to g6.']
            }
          ]
        },
        {
          id: 'answer-the-threat',
          title: 'answer the threat',
          intro: 'before choosing your move, ask what the opponent’s last move attacks.',
          example: {
            fen: '7k/8/8/5b2/8/3Q4/8/6K1 w - - 0 1',
            prompt: 'your queen is attacked. solve the problem.',
            after: 'taking the attacker answers the threat and wins material.',
            moves: [{ from: 'd3', to: 'f5' }]
          },
          attempts: [
            {
              fen: '4r2k/8/8/8/8/8/4Q3/6K1 w - - 0 1',
              prompt: 'the attacking rook is loose. take it.',
              accepted: [{ from: 'e2', to: 'e8' }],
              success: 'you answered the threat and won the rook.',
              wrong: 'take the loose rook that is attacking the queen.',
              hints: [
                'the attacker is on e8.',
                'queen e2 takes e8.'
              ]
            },
            {
              fen: '5k1b/8/8/8/8/8/8/Q5K1 w - - 0 1',
              prompt: 'remove the attacker.',
              accepted: [{ from: 'a1', to: 'h8' }],
              success: 'threat answered.',
              wrong: 'follow the long diagonal.',
              hints: ['queen a1 takes h8.']
            }
          ]
        },
        {
          id: 'trade-when-ahead',
          title: 'trade when ahead',
          intro: 'when you have extra material, exchanging pieces often makes the win simpler.',
          example: {
            fen: '3qk3/8/8/8/8/8/8/R2Q2K1 w - - 0 1',
            prompt: 'trade queens and keep the extra rook.',
            after: 'fewer pieces means fewer chances for the opponent.',
            moves: [
              { from: 'd1', to: 'd8' },
              { from: 'e8', to: 'd8' }
            ]
          },
          attempts: [
            {
              fen: 'rk6/8/8/8/8/8/8/R5KR w - - 0 1',
              prompt: 'exchange one pair of rooks.',
              accepted: [{ from: 'a1', to: 'a8' }],
              success: 'black can recapture. either way, your extra rook makes the ending simpler.',
              wrong: 'trade the matching pair.',
              hints: ['rook a1 takes a8.']
            },
            {
              fen: '3kq3/8/8/8/8/8/8/R3Q1K1 w - - 0 1',
              prompt: 'trade queens while keeping the extra rook.',
              accepted: [{ from: 'e1', to: 'e8' }],
              success: 'black can recapture. either way, your extra rook makes the ending simpler.',
              wrong: 'exchange the queens directly.',
              hints: ['queen e1 takes e8.']
            }
          ]
        }
      ];

      function pathwayLesson({ id, title, intro, principle, positions }) {
        const attempts = positions.map((position, index) => {
          const independent = index === positions.length - 1;
          return {
            phase: independent ? 'independent' : index === 0 ? 'try' : 'use',
            ...(independent ? { allowHint: false } : {}),
            fen: position.fen,
            prompt: position.prompt,
            accepted: [position.move],
            success: position.success,
            wrong: position.wrong,
            hints: independent
              ? []
              : position.hints || [
                  `start on ${position.move.from}.`,
                  `move from ${position.move.from} to ${position.move.to}.`
                ]
          };
        });
        const example = positions[0];
        return {
          id,
          title,
          guided: true,
          intro,
          example: {
            fen: example.fen,
            prompt: example.prompt,
            after: example.success,
            moves: [example.move]
          },
          notice: { copy: principle },
          attempts
        };
      }

      const deeperBeginnerLessons = [
        pathwayLesson({
          id: 'repertoire-white-e4',
          title: 'a white repertoire with e4',
          intro: 'begin with a centre pawn, develop quickly and aim for an open game.',
          principle: 'a repertoire is a connected set of plans, not a list of moves to memorise.',
          positions: [
            {
              fen: startingFen,
              prompt: 'claim the centre and open lines for the queen and bishop.',
              move: { from: 'e2', to: 'e4' },
              success: 'e4 starts the open-game repertoire and frees two pieces.',
              wrong: 'start with the king pawn.'
            },
            {
              fen: 'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq c6 0 2',
              prompt: 'black chose the sicilian. challenge the centre immediately.',
              move: { from: 'd2', to: 'd4' },
              success: 'd4 creates the open sicilian structure and keeps development active.',
              wrong: 'use the other centre pawn to challenge c5.'
            }
          ]
        }),
        pathwayLesson({
          id: 'repertoire-black-centre',
          title: 'a black repertoire for the centre',
          intro: 'meet a centre pawn with a centre pawn and build from sound development.',
          principle: 'against e4 or d4, contest the centre before starting a wing attack.',
          positions: [
            {
              fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq e3 0 1',
              prompt: 'answer e4 with a direct claim in the centre.',
              move: { from: 'e7', to: 'e5' },
              success: 'e5 creates a clear open-game repertoire for black.',
              wrong: 'match the king pawn in the centre.'
            },
            {
              fen: 'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq d3 0 1',
              prompt: 'answer d4 with a stable queen-pawn centre.',
              move: { from: 'd7', to: 'd5' },
              success: 'd5 claims equal space and gives every piece a familiar route.',
              wrong: 'place the queen pawn beside white’s centre pawn.'
            }
          ]
        }),
        pathwayLesson({
          id: 'use-the-open-file',
          title: 'use the open file',
          intro: 'a rook becomes active when no pawn blocks its file.',
          principle: 'put rooks on open files before trying to invade on them.',
          positions: [
            {
              fen: '6k1/8/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'place the rook on the open e-file.',
              move: { from: 'a1', to: 'e1' },
              success: 'the rook now controls the full e-file.',
              wrong: 'move the rook horizontally to e1.'
            },
            {
              fen: '6k1/8/8/8/8/8/8/K6R w - - 0 1',
              prompt: 'place the rook on the open d-file.',
              move: { from: 'h1', to: 'd1' },
              success: 'the rook reaches the open file in one move.',
              wrong: 'move the rook to d1.'
            }
          ]
        }),
        pathwayLesson({
          id: 'create-a-pawn-break',
          title: 'create a pawn break',
          intro: 'when the centre is locked, a pawn move can open a new line.',
          principle: 'prepare a pawn break where your pieces are ready to use the opening lines.',
          positions: [
            {
              fen: '6k1/8/3p4/3Pp3/4P3/8/5P2/6K1 w - - 0 1',
              prompt: 'attack the base of black’s centre from the kingside.',
              move: { from: 'f2', to: 'f4' },
              success: 'f4 challenges e5 and starts to open the position.',
              wrong: 'use the f-pawn to attack e5.'
            },
            {
              fen: '6k1/8/4p3/3pP3/3P4/8/2P5/6K1 w - - 0 1',
              prompt: 'challenge d5 from the queenside.',
              move: { from: 'c2', to: 'c4' },
              success: 'c4 attacks the locked centre at its base.',
              wrong: 'use the c-pawn to challenge d5.'
            }
          ]
        }),
        pathwayLesson({
          id: 'queen-checkmate-net',
          title: 'mate with a queen',
          intro: 'the queen seals the edge while the king protects the mating square.',
          principle: 'bring your king close before delivering the final queen check.',
          positions: [
            {
              fen: '7k/8/5KQ1/8/8/8/8/8 w - - 0 1',
              prompt: 'deliver checkmate in one move.',
              move: { from: 'g6', to: 'g7' },
              success: 'Qg7 is mate because the king protects the queen.',
              wrong: 'give check on g7.'
            },
            {
              fen: 'k7/8/2K5/1Q6/8/8/8/8 w - - 0 1',
              prompt: 'close every escape square and checkmate.',
              move: { from: 'b5', to: 'b7' },
              success: 'Qb7 is mate and the king protects the queen.',
              wrong: 'move the queen to b7.'
            }
          ]
        }),
        pathwayLesson({
          id: 'rook-checkmate-net',
          title: 'mate with a rook',
          intro: 'the rook checks along the edge while the king covers the escape squares.',
          principle: 'a rook and king work as a team: one checks, the other closes the next rank.',
          positions: [
            {
              fen: '7k/5K2/8/8/8/8/8/R7 w - - 0 1',
              prompt: 'deliver the final rook check.',
              move: { from: 'a1', to: 'h1' },
              success: 'Rh1 is mate; the white king covers g8 and g7.',
              wrong: 'place the rook on the h-file.'
            },
            {
              fen: 'k7/2K5/8/8/8/8/8/7R w - - 0 1',
              prompt: 'mirror the same checkmate on the other edge.',
              move: { from: 'h1', to: 'a1' },
              success: 'Ra1 is mate; the king closes b8 and b7.',
              wrong: 'move the rook to the a-file.'
            }
          ]
        })
      ];
      beginnerLessons.push(...deeperBeginnerLessons);

      const openingRepertoireLessons = [
        pathwayLesson({
          id: 'london-first-three-moves',
          title: 'the first three moves',
          intro: 'the london begins with d4, Nf3 and Bf4. the order keeps the centre stable and develops the bishop early.',
          principle: 'remember the jobs, not just the sequence: claim the centre, control e5, then place the bishop outside the pawn chain.',
          positions: [
            {
              fen: startingFen,
              prompt: 'begin the london by claiming the centre with the queen pawn.',
              move: { from: 'd2', to: 'd4' },
              success: 'd4 takes central space and opens the c1 bishop.',
              wrong: 'start with the pawn in front of the queen.'
            },
            {
              fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - 0 2',
              prompt: 'develop the king’s knight towards e5.',
              move: { from: 'g1', to: 'f3' },
              success: 'Nf3 develops, supports d4 and controls e5.',
              wrong: 'bring the king’s knight to f3.'
            },
            {
              fen: 'rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - 2 3',
              prompt: 'complete the london’s opening identity.',
              move: { from: 'c1', to: 'f4' },
              success: 'Bf4 places the bishop actively before e3 closes its diagonal.',
              wrong: 'develop the c1 bishop to f4.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-bishop-first',
          title: 'bishop before e3',
          intro: 'the dark-squared bishop belongs outside the pawn chain. develop it before playing e3.',
          principle: 'if e3 comes first, the bishop loses its easiest active square. Bf4 is the london move that prevents that problem.',
          positions: [
            {
              fen: 'rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - 2 3',
              prompt: 'develop the bishop before supporting d4 with e3.',
              move: { from: 'c1', to: 'f4' },
              success: 'the bishop reaches an active diagonal before the pawn chain closes.',
              wrong: 'move the c1 bishop to f4 before playing e3.'
            },
            {
              fen: 'rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - 1 2',
              prompt: 'black has not committed the centre. keep the london move order.',
              move: { from: 'c1', to: 'f4' },
              success: 'Bf4 keeps the setup flexible against several black structures.',
              wrong: 'place the dark-squared bishop on f4.'
            },
            {
              fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - 0 3',
              prompt: 'black chose e6. develop the bishop before e3.',
              move: { from: 'c1', to: 'f4' },
              success: 'Bf4 avoids becoming a bad bishop behind the e3 pawn.',
              wrong: 'the bishop needs to leave c1 now.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-build-the-shell',
          title: 'build the shell',
          intro: 'after Bf4, support the centre with e3, develop the king’s bishop and bring the queen’s knight to d2.',
          principle: 'the shell is a launch point, not an autopilot: e3, Bd3 and Nbd2 finish development while preserving both central breaks.',
          positions: [
            {
              fen: 'rnbqkb1r/ppp2ppp/4pn2/3p4/3P1B2/5N2/PPP1PPPP/RN1QKB1R w KQkq - 0 4',
              prompt: 'support d4 and open the king’s bishop.',
              move: { from: 'e2', to: 'e3' },
              success: 'e3 strengthens d4 and clears the diagonal from f1.',
              wrong: 'move the e-pawn one square.'
            },
            {
              fen: 'rnbqkb1r/pp3ppp/4pn2/2pp4/3P1B2/4PN2/PPP2PPP/RN1QKB1R w KQkq - 0 5',
              prompt: 'develop the bishop towards the kingside.',
              move: { from: 'f1', to: 'd3' },
              success: 'Bd3 develops and points towards h7.',
              wrong: 'place the king’s bishop on d3.'
            },
            {
              fen: 'r1bqkb1r/pp3ppp/2n1pn2/2pp4/3P1B2/3BPN2/PPP2PPP/RN1QK2R w KQkq - 2 6',
              prompt: 'complete the compact london development.',
              move: { from: 'b1', to: 'd2' },
              success: 'Nbd2 supports e4 and keeps the c-pawn free to move.',
              wrong: 'develop the queen’s knight to d2.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-meet-c5',
          title: 'meet an early c5',
          intro: 'black often attacks d4 with c5. reinforce the centre, finish development and prepare the right break.',
          principle: 'do not ignore pressure on d4. e3 and c3 make the centre secure while Nbd2 prepares e4.',
          positions: [
            {
              fen: 'rnbqkb1r/pp2pppp/5n2/2pp4/3P1B2/5N2/PPP1PPPP/RN1QKB1R w KQkq - 0 4',
              prompt: 'black attacked d4 with c5. reinforce the centre.',
              move: { from: 'e2', to: 'e3' },
              success: 'e3 supports d4 without blocking the bishop, which already reached f4.',
              wrong: 'support d4 with the e-pawn.'
            },
            {
              fen: 'r1bqkb1r/pp2pppp/2n2n2/2pp4/3P1B2/4PN2/PPP2PPP/RN1QKB1R w KQkq - 1 5',
              prompt: 'build a firm centre before choosing a pawn break.',
              move: { from: 'c2', to: 'c3' },
              success: 'c3 reinforces d4 and gives the queen a safe route to b3.',
              wrong: 'move the c-pawn one square.'
            },
            {
              fen: 'r1bqkb1r/pp3ppp/2n1pn2/2pp4/3P1B2/2P1PN2/PP3PPP/RN1QKB1R w KQkq - 0 6',
              prompt: 'develop while keeping c3 and e4 available.',
              move: { from: 'b1', to: 'd2' },
              success: 'Nbd2 completes the shell and prepares the e4 break.',
              wrong: 'develop the queen’s knight to d2.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-meet-qb6',
          title: 'meet Qb6',
          intro: 'Qb6 attacks b2 and sometimes d4. answer the threat before continuing the standard setup.',
          principle: 'Qb3 offers a queen trade and protects b2. Qc1 is a quieter alternative when the b-file remains secure.',
          positions: [
            {
              fen: 'r1b1kb1r/pp2pppp/1qn2n2/2pp4/3P1B2/2P1PN2/PP3PPP/RN1QKB1R w KQkq - 1 6',
              prompt: 'protect b2 and offer a queen trade.',
              move: { from: 'd1', to: 'b3' },
              success: 'Qb3 meets the threat directly and invites a simplifying queen trade.',
              wrong: 'place the queen on b3 to protect b2.'
            },
            {
              fen: 'rnb1kb1r/pp2pppp/1q3n2/2pp4/3P1B2/2P1P3/PP3PPP/RN1QKBNR w KQkq - 1 5',
              prompt: 'black’s queen is already on b6. defend b2 actively.',
              move: { from: 'd1', to: 'b3' },
              success: 'Qb3 answers the pressure without abandoning the london structure.',
              wrong: 'meet the queen with Qb3.'
            },
            {
              fen: 'rnb1kb1r/pp1p1ppp/1q2pn2/2p5/3P1B2/4PN2/PPP2PPP/RN1QKB1R w KQkq - 1 5',
              prompt: 'choose the solid queen move that guards b2.',
              move: { from: 'd1', to: 'c1' },
              success: 'Qc1 protects b2 and keeps the position compact.',
              wrong: 'move the queen to c1 so b2 is defended.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-c4-break',
          title: 'use the c4 break',
          intro: 'c4 challenges black’s d5 pawn and turns a quiet setup into active central play.',
          principle: 'play c4 when your pieces are developed and black’s centre can be questioned without weakening your own king.',
          positions: [
            {
              fen: 'r1bq1rk1/pppnbppp/4pn2/3p4/3P1B2/3BPN2/PPP2PPP/RN1Q1RK1 w - - 5 7',
              prompt: 'challenge the d5 pawn from the side.',
              move: { from: 'c2', to: 'c4' },
              success: 'c4 immediately questions black’s central foothold.',
              wrong: 'use the c-pawn to attack d5.'
            },
            {
              fen: 'rnbq1rk1/pp2bppp/2p1pn2/3p4/3P1B2/3BPN2/PPP2PPP/RN1Q1RK1 w - - 0 7',
              prompt: 'black built a solid centre. create tension with c4.',
              move: { from: 'c2', to: 'c4' },
              success: 'c4 stops black from keeping d5 without a decision.',
              wrong: 'challenge d5 with the c-pawn.'
            },
            {
              fen: 'rn1q1rk1/pbppbppp/1p2pn2/8/3P1B2/3BPN2/PPP2PPP/RN1Q1RK1 w - - 5 7',
              prompt: 'black delayed d5. claim more queenside space.',
              move: { from: 'c2', to: 'c4' },
              success: 'c4 gains space and prepares Nc3 without losing the london bishop.',
              wrong: 'advance the c-pawn two squares.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-e4-break',
          title: 'build the e4 break',
          intro: 'e4 is the london’s most ambitious central break. prepare it with Nbd2, c3 and a safe king.',
          principle: 'the setup is complete when it creates a pawn break. e4 takes more space and opens lines for the pieces behind it.',
          positions: [
            {
              fen: 'r1bq1rk1/p3bppp/1pn1pn2/2pp4/3P1B2/2PBPN2/PP1N1PPP/R2Q1RK1 w - - 0 9',
              prompt: 'the pieces are ready. take more central space.',
              move: { from: 'e3', to: 'e4' },
              success: 'e4 completes the central build and challenges d5.',
              wrong: 'use the prepared e-pawn break.'
            },
            {
              fen: 'r1bqr1k1/pp2bppp/2n1pn2/2pp4/3P1B2/2PBPN2/PP1N1PPP/R2Q1RK1 w - - 3 9',
              prompt: 'black placed a rook in the centre. strike before black improves.',
              move: { from: 'e3', to: 'e4' },
              success: 'e4 uses the lead in preparation before black can increase pressure.',
              wrong: 'break with the e-pawn now.'
            },
            {
              fen: 'r1bq1rk1/pppn1pbp/3p1np1/4p3/3P1B2/3BPN2/PPPN1PPP/R2Q1RK1 w - - 0 8',
              prompt: 'challenge the fianchetto centre.',
              move: { from: 'e3', to: 'e4' },
              success: 'e4 claims the centre and limits the g7 bishop.',
              wrong: 'advance the e-pawn into the centre.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-fianchetto',
          title: 'against a fianchetto',
          intro: 'against ...g6 and ...Bg7, prepare e4 and keep the bishop safe if ...Nh5 attacks it.',
          principle: 'the fianchetto changes the target, not the london’s logic: prepare e4, keep the bishop and contest the centre.',
          positions: [
            {
              fen: 'r1bq1rk1/pp1n1pbp/3ppnp1/2p5/3P1B2/2PBPN2/PP1N1PPP/R2Q1RK1 w - - 0 9',
              prompt: 'support the coming e4 break without blocking a piece.',
              move: { from: 'd1', to: 'e2' },
              success: 'Qe2 supports e4 and connects the pieces behind the centre.',
              wrong: 'place the queen behind the e-pawn on e2.'
            },
            {
              fen: 'r1bq1rk1/pppn1pbp/3p1np1/4p3/3P1B2/3BPN2/PPPN1PPP/R2Q1RK1 w - - 0 8',
              prompt: 'take the centre before the g7 bishop becomes dominant.',
              move: { from: 'e3', to: 'e4' },
              success: 'e4 builds a broad centre and reduces the bishop’s diagonal.',
              wrong: 'push the e-pawn to e4.'
            },
            {
              fen: 'rnbq1rk1/ppp1ppbp/3p2p1/7n/3P1B2/3BPN2/PPPN1PPP/R2QK2R w KQ - 2 7',
              prompt: 'black attacked the london bishop with ...Nh5. preserve it.',
              move: { from: 'f4', to: 'g3' },
              success: 'Bg3 keeps the bishop and maintains pressure on the kingside.',
              wrong: 'retreat the bishop to g3.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-kingside-attack',
          title: 'the kingside attack',
          intro: 'when black castles short and the centre is stable, Ne5, Qf3 and h4 can build a real attack.',
          principle: 'attack in order: improve the knight, bring the queen, then use a pawn. do not begin with the pawn while the pieces are asleep.',
          positions: [
            {
              fen: 'r1bq1rk1/p3bppp/1pn1pn2/2pp4/3P1B2/2PBPN2/PP1N1PPP/R2Q1RK1 w - - 0 9',
              prompt: 'place the knight on the central attacking square.',
              move: { from: 'f3', to: 'e5' },
              success: 'Ne5 centralises the knight and increases pressure near the king.',
              wrong: 'move the f3 knight to e5.'
            },
            {
              fen: 'r2q1rk1/pb2bppp/1pn1pn2/2ppN3/3P1B2/2PBP3/PP1N1PPP/R2Q1RK1 w - - 2 10',
              prompt: 'bring the queen towards h7 without exposing it.',
              move: { from: 'd1', to: 'f3' },
              success: 'Qf3 joins the bishop and knight around the kingside.',
              wrong: 'move the queen to f3.'
            },
            {
              fen: '2rq1rk1/pb2bppp/1pn1pn2/2ppN3/3P1B2/2PBPQ2/PP1N1PPP/R4RK1 w - - 4 11',
              prompt: 'the pieces are ready. gain space and prepare h5.',
              move: { from: 'h2', to: 'h4' },
              success: 'h4 is justified now because the king is safe and the attacking pieces are placed.',
              wrong: 'start the pawn attack with h4.'
            }
          ]
        }),
        pathwayLesson({
          id: 'london-enter-the-middlegame',
          title: 'enter the middlegame',
          intro: 'the london setup only matters if it leads to active pieces. place a rook behind the break and use the open file.',
          principle: 'leave the opening with one clear plan: e4, c4, a central knight or a rook on the file your pawn break will open.',
          positions: [
            {
              fen: 'r1bq1rk1/p3bppp/1pn1pn2/2pp4/3P1B2/2PBPN2/PP1N1PPP/R2Q1RK1 w - - 0 9',
              prompt: 'place a rook behind the planned e4 break.',
              move: { from: 'f1', to: 'e1' },
              success: 'Re1 supports e4 and gives the rook a central job.',
              wrong: 'move the rook from f1 to e1.'
            },
            {
              fen: 'r1bq1rk1/p3bppp/1pn1pn2/8/2NP1B2/3B1N2/PP3PPP/R2Q1RK1 w - - 0 11',
              prompt: 'the c-file is open. claim it with the correct rook.',
              move: { from: 'a1', to: 'c1' },
              success: 'Rac1 uses the newly opened file and improves the least active rook.',
              wrong: 'move the a1 rook to c1.'
            },
            {
              fen: 'r1bq1rk1/pp1nbppp/2p1pn2/3p4/3P1B2/3BPN2/PPPN1PPP/R2Q1RK1 w - - 2 8',
              prompt: 'finish the opening by challenging d5.',
              move: { from: 'c2', to: 'c4' },
              success: 'c4 turns the setup into active central play.',
              wrong: 'challenge d5 with the c-pawn.'
            }
          ]
        }),
        pathwayLesson({
          id: 'black-e5-claim-the-centre',
          title: 'answer e4 with e5',
          intro: '1...e5 claims equal central space and opens lines for both bishops.',
          principle: 'a classical answer does not concede the centre: meet the king pawn with your own king pawn.',
          positions: [
            {
              fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - 0 1',
              prompt: 'claim equal space in the centre.',
              move: { from: 'e7', to: 'e5' },
              success: 'e5 establishes the classical open-game centre.',
              wrong: 'match white’s e-pawn with your own.'
            }
          ]
        }),
        pathwayLesson({
          id: 'black-e5-develop',
          title: 'develop against white’s threat',
          intro: 'develop while defending e5 and asking white’s pieces useful questions.',
          principle: 'Nc6 protects e5, Nf6 attacks e4 and ...a6 asks the Spanish bishop to decide.',
          positions: [
            {
              fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - 1 2',
              prompt: 'develop and protect the e5 pawn.',
              move: { from: 'b8', to: 'c6' },
              success: 'Nc6 develops towards the centre and protects e5.',
              wrong: 'develop the queen’s knight to c6.'
            },
            {
              fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - 3 3',
              prompt: 'develop with an attack on e4.',
              move: { from: 'g8', to: 'f6' },
              success: 'Nf6 develops, prepares castling and attacks e4.',
              wrong: 'bring the king’s knight to f6.'
            },
            {
              fen: 'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - 3 3',
              prompt: 'ask the Spanish bishop to choose a square.',
              move: { from: 'a7', to: 'a6' },
              success: 'a6 gains space and asks the bishop whether it will exchange or retreat.',
              wrong: 'challenge the bishop with the a-pawn.'
            }
          ]
        }),
        pathwayLesson({
          id: 'black-e5-italian',
          title: 'meet the italian',
          intro: 'against Bc4, develop actively, control d4 and castle before the centre opens.',
          principle: 'the Italian is met with natural development: ...Bc5, ...Nf6 and ...O-O.',
          positions: [
            {
              fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - 3 3',
              prompt: 'develop the bishop to an active diagonal.',
              move: { from: 'f8', to: 'c5' },
              success: 'Bc5 develops and watches d4 and f2.',
              wrong: 'place the king’s bishop on c5.'
            },
            {
              fen: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - 0 4',
              prompt: 'develop the final kingside piece and attack e4.',
              move: { from: 'g8', to: 'f6' },
              success: 'Nf6 develops with tempo and prepares a safe king.',
              wrong: 'move the king’s knight to f6.'
            },
            {
              fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 b kq - 2 5',
              prompt: 'finish development on the kingside.',
              move: { from: 'e8', to: 'g8' },
              success: 'castling makes the king safe before the centre changes.',
              wrong: 'castle on the kingside.'
            }
          ]
        }),
        pathwayLesson({
          id: 'black-e5-central-break',
          title: 'castle, then strike',
          intro: 'secure the king, support e5 with d6 and use ...d5 when white gives enough time.',
          principle: 'the goal of the setup is the central break. development makes ...d5 possible without exposing the king.',
          positions: [
            {
              fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 b kq - 2 5',
              prompt: 'secure the king before changing the centre.',
              move: { from: 'e8', to: 'g8' },
              success: 'castling completes the first stage of development.',
              wrong: 'castle kingside.'
            },
            {
              fen: 'r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 b - - 0 6',
              prompt: 'support e5 and prepare the central break.',
              move: { from: 'd7', to: 'd6' },
              success: 'd6 reinforces e5 and prepares ...d5 under better conditions.',
              wrong: 'move the d-pawn one square.'
            },
            {
              fen: 'r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQR1K1 b - - 1 7',
              prompt: 'white has played slowly. challenge the centre now.',
              move: { from: 'd6', to: 'd5' },
              success: 'd5 equalises space and activates the central pieces.',
              wrong: 'use the prepared d-pawn break.'
            }
          ]
        }),
        pathwayLesson({
          id: 'qgd-claim-with-d5',
          title: 'answer d4 with d5',
          intro: '1...d5 claims equal space and begins a dependable defence to queen-pawn openings.',
          principle: 'meet a central pawn with a central pawn before building the rest of the queen’s gambit declined.',
          positions: [
            {
              fen: 'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - 0 1',
              prompt: 'claim equal space in the centre.',
              move: { from: 'd7', to: 'd5' },
              success: 'd5 establishes a stable queen-pawn centre.',
              wrong: 'match white’s d-pawn with your own.'
            }
          ]
        }),
        pathwayLesson({
          id: 'qgd-build-the-chain',
          title: 'build the pawn chain',
          intro: 'support d5 with e6, then develop the king’s knight without releasing the centre too early.',
          principle: 'the e6 pawn protects d5 and opens the f8 bishop; Nf6 develops while adding more central control.',
          positions: [
            {
              fen: 'rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - 0 2',
              prompt: 'decline the gambit and support d5.',
              move: { from: 'e7', to: 'e6' },
              success: 'e6 creates the queen’s gambit declined pawn chain.',
              wrong: 'support d5 with the e-pawn.'
            },
            {
              fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - 1 3',
              prompt: 'develop and increase control of e4 and d5.',
              move: { from: 'g8', to: 'f6' },
              success: 'Nf6 develops naturally and reinforces the centre.',
              wrong: 'bring the king’s knight to f6.'
            },
            {
              fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - 1 3',
              prompt: 'continue with the most useful kingside development.',
              move: { from: 'g8', to: 'f6' },
              success: 'Nf6 keeps the structure flexible and prepares castling.',
              wrong: 'develop the g8 knight to f6.'
            }
          ]
        }),
        pathwayLesson({
          id: 'qgd-finish-development',
          title: 'finish development',
          intro: 'break the pin calmly with ...Be7, castle and develop the queen’s knight without weakening the centre.',
          principle: 'the queen’s gambit declined works because every move strengthens the same centre while the king reaches safety.',
          positions: [
            {
              fen: 'rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR b KQkq - 3 4',
              prompt: 'develop and prepare to castle.',
              move: { from: 'f8', to: 'e7' },
              success: 'Be7 breaks the pin and clears the castling path.',
              wrong: 'develop the bishop to e7.'
            },
            {
              fen: 'rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR b KQkq - 0 5',
              prompt: 'secure the king.',
              move: { from: 'e8', to: 'g8' },
              success: 'castling completes the kingside development.',
              wrong: 'castle on the kingside.'
            },
            {
              fen: 'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQ - 2 6',
              prompt: 'develop the remaining knight without blocking the c-pawn.',
              move: { from: 'b8', to: 'd7' },
              success: 'Nbd7 supports e5 and keeps the c-pawn ready to challenge the centre.',
              wrong: 'develop the b8 knight to d7.'
            }
          ]
        }),
        pathwayLesson({
          id: 'qgd-c5-break',
          title: 'challenge with c5',
          intro: 'the queen’s gambit declined is not passive. use ...c5 to challenge d4 when development is ready.',
          principle: 'the c5 break attacks white’s centre from the side and prevents the pawn chain from becoming permanent.',
          positions: [
            {
              fen: 'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQ - 2 6',
              prompt: 'challenge white’s d4 pawn immediately.',
              move: { from: 'c7', to: 'c5' },
              success: 'c5 creates central tension and activates the queenside.',
              wrong: 'attack d4 with the c-pawn.'
            },
            {
              fen: 'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQ - 0 6',
              prompt: 'prepare the c5 break while adding central support.',
              move: { from: 'b8', to: 'd7' },
              success: 'Nbd7 develops and supports the coming ...c5 break.',
              wrong: 'develop the queen’s knight to d7.'
            },
            {
              fen: 'r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2NBPN2/PP3PPP/R2QK2R b KQ - 2 7',
              prompt: 'development is complete. strike at d4.',
              move: { from: 'c7', to: 'c5' },
              success: 'c5 challenges the centre before white can consolidate it.',
              wrong: 'use the c-pawn break now.'
            }
          ]
        })
      ];
      beginnerLessons.push(...openingRepertoireLessons);

      const learnCourses = [
        {
          id: 'foundations',
          title: 'foundations',
          lessonIds: [
            'board',
            'pawns',
            'straight-lines',
            'diagonals',
            'knight',
            'king-check'
          ]
        },
        {
          id: 'special-moves',
          title: 'special moves',
          requires: ['beginner:foundations'],
          lessonIds: [
            'castling',
            'promotion',
            'en-passant'
          ]
        },
        {
          id: 'reading-moves',
          title: 'reading moves',
          requires: ['beginner:foundations'],
          lessonIds: [
            'files-and-ranks',
            'piece-notation',
            'notation-symbols'
          ]
        },
        {
          id: 'starting-a-game',
          title: 'starting a game',
          track: 'openings',
          openingGroup: 'principles',
          requires: ['beginner:special-moves'],
          lessonIds: [
            'centre',
            'develop',
            'king-safety',
            'opening-plan'
          ]
        },
        {
          id: 'london-system',
          title: 'the london system',
          track: 'openings',
          openingGroup: 'white',
          requires: ['beginner:starting-a-game'],
          intro: 'build a complete white repertoire from the setup to the central break, critical replies and middlegame plan.',
          modelMoments: [
            'model moment: finish the shell before choosing c4 or e4.',
            'model moment: against a short-castled king, Ne5 brings the pieces before the pawns attack.',
            'model moment: the setup becomes useful only when it leads to a central break.'
          ],
          lessonIds: [
            'london-first-three-moves',
            'london-bishop-first',
            'london-build-the-shell',
            'london-meet-c5',
            'london-meet-qb6',
            'london-c4-break',
            'london-e4-break',
            'london-fianchetto',
            'london-kingside-attack',
            'london-enter-the-middlegame'
          ]
        },
        {
          id: 'black-with-e5',
          title: 'black with e5',
          track: 'openings',
          openingGroup: 'black-e4',
          requires: ['beginner:starting-a-game'],
          intro: 'answer e4 classically, develop against the italian and spanish, then prepare the central break.',
          modelMoments: [
            'model moment: develop, castle, then use d5 to free the position.',
            'model moment: against the italian, challenge the centre before beginning a wing attack.',
            'model moment: every e5 move should help complete development or prepare the central break.'
          ],
          lessonIds: [
            'black-e5-claim-the-centre',
            'black-e5-develop',
            'black-e5-italian',
            'black-e5-central-break'
          ]
        },
        {
          id: 'queens-gambit-declined',
          title: 'queen’s gambit declined',
          track: 'openings',
          openingGroup: 'black-d4',
          requires: ['beginner:starting-a-game'],
          intro: 'build a sound answer to d4 with a stable centre, safe king and active c5 break.',
          modelMoments: [
            'model moment: e6 supports d5 while the pieces prepare to challenge the centre.',
            'model moment: complete development before releasing the position with c5.',
            'model moment: a sound pawn chain is a base for activity, not a reason to stay passive.'
          ],
          lessonIds: [
            'qgd-claim-with-d5',
            'qgd-build-the-chain',
            'qgd-finish-development',
            'qgd-c5-break'
          ]
        },
        {
          id: 'winning-material',
          title: 'winning material',
          track: 'middlegames',
          requires: ['beginner:foundations'],
          lessonIds: [
            'free-pieces',
            'forks',
            'pins'
          ]
        },
        {
          id: 'finishing-games',
          title: 'finishing games',
          track: 'middlegames',
          requires: ['beginner:winning-material'],
          lessonIds: [
            'mate-in-one',
            'back-rank'
          ]
        },
        {
          id: 'endgames',
          title: 'endgames',
          track: 'endgames',
          requires: ['beginner:foundations'],
          lessonIds: [
            'active-king',
            'opposition',
            'passed-pawn'
          ]
        },
        {
          id: 'playing-well',
          title: 'playing well',
          track: 'middlegames',
          requires: ['beginner:winning-material', 'beginner:endgames'],
          lessonIds: [
            'answer-the-threat',
            'trade-when-ahead'
          ]
        },
        {
          id: 'first-repertoire',
          title: 'first repertoire',
          track: 'openings',
          openingGroup: 'principles',
          requires: ['beginner:starting-a-game'],
          intro: 'connect the opening principles to a dependable first move and a clear reply with black.',
          lessonIds: [
            'repertoire-white-e4',
            'repertoire-black-centre'
          ]
        },
        {
          id: 'active-middlegame',
          title: 'active middlegame',
          track: 'middlegames',
          requires: ['beginner:playing-well'],
          intro: 'open lines deliberately and place pieces where those lines will matter.',
          lessonIds: [
            'use-the-open-file',
            'create-a-pawn-break'
          ]
        },
        {
          id: 'essential-checkmates',
          title: 'essential checkmates',
          track: 'endgames',
          requires: ['beginner:endgames', 'beginner:finishing-games'],
          intro: 'convert a winning position without guesswork by coordinating the king with one major piece.',
          lessonIds: [
            'queen-checkmate-net',
            'rook-checkmate-net'
          ]
        }
      ];
      const intermediateLessons = [
        {
          id: 'checks-captures-threats',
          title: 'checks, captures, threats',
          guided: true,
          intro: 'on every turn, scan checks, then captures, then threats. forcing moves are easier to calculate.',
          example: {
            fen: '2r3k1/5ppp/8/8/8/8/5PPP/2R3K1 w - - 0 1',
            prompt: 'the rook can capture with check.',
            after: 'the rook takes the piece on c8 and gives checkmate.',
            moves: [{ from: 'c1', to: 'c8' }]
          },
          notice: {
            copy: 'checks force replies. captures change the material. threats make the opponent react.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/5ppp/8/8/8/8/5PPP/3R2K1 w - - 0 1',
              prompt: 'scan checks first. finish on the back rank.',
              accepted: [{ from: 'd1', to: 'd8' }],
              success: 'yes. the rook moves to d8 and gives checkmate.',
              wrong: 'start with the most forcing move: a rook check.',
              hints: [
                'the black pawns leave the king no flight square.',
                'keep the rook on the d-file.',
                'move the rook from d1 to d8.'
              ]
            },
            {
              phase: 'use',
              fen: '7k/8/8/3r4/4P3/8/8/6K1 w - - 0 1',
              prompt: 'checks are quiet. scan captures and win the loose rook.',
              accepted: [{ from: 'e4', to: 'd5' }],
              success: 'good. the pawn takes a rook for free.',
              wrong: 'look for the valuable piece your pawn can capture.',
              hints: [
                'the pawn captures diagonally.',
                'start with the pawn on e4.',
                'capture the rook on d5.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7k/8/3q4/8/8/2N5/8/6K1 w - - 0 1',
              prompt: 'there is no check or capture. make a threat that hits the queen.',
              accepted: [{ from: 'c3', to: 'b5' }, { from: 'c3', to: 'e4' }],
              success: 'right. the knight attacks the queen and forces a reply.',
              wrong: 'use the knight to create an immediate threat against the queen.',
              hints: []
            }
          ]
        },
        {
          id: 'candidate-moves',
          title: 'candidate moves',
          guided: true,
          intro: 'do not calculate every legal move. make a short list of forcing candidates, then compare them.',
          example: {
            fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p2Q/2B1P3/8/PPPP1PPP/RNB1K1NR w KQkq - 4 4',
            prompt: 'checks come first. compare them before choosing.',
            after: 'the queen takes the pawn on f7 and gives checkmate.',
            moves: [{ from: 'h5', to: 'f7' }]
          },
          notice: {
            copy: 'shortlist first. calculate second. choose only after the candidates have been compared.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/8/8/8/4Q3/8/8/6K1 w - - 0 1',
              prompt: 'start a shortlist: find any queen check.',
              accepted: [
                { from: 'e4', to: 'd5' },
                { from: 'e4', to: 'a8' },
                { from: 'e4', to: 'e6' },
                { from: 'e4', to: 'e8' },
                { from: 'e4', to: 'g6' },
                { from: 'e4', to: 'h7' },
                { from: 'e4', to: 'g4' },
                { from: 'e4', to: 'g2' },
                { from: 'e4', to: 'c4' }
              ],
              success: 'good. every legal check belongs on the shortlist before you compare them.',
              wrong: 'begin with one of the queen’s legal checks.',
              hints: [
                'look along every rank, file and diagonal from e4.',
                'the queen starts on e4.',
                'for example, the queen can move to a8 or e8 and give check.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/3q1p2/8/4N3/8/8/8/6K1 w - - 0 1',
              prompt: 'two knight captures are candidates. which one wins more material?',
              accepted: [{ from: 'e5', to: 'd7' }],
              success: 'right. the queen is worth far more than the pawn.',
              wrong: 'compare what each capture wins before choosing.',
              hints: [
                'the knight can capture on d7 or f7.',
                'one target is a queen.',
                'play knight e5 takes d7.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/5ppp/8/8/8/8/5PPP/R5K1 w - - 0 1',
              prompt: 'one candidate ends the game. compare the checks and play it.',
              accepted: [{ from: 'a1', to: 'a8' }],
              success: 'one square better. the rook moves to a8 and gives checkmate.',
              wrong: 'look for a rook check that covers every back-rank escape.',
              hints: []
            }
          ]
        },
        {
          id: 'double-attacks',
          title: 'double attacks',
          guided: true,
          intro: 'a double attack makes one move hit two targets. the defender can rarely save both.',
          example: {
            fen: '3q3k/8/8/4N3/8/8/8/6K1 w - - 0 1',
            prompt: 'the knight can check the king and attack the queen.',
            after: 'the king moves; the second target cannot move with it.',
            moves: [
              { from: 'e5', to: 'f7' },
              { from: 'h8', to: 'g8' },
              { from: 'f7', to: 'd8' }
            ]
          },
          notice: {
            copy: 'look for one move that reaches two valuable targets at once.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '3q1k2/8/8/2N5/8/8/8/6K1 w - - 0 1',
              prompt: 'fork the king and queen with the knight.',
              accepted: [{ from: 'c5', to: 'e6' }],
              success: 'yes. the knight checks the king on f8 and attacks the queen on d8.',
              wrong: 'find the knight jump that reaches both d8 and f8.',
              hints: [
                'the fork square lies between the two targets.',
                'start with the knight on c5.',
                'move the knight to e6.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/3r1r2/8/4P3/8/8/8/6K1 w - - 0 1',
              prompt: 'push the pawn to fork both rooks.',
              accepted: [{ from: 'e5', to: 'e6' }],
              success: 'good. one pawn now attacks both rooks.',
              wrong: 'place the pawn where its two capture squares reach d7 and f7.',
              hints: [
                'a pawn attacks one diagonal on each side.',
                'the fork square is e6.',
                'push the pawn from e5 to e6.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '1r3k2/8/8/8/8/3Q4/8/6K1 w - - 0 1',
              prompt: 'find the queen move that checks the king and attacks the rook.',
              accepted: [{ from: 'd3', to: 'd6' }],
              success: 'right. the king must answer, then the rook on b8 falls.',
              wrong: 'look for a queen check that also reaches the rook on b8.',
              hints: []
            }
          ]
        },
        {
          id: 'discovered-attacks',
          title: 'discovered attacks',
          guided: true,
          intro: 'move one piece away and a hidden line piece begins to attack.',
          example: {
            fen: '4k3/6q1/8/4B3/8/8/8/4R2K w - - 0 1',
            prompt: 'the bishop can move with gain while uncovering the rook.',
            after: 'the bishop takes the queen on g7 and gives check.',
            moves: [{ from: 'e5', to: 'g7' }]
          },
          notice: {
            copy: 'the moving piece acts once. the piece behind it acts at the same time.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '3k4/8/5q2/3N4/8/8/8/3R2K1 w - - 0 1',
              prompt: 'move the knight, win the queen, and uncover rook check.',
              accepted: [{ from: 'd5', to: 'f6' }],
              success: 'yes. the knight takes the queen on f6 and gives check.',
              wrong: 'the knight must leave the d-file and capture with tempo.',
              hints: [
                'the rook is hidden behind the knight.',
                'the queen is on f6.',
                'play knight d5 takes f6.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/7r/8/8/8/3N4/8/1B4K1 w - - 0 1',
              prompt: 'move the knight and uncover the bishop’s attack on the rook.',
              accepted: [
                { from: 'd3', to: 'b2' },
                { from: 'd3', to: 'b4' },
                { from: 'd3', to: 'c1' },
                { from: 'd3', to: 'c5' },
                { from: 'd3', to: 'e1' },
                { from: 'd3', to: 'e5' },
                { from: 'd3', to: 'f2' },
                { from: 'd3', to: 'f4' }
              ],
              success: 'good. the knight clears d3 and the open diagonal reaches the rook on h7.',
              wrong: 'move the knight away from d3 without blocking the diagonal again.',
              hints: [
                'the knight on d3 is hiding the bishop.',
                'every legal knight move from d3 clears the diagonal.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '4k3/8/3n4/4P3/8/8/8/4R2K w - - 0 1',
              prompt: 'capture the knight and uncover check.',
              accepted: [{ from: 'e5', to: 'd6' }],
              success: 'right. the pawn from e5 takes the knight on d6, gives check and opens the e-file.',
              wrong: 'the pawn must leave the rook’s file as it captures.',
              hints: []
            }
          ]
        },
        {
          id: 'skewers',
          title: 'skewers',
          guided: true,
          intro: 'a skewer attacks the valuable piece in front. when it moves, the piece behind is lost.',
          example: {
            fen: 'q7/k7/8/8/8/8/7K/7R w - - 0 1',
            prompt: 'check the king through the queen behind it.',
            after: 'the king steps away, and the queen is left on the same line.',
            moves: [
              { from: 'h1', to: 'a1' },
              { from: 'a7', to: 'b6' },
              { from: 'a1', to: 'a8' }
            ]
          },
          notice: {
            copy: 'in a skewer, the front target is forced away and exposes the target behind.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '5r2/4k3/8/8/8/2B5/8/6K1 w - - 0 1',
              prompt: 'skewer the king and rook with the bishop.',
              accepted: [{ from: 'c3', to: 'b4' }],
              success: 'yes. the king must move, leaving the rook on f8.',
              wrong: 'put the bishop on the diagonal through e7 and f8.',
              hints: [
                'the king and rook share one diagonal.',
                'the bishop starts on c3.',
                'move the bishop to b4.'
              ]
            },
            {
              phase: 'use',
              fen: '8/3r4/2k5/8/7Q/8/8/6K1 w - - 0 1',
              prompt: 'check the king and expose the rook behind it.',
              accepted: [{ from: 'h4', to: 'a4' }],
              success: 'good. the king moves, then the rook on d7 falls.',
              wrong: 'find the queen check along the a4–d7 diagonal.',
              hints: [
                'the skewer begins from a4.',
                'the queen starts on h4.',
                'move the queen to a4.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '4r3/4k3/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'place the rook on the e-file to skewer the king and rook.',
              accepted: [{ from: 'a1', to: 'e1' }],
              success: 'right. the king must move, then the rook on e8 falls.',
              wrong: 'line your rook up with the king and the rook behind it.',
              hints: []
            }
          ]
        },
        {
          id: 'remove-the-defender',
          title: 'remove the defender',
          guided: true,
          intro: 'before taking the prize, take away the piece that protects it.',
          example: {
            fen: 'k2q4/1n6/8/8/4B3/8/8/3R2K1 w - - 0 1',
            prompt: 'the knight protects the queen. remove it with check.',
            after: 'the defender disappeared with tempo. after the king answered, the queen fell.',
            moves: [
              { from: 'e4', to: 'b7' },
              { from: 'a8', to: 'b7' },
              { from: 'd1', to: 'd8' }
            ]
          },
          notice: {
            copy: 'find the target, find its defender, then ask whether the defender can be removed with force.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '1k2q3/2n5/8/8/5B2/8/8/4R1K1 w - - 0 1',
              prompt: 'remove the knight that protects the queen.',
              accepted: [{ from: 'f4', to: 'c7' }],
              success: 'yes. check removes the defender; the queen falls next.',
              wrong: 'remove the defender with check before taking the queen.',
              hints: [
                'the knight on c7 protects e8.',
                'your bishop can take it with check.',
                'bishop f4 to c7.'
              ]
            },
            {
              phase: 'use',
              fen: '8/1k2q3/2n5/8/8/5B2/8/4R1K1 w - - 0 1',
              prompt: 'take away the queen’s defender with tempo.',
              accepted: [{ from: 'f3', to: 'c6' }],
              success: 'good. the check forces the king to answer while the queen loses its guard.',
              wrong: 'remove the knight before taking the queen.',
              hints: [
                'the knight on c6 protects e7.',
                'look along the bishop’s diagonal.',
                'bishop f3 to c6.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '4q2k/8/5n2/6B1/8/8/8/4R1K1 w - - 0 1',
              prompt: 'one move removes the defender with check. find it.',
              accepted: [{ from: 'g5', to: 'f6' }],
              success: 'one square better. the queen on e8 has lost its defender.',
              wrong: 'the defender is the knight on f6.',
              hints: []
            }
          ]
        },
        {
          id: 'deflection-decoy',
          title: 'decoys',
          guided: true,
          intro: 'offer something tempting to pull a defender onto the square you want.',
          example: {
            fen: '5r1k/6pp/4Q2N/8/8/8/8/6K1 w - - 0 1',
            prompt: 'offer the queen to pull the rook onto g8.',
            after: 'the rook took the decoy. the knight then finished the game.',
            moves: [
              { from: 'e6', to: 'g8' },
              { from: 'f8', to: 'g8' },
              { from: 'h6', to: 'f7' }
            ]
          },
          notice: {
            copy: 'a decoy is not a gift. it makes an enemy piece stand where you need it.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '5r1k/6pp/7N/3Q4/8/8/8/6K1 w - - 0 1',
              prompt: 'pull the rook onto g8, then the knight can finish.',
              accepted: [{ from: 'd5', to: 'g8' }],
              success: 'yes. the rook must take the queen, and knight f7 is mate.',
              wrong: 'start with the queen sacrifice on g8.',
              hints: [
                'the knight on h6 protects g8.',
                'offer the queen on g8.',
                'queen d5 to g8.'
              ]
            },
            {
              phase: 'use',
              fen: '5r1k/6pp/7N/8/2Q5/8/8/6K1 w - - 0 1',
              prompt: 'find the same decoy from farther away.',
              accepted: [{ from: 'c4', to: 'g8' }],
              success: 'good. the rook is pulled onto g8 and the knight reaches f7.',
              wrong: 'follow the queen’s diagonal to g8.',
              hints: [
                'the queen can reach g8 with check.',
                'the knight protects that square.',
                'queen c4 to g8.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'k1r5/pp6/N2Q4/8/8/8/8/1K6 w - - 0 1',
              prompt: 'find the mirrored queen decoy that forces the rook to move.',
              accepted: [{ from: 'd6', to: 'b8' }],
              success: 'one square better. the rook is dragged onto b8 and knight c7 is mate.',
              wrong: 'offer the queen on the square protected by the knight.',
              hints: []
            }
          ]
        },
        {
          id: 'overload-interference',
          title: 'one defender, two jobs',
          guided: true,
          intro: 'an overloaded piece cannot protect two important squares at once.',
          example: {
            fen: '3q2k1/5ppp/8/r7/8/8/3B4/4R1K1 w - - 0 1',
            prompt: 'the queen guards e8 and the rook on a5. force it to choose.',
            after: 'the queen answered the check and abandoned the rook.',
            moves: [
              { from: 'e1', to: 'e8' },
              { from: 'd8', to: 'e8' },
              { from: 'd2', to: 'a5' }
            ]
          },
          notice: {
            copy: 'when one defender has two jobs, attack one job with tempo and collect the other.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '4q2k/6pp/8/1r6/8/3B4/8/5RK1 w - - 0 1',
              prompt: 'force the queen away from the rook on b5.',
              accepted: [{ from: 'f1', to: 'f8' }],
              success: 'yes. the queen must answer the check, so the bishop can take b5.',
              wrong: 'start with the forcing rook check on f8.',
              hints: [
                'the queen on e8 guards the rook on b5.',
                'make it answer a check.',
                'rook f1 to f8.'
              ]
            },
            {
              phase: 'use',
              fen: '2q3k1/5ppp/8/5r2/8/7B/8/4R1K1 w - - 0 1',
              prompt: 'make the queen choose between e8 and the rook on f5.',
              accepted: [{ from: 'e1', to: 'e8' }],
              success: 'good. after the queen captures on e8, the bishop takes f5.',
              wrong: 'begin with the rook check on e8.',
              hints: [
                'the queen on c8 protects f5.',
                'force it onto e8.',
                'rook e1 to e8.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '1q4k1/5ppp/3r4/8/8/6B1/8/4R1K1 w - - 0 1',
              prompt: 'overload the queen and win the rook.',
              accepted: [{ from: 'e1', to: 'e8' }],
              success: 'one square better. the queen answered the check and left d6 unprotected.',
              wrong: 'use check to pull the queen away from d6.',
              hints: []
            }
          ]
        },
        {
          id: 'zwischenzug',
          title: 'the in-between move',
          guided: true,
          intro: 'before an automatic capture, look for a check or capture that must be answered first.',
          example: {
            fen: '1k6/r7/8/3q4/2P5/4B3/8/R5K1 w - - 0 1',
            prompt: 'do not take the queen yet. take the rook with check first.',
            after: 'the bishop won the rook with check. only after the king moved did the pawn take the queen.',
            moves: [
              { from: 'e3', to: 'a7' },
              { from: 'b8', to: 'c8' },
              { from: 'c4', to: 'd5' }
            ]
          },
          notice: {
            copy: 'because bishop takes a7 came with check, black had to answer before the queen on d5 could move.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/7r/8/3q4/2P5/8/2B5/6KR w - - 0 1',
              prompt: 'before c4 takes the queen, take the rook on h7 with check.',
              accepted: [{ from: 'c2', to: 'h7' }],
              success: 'black must move the king. the pawn on c4 can still take d5.',
              wrong: 'start with the bishop capture on h7.',
              hints: [
                'look for a capture that checks the king.',
                'bishop c2 takes h7 first.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/5r2/8/1q6/P1B5/8/8/5RK1 w - - 0 1',
              prompt: 'before a4 takes the queen, take the rook on f7 with check.',
              accepted: [{ from: 'c4', to: 'f7' }],
              success: 'black must move the king. the pawn on a4 can still take b5.',
              wrong: 'take the rook with check before taking the queen.',
              hints: [
                'the bishop can capture the rook on f7.',
                'bishop c4 takes f7 with check.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '1k6/2r5/8/5q2/5BP1/8/8/2R3K1 w - - 0 1',
              prompt: 'before g4 takes the queen, take the rook on c7 with check.',
              accepted: [{ from: 'f4', to: 'c7' }],
              success: 'one square better. black must answer check, and g4 still takes f5.',
              wrong: 'find the bishop capture that wins the rook with check.',
              hints: []
            }
          ]
        },
        {
          id: 'calculate-two-moves',
          title: 'calculate two moves',
          guided: true,
          intro: 'picture your first move, their reply, and your finish before you touch a piece.',
          example: {
            fen: '3r3k/5ppp/8/3q4/8/8/8/3QR1K1 w - - 0 1',
            prompt: 'calculate both white moves before starting.',
            after: 'rook e8 forces the rook off d8. queen takes d5 and wins the queen the rook had defended.',
            moves: [
              { from: 'e1', to: 'e8' },
              { from: 'd8', to: 'e8' },
              { from: 'd1', to: 'd5' }
            ]
          },
          notice: {
            copy: 'the first move forced the defending rook away. the second white move collected the queen it had guarded.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '1k2q3/8/Q7/1N6/8/8/8/6K1 w - - 0 1',
              prompt: 'calculate the decoy to a8 and the knight fork. play move one.',
              accepted: [{ from: 'a6', to: 'a8' }],
              success: 'the line is queen a8 check, king takes a8, knight c7 check.',
              wrong: 'begin by offering the queen on a8.',
              hints: [
                'the king must be drawn onto a8.',
                'start with queen a6 to a8.'
              ]
            },
            {
              phase: 'use',
              fen: '3q2k1/5ppp/8/8/Q7/8/8/4R1K1 w - - 0 1',
              prompt: 'calculate the rook check, the forced queen capture, and the final mate.',
              accepted: [{ from: 'e1', to: 'e8' }],
              success: 'the line is rook e8 check, queen takes e8, queen takes e8 mate.',
              wrong: 'start with the rook check on e8.',
              hints: [
                'the black queen is the only piece that can answer the check.',
                'rook e1 to e8 forces queen takes e8.',
                'then queen a4 takes e8 mate.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '5bkn/5ppp/5n2/3q4/4B3/3Q4/8/6K1 w - - 0 1',
              prompt: 'calculate: force the knight onto h7, then take the queen on d5.',
              accepted: [{ from: 'e4', to: 'h7' }],
              success: 'the line is bishop takes h7 check, knight takes h7, queen takes d5.',
              wrong: 'the first move must check and force the knight away from d5.',
              hints: []
            }
          ]
        }
      ];
      const intermediateCourses = [
        {
          id: 'tactical-vision',
          title: 'tactical vision',
          track: 'middlegames',
          requires: ['beginner:winning-material', 'beginner:finishing-games'],
          intro: 'see forcing moves, loose pieces and tactical patterns before they disappear.',
          lessonIds: [
            'checks-captures-threats',
            'candidate-moves',
            'double-attacks',
            'discovered-attacks',
            'skewers',
            'remove-the-defender',
            'deflection-decoy',
            'overload-interference',
            'zwischenzug',
            'calculate-two-moves'
          ]
        }
      ];
      
      const intermediateExpansionLessons = [
        {
          id: 'develop-with-purpose',
          title: 'develop with purpose',
          guided: true,
          intro: 'bring a new piece into the game while making it do a useful job.',
          example: {
            fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
            prompt: 'develop the king’s knight and attack the pawn on e5.',
            after: 'the knight is active, helps the centre and attacks a pawn.',
            moves: [{ from: 'g1', to: 'f3' }]
          },
          notice: { copy: 'good development improves a piece and supports the position at the same time.' },
          attempts: [
            {
              phase: 'try',
              fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
              prompt: 'develop a knight and attack the pawn on e5.',
              accepted: [{ from: 'g1', to: 'f3' }],
              success: 'yes. the knight enters the game with a clear job.',
              wrong: 'look for the knight that can attack e5.',
              hints: ['use the knight beside your king.', 'move the knight from g1 to f3.']
            },
            {
              phase: 'use',
              fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - 0 2',
              prompt: 'develop a knight and add pressure to the pawn on d5.',
              accepted: [{ from: 'b1', to: 'c3' }],
              success: 'good. the knight develops towards the centre and attacks d5.',
              wrong: 'find the knight move that reaches towards d5.',
              hints: ['use the knight beside your queen.', 'move the knight from b1 to c3.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 2 3',
              prompt: 'develop the bishop with pressure on the knight that protects e5.',
              accepted: [{ from: 'f1', to: 'b5' }],
              success: 'one square better. the bishop develops and makes the knight’s job harder.',
              wrong: 'develop the king’s bishop to a square that attacks the knight on c6.',
              hints: []
            }
          ]
        },
        {
          id: 'central-tension',
          title: 'central tension',
          guided: true,
          intro: 'when pawns meet in the centre, you do not have to exchange immediately. support them, develop, then choose.',
          example: {
            fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - 0 3',
            prompt: 'keep the central tension and develop another piece.',
            after: 'the knight adds pressure without deciding the centre too early.',
            moves: [{ from: 'b1', to: 'c3' }]
          },
          notice: { copy: 'keeping tension preserves options. release it only when the resulting position helps you.' },
          attempts: [
            {
              phase: 'try',
              fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - 0 3',
              prompt: 'keep both central pawns in place and add pressure to d5.',
              accepted: [{ from: 'b1', to: 'c3' }],
              success: 'right. you improved a piece and kept both central options.',
              wrong: 'do not exchange yet. develop a knight towards d5.',
              hints: ['the queen’s knight can help.', 'move the knight from b1 to c3.']
            },
            {
              phase: 'use',
              fen: 'rnbqkbnr/pp3ppp/2p1p3/3pP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - 0 4',
              prompt: 'support the advanced pawn on e5 before the centre opens.',
              accepted: [{ from: 'f2', to: 'f4' }],
              success: 'good. the centre stays closed while the e5 pawn gains support.',
              wrong: 'support the pawn on e5 with its neighbouring pawn.',
              hints: ['the f-pawn can support e5.', 'move the pawn from f2 to f4.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - 1 3',
              prompt: 'keep the central choice open and finish developing a knight.',
              accepted: [{ from: 'b1', to: 'c3' }],
              success: 'yes. improve the position before deciding whether to exchange.',
              wrong: 'keep both central pawns where they are and develop.',
              hints: []
            }
          ]
        },
        {
          id: 'opening-to-middlegame',
          title: 'opening to middlegame',
          guided: true,
          intro: 'finish development, make the king safe, then choose a central plan.',
          example: {
            fen: 'r1bqk2r/ppp1bppp/2np1n2/4p3/4P3/2NP1N2/PPP1BPPP/R1BQK2R w KQkq - 4 7',
            prompt: 'finish the opening by making the king safe.',
            after: 'the king is safer and the rook joins the game.',
            moves: [{ from: 'e1', to: 'g1' }]
          },
          notice: { copy: 'a useful middlegame plan usually begins after every piece has a role and the king is safe.' },
          attempts: [
            {
              phase: 'try',
              fen: 'r1bqk2r/ppp1bppp/2np1n2/4p3/4P3/2NP1N2/PPP1BPPP/R1BQK2R w KQkq - 4 7',
              prompt: 'complete development by castling on the king’s side.',
              accepted: [{ from: 'e1', to: 'g1' }],
              success: 'yes. the king is safer and the rook becomes active.',
              wrong: 'make the special king move that also brings out the rook.',
              hints: ['castle on the king’s side.', 'move the king from e1 to g1.']
            },
            {
              phase: 'use',
              fen: 'r2q1rk1/ppp1bppp/2np1n2/4p3/4P3/2NP1N2/PPP1BPPP/R2Q1RK1 w - - 5 8',
              prompt: 'connect the rooks by moving the queen off their rank.',
              accepted: [{ from: 'd1', to: 'd2' }],
              success: 'good. the rooks can now support each other across the first rank.',
              wrong: 'move the queen without blocking the line between the rooks.',
              hints: ['the square d2 is clear.', 'move the queen from d1 to d2.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r2q1rk1/pp3ppp/2npbn2/8/4P3/2NP1N2/PPQ1BPPP/R4RK1 w - - 0 10',
              prompt: 'the pieces are ready. claim more central space with the pawn on d3.',
              accepted: [{ from: 'd3', to: 'd4' }],
              success: 'one square better. development has turned into a clear central plan.',
              wrong: 'use the central pawn that can advance safely.',
              hints: []
            }
          ]
        },
        {
          id: 'worst-placed-piece',
          title: 'improve the quiet piece',
          guided: true,
          intro: 'when there is no urgent tactic, find the piece doing the least and improve it.',
          example: {
            fen: '6k1/8/8/8/8/8/8/N5K1 w - - 0 1',
            prompt: 'bring the corner knight towards the centre.',
            after: 'the knight has more routes and can reach useful squares sooner.',
            moves: [{ from: 'a1', to: 'c2' }]
          },
          notice: { copy: 'improving the least active piece often strengthens the whole position without creating a weakness.' },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/8/8/8/8/8/8/N5K1 w - - 0 1',
              prompt: 'move the corner knight closer to the centre.',
              accepted: [{ from: 'a1', to: 'c2' }, { from: 'a1', to: 'b3' }],
              success: 'yes. either route gives the knight more useful future squares.',
              wrong: 'improve the knight on a1.',
              hints: ['a knight moves in an L-shape.', 'try c2 or b3.']
            },
            {
              phase: 'use',
              fen: '4k3/8/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'bring the rook away from the edge and onto a central file.',
              accepted: [{ from: 'a1', to: 'd1' }, { from: 'a1', to: 'e1' }],
              success: 'good. the rook now influences central files.',
              wrong: 'move the rook along the first rank towards the centre.',
              hints: ['the central files are d and e.', 'move the rook to d1 or e1.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/8/8/8/8/8/B7/6K1 w - - 0 1',
              prompt: 'place the bishop on a central diagonal with more reach.',
              accepted: [
                { from: 'a2', to: 'c4' },
                { from: 'a2', to: 'd5' },
                { from: 'a2', to: 'e6' }
              ],
              success: 'right. the bishop now sees both sides of the board.',
              wrong: 'move the bishop farther along its open diagonal towards the centre.',
              hints: []
            }
          ]
        },
        {
          id: 'weak-squares-outposts',
          title: 'weak squares and outposts',
          guided: true,
          intro: 'an outpost is a square where a piece is supported and enemy pawns cannot chase it away.',
          example: {
            fen: '6k1/8/8/2p1p3/2P1PN2/8/8/6K1 w - - 0 1',
            prompt: 'place the knight on the supported square that the black pawns cannot attack.',
            after: 'the knight is protected on d5 and the black pawns cannot drive it away.',
            moves: [{ from: 'f4', to: 'd5' }]
          },
          notice: { copy: 'before calling a square an outpost, check both conditions: support from your pawn and no enemy pawn challenge.' },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/8/8/2p1p3/2P1PN2/8/8/6K1 w - - 0 1',
              prompt: 'find the protected outpost for the knight.',
              accepted: [{ from: 'f4', to: 'd5' }],
              success: 'yes. d5 is protected and cannot be chased by either black pawn.',
              wrong: 'look for the square protected by the c4 and e4 pawns.',
              hints: ['both white pawns protect d5.', 'move the knight from f4 to d5.']
            },
            {
              phase: 'use',
              fen: '6k1/8/8/2p1p3/2P1P3/2N5/8/6K1 w - - 0 1',
              prompt: 'occupy the same outpost from a different starting square.',
              accepted: [{ from: 'c3', to: 'd5' }],
              success: 'good. the knight reaches a stable central home.',
              wrong: 'move the knight to the square supported by both white pawns.',
              hints: ['the outpost is d5.', 'move the knight from c3 to d5.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/8/8/4p1p1/4P2P/6N1/8/6K1 w - - 0 1',
              prompt: 'find the new outpost supported by a pawn.',
              accepted: [{ from: 'g3', to: 'f5' }],
              success: 'one square better. the knight is supported by the e-pawn on f5, and the black pawns cannot chase it away.',
              wrong: 'find the square supported by the pawn on e4 that neither black pawn can challenge.',
              hints: []
            }
          ]
        },
        {
          id: 'good-exchanges',
          title: 'good exchanges',
          guided: true,
          intro: 'trade when the piece you remove matters more to the position than the piece you give up.',
          example: {
            fen: '6k1/8/2p5/3n4/2B5/8/8/6K1 w - - 0 1',
            prompt: 'exchange the bishop for the strongly placed knight.',
            after: 'after the pawn recaptures, the dominant knight is gone.',
            moves: [{ from: 'c4', to: 'd5' }, { from: 'c6', to: 'd5' }]
          },
          notice: { copy: 'do not compare piece names alone. compare what each piece is doing in the actual position.' },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/8/2p5/3n4/2B5/8/8/6K1 w - - 0 1',
              prompt: 'remove the knight that controls the centre.',
              accepted: [{ from: 'c4', to: 'd5' }],
              success: 'yes. the bishop gives itself for the more influential knight.',
              wrong: 'use the bishop to capture the knight on d5.',
              hints: ['the knight is the target.', 'bishop c4 takes d5.']
            },
            {
              phase: 'use',
              fen: '6k1/8/5p2/4n3/3B4/8/8/6K1 w - - 0 1',
              prompt: 'exchange the bishop for the central knight.',
              accepted: [{ from: 'd4', to: 'e5' }],
              success: 'good. black can recapture, but the powerful knight is gone.',
              wrong: 'capture the knight with the bishop.',
              hints: ['the knight stands on e5.', 'bishop d4 takes e5.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/1p6/2n5/8/8/8/6B1/6K1 w - - 0 1',
              prompt: 'remove the knight before it settles into the centre.',
              accepted: [{ from: 'g2', to: 'c6' }],
              success: 'right. black may recapture, but the active knight has been exchanged.',
              wrong: 'follow the bishop’s long diagonal to the knight.',
              hints: []
            }
          ]
        },
        {
          id: 'pawn-races',
          title: 'pawn races',
          guided: true,
          intro: 'count the moves to promotion for both sides before pushing. one tempo can decide the ending.',
          example: {
            fen: '7k/8/P7/8/8/7p/8/K7 w - - 0 1',
            prompt: 'push the pawn that promotes first and controls the other promotion square.',
            after: 'the new queen arrives first and controls h1, so the black pawn cannot promote.',
            moves: [
              { from: 'a6', to: 'a7' },
              { from: 'h3', to: 'h2' },
              { from: 'a7', to: 'a8', promotion: 'q' }
            ]
          },
          notice: { copy: 'count every move, then check whether the first new queen can stop the other pawn.' },
          attempts: [
            {
              phase: 'try',
              fen: '7k/8/P7/8/8/7p/8/K7 w - - 0 1',
              prompt: 'begin the winning race.',
              accepted: [{ from: 'a6', to: 'a7' }],
              success: 'yes. white promotes first and the new queen controls h1.',
              wrong: 'push the pawn that is two steps from promotion.',
              hints: ['count from a6 to a8.', 'move the pawn from a6 to a7.']
            },
            {
              phase: 'use',
              fen: 'k7/8/7P/8/8/p7/8/7K w - - 0 1',
              prompt: 'win the mirrored race.',
              accepted: [{ from: 'h6', to: 'h7' }],
              success: 'good. the h-pawn promotes first and controls a1.',
              wrong: 'push the white pawn towards h8.',
              hints: ['white has the first move.', 'move the pawn from h6 to h7.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '7k/8/8/1P6/6p1/8/8/K7 w - - 0 1',
              prompt: 'count the race, then make the first move.',
              accepted: [{ from: 'b5', to: 'b6' }],
              success: 'one square better. the b-pawn promotes first with check, so black cannot promote on the next move.',
              wrong: 'push the pawn that will promote first and give check.',
              hints: []
            }
          ]
        },
        {
          id: 'key-squares',
          title: 'key squares',
          guided: true,
          intro: 'in a king-and-pawn ending, occupying a key square lets the king guide the pawn through.',
          example: {
            fen: '4k3/8/8/4K3/4P3/8/8/8 w - - 0 1',
            prompt: 'step onto one of the pawn’s key squares.',
            after: 'the king is far enough ahead to help the pawn promote.',
            moves: [{ from: 'e5', to: 'e6' }]
          },
          notice: { copy: 'for a pawn on the fourth rank, the three squares two ranks ahead are the key squares.' },
          attempts: [
            {
              phase: 'try',
              fen: '4k3/8/8/4K3/4P3/8/8/8 w - - 0 1',
              prompt: 'move the king onto a key square in front of the pawn.',
              accepted: [
                { from: 'e5', to: 'd6' },
                { from: 'e5', to: 'e6' },
                { from: 'e5', to: 'f6' }
              ],
              success: 'yes. the king has reached a square that supports promotion.',
              wrong: 'move the king two ranks ahead of the pawn.',
              hints: ['the key squares are d6, e6 and f6.']
            },
            {
              phase: 'use',
              fen: '2k5/8/8/2K5/2P5/8/8/8 w - - 0 1',
              prompt: 'reach a key square for the pawn on c4.',
              accepted: [
                { from: 'c5', to: 'b6' },
                { from: 'c5', to: 'c6' },
                { from: 'c5', to: 'd6' }
              ],
              success: 'good. the king is now in the winning zone in front of the pawn.',
              wrong: 'step onto b6, c6 or d6.',
              hints: ['look two ranks ahead of the pawn.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '5k2/8/8/5K2/5P2/8/8/8 w - - 0 1',
              prompt: 'find any key square for the pawn on f4.',
              accepted: [
                { from: 'f5', to: 'e6' },
                { from: 'f5', to: 'f6' },
                { from: 'f5', to: 'g6' }
              ],
              success: 'right. the king is ready to lead the pawn forward.',
              wrong: 'move onto one of the three squares two ranks ahead of the pawn.',
              hints: []
            }
          ]
        },
        {
          id: 'rook-ending-basics',
          title: 'active rooks',
          guided: true,
          intro: 'rooks belong behind passed pawns and on active ranks where they can attack from the side.',
          example: {
            fen: '6k1/8/8/P7/8/8/6K1/7R w - - 0 1',
            prompt: 'put the rook behind its passed pawn.',
            after: 'the rook supports every future step of the pawn from behind.',
            moves: [{ from: 'h1', to: 'a1' }]
          },
          notice: { copy: 'activity comes first in rook endings. a passive rook can turn an extra pawn into nothing.' },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/8/8/P7/8/8/6K1/7R w - - 0 1',
              prompt: 'place the rook behind the white passed pawn.',
              accepted: [{ from: 'h1', to: 'a1' }],
              success: 'yes. the rook supports the pawn without standing in its way.',
              wrong: 'move the rook to the same file, behind the pawn.',
              hints: ['the pawn is on the a-file.', 'move the rook from h1 to a1.']
            },
            {
              phase: 'use',
              fen: '7R/5K2/8/8/8/p7/8/6k1 w - - 0 1',
              prompt: 'get behind the enemy passed pawn before it advances.',
              accepted: [{ from: 'h8', to: 'a8' }],
              success: 'good. the rook can now stop the pawn from behind.',
              wrong: 'put the rook on the enemy pawn’s file.',
              hints: ['the black pawn is on the a-file.', 'move the rook from h8 to a8.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/5ppp/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'activate the rook on the seventh rank and attack the pawns from the side.',
              accepted: [{ from: 'a1', to: 'a7' }],
              success: 'one square better. the rook becomes active and attacks across the seventh rank.',
              wrong: 'move the rook onto the same rank as the black pawns.',
              hints: []
            }
          ]
        },
        {
          id: 'opening-pawn-breaks',
          title: 'opening pawn breaks',
          guided: true,
          intro: 'a closed centre needs a pawn break. attack the base or the head of the opposing pawn chain.',
          example: {
            fen: 'r1bq1rk1/ppp1bppp/2np1n2/4p3/2BPP3/2N1B3/PPP1NPPP/R2QR1K1 w - - 0 8',
            prompt: 'challenge the pawn on e5 with the correct kingside break.',
            after: 'f4 attacks the head of the chain and creates play while the centre stays closed.',
            moves: [{ from: 'f2', to: 'f4' }]
          },
          notice: { copy: 'the structure tells you where to play. closed centres are opened with prepared pawn breaks.' },
          attempts: [
            {
              phase: 'try',
              fen: 'r1bq1rk1/ppp1bppp/2np1n2/4p3/2BPP3/2N1B3/PPP1NPPP/R2QR1K1 w - - 0 8',
              prompt: 'begin the kingside pawn break against e5.',
              accepted: [{ from: 'f2', to: 'f4' }],
              success: 'correct. f4 challenges the locked centre and gains useful space.',
              wrong: 'attack the e5 pawn with its neighbouring pawn.',
              hints: ['the break begins with the f-pawn.', 'move f2 to f4.']
            },
            {
              phase: 'use',
              fen: 'r1bq1rk1/ppp1bppp/4pn2/3pP3/3P4/3N1N2/PPP1BPPP/R1BQ1RK1 w - - 2 8',
              prompt: 'attack the base of black’s pawn chain on d5.',
              accepted: [{ from: 'c2', to: 'c4' }],
              success: 'right. c4 challenges the base that supports the closed centre.',
              wrong: 'use the c-pawn to attack d5.',
              hints: ['the break comes from the c-file.', 'move c2 to c4.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r1bq1rk1/ppp1nppp/2np4/4p3/3PP3/2N1BN2/PPP2PPP/R2Q1RK1 b - - 4 8',
              prompt: 'black to move. find the thematic break against e4.',
              accepted: [{ from: 'f7', to: 'f5' }],
              success: 'one square better. f5 challenges white’s centre before it can advance.',
              wrong: 'attack the e4 pawn with the neighbouring kingside pawn.',
              hints: []
            }
          ]
        },
        {
          id: 'development-lead',
          title: 'use a development lead',
          guided: true,
          intro: 'when your pieces are ready and the opposing king is not, open the centre before they catch up.',
          example: {
            fen: 'rnbqk2r/ppp2ppp/3b1n2/3pp3/4P3/2N2N2/PPPP1PPP/R1BQ1RK1 w kq - 4 6',
            prompt: 'open the centre while black is still uncastled.',
            after: 'd4 challenges the centre immediately and gives the developed pieces open lines.',
            moves: [{ from: 'd2', to: 'd4' }]
          },
          notice: { copy: 'a lead in development is temporary. opening the position turns that lead into concrete activity.' },
          attempts: [
            {
              phase: 'try',
              fen: 'rnbqk2r/ppp2ppp/3b1n2/3pp3/4P3/2N2N2/PPPP1PPP/R1BQ1RK1 w kq - 4 6',
              prompt: 'strike in the centre before black castles.',
              accepted: [{ from: 'd2', to: 'd4' }],
              success: 'correct. d4 opens lines while black’s king remains in the centre.',
              wrong: 'use the central pawn that can challenge e5.',
              hints: ['the d-pawn can move two squares.', 'move d2 to d4.']
            },
            {
              phase: 'use',
              fen: 'r1bqkbnr/ppp2ppp/2n5/3pp3/4P3/2N2N2/PPPP1PPP/R1BQ1RK1 w kq - 4 5',
              prompt: 'white is ahead in development. open the position now.',
              accepted: [{ from: 'd2', to: 'd4' }],
              success: 'right. the central break asks black to solve problems before developing.',
              wrong: 'challenge the black centre with the d-pawn.',
              hints: ['play in the centre immediately.', 'move d2 to d4.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r1bq1rk1/ppp2ppp/2np1n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQ - 4 6',
              prompt: 'black is castled and white is not. open the centre.',
              accepted: [{ from: 'd6', to: 'd5' }],
              success: 'one square better. d5 acts before white can finish development.',
              wrong: 'use the d-pawn to challenge white’s centre.',
              hints: []
            }
          ]
        },
        {
          id: 'meet-a-gambit',
          title: 'meet a gambit',
          guided: true,
          intro: 'when you accept material, return it if necessary to finish development and keep the king safe.',
          example: {
            fen: 'r1bqkbnr/pppp1ppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R b KQkq - 1 4',
            prompt: 'develop instead of trying to hold every extra pawn.',
            after: 'Nf6 develops, attacks e4 and prepares a safe king.',
            moves: [{ from: 'g8', to: 'f6' }]
          },
          notice: { copy: 'the safest response to a gambit is principled development. material matters only if the position survives.' },
          attempts: [
            {
              phase: 'try',
              fen: 'r1bqkbnr/pppp1ppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R b KQkq - 1 4',
              prompt: 'develop a knight, attack e4 and prepare to castle.',
              accepted: [{ from: 'g8', to: 'f6' }],
              success: 'correct. black develops with tempo instead of spending moves defending the pawn.',
              wrong: 'bring the king’s knight towards the centre.',
              hints: ['the knight on g8 has a useful developing square.', 'move g8 to f6.']
            },
            {
              phase: 'use',
              fen: 'rnbqkb1r/ppp1pppp/5n2/8/2pP4/4PN2/PP3PPP/RNBQKB1R b KQkq - 0 4',
              prompt: 'support development and prepare to return the gambit pawn.',
              accepted: [{ from: 'e7', to: 'e6' }],
              success: 'right. e6 opens the bishop and prepares to recover c4 safely.',
              wrong: 'open the dark-squared bishop rather than clinging to c4.',
              hints: ['move the e-pawn one square.', 'move e7 to e6.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'rnbqkbnr/pp1ppppp/8/8/4P3/2p5/PP3PPP/RNBQKBNR w KQkq - 0 4',
              prompt: 'white has sacrificed a pawn. complete development with tempo.',
              accepted: [{ from: 'b1', to: 'c3' }],
              success: 'one square better. Nxc3 develops a piece and restores control of the centre.',
              wrong: 'recapture on c3 with the piece that develops towards the centre.',
              hints: []
            }
          ]
        }
      ];
      
      const deeperIntermediateLessons = [
        pathwayLesson({
          id: 'italian-repertoire',
          title: 'the italian repertoire',
          intro: 'develop naturally, prepare the centre and castle before the position becomes tactical.',
          principle: 'learn the purpose of the move order: c3 supports d4 and castling makes the central break safe.',
          positions: [
            {
              fen: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 4 4',
              prompt: 'prepare to build a two-pawn centre.',
              move: { from: 'c2', to: 'c3' },
              success: 'c3 prepares d4 while giving the bishop a safe retreat.',
              wrong: 'support the d4 break with the c-pawn.'
            },
            {
              fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R w KQkq - 1 5',
              prompt: 'secure the king before opening the centre.',
              move: { from: 'e1', to: 'g1' },
              success: 'castling completes the setup and makes the coming d4 break safer.',
              wrong: 'castle on the kingside.'
            }
          ]
        }),
        pathwayLesson({
          id: 'queens-gambit-repertoire',
          title: 'the queen’s gambit repertoire',
          intro: 'challenge d5 with c4, then develop while keeping pressure on the centre.',
          principle: 'the queen’s gambit offers a wing pawn to weaken black’s central pawn, not for a quick trick.',
          positions: [
            {
              fen: 'rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq d6 0 2',
              prompt: 'challenge black’s d5 pawn from the side.',
              move: { from: 'c2', to: 'c4' },
              success: 'c4 begins the queen’s gambit and questions black’s central support.',
              wrong: 'use the c-pawn to attack d5.'
            },
            {
              fen: 'rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - 2 4',
              prompt: 'develop the bishop outside the pawn chain.',
              move: { from: 'c1', to: 'g5' },
              success: 'Bg5 develops actively before e3 closes the diagonal.',
              wrong: 'place the dark-squared bishop on g5.'
            }
          ]
        }),
        pathwayLesson({
          id: 'build-a-knight-outpost',
          title: 'build a knight outpost',
          intro: 'a protected central square that enemy pawns cannot attack can become a permanent home for a knight.',
          principle: 'identify the outpost first, then improve the knight towards it without creating a new weakness.',
          positions: [
            {
              fen: '6k1/8/3p4/8/8/2N5/8/6K1 w - - 0 1',
              prompt: 'occupy the central square in front of the pawn.',
              move: { from: 'c3', to: 'd5' },
              success: 'Nd5 blocks the pawn and centralises the knight.',
              wrong: 'move the knight to d5.'
            },
            {
              fen: '6k1/2p1p3/8/8/8/4N3/8/6K1 w - - 0 1',
              prompt: 'choose the square neither enemy pawn can challenge.',
              move: { from: 'e3', to: 'd5' },
              success: 'Nd5 is stable because the c- and e-pawns have already moved past the square.',
              wrong: 'place the knight on the protected central outpost.'
            }
          ]
        }),
        pathwayLesson({
          id: 'opposite-wing-attack',
          title: 'attack on the opposite wing',
          intro: 'when the centre is stable, gain space on the wing where you have more room and more pieces.',
          principle: 'a wing attack needs a closed or controlled centre; otherwise the opponent can strike at your king first.',
          positions: [
            {
              fen: '2kr4/ppp3pp/8/4p3/3P2P1/8/PPP4P/2KR4 w - - 0 1',
              prompt: 'gain kingside space and begin opening a file.',
              move: { from: 'g4', to: 'g5' },
              success: 'g5 fixes space and prepares to open lines near the king.',
              wrong: 'advance the g-pawn.'
            },
            {
              fen: '3r2k1/ppp4p/8/3p4/1P2P3/8/P4PPP/3R2K1 w - - 0 1',
              prompt: 'gain queenside space against the fixed centre.',
              move: { from: 'b4', to: 'b5' },
              success: 'b5 gains space and prepares pressure against the queenside pawns.',
              wrong: 'advance the b-pawn.'
            }
          ]
        }),
        pathwayLesson({
          id: 'outside-passed-pawn',
          title: 'create an outside passed pawn',
          intro: 'a passed pawn far from the kings can pull the defender away from the rest of the board.',
          principle: 'push the outside passer when it forces the enemy king to choose between two distant problems.',
          positions: [
            {
              fen: '6k1/8/1p6/8/P7/8/8/6K1 w - - 0 1',
              prompt: 'fix the queenside passer farther from the kings.',
              move: { from: 'a4', to: 'a5' },
              success: 'a5 gains space and keeps the distant pawn as a lasting distraction.',
              wrong: 'advance the outside a-pawn.'
            },
            {
              fen: '6k1/8/6p1/8/7P/8/8/6K1 w - - 0 1',
              prompt: 'gain space with the outside passer.',
              move: { from: 'h4', to: 'h5' },
              success: 'h5 fixes a distant target and can pull the king away later.',
              wrong: 'advance the h-pawn.'
            }
          ]
        }),
        pathwayLesson({
          id: 'knight-blockade',
          title: 'blockade with a knight',
          intro: 'a knight is an excellent blockader because it stays useful while sitting directly in front of a pawn.',
          principle: 'put the knight in front of the passed pawn, then attack the pawn with another piece.',
          positions: [
            {
              fen: '6k1/8/3p4/8/8/2N5/8/6K1 w - - 0 1',
              prompt: 'block the pawn from the front.',
              move: { from: 'c3', to: 'd5' },
              success: 'Nd5 stops the pawn and remains active in the centre.',
              wrong: 'place the knight directly in front of the pawn.'
            },
            {
              fen: '6k1/8/5n2/8/3P4/8/8/6K1 b - - 0 1',
              prompt: 'establish the same blockade with black.',
              move: { from: 'f6', to: 'd5' },
              success: 'Nd5 stops the passed pawn and controls useful central squares.',
              wrong: 'move the knight to d5.'
            }
          ]
        })
      ];
      intermediateExpansionLessons.push(...deeperIntermediateLessons);

      const intermediateExpansionCourses = [
        {
          id: 'opening-decisions',
          title: 'opening decisions',
          track: 'openings',
          openingGroup: 'principles',
          requires: ['beginner:starting-a-game'],
          intro: 'finish development with purpose, manage the centre and enter the middlegame with a plan.',
          lessonIds: [
            'develop-with-purpose',
            'central-tension',
            'opening-to-middlegame',
            'opening-pawn-breaks',
            'development-lead',
            'meet-a-gambit'
          ]
        },
        {
          id: 'positional-play',
          title: 'positional play',
          track: 'middlegames',
          requires: ['intermediate:tactical-vision', 'intermediate:opening-decisions'],
          intro: 'improve pieces, recognise stable squares and choose exchanges for the position in front of you.',
          lessonIds: [
            'worst-placed-piece',
            'weak-squares-outposts',
            'good-exchanges'
          ]
        },
        {
          id: 'practical-endgames',
          title: 'practical endgames',
          track: 'endgames',
          requires: ['beginner:endgames'],
          intro: 'count pawn races, guide pawns with the king and keep rooks active.',
          lessonIds: [
            'pawn-races',
            'key-squares',
            'rook-ending-basics'
          ]
        },
        {
          id: 'repertoire-building',
          title: 'repertoire building',
          track: 'openings',
          openingGroup: 'white',
          requires: ['intermediate:opening-decisions'],
          intro: 'learn a connected white repertoire through the positions and plans it is meant to create.',
          lessonIds: [
            'italian-repertoire',
            'queens-gambit-repertoire'
          ]
        },
        {
          id: 'middlegame-blueprints',
          title: 'middlegame blueprints',
          track: 'middlegames',
          requires: ['intermediate:positional-play'],
          intro: 'turn stable positional features into clear piece placement and wing play.',
          lessonIds: [
            'build-a-knight-outpost',
            'opposite-wing-attack'
          ]
        },
        {
          id: 'minor-piece-endgames',
          title: 'minor-piece endgames',
          track: 'endgames',
          requires: ['intermediate:practical-endgames'],
          intro: 'use distant passers and stable blockades to make an endgame plan that lasts.',
          lessonIds: [
            'outside-passed-pawn',
            'knight-blockade'
          ]
        }
      ];
      
      const advancedLessons = [
        {
          id: 'read-the-imbalances',
          title: 'read the imbalances',
          guided: true,
          intro: 'before choosing a move, compare the open files, weak squares, pawn structure and least active piece.',
          example: {
            fen: '4k2r/ppp1pppp/8/8/8/8/PPP1PPPP/R5K1 w - - 0 1',
            prompt: 'the d-file is the only file without pawns. give the rook that open road.',
            after: 'the rook reaches d1 and can enter the position without a pawn blocking it.',
            moves: [{ from: 'a1', to: 'd1' }]
          },
          notice: {
            copy: 'an imbalance is a lasting difference. make your plan around the difference you can use.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '4k2r/ppp1pppp/8/8/8/8/PPP1PPPP/2R3K1 w - - 0 1',
              prompt: 'find the open file and place the rook on it.',
              accepted: [{ from: 'c1', to: 'd1' }],
              success: 'good. the rook now owns the only fully open file.',
              wrong: 'look for the file with no white pawn and no black pawn.',
              hints: [
                'the d-file is empty.',
                'move the rook from c1 to d1.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/pp3ppp/3p4/8/8/2N5/PP3PPP/6K1 w - - 0 1',
              prompt: 'black has no c-pawn or e-pawn. put the knight on a central square that no pawn can chase.',
              accepted: [{ from: 'c3', to: 'd5' }],
              success: 'right. the knight has reached a lasting outpost that no black pawn can chase.',
              wrong: 'use the hole between the missing c-pawn and e-pawn.',
              hints: [
                'the outpost is d5.',
                'move the knight from c3 to d5.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/ppp2ppp/8/8/8/8/PPP2PPP/RN4K1 w - - 0 1',
              prompt: 'the rook is active enough. improve the least active piece.',
              accepted: [{ from: 'b1', to: 'c3' }, { from: 'b1', to: 'd2' }],
              success: 'one square better. the undeveloped knight has joined the game.',
              wrong: 'find the piece still standing on its starting square with no useful role.',
              hints: []
            }
          ]
        },
        {
          id: 'pawn-structure-transformations',
          title: 'change the pawn structure',
          guided: true,
          intro: 'a pawn move can change the whole board. use a break to create a passed pawn, open a line or change the centre.',
          example: {
            fen: '7k/ppp5/8/PPP5/8/8/8/7K w - - 0 1',
            prompt: 'sacrifice the middle pawn so one outside pawn can pass.',
            after: 'after black takes on b6, the other pawn recaptures and becomes passed.',
            moves: [
              { from: 'b5', to: 'b6' },
              { from: 'a7', to: 'b6' },
              { from: 'c5', to: 'b6' }
            ]
          },
          notice: {
            copy: 'do not judge a pawn move only by the pawn it loses. judge the structure it leaves behind.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '7k/5ppp/8/5PPP/8/8/8/K7 w - - 0 1',
              prompt: 'find the breakthrough that creates a passed-pawn threat.',
              accepted: [{ from: 'g5', to: 'g6' }],
              success: 'yes. if either pawn captures, the pawn on the other side recaptures and passes.',
              wrong: 'offer the middle pawn first.',
              hints: [
                'the middle pawn is on g5.',
                'push g5 to g6.'
              ]
            },
            {
              phase: 'use',
              fen: '7k/8/p7/8/PP6/8/8/7K w - - 0 1',
              prompt: 'offer an exchange that can leave one outside passed pawn.',
              accepted: [{ from: 'b4', to: 'b5' }],
              success: 'good. if the a-pawn captures, your a-pawn recaptures and passes.',
              wrong: 'use the pawn farther from the edge to offer the exchange.',
              hints: [
                'push the b-pawn.',
                'move b4 to b5.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/5p2/3p4/3Pp3/4P3/8/5P2/6K1 w - - 0 1',
              prompt: 'break the locked centre before black can settle.',
              accepted: [{ from: 'f2', to: 'f4' }],
              success: 'one square better. the pawn break challenges e5 and changes the centre.',
              wrong: 'attack the base of black’s central chain with a pawn.',
              hints: []
            }
          ]
        },
        {
          id: 'prophylaxis',
          title: 'prophylaxis',
          guided: true,
          intro: 'before carrying out your plan, ask what your opponent wants next and remove its force.',
          example: {
            fen: '6k1/8/8/8/8/8/4rPPP/R5K1 w - - 0 1',
            prompt: 'black wants a back-rank check. make an escape square first.',
            after: 'the h-pawn moves and h2 becomes a safe route for the king.',
            moves: [{ from: 'h2', to: 'h3' }]
          },
          notice: {
            copy: 'prophylaxis is not passive. one small prevention can make your own plan safe to begin.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/8/8/8/8/8/4rPPP/6K1 w - - 0 1',
              prompt: 'give the king room before the rook reaches the back rank.',
              accepted: [{ from: 'h2', to: 'h3' }],
              success: 'right. h2 is now available after a back-rank check.',
              wrong: 'move one pawn without weakening the f-pawn or g-pawn.',
              hints: [
                'make room beside the king.',
                'move h2 to h3.'
              ]
            },
            {
              phase: 'use',
              fen: '2b3k1/8/8/8/8/5N2/7P/3Q2K1 w - - 0 1',
              prompt: 'black wants to pin the knight to the queen. prepare to challenge a bishop on g4.',
              accepted: [{ from: 'h2', to: 'h3' }],
              success: 'good. the h-pawn now challenges a bishop that comes to g4.',
              wrong: 'control g4 before continuing your own plan.',
              hints: [
                'the h-pawn can control g4.',
                'move h2 to h3.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6k1/8/8/8/7q/8/5PPP/6K1 w - - 0 1',
              prompt: 'black threatens to enter beside the king. gain time by attacking the queen.',
              accepted: [{ from: 'g2', to: 'g3' }],
              success: 'one square better. the threat is stopped with tempo on the queen.',
              wrong: 'use a pawn move that attacks the queen on h4.',
              hints: []
            }
          ]
        },
        {
          id: 'isolated-queen-pawn',
          title: 'the isolated queen pawn',
          guided: true,
          intro: 'an isolated queen pawn has no friendly pawn on either neighbouring file. it can become weak later, so use its space and central break while pieces remain active.',
          example: {
            fen: 'r1bq1rk1/pp2bppp/2n1pn2/8/3P4/2N1PN2/PP2BPPP/R1BQ1RK1 w - - 0 1',
            prompt: 'white has an isolated pawn on d4. use its dynamic break before black blockades it.',
            after: 'd5 gains space, opens lines and makes the isolated pawn an active strength.',
            moves: [{ from: 'd4', to: 'd5' }]
          },
          notice: {
            copy: 'the isolated pawn is a weakness only when the opponent can attack it safely. activity comes first.'
          },
          attempts: [
            {
              phase: 'try',
              fen: 'r1bq1rk1/pp2bppp/2n1pn2/8/3P4/2N1PN2/PP2BPPP/R1BQ1RK1 w - - 0 1',
              prompt: 'play the thematic pawn break.',
              accepted: [{ from: 'd4', to: 'd5' }],
              success: 'the break gains time and opens the centre for the active pieces.',
              wrong: 'use the isolated pawn before black can fix it in place.',
              hints: [
                'the key break is on the d-file.',
                'move the pawn from d4 to d5.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/pp3ppp/2n1pn2/8/3P4/2N1PN2/PP3PPP/6K1 w - - 0 1',
              prompt: 'the pawn also gives your pieces useful outposts. occupy one.',
              accepted: [{ from: 'c3', to: 'e4' }, { from: 'c3', to: 'b5' }],
              success: 'the knight uses a square created by the pawn structure instead of defending passively.',
              wrong: 'improve the knight with tempo and keep the position active.',
              hints: [
                'look for an advanced square the knight can reach now.',
                'move the knight from c3 to e4 or b5.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r3r1k1/pp1b1ppp/2n1pn2/q7/3P4/2N1PN2/PPQ1BPPP/R2R2K1 w - - 0 1',
              prompt: 'black is increasing pressure on d4. change the position before the blockade arrives.',
              accepted: [{ from: 'd4', to: 'd5' }],
              success: 'one square better. you used the pawn’s energy instead of waiting to defend it.',
              wrong: 'the central break is more active than another defensive move.',
              hints: []
            }
          ]
        },
        {
          id: 'hanging-pawns',
          title: 'hanging pawns',
          guided: true,
          intro: 'hanging pawns stand side by side with no neighbouring pawn support. together they control space; one timely push can create a passed pawn or open lines.',
          example: {
            fen: '6k1/pp3ppp/2n1pn2/8/2PP4/2N1PN2/PP3PPP/6K1 w - - 0 1',
            prompt: 'the c4 and d4 pawns are strongest while they can advance together.',
            after: 'd5 gains space and threatens to drive the knight away.',
            moves: [{ from: 'd4', to: 'd5' }]
          },
          notice: {
            copy: 'do not push automatically. advance when the move gains space, time or a passed pawn.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/pp3ppp/2n1pn2/8/2PP4/2N1PN2/PP3PPP/6K1 w - - 0 1',
              prompt: 'gain space and hit the knight on c6.',
              accepted: [{ from: 'd4', to: 'd5' }],
              success: 'the pawn advances with tempo, so black has less time to attack the pair.',
              wrong: 'find the pawn push that attacks a developed piece.',
              hints: [
                'the d-pawn can gain a tempo on the knight.',
                'move d4 to d5.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/pp3ppp/3npn2/8/2PP4/2N1PN2/PP3PPP/6K1 w - - 0 1',
              prompt: 'the knight moved to d6. use the other pawn to gain space.',
              accepted: [{ from: 'c4', to: 'c5' }],
              success: 'the c-pawn takes space and fixes queenside targets.',
              wrong: 'the c-pawn can advance without abandoning the whole centre.',
              hints: [
                'use the pawn on c4.',
                'move c4 to c5.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '2r3k1/pp3ppp/2n1pn2/8/2PP4/2N1PN2/PP3PPP/2R3K1 w - - 0 1',
              prompt: 'black has placed a rook opposite c4. advance with tempo before the pawns become fixed targets.',
              accepted: [{ from: 'd4', to: 'd5' }],
              success: 'one square better. activity makes the structure work.',
              wrong: 'create a threat with the central pawn before defending passively.',
              hints: []
            }
          ]
        },
        {
          id: 'minority-attack',
          title: 'the minority attack',
          guided: true,
          intro: 'a pawn minority can advance against a larger pawn group to create a fixed weakness. the goal is a target, not a race to promote.',
          example: {
            fen: 'r2q1rk1/pp1bbppp/2p1pn2/3p4/3P4/2PBPN2/PP1N1PPP/R1BQR1K1 w - - 0 1',
            prompt: 'white has two queenside pawns against black’s three. begin the attack with the b-pawn.',
            after: 'b4 prepares b5, where the pawn can challenge c6 and leave a weak pawn behind.',
            moves: [{ from: 'b2', to: 'b4' }]
          },
          notice: {
            copy: 'the minority attack succeeds when the opponent is left with a pawn that cannot be defended by another pawn.'
          },
          attempts: [
            {
              phase: 'try',
              fen: 'r2q1rk1/pp1bbppp/2p1pn2/3p4/3P4/2PBPN2/PP1N1PPP/R1BQR1K1 w - - 0 1',
              prompt: 'start the standard queenside plan.',
              accepted: [{ from: 'b2', to: 'b4' }],
              success: 'the b-pawn leads because it can challenge the base on c6.',
              wrong: 'advance the pawn that can reach b5 and attack c6.',
              hints: [
                'begin with the b-pawn.',
                'move b2 to b4.'
              ]
            },
            {
              phase: 'use',
              fen: 'r2q1rk1/pp1bbppp/2p1pn2/3p4/1P1P4/2PBPN2/P2N1PPP/R1BQR1K1 w - - 0 1',
              prompt: 'the pawn has reached b4. make contact with black’s pawn chain.',
              accepted: [{ from: 'b4', to: 'b5' }],
              success: 'b5 forces black to decide how the queenside structure will break.',
              wrong: 'continue the same pawn until it challenges c6.',
              hints: [
                'the target is the c6-pawn.',
                'move b4 to b5.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r2q1rk1/1p1bbppp/p1p1pn2/3p4/1P1P4/2PBPN2/P2N1PPP/R1BQR1K1 w - - 0 1',
              prompt: 'black has played a6. create the queenside target before black reorganises.',
              accepted: [{ from: 'b4', to: 'b5' }],
              success: 'one square better. the smaller pawn group has created a concrete weakness to attack.',
              wrong: 'make contact with the c6-pawn now.',
              hints: []
            }
          ]
        },
        {
          id: 'calculate-the-branches',
          title: 'calculate the branches',
          guided: true,
          intro: 'start with forcing moves, list the opponent’s serious replies, and follow each branch until the position becomes quiet.',
          example: {
            fen: '3q2k1/5ppp/8/8/Q7/8/8/4R1K1 w - - 0 1',
            prompt: 'calculate the check, black’s forced capture, and the final move before playing.',
            after: 'rook to e8 forces the queen to take. the white queen then takes on e8 with checkmate.',
            moves: [
              { from: 'e1', to: 'e8' },
              { from: 'd8', to: 'e8' },
              { from: 'a4', to: 'e8' }
            ]
          },
          notice: {
            copy: 'a line is not calculated when you have seen only your own idea. include the opponent’s best reply.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '1k2q3/ppp5/8/8/7Q/8/8/3R2K1 w - - 0 1',
              prompt: 'find the forcing first move. the queen must answer, then your queen finishes.',
              accepted: [{ from: 'd1', to: 'd8' }],
              success: 'yes. rook to d8 forces queen takes d8, then queen takes d8 mate.',
              wrong: 'begin with the rook check on the back rank.',
              hints: [
                'the rook can reach d8 with check.',
                'calculate rook d8, queen takes d8, queen takes d8.'
              ]
            },
            {
              phase: 'use',
              fen: '5r1k/6pp/4Q2N/8/8/8/8/6K1 w - - 0 1',
              prompt: 'calculate the sacrifice, the forced rook capture, and the knight’s finish.',
              accepted: [{ from: 'e6', to: 'g8' }],
              success: 'good. the rook is drawn to g8 and the knight then reaches f7 with mate.',
              wrong: 'force the rook onto the square the knight protects.',
              hints: [
                'offer the queen on g8.',
                'queen to g8 check is the first move.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '3q2k1/5ppp/8/r7/8/8/3B4/4R1K1 w - - 0 1',
              prompt: 'calculate the check, the forced reply, and the loose rook left behind.',
              accepted: [{ from: 'e1', to: 'e8' }],
              success: 'one square better. the queen must answer on e8, leaving the rook on a5 for the bishop.',
              wrong: 'use a rook check to force the queen away from its second job.',
              hints: []
            }
          ]
        },
        {
          id: 'move-order',
          title: 'move order',
          guided: true,
          intro: 'when two good moves are available, play the one that forces a reply before the opponent can escape.',
          example: {
            fen: '1k6/r7/8/3q4/2P5/4B3/8/R5K1 w - - 0 1',
            prompt: 'the pawn can take the queen, but the bishop can first take a rook with check.',
            after: 'the king must answer the bishop check. the pawn still takes the queen afterwards.',
            moves: [
              { from: 'e3', to: 'a7' },
              { from: 'b8', to: 'c8' },
              { from: 'c4', to: 'd5' }
            ]
          },
          notice: {
            copy: 'a forcing move can preserve the move you already wanted. always check for the in-between move first.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '6k1/7r/8/3q4/2P5/8/2B5/6KR w - - 0 1',
              prompt: 'before the pawn takes the queen, win the rook with check.',
              accepted: [{ from: 'c2', to: 'h7' }],
              success: 'right. the king must move, and the queen on d5 still falls.',
              wrong: 'take the rook with the bishop before taking the queen.',
              hints: [
                'the bishop capture on h7 is check.',
                'move the bishop from c2 to h7.'
              ]
            },
            {
              phase: 'use',
              fen: '6k1/5r2/8/1q6/P1B5/8/8/5RK1 w - - 0 1',
              prompt: 'win the rook with tempo before the a-pawn takes the queen.',
              accepted: [{ from: 'c4', to: 'f7' }],
              success: 'good. the bishop check wins a rook without giving up the queen capture.',
              wrong: 'find the bishop capture that comes with check.',
              hints: [
                'the rook is on f7.',
                'bishop c4 takes f7 with check.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '1k6/2r5/8/5q2/5BP1/8/8/2R3K1 w - - 0 1',
              prompt: 'do not take the queen yet. improve the move order and win both targets.',
              accepted: [{ from: 'f4', to: 'c7' }],
              success: 'one square better. check wins the rook first; the pawn still takes the queen.',
              wrong: 'look for a bishop capture with check before the pawn capture.',
              hints: []
            }
          ]
        },
        {
          id: 'evaluate-the-result',
          title: 'evaluate the result',
          guided: true,
          intro: 'finish the calculation by comparing material, king safety, pawn structure and activity in the position that remains.',
          example: {
            fen: '3q4/4k3/8/8/8/8/3Q4/R5K1 w - - 0 1',
            prompt: 'trade queens because the position left behind contains an extra rook.',
            after: 'both queens disappear. the remaining rook makes the final position winning.',
            moves: [
              { from: 'd2', to: 'd8' },
              { from: 'e7', to: 'd8' }
            ]
          },
          notice: {
            copy: 'do not stop at “the trades are equal.” name what remains and decide who benefits from it.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '4q3/5k2/8/8/8/8/4Q3/6KR w - - 0 1',
              prompt: 'offer the queen trade because you keep the only rook if black accepts.',
              accepted: [{ from: 'e2', to: 'e8' }],
              success: 'yes. if the king recaptures, the extra rook decides the ending.',
              wrong: 'exchange queens on e8 and compare what remains.',
              hints: [
                'your rook on h1 survives the exchange.',
                'queen e2 takes e8.'
              ]
            },
            {
              phase: 'use',
              fen: 'rk6/8/8/7P/8/8/8/R5K1 w - - 0 1',
              prompt: 'offer the rook trade and judge the king-and-pawn ending if black accepts.',
              accepted: [{ from: 'a1', to: 'a8' }],
              success: 'good. if the king recaptures, black is far from the outside passed pawn.',
              wrong: 'remove the only rook that can stop the h-pawn from the side.',
              hints: [
                'trade rooks on a8.',
                'rook a1 takes a8 with check.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '8/1qk5/8/8/8/8/1Q6/6KR w - - 0 1',
              prompt: 'offer the queen trade that leaves your rook on the board if black accepts.',
              accepted: [{ from: 'b2', to: 'b7' }],
              success: 'one square better. if black accepts, the queens leave and your rook remains.',
              wrong: 'offer the queen trade on b7, then evaluate the material that would remain.',
              hints: []
            }
          ]
        },
        {
          id: 'active-rook',
          title: 'the active rook',
          guided: true,
          intro: 'in rook endings, activity comes first. put the rook behind a passed pawn or use it to cut off the king.',
          example: {
            fen: '8/4k3/8/7P/8/8/6K1/R7 w - - 0 1',
            prompt: 'place the rook behind your passed pawn before pushing it.',
            after: 'the rook supports every step of the h-pawn from behind.',
            moves: [{ from: 'a1', to: 'h1' }]
          },
          notice: {
            copy: 'a rook behind a passed pawn stays useful as the pawn advances.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '8/4k3/8/6P1/8/8/5K2/R7 w - - 0 1',
              prompt: 'support the passed pawn from behind.',
              accepted: [{ from: 'a1', to: 'g1' }],
              success: 'right. the rook and pawn now move in the same direction.',
              wrong: 'put the rook on the pawn’s file, behind the pawn.',
              hints: [
                'the pawn is on the g-file.',
                'move the rook from a1 to g1.'
              ]
            },
            {
              phase: 'use',
              fen: '8/6k1/8/4P3/4K3/8/8/R7 w - - 0 1',
              prompt: 'cut the black king away from your king and pawn.',
              accepted: [{ from: 'a1', to: 'f1' }],
              success: 'good. the rook controls the f-file and restricts the king.',
              wrong: 'use the file between the black king and the e-pawn.',
              hints: [
                'the cutting file is the f-file.',
                'move the rook from a1 to f1.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '8/6k1/8/R7/3p4/8/6K1/8 w - - 0 1',
              prompt: 'get behind the enemy passed pawn before it advances.',
              accepted: [{ from: 'a5', to: 'd5' }],
              success: 'one square better. the rook now follows the pawn from behind.',
              wrong: 'place the rook on the pawn’s file, on the side it came from.',
              hints: []
            }
          ]
        },
        {
          id: 'lucena-position',
          title: 'the lucena position',
          guided: true,
          intro: 'when your king reaches the promotion square, move the rook to the fourth rank and build a bridge against side checks.',
          example: {
            fen: '2K5/2P1k3/8/8/8/8/7r/3R4 w - - 0 1',
            prompt: 'prepare the bridge before the defending rook starts checking.',
            after: 'the rook reaches the fourth rank, ready to block a side check later.',
            moves: [{ from: 'd1', to: 'd4' }]
          },
          notice: {
            copy: 'king in front, pawn on the seventh, rook to the fourth: that is the bridge-building pattern.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '2K5/2P1k3/8/8/8/8/7r/3R4 w - - 0 1',
              prompt: 'build the bridge on the fourth rank.',
              accepted: [{ from: 'd1', to: 'd4' }],
              success: 'yes. the rook is ready to shield the king from a side check.',
              wrong: 'lift the rook three squares while keeping it beside the pawn.',
              hints: [
                'the bridge square is d4.',
                'move the rook from d1 to d4.'
              ]
            },
            {
              phase: 'use',
              fen: '5K2/3k1P2/8/8/8/8/r7/4R3 w - - 0 1',
              prompt: 'find the same bridge-building move beside the f-pawn.',
              accepted: [{ from: 'e1', to: 'e4' }],
              success: 'good. the rook reaches the fourth rank and can cover the king.',
              wrong: 'use the fourth-rank lift beside the pawn.',
              hints: [
                'the rook stays on the e-file.',
                'move e1 to e4.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '1K6/1P1k4/8/8/8/8/7r/2R5 w - - 0 1',
              prompt: 'prepare the bridge in this mirrored lucena position.',
              accepted: [{ from: 'c1', to: 'c4' }],
              success: 'one square better. the rook is on the fourth rank, ready to block checks.',
              wrong: 'lift the rook on the c-file to the fourth rank.',
              hints: []
            }
          ]
        },
        {
          id: 'philidor-defence',
          title: 'the philidor defence',
          guided: true,
          intro: 'against a rook and pawn, keep the king in front and place the rook on the defender’s third rank.',
          example: {
            fen: 'r7/4k3/8/4K3/4P3/8/8/7R b - - 0 1',
            prompt: 'move the defending rook to the rank that keeps the king from advancing.',
            after: 'the rook controls the sixth rank. when the pawn advances, the rook can switch to checks from behind.',
            moves: [{ from: 'a8', to: 'a6' }]
          },
          notice: {
            copy: 'king in front, rook on the third rank, then checks from behind after the pawn advances.'
          },
          attempts: [
            {
              phase: 'try',
              fen: '7r/3k4/8/3K4/3P4/8/8/R7 b - - 0 1',
              prompt: 'set up the third-rank defence before the attacking king advances.',
              accepted: [{ from: 'h8', to: 'h6' }],
              success: 'right. the rook now keeps the king off the sixth rank.',
              wrong: 'place the rook on the defender’s third rank — the sixth rank on the board.',
              hints: [
                'the defending rook belongs on h6.',
                'move h8 to h6.'
              ]
            },
            {
              phase: 'use',
              fen: '1r6/5k2/8/5K2/5P2/8/8/R7 b - - 0 1',
              prompt: 'build the same defensive barrier against the f-pawn.',
              accepted: [{ from: 'b8', to: 'b6' }],
              success: 'good. the rook controls the sixth rank and denies the king progress.',
              wrong: 'bring the rook down to the sixth rank.',
              hints: [
                'keep the rook on the b-file.',
                'move b8 to b6.'
              ]
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: '6r1/2k5/8/2K5/2P5/8/8/R7 b - - 0 1',
              prompt: 'complete the philidor setup before white improves the king.',
              accepted: [{ from: 'g8', to: 'g6' }],
              success: 'one square better. the rook has built the third-rank barrier.',
              wrong: 'move the rook to the rank that cuts off the attacking king.',
              hints: []
            }
          ]
        },
        {
          id: 'move-order-discipline',
          title: 'move-order discipline',
          guided: true,
          intro: 'the right idea at the wrong moment can allow counterplay. remove the opponent’s resource before committing your plan.',
          example: {
            fen: 'r1bqk2r/ppp1bppp/2np1n2/4p3/4P3/2NP1N2/PPP1BPPP/R1BQ1RK1 w kq - 4 7',
            prompt: 'before developing the bishop to e3, stop the knight jump to g4.',
            after: 'h3 removes ...Ng4, so the next developing move can be played without interruption.',
            moves: [{ from: 'h2', to: 'h3' }]
          },
          notice: { copy: 'move order is resource control. ask what the opponent can do between the moves of your plan.' },
          attempts: [
            {
              phase: 'try',
              fen: 'r1bqk2r/ppp1bppp/2np1n2/4p3/4P3/2NP1N2/PPP1BPPP/R1BQ1RK1 w kq - 4 7',
              prompt: 'take away ...Ng4 before placing the bishop on e3.',
              accepted: [{ from: 'h2', to: 'h3' }],
              success: 'correct. h3 makes the intended development stable.',
              wrong: 'remove the g4 square from the black knight.',
              hints: ['use the h-pawn.', 'move h2 to h3.']
            },
            {
              phase: 'use',
              fen: 'rnbqk2r/pp2bppp/2pp1n2/4p3/4P3/2NP1N2/PPP1BPPP/R1BQK2R b KQkq - 2 6',
              prompt: 'prepare ...b5 without allowing a piece to settle on b5 first.',
              accepted: [{ from: 'a7', to: 'a6' }],
              success: 'right. a6 controls b5 and prepares the queenside expansion.',
              wrong: 'use the a-pawn to prepare the b-pawn advance.',
              hints: ['control b5 first.', 'move a7 to a6.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r1bq1rk1/ppp1bppp/2np1n2/4p3/4P3/2NP1N2/PPP1BPPP/R1BQ1RK1 w - - 5 8',
              prompt: 'prepare Bb2 while keeping the c-pawn free for a later break.',
              accepted: [{ from: 'b2', to: 'b3' }],
              success: 'one square better. b3 prepares the bishop without blocking the c-pawn.',
              wrong: 'prepare the long diagonal with the b-pawn.',
              hints: []
            }
          ]
        },
        {
          id: 'initiative-over-material',
          title: 'initiative over material',
          guided: true,
          intro: 'a temporary material investment is justified when every move arrives with tempo and the opposing king cannot settle.',
          example: {
            fen: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 4 4',
            prompt: 'offer a pawn to gain time against the bishop and open lines.',
            after: 'b4 forces the bishop to decide and offers rapid development as compensation.',
            moves: [{ from: 'b2', to: 'b4' }]
          },
          notice: { copy: 'compensation must be concrete: development, open lines, exposed king or forcing moves.' },
          attempts: [
            {
              phase: 'try',
              fen: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 4 4',
              prompt: 'gain time against the bishop and offer the thematic pawn.',
              accepted: [{ from: 'b2', to: 'b4' }],
              success: 'correct. b4 exchanges a pawn for time and open lines.',
              wrong: 'attack the bishop with the b-pawn.',
              hints: ['the queenside pawn can gain a tempo.', 'move b2 to b4.']
            },
            {
              phase: 'use',
              fen: 'r1bqkb1r/ppp2ppp/2n5/3nP1N1/2B5/8/PPPP1PPP/RNBQK2R w KQkq - 0 6',
              prompt: 'use the exposed king and fork the heavy pieces.',
              accepted: [{ from: 'g5', to: 'f7' }],
              success: 'right. Nxf7 attacks the queen and rook while the king remains in the centre.',
              wrong: 'look for the forcing knight jump on f7.',
              hints: ['the target is beside the king.', 'move g5 to f7.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'r1bqk2r/ppp2ppp/2np1n2/8/2B1P3/2N2N2/PPP2PPP/R1BQR1K1 w kq - 0 8',
              prompt: 'gain a tempo on the knight before black secures the king.',
              accepted: [{ from: 'e4', to: 'e5' }],
              success: 'one square better. e5 drives the knight and keeps the initiative moving.',
              wrong: 'advance the central pawn with tempo on f6.',
              hints: []
            }
          ]
        },
        {
          id: 'opening-transpositions',
          title: 'opening transpositions',
          guided: true,
          intro: 'the same position can be reached through different move orders. choose flexible moves that preserve the structures you want.',
          example: {
            fen: 'rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - 2 3',
            prompt: 'develop without allowing ...Bb4 to pin the queen’s knight.',
            after: 'Nf3 keeps Catalan and queen’s-gambit structures available without committing Nc3.',
            moves: [{ from: 'g1', to: 'f3' }]
          },
          notice: { copy: 'transposition awareness is choice awareness. know which future positions each flexible move keeps available.' },
          attempts: [
            {
              phase: 'try',
              fen: 'rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - 2 3',
              prompt: 'keep several queen’s-pawn systems available while developing.',
              accepted: [{ from: 'g1', to: 'f3' }],
              success: 'correct. Nf3 develops while preserving multiple structures.',
              wrong: 'develop the king’s knight before committing the queen’s knight.',
              hints: ['use the knight on g1.', 'move g1 to f3.']
            },
            {
              phase: 'use',
              fen: 'r1bqkbnr/pp2pppp/2n5/2pp4/8/5NP1/PPPPPPBP/RNBQK2R w KQkq - 2 4',
              prompt: 'transpose from a flank opening into a central queen’s-pawn structure.',
              accepted: [{ from: 'd2', to: 'd4' }],
              success: 'right. d4 claims the centre and reaches familiar queen’s-pawn territory.',
              wrong: 'occupy the centre with the d-pawn.',
              hints: ['the flexible flank setup can now become central.', 'move d2 to d4.']
            },
            {
              phase: 'independent',
              allowHint: false,
              fen: 'rnbqkb1r/pppp1ppp/4pn2/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - 0 3',
              prompt: 'use a check to enter a Nimzo/Bogo-style structure before committing the centre.',
              accepted: [{ from: 'f8', to: 'b4' }],
              success: 'one square better. Bb4+ develops with tempo and keeps several transpositions available.',
              wrong: 'develop the king’s bishop with check on b4.',
              hints: []
            }
          ]
        }
      ];
      
      const deeperAdvancedLessons = [
        pathwayLesson({
          id: 'repertoire-tabiya',
          title: 'build around a tabiya',
          intro: 'a tabiya is the position your repertoire is designed to reach: study its plans, not only the route into it.',
          principle: 'prepare the first middlegame decision in every main position of your repertoire.',
          positions: [
            {
              fen: 'rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - 0 6',
              prompt: 'develop flexibly in the open sicilian structure.',
              move: { from: 'c1', to: 'e3' },
              success: 'Be3 develops, supports the centre and keeps several attacking setups available.',
              wrong: 'develop the dark-squared bishop to e3.'
            },
            {
              fen: 'r1bqk2r/ppp1bppp/2n1pn2/3p4/2PP4/2N1PN2/PP1B1PPP/R2QKB1R w KQkq - 4 7',
              prompt: 'place the rook on the file that will open after central exchanges.',
              move: { from: 'a1', to: 'c1' },
              success: 'Rac1 prepares pressure on the c-file before the centre changes.',
              wrong: 'move the a-rook to c1.'
            }
          ]
        }),
        pathwayLesson({
          id: 'repertoire-sideline',
          title: 'answer the sideline',
          intro: 'a repertoire is resilient when it gives you a principled response to common sidelines without demanding endless memorisation.',
          principle: 'against an offbeat setup, claim the centre and reach structures you already understand.',
          positions: [
            {
              fen: 'rnbqkb1r/ppp1pppp/5n2/3p4/3P1B2/5N2/PPP1PPPP/RN1QKB1R b KQkq - 2 3',
              prompt: 'challenge the London setup before white builds it comfortably.',
              move: { from: 'c7', to: 'c5' },
              success: 'c5 immediately questions d4 and creates active queen-side play.',
              wrong: 'strike at d4 with the c-pawn.'
            },
            {
              fen: 'rnbqkbnr/pp1ppppp/8/2p5/4P3/2P5/PP1P1PPP/RNBQKBNR b KQkq - 0 2',
              prompt: 'meet the Alapin by occupying the centre now.',
              move: { from: 'd7', to: 'd5' },
              success: 'd5 uses the moment before white can build an uncontested centre.',
              wrong: 'push the queen pawn two squares.'
            }
          ]
        }),
        pathwayLesson({
          id: 'exchange-for-initiative',
          title: 'exchange for the initiative',
          intro: 'material is one feature of a position. an exchange can be justified when the resulting activity is immediate and concrete.',
          principle: 'before giving material, name the forcing continuation and the position you expect when it ends.',
          positions: [
            {
              fen: '2r3k1/8/8/8/8/2N5/1P6/2K5 b - - 0 1',
              prompt: 'remove the central knight and create a passed pawn after the recapture.',
              move: { from: 'c8', to: 'c3' },
              success: 'Rxc3 gives material to transform the position and activate the queenside pawn majority.',
              wrong: 'capture the knight with the rook.'
            },
            {
              fen: '6k1/5npp/8/8/8/8/6PP/5RK1 w - - 0 1',
              prompt: 'remove the key defender and enter the seventh rank.',
              move: { from: 'f1', to: 'f7' },
              success: 'Rxf7 removes the defender and creates immediate activity around the king.',
              wrong: 'capture the knight on f7.'
            }
          ]
        }),
        pathwayLesson({
          id: 'defensive-simplification',
          title: 'simplify the defence',
          intro: 'when under pressure, exchanging the attacker’s most powerful piece can remove the danger even if the ending is still demanding.',
          principle: 'simplify the source of the threat, not every piece automatically.',
          positions: [
            {
              fen: '4q1k1/8/8/8/8/8/8/4Q1K1 w - - 0 1',
              prompt: 'remove the attacking queens and make the position easier to hold.',
              move: { from: 'e1', to: 'e8' },
              success: 'Qxe8+ forces the queen trade and ends the direct attack.',
              wrong: 'exchange queens on e8.'
            },
            {
              fen: '3q2k1/8/8/8/8/8/8/3Q2K1 b - - 0 1',
              prompt: 'black can remove the only attacking piece.',
              move: { from: 'd8', to: 'd1' },
              success: 'Qxd1+ trades queens and converts the position into a calmer ending.',
              wrong: 'capture the queen on d1.'
            }
          ]
        }),
        pathwayLesson({
          id: 'rook-side-checks',
          title: 'check from the side',
          intro: 'in rook endings, checking from the side keeps distance from the king and can stop a pawn without passive defence.',
          principle: 'leave enough files between the rook and king so the checks cannot be blocked or attacked at once.',
          positions: [
            {
              fen: '6k1/8/8/8/8/8/8/R5K1 w - - 0 1',
              prompt: 'give a distant check along the eighth rank.',
              move: { from: 'a1', to: 'a8' },
              success: 'Ra8+ checks from maximum distance and keeps the rook active.',
              wrong: 'move the rook to a8.'
            },
            {
              fen: 'k6r/8/8/8/8/8/8/1K6 b - - 0 1',
              prompt: 'mirror the same side-check technique.',
              move: { from: 'h8', to: 'h1' },
              success: 'Rh1+ checks across the first rank while staying far from the king.',
              wrong: 'move the rook to h1.'
            }
          ]
        }),
        pathwayLesson({
          id: 'opposite-bishop-fortress',
          title: 'build the opposite-bishop fortress',
          intro: 'opposite-coloured bishops often make defence possible because the attacking bishop cannot control the defender’s colour complex.',
          principle: 'place the king on the promotion colour and refuse to abandon the blockade.',
          positions: [
            {
              fen: '8/8/8/2b5/6k1/8/6Kp/8 w - - 0 1',
              prompt: 'occupy the corner in front of the pawn.',
              move: { from: 'g2', to: 'h1' },
              success: 'Kh1 blocks the pawn on a square the bishop cannot control.',
              wrong: 'move the king into the h1 corner.'
            },
            {
              fen: '8/8/8/5b2/6k1/8/pK6/8 w - - 0 1',
              prompt: 'build the mirrored corner blockade.',
              move: { from: 'b2', to: 'a1' },
              success: 'Ka1 creates the fortress because the bishop cannot drive the king from the corner.',
              wrong: 'move the king to a1.'
            }
          ]
        })
      ];
      advancedLessons.push(...deeperAdvancedLessons);

      const advancedCourses = [
        {
          id: 'advanced-opening-strategy',
          title: 'advanced opening strategy',
          track: 'openings',
          openingGroup: 'principles',
          requires: ['intermediate:opening-decisions', 'intermediate:tactical-vision'],
          intro: 'use move order, initiative and transpositions to shape the middlegame before it begins.',
          lessonIds: [
            'move-order-discipline',
            'initiative-over-material',
            'opening-transpositions'
          ]
        },
        {
          id: 'strategic-planning',
          title: 'strategic planning',
          track: 'middlegames',
          requires: ['intermediate:positional-play'],
          intro: 'turn lasting features of the position into a practical plan.',
          lessonIds: [
            'read-the-imbalances',
            'pawn-structure-transformations',
            'prophylaxis'
          ]
        },
        {
          id: 'pawn-structures',
          title: 'pawn structures',
          track: 'middlegames',
          requires: ['advanced:strategic-planning', 'intermediate:opening-decisions'],
          intro: 'recognise the structure, then use its correct break before its long-term weaknesses take over.',
          lessonIds: [
            'isolated-queen-pawn',
            'hanging-pawns',
            'minority-attack'
          ]
        },
        {
          id: 'advanced-calculation',
          title: 'advanced calculation',
          track: 'middlegames',
          requires: ['intermediate:tactical-vision'],
          intro: 'calculate forcing branches in the right order and judge the position left at the end.',
          lessonIds: [
            'calculate-the-branches',
            'move-order',
            'evaluate-the-result'
          ]
        },
        {
          id: 'technical-rook-endgames',
          title: 'technical rook endgames',
          track: 'endgames',
          requires: ['intermediate:practical-endgames'],
          intro: 'learn the active-rook rule, the standard win and the standard defence.',
          lessonIds: [
            'active-rook',
            'lucena-position',
            'philidor-defence'
          ]
        },
        {
          id: 'repertoire-depth',
          title: 'repertoire depth',
          track: 'openings',
          openingGroup: 'principles',
          requires: ['advanced:advanced-opening-strategy'],
          intro: 'organise preparation around critical positions, recurring plans and practical answers to sidelines.',
          lessonIds: [
            'repertoire-tabiya',
            'repertoire-sideline'
          ]
        },
        {
          id: 'dynamic-middlegames',
          title: 'dynamic middlegames',
          track: 'middlegames',
          requires: ['advanced:strategic-planning', 'advanced:advanced-calculation'],
          intro: 'judge when activity is worth material and when simplification is the strongest defensive resource.',
          lessonIds: [
            'exchange-for-initiative',
            'defensive-simplification'
          ]
        },
        {
          id: 'endgame-judgement',
          title: 'endgame judgement',
          track: 'endgames',
          requires: ['advanced:technical-rook-endgames'],
          intro: 'choose active checking geometry and recognise the defensive fortresses that calculation alone can miss.',
          lessonIds: [
            'rook-side-checks',
            'opposite-bishop-fortress'
          ]
        }
      ];
      const learnLevelOrder = ['beginner', 'intermediate', 'advanced'];
      const learnTrackOrder = ['core', 'openings', 'middlegames', 'endgames'];
      const learnOpeningGroupOrder = ['all', 'white', 'black-e4', 'black-d4'];
      function placementAttemptFrom(lessons, lessonId) {
        const sourceLesson = lessons.find((item) => item.id === lessonId);
        const sourceAttempts = Array.isArray(sourceLesson?.attempts) ? sourceLesson.attempts : [];
        const sourceAttempt = [...sourceAttempts].reverse().find(
          (attempt) => attempt.allowHint === false || attempt.phase === 'independent'
        ) || sourceAttempts[sourceAttempts.length - 1];
        return sourceAttempt
          ? {
              ...sourceAttempt,
              phase: 'independent',
              allowHint: false,
              hints: []
            }
          : null;
      }

      function placementLesson({ id, title, intro, lessons, lessonIds, recommendation }) {
        return {
          id,
          title,
          intro,
          assessment: {
            kind: 'placement',
            size: 5,
            pass: 4,
            recommendation
          },
          attempts: lessonIds
            .map((lessonId) => placementAttemptFrom(lessons, lessonId))
            .filter(Boolean)
        };
      }

      const learnPlacements = {
        beginner: placementLesson({
          id: 'beginner-placement',
          title: 'beginner placement',
          intro: 'five positions. four correct answers unlock the beginner curriculum.',
          lessons: beginnerLessons,
          lessonIds: [
            'pawns',
            'straight-lines',
            'diagonals',
            'knight',
            'king-check',
            'castling',
            'centre',
            'forks',
            'mate-in-one',
            'opposition'
          ],
          recommendation: 'start with foundations, then retake placement.'
        }),
        intermediate: placementLesson({
          id: 'intermediate-placement',
          title: 'intermediate placement',
          intro: 'five positions. four correct answers unlock the intermediate curriculum.',
          lessons: [...intermediateLessons, ...intermediateExpansionLessons],
          lessonIds: [
            'checks-captures-threats',
            'candidate-moves',
            'double-attacks',
            'remove-the-defender',
            'calculate-two-moves',
            'develop-with-purpose',
            'central-tension',
            'worst-placed-piece',
            'pawn-races',
            'rook-ending-basics'
          ],
          recommendation: 'review the missed ideas, then retake placement.'
        }),
        advanced: placementLesson({
          id: 'advanced-placement',
          title: 'advanced placement',
          intro: 'five positions. four correct answers unlock the advanced curriculum.',
          lessons: advancedLessons,
          lessonIds: [
            'read-the-imbalances',
            'pawn-structure-transformations',
            'prophylaxis',
            'isolated-queen-pawn',
            'hanging-pawns',
            'minority-attack',
            'calculate-the-branches',
            'move-order',
            'evaluate-the-result',
            'active-rook',
            'lucena-position',
            'philidor-defence'
          ],
          recommendation: 'review the missed ideas, then retake placement.'
        })
      };

      function attachCourseCheckpoints(level, lessons, courses) {
        courses.forEach((course) => {
          const checkpointId = `${course.id}-checkpoint`;
          const sourceAttempts = course.lessonIds.flatMap((lessonId) => {
            const sourceLesson = lessons.find((item) => item.id === lessonId);
            return (sourceLesson?.attempts || []).slice(-2).map((attempt) => ({
              ...attempt,
              phase: 'independent',
              allowHint: false,
              hints: []
            }));
          });
          const size = Math.min(5, sourceAttempts.length);
          if (size < 2) return;
          lessons.push({
            id: checkpointId,
            title: `${course.title} checkpoint`,
            intro: `${size} positions. solve ${Math.ceil(size * 0.8)} to master ${course.title}.`,
            assessment: {
              kind: 'checkpoint',
              size,
              pass: Math.ceil(size * 0.8),
              recommendation: `review ${course.title}, then retry the checkpoint.`
            },
            attempts: sourceAttempts
          });
          course.lessonIds.push(checkpointId);
        });
      }

      attachCourseCheckpoints('beginner', beginnerLessons, learnCourses);
      attachCourseCheckpoints(
        'intermediate',
        intermediateLessons,
        intermediateCourses
      );
      attachCourseCheckpoints(
        'intermediate',
        intermediateExpansionLessons,
        intermediateExpansionCourses
      );
      attachCourseCheckpoints('advanced', advancedLessons, advancedCourses);

      const learnCurricula = {
        beginner: {
          lessons: beginnerLessons,
          courses: learnCourses
        },
        intermediate: {
          lessons: [...intermediateLessons, ...intermediateExpansionLessons],
          courses: [...intermediateCourses, ...intermediateExpansionCourses]
        },
        advanced: {
          lessons: advancedLessons,
          courses: advancedCourses
        }
      };
      const allLearnLessons = [
        ...learnLevelOrder.flatMap((level) => learnCurricula[level].lessons),
        ...Object.values(learnPlacements)
      ];
      const lessonIndexByLevel = Object.fromEntries(
        learnLevelOrder.map((level) => [
          level,
          new Map(
            learnCurricula[level].lessons.map((item, index) => [item.id, index])
          )
        ])
      );

      function normalizedLearnLevel(level = 'beginner') {
        return learnCurricula[level] ? level : 'beginner';
      }

      function learnCurriculum(level = 'beginner') {
        return learnCurricula[normalizedLearnLevel(level)];
      }

      function lessonsForLevel(level = 'beginner') {
        return learnCurriculum(level).lessons;
      }

      function coursesForLevel(level = 'beginner') {
        return learnCurriculum(level).courses;
      }

      function normalizedLearnTrack(track = 'core') {
        return learnTrackOrder.includes(track) ? track : 'core';
      }

      function normalizedLearnOpeningGroup(group = 'all') {
        return learnOpeningGroupOrder.includes(group) ? group : 'all';
      }

      function coursesForTrack(level = 'beginner', track = 'core') {
        const courses = coursesForLevel(level);
        const normalizedTrack = normalizedLearnTrack(track);
        if (normalizedTrack === 'core') return courses;
        const trackCourses = courses.filter((course) => course.track === normalizedTrack);
        if (normalizedTrack !== 'openings' || activeLearnOpeningGroup === 'all') {
          return trackCourses;
        }
        return trackCourses.filter(
          (course) => course.openingGroup === activeLearnOpeningGroup
        );
      }

      function lessonLevelForId(id) {
        return learnLevelOrder.find(
          (level) => lessonIndexByLevel[level].has(id) || learnPlacements[level]?.id === id
        ) || '';
      }

      function placementIsComplete(level = activeLearnLevel) {
        const placementId = learnPlacements[normalizedLearnLevel(level)]?.id;
        return Boolean(placementId && learnProgress.completed.includes(placementId));
      }

      function learnLevelIsComplete(level) {
        const lessons = lessonsForLevel(level);
        return Boolean(
          lessons.length
          && lessons.every((item) => learnProgress.completed.includes(item.id))
        );
      }

      function learnLevelIsUnlocked(level) {
        return Boolean(learnCurricula[level]?.lessons?.length);
      }

      function recommendedLearnLevel() {
        const incompleteUnlockedLevel = learnLevelOrder.find(
          (level) => learnLevelIsUnlocked(level) && !learnLevelIsComplete(level)
        );
        if (incompleteUnlockedLevel) return incompleteUnlockedLevel;
        return [...learnLevelOrder].reverse().find((level) => learnLevelIsUnlocked(level))
          || 'beginner';
      }

      function courseLessonIndexes(course, level = lessonState?.level || activeLearnLevel || 'beginner') {
        const indexById = lessonIndexByLevel[normalizedLearnLevel(level)];
        return (course?.lessonIds || [])
          .map((id) => indexById.get(id))
          .filter(Number.isInteger);
      }

      function courseForLessonIndex(index, level = lessonState?.level || activeLearnLevel || 'beginner') {
        const normalizedLevel = normalizedLearnLevel(level);
        const lessons = lessonsForLevel(normalizedLevel);
        const courses = coursesForLevel(normalizedLevel);
        const lessonId = lessons[index]?.id;
        return courses.find((course) => course.lessonIds.includes(lessonId))
          || courses[0];
      }

      function currentCourse() {
        if (currentLesson()?.assessment?.kind === 'placement') {
          return { id: 'placement', title: 'placement', lessonIds: [] };
        }
        if (currentLesson()?.assessment?.kind === 'practice') {
          return coursesForLevel(lessonState?.level || activeLearnLevel).find(
            (course) => course.id === lessonState?.practiceCourseId
          ) || { id: 'practice', title: 'opening practice', lessonIds: [] };
        }
        return courseForLessonIndex(
          lessonState?.lessonIndex || 0,
          lessonState?.level || activeLearnLevel || 'beginner'
        );
      }

      function openingPracticeCourseForLesson(
        item = currentLesson(),
        level = lessonState?.level || activeLearnLevel || 'beginner'
      ) {
        if (!item) return null;
        return coursesForLevel(normalizedLearnLevel(level)).find((course) => (
          course.track === 'openings'
          && Array.isArray(course.modelMoments)
          && course.modelMoments.length
          && course.lessonIds.includes(item.id)
        )) || null;
      }

      function openingPracticeItem(course, level = activeLearnLevel) {
        if (!course) return null;
        const lessons = lessonsForLevel(normalizedLearnLevel(level));
        const candidates = course.lessonIds
          .map((lessonId) => lessons.find((item) => item.id === lessonId))
          .filter((item) => item && !item.assessment)
          .map((item) => {
            const attempt = [...(item.attempts || [])].reverse().find((candidate) => (
              Array.isArray(candidate?.accepted) && candidate.accepted.length
            ));
            return attempt ? { item, attempt } : null;
          })
          .filter(Boolean);
        if (!candidates.length) return null;
        const selected = shuffledAttemptIndexes(candidates.length, Math.min(5, candidates.length))
          .map((index) => candidates[index]);
        const modelMoments = course.modelMoments;
        const attempts = selected.map(({ item, attempt }, index) => ({
          ...attempt,
          phase: 'independent',
          allowHint: false,
          hints: [],
          sourceLessonId: item.id,
          success: [
            String(attempt.success || 'correct. the opening plan is working.').trim(),
            String(modelMoments[index % modelMoments.length] || '').trim()
          ].filter(Boolean).join(' ')
        }));
        return {
          id: `practice:${course.id}`,
          title: `${course.title} practice`,
          intro: `five positions from ${course.title}. solve them without hints, then use the model idea after each move.`,
          practiceCourseId: course.id,
          assessment: {
            kind: 'practice',
            size: attempts.length,
            pass: attempts.length
          },
          attempts
        };
      }

      function courseIsComplete(course, level = lessonState?.level || activeLearnLevel || 'beginner') {
        const lessonIds = new Set(lessonsForLevel(level).map((item) => item.id));
        return Boolean(
          course?.lessonIds?.length
          && course.lessonIds.every(
            (id) => lessonIds.has(id) && learnProgress.completed.includes(id)
          )
        );
      }

      function courseReference(reference, fallbackLevel = activeLearnLevel) {
        const [referencedLevel, courseId] = String(reference || '').includes(':')
          ? String(reference).split(':', 2)
          : [fallbackLevel, String(reference || '')];
        const level = normalizedLearnLevel(referencedLevel);
        return {
          level,
          course: coursesForLevel(level).find((course) => course.id === courseId) || null
        };
      }

      function courseRequirementIsMet(reference, fallbackLevel = activeLearnLevel) {
        const required = courseReference(reference, fallbackLevel);
        return Boolean(
          required.course
          && (
            placementIsComplete(required.level)
            || courseIsComplete(required.course, required.level)
          )
        );
      }

      function courseIsUnlocked(courseIndex, level = lessonState?.level || activeLearnLevel || 'beginner') {
        const normalizedLevel = normalizedLearnLevel(level);
        const curriculum = learnCurricula[normalizedLevel];
        const course = curriculum?.courses?.[courseIndex];
        if (!course) return false;
        if (course.lessonIds.some((id) => learnProgress.completed.includes(id))) return true;
        if (placementIsComplete(normalizedLevel)) return true;
        const requirements = Array.isArray(course.requires) ? course.requires : [];
        return requirements.every(
          (reference) => courseRequirementIsMet(reference, normalizedLevel)
        );
      }

      function courseUnlockLabel(course, level = activeLearnLevel) {
        const requirements = Array.isArray(course?.requires) ? course.requires : [];
        const missing = requirements.find(
          (reference) => !courseRequirementIsMet(reference, level)
        );
        const required = courseReference(missing, level);
        return required.course?.title || 'placement';
      }

      function firstAvailableLessonIndexForCourse(course, level = lessonState?.level || activeLearnLevel || 'beginner') {
        const lessons = lessonsForLevel(level);
        const indexes = courseLessonIndexes(course, level);
        const firstIncomplete = indexes.find(
          (index) => (
            lessonIsUnlocked(index, level)
            && !learnProgress.completed.includes(lessons[index]?.id)
          )
        );
        const firstUnlocked = indexes.find((index) => lessonIsUnlocked(index, level));
        return Number.isInteger(firstIncomplete)
          ? firstIncomplete
          : Number.isInteger(firstUnlocked) ? firstUnlocked : (indexes[0] || 0);
      }

      function lessonIndexWithinCourse(
        index,
        course = courseForLessonIndex(index),
        level = lessonState?.level || activeLearnLevel || 'beginner'
      ) {
        return Math.max(0, courseLessonIndexes(course, level).indexOf(index));
      }
      let session = null;
      let socket = null;
      let readyPromise = null;
      let resolveReady = null;
      let rejectReady = null;
      let game = null;
      let color = 'w';
      let selectedSquare = null;
      let queued = false;
      let queueJoinPending = false;
      let resumeAutomaticQueue = false;
      let resumeQueueTimer = null;
      let reconnectTimer = null;
      let reconnectAttempt = 0;
      let intentionalClose = false;
      const intentionallyClosedSockets = new WeakSet();
      let revealTimer = null;
      let computerOfferTimer = null;
      let computerLevelMenuTimer = null;
      let computerLevelPromptGameId = '';
      let statusTransitionTimer = null;
      let lessonCopyTimer = null;
      let lessonDemonstrationTimer = null;
      let lessonResetTimer = null;
      let lessonFeedbackTimer = null;
      let lessonStatusTimer = null;
      let puzzleReplyTimer = null;
      let lastLessonStatus = '';
      let lessonState = null;
      let puzzleState = null;
      let renderedPosition = new Map();
      let renderedColor = '';
      let pendingMove = null;
      let premove = null;
      let promotionMove = null;
      let dragState = null;
      let handledPointerClick = null;
      let ignoreClickUntil = 0;
      let clockState = null;
      let audioContext = null;
      let localVoiceStream = null;
      let voicePeer = null;
      let voiceJoined = false;
      let voiceMuted = false;
      let voiceNeedsGesture = false;
      let pendingIceCandidates = [];
      let rtcIceServers = [{ urls: 'stun:stun.l.google.com:19302' }];
      let activeRequestId = '';
      let incomingChallenge = null;
      let outgoingChallenge = null;
      let handoverRequest = null;
      let handoverTrigger = null;
      let handoverResponsePending = false;
      let incomingRematch = null;
      let rematchRequested = false;
      let challengeExpiryTimer = null;
      let directoryPlayers = [];
      let livePlayersExpanded = false;
      let desktopLiveExpanded = false;
      let directoryRefreshTimer = null;
      let idleConnectionTimer = null;
      let connectionState = null;
      let connectionStatusActive = false;
      let automaticMatchmaking = false;
      let matchCancelRequested = false;
      let entryMode = '';
      let pendingEntryMode = '';
      let socketStateReady = true;
      let socketStatePromise = Promise.resolve();
      let resolveSocketState = null;
      let selectedComputerDifficulty = 'beginner';
      let learnProgress = { schemaVersion: 2, completed: [], currentLessonId: '' };
      let puzzleProgress = null;
      let puzzleHistoryExpanded = false;
      let reviewProgress = null;
      const gameAnalysisPollTimers = new Map();
      let expandedReviewGameId = '';
      let showOlderReviewGames = false;
      const reviewTimelineIndexes = new Map();
      let activeLearnLevel = 'beginner';
      let activeLearnTrack = 'core';
      let activeLearnOpeningGroup = 'all';
      let activeLearnMode = 'courses';
      let learnProgressIdentityKey = '';
      try {
        const storedComputerDifficulty = localStorage.getItem(computerLevelStorageKey);
        if (['beginner', 'intermediate', 'advanced'].includes(storedComputerDifficulty)) {
          selectedComputerDifficulty = storedComputerDifficulty;
        }
      } catch {}
      const squareElements = new Map();
      const clockTimer = window.setInterval(() => {
        if (lessonState || puzzleState) return;
        updateClocks();
        updateConnectionUi();
      }, 100);

      function setStatus(message, options = {}) {
        if (!status) return;
        const nextMessage = String(message || '');
        const active = Boolean(options.active);
        const currentMessage = status.dataset.message || '';
        window.clearTimeout(statusTransitionTimer);
        status.classList.remove('is-result');
        status.classList.toggle('is-active', active);
        if (!nextMessage) {
          status.dataset.message = '';
          status.classList.remove('is-entering', 'is-active');
          if (!currentMessage && !status.textContent) {
            status.classList.remove('is-clearing');
            return;
          }
          status.classList.add('is-clearing');
          statusTransitionTimer = window.setTimeout(() => {
            if (status.dataset.message) return;
            status.textContent = '';
            status.classList.remove('is-clearing');
          }, 180);
          return;
        }
        status.dataset.message = nextMessage;
        status.classList.remove('is-clearing');
        if (currentMessage === nextMessage) return;
        status.textContent = nextMessage;
        status.classList.remove('is-entering');
        void status.offsetWidth;
        status.classList.add('is-entering');
      }

      function setResultStatus(activeGame, computerGame = false) {
        if (!status) return;
        window.clearTimeout(statusTransitionTimer);
        const result = activeGame?.result;
        const resultElement = document.createElement('span');
        resultElement.className = 'osb-live__status-result';
        resultElement.dataset.resultReason = result?.reason || '';
        resultElement.textContent = resultLabel(activeGame, computerGame);
        status.replaceChildren(resultElement);
        status.dataset.message = resultElement.textContent;
        status.classList.remove('is-active', 'is-clearing', 'is-entering');
        status.classList.add('is-result');
      }

      function hideMatchOptions() {
        window.clearTimeout(computerOfferTimer);
        matchCancelButton?.classList.remove('is-pending');
        matchContinueButton?.classList.remove('is-pending');
        computerButton?.classList.remove('is-pending');
        if (matchCancelButton) {
          matchCancelButton.hidden = true;
          matchCancelButton.disabled = false;
        }
        if (matchContinueButton) {
          matchContinueButton.hidden = true;
          matchContinueButton.disabled = false;
          matchContinueButton.textContent = 'keep looking';
          delete matchContinueButton.dataset.matchRetry;
        }
        if (computerButton) {
          computerButton.hidden = true;
          computerButton.disabled = false;
        }
      }

      function showCancelledMatchState() {
        arena?.classList.add('is-lobby');
        arena?.classList.remove('is-matching');
        if (controls) controls.hidden = false;
        setOpponentIdentity('live', '');
        if (opponent) {
          opponent.disabled = true;
          opponent.setAttribute('aria-label', 'live opponent');
        }
        if (matchContinueButton) {
          matchContinueButton.hidden = false;
          matchContinueButton.disabled = false;
          matchContinueButton.textContent = 'find again';
          matchContinueButton.dataset.matchRetry = 'true';
        }
        if (computerButton) {
          computerButton.hidden = false;
          computerButton.disabled = false;
        }
        turnSquare?.classList.remove('is-live');
        setStatus('search cancelled');
      }

      function scheduleMatchOptions() {
        window.clearTimeout(computerOfferTimer);
        if (matchContinueButton) matchContinueButton.hidden = true;
        if (computerButton) computerButton.hidden = true;
        computerOfferTimer = window.setTimeout(() => {
          if (!queued) return;
          if (matchContinueButton) matchContinueButton.hidden = false;
          if (computerButton) computerButton.hidden = false;
        }, 8000);
      }

      function computerDifficulty(activeGame = game) {
        const difficulty = String(activeGame?.metadata?.difficulty || '').toLowerCase();
        if (['beginner', 'intermediate', 'advanced'].includes(difficulty)) return difficulty;
        const opponentRating = Number(activeGame?.metadata?.opponentRating);
        if (Number.isFinite(opponentRating) && opponentRating > 0) {
          if (opponentRating < 1100) return 'beginner';
          if (opponentRating < 1650) return 'intermediate';
          return 'advanced';
        }
        return selectedComputerDifficulty;
      }

      function setOpponentIdentity(name = '', difficulty = '', options = {}) {
        if (opponentName) {
          const previousName = opponentName.textContent || '';
          opponentName.textContent = name;
          opponentName.dataset.matchmaking = options.matchmaking ? 'true' : 'false';
          if (
            previousName !== name
            && name
            && typeof opponentName.animate === 'function'
            && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            opponentName.animate(
              [
                { opacity: 0.35, transform: 'translateY(0.18em)' },
                { opacity: 1, transform: 'translateY(0)' }
              ],
              { duration: 180, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
            );
          }
        } else if (opponent) {
          opponent.textContent = name;
        }
        if (!computerLevel) return;
        computerLevel.textContent = difficulty;
        computerLevel.hidden = !difficulty;
      }

      function syncMatchmakingIdentity() {
        const searching = Boolean(
          automaticMatchmaking
          && (queued || queueJoinPending || resumeAutomaticQueue)
          && (!game || game.status !== 'active')
        );
        const usesOpponentSlot = desktopGameLayout();

        if (searching && usesOpponentSlot) {
          setOpponentIdentity('finding a player', '', { matchmaking: true });
          if (opponent) {
            opponent.disabled = true;
            opponent.setAttribute('aria-label', 'finding a player');
          }
          if (['finding a player', 'joining live room'].includes(status?.dataset.message || '')) {
            setStatus('');
          }
          return;
        }

        if (opponentName?.dataset.matchmaking === 'true') {
          setOpponentIdentity('', '');
        }
        if (searching) {
          setStatus('finding a player', { active: true });
        } else if (['finding a player', 'joining live room'].includes(status?.dataset.message || '')) {
          setStatus('');
        }
      }

      function setComputerLevelMenu(open = false) {
        if (!computerLevelMenu || !opponent) return;
        window.clearTimeout(computerLevelMenuTimer);
        const shouldOpen = Boolean(open && !opponent.disabled);

        if (shouldOpen) {
          computerLevelMenu.hidden = false;
          computerLevelMenu.setAttribute('aria-hidden', 'false');
          void computerLevelMenu.offsetWidth;
          computerLevelMenu.classList.add('is-open');
        } else {
          computerLevelMenu.classList.remove('is-open');
          computerLevelMenu.setAttribute('aria-hidden', 'true');

          const finishClose = () => {
            if (!computerLevelMenu.classList.contains('is-open')) {
              computerLevelMenu.hidden = true;
            }
          };

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            finishClose();
          } else {
            computerLevelMenuTimer = window.setTimeout(finishClose, 180);
          }
        }

        opponent.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      function syncComputerLevelControl(activeGame, computerGame, hasPlayedMove) {
        if (!opponent) return;
        if (computerGame) selectedComputerDifficulty = computerDifficulty(activeGame);
        if (computerGame) {
          setOpponentIdentity('computer', selectedComputerDifficulty);
        } else if (computerLevel) {
          computerLevel.textContent = '';
          computerLevel.hidden = true;
        }
        const gameId = String(activeGame?.id || '');
        const canChange = Boolean(
          computerGame
          && activeGame?.status === 'active'
          && !hasPlayedMove
          && activeGame?.metadata?.mode !== 'placement'
        );
        opponent.disabled = !canChange;
        opponent.setAttribute(
          'aria-label',
          canChange
            ? `computer level: ${selectedComputerDifficulty}`
            : computerGame
              ? `computer, ${selectedComputerDifficulty}`
              : (opponentName?.textContent || opponent.textContent || 'opponent')
        );
        computerLevelOptions.forEach((option) => {
          option.setAttribute(
            'aria-selected',
            option.dataset.osbComputerLevelOption === selectedComputerDifficulty ? 'true' : 'false'
          );
        });
        if (!canChange) {
          setComputerLevelMenu(false);
          if (!computerGame || activeGame?.status !== 'active') computerLevelPromptGameId = '';
        } else if (computerLevelPromptGameId !== gameId) {
          computerLevelPromptGameId = gameId;
          setComputerLevelMenu(true);
        }
      }

      function playerLabel(player, fallback = 'player') {
        return player?.name || fallback;
      }

      function renderSignal(element, state) {
        if (!element) return;
        element.hidden = !state;
        const bars = state?.connected ? Math.max(1, Math.min(4, Number(state.bars || 1))) : 0;
        Array.from(element.children).forEach((bar, index) => {
          const shouldBeOn = index < bars;
          if (bar.classList.contains('is-on') !== shouldBeOn) bar.classList.toggle('is-on', shouldBeOn);
        });
        element.setAttribute(
          'aria-label',
          state?.connected ? `${bars} of 4 connection strength` : 'disconnected'
        );
      }

      function updateConnectionUi() {
        if (isComputerGame(game)) {
          connectionStatusActive = false;
          renderSignal(yourSignal, null);
          renderSignal(opponentSignal, null);
          return;
        }
        if (!game || game.status !== 'active' || connectionState?.gameId !== game.id) {
          if (connectionStatusActive) {
            connectionStatusActive = false;
            if (game?.status === 'active') setStatus('');
          }
          return;
        }
        const ownState = connectionState.players?.[color];
        const otherColor = color === 'w' ? 'b' : 'w';
        const otherState = connectionState.players?.[otherColor];
        renderSignal(yourSignal, ownState);
        renderSignal(opponentSignal, otherState);
        if (otherState && !otherState.connected && otherState.deadlineAt) {
          const seconds = Math.max(0, Math.ceil((Number(otherState.deadlineAt) - Date.now()) / 1000));
          const other = game.players?.[otherColor];
          setStatus(`${other?.name || 'opponent'} reconnecting ${seconds}`, { active: true });
          connectionStatusActive = true;
        } else if (connectionStatusActive) {
          connectionStatusActive = false;
          setStatus('');
        }
      }

      function clearLessonTimers() {
        window.clearTimeout(lessonCopyTimer);
        window.clearTimeout(lessonDemonstrationTimer);
        window.clearTimeout(lessonResetTimer);
        window.clearTimeout(lessonFeedbackTimer);
        window.clearTimeout(lessonStatusTimer);
        window.clearTimeout(puzzleReplyTimer);
        lessonCopyTimer = null;
        lessonDemonstrationTimer = null;
        lessonResetTimer = null;
        lessonFeedbackTimer = null;
        lessonStatusTimer = null;
        puzzleReplyTimer = null;
      }

      function setLessonCopy(message) {
        if (!lessonCopy) return;
        const nextMessage = String(message || '');
        window.clearTimeout(lessonCopyTimer);
        if (
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
          || !lessonCopy.textContent
          || lessonCopy.textContent === nextMessage
        ) {
          lessonCopy.textContent = nextMessage;
          lessonCopy.classList.remove('is-changing');
          return;
        }
        lessonCopy.classList.add('is-changing');
        lessonCopyTimer = window.setTimeout(() => {
          lessonCopy.textContent = nextMessage;
          lessonCopy.classList.remove('is-changing');
        }, 90);
      }

      function lessonReason(message, fallback = '') {
        return String(message || fallback || '')
          .replace(/^(?:yes|good|right|correct|one square better)\.\s*/i, '')
          .trim();
      }

      function setLessonStatus(message = '', options = {}) {
        if (!lessonStatus) return;
        const nextMessage = String(message || '').trim().toLowerCase();
        const danger = options.danger === true;
        const tone = danger
          ? 'danger'
          : nextMessage.startsWith('correct')
            ? 'correct'
            : nextMessage.startsWith('incorrect') || nextMessage.startsWith('illegal')
              ? 'incorrect'
              : nextMessage.startsWith('hint')
                ? 'hint'
                : 'neutral';
        window.clearTimeout(lessonStatusTimer);
        lessonStatusTimer = null;

        if (!nextMessage) {
          if (!lastLessonStatus) {
            lessonStatus.hidden = true;
            return;
          }
          const finishClear = () => {
            lastLessonStatus = '';
            lessonStatus.textContent = '';
            lessonStatus.hidden = true;
            delete lessonStatus.dataset.tone;
            lessonStatus.classList.remove('is-danger', 'is-clearing');
          };
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            finishClear();
            return;
          }
          lessonStatus.classList.add('is-clearing');
          lessonStatusTimer = window.setTimeout(finishClear, 200);
          return;
        }

        if (lastLessonStatus === nextMessage) {
          lessonStatus.classList.toggle('is-danger', danger);
          lessonStatus.dataset.tone = tone;
          lessonStatus.classList.remove('is-clearing');
          return;
        }
        lastLessonStatus = nextMessage;
        lessonStatus.hidden = false;
        lessonStatus.textContent = nextMessage;
        lessonStatus.dataset.tone = tone;
        lessonStatus.classList.toggle('is-danger', danger);
        lessonStatus.classList.remove('is-clearing');
      }

      const defaultPuzzleRatings = { beginner: 800, intermediate: 1500, advanced: 2100 };

      function puzzleProgressStorageKeyForSession(targetSession = session) {
        const accountId = targetSession?.player?.kind === 'account'
          ? String(targetSession.player.id || '').trim()
          : '';
        return accountId
          ? `${puzzleProgressStorageBaseKey}:account:${encodeURIComponent(accountId)}`
          : `${puzzleProgressStorageBaseKey}:guest`;
      }

      function todayKey() {
        const date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      }

      function weekKey() {
        const date = new Date();
        const mondayOffset = (date.getDay() + 6) % 7;
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() - mondayOffset);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      }

      function validPuzzleFen(value) {
        const parts = String(value || '').trim().split(/\s+/);
        if (parts.length < 2 || !/^[wb]$/.test(parts[1])) return false;
        const ranks = String(parts[0] || '').split('/');
        if (ranks.length !== 8) return false;
        return ranks.every((rank) => {
          let files = 0;
          for (const token of rank) {
            if (/^[1-8]$/.test(token)) files += Number(token);
            else if (/^[prnbqkPRNBQK]$/.test(token)) files += 1;
            else return false;
          }
          return files === 8;
        });
      }

      function rejectPuzzle(value, reason) {
        const id = String(value?.id || '').trim();
        if (id) console.warn('[one square better] skipped puzzle', { id, reason });
        return null;
      }

      function samePuzzlePosition(left, right) {
        if (left.size !== right.size) return false;
        return Array.from(left).every(([square, piece]) => right.get(square) === piece);
      }

      function compactPuzzle(value) {
        if (!value || !/^[a-zA-Z0-9]{4,16}$/.test(String(value.id || ''))) {
          return rejectPuzzle(value, 'invalid id');
        }
        const solution = Array.isArray(value.solution)
          ? value.solution.map((move) => String(move || '').trim().toLowerCase())
          : [];
        const lineFens = Array.isArray(value.lineFens)
          ? value.lineFens.map((fen) => String(fen || '').trim())
          : [];
        const fen = String(value.fen || '').trim();
        if (!validPuzzleFen(fen)) return rejectPuzzle(value, 'invalid starting position');
        if (!solution.length || lineFens.length !== solution.length) {
          return rejectPuzzle(value, 'incomplete solution line');
        }
        if (solution.some((move) => !/^[a-h][1-8][a-h][1-8][qrbn]?$/.test(move))) {
          return rejectPuzzle(value, 'invalid solution move');
        }
        if (lineFens.some((lineFen) => !validPuzzleFen(lineFen))) {
          return rejectPuzzle(value, 'invalid solution position');
        }
        const startTurn = fenTurn(fen);
        const color = value.color === 'b' || value.color === 'w' ? value.color : startTurn;
        if (color !== startTurn) return rejectPuzzle(value, 'side to move mismatch');
        let previousTurn = startTurn;
        let previousFen = fen;
        for (let index = 0; index < lineFens.length; index += 1) {
          const lineFen = lineFens[index];
          const nextTurn = fenTurn(lineFen);
          if (nextTurn === previousTurn) {
            return rejectPuzzle(value, `solution turn did not advance at move ${index + 1}`);
          }
          const move = puzzleMove(solution[index]);
          const position = boardMap(previousFen);
          if (
            !move
            || pieceColor(position.get(move.from)) !== previousTurn
            || !lessonMoveIsLegal(position, move.from, move.to, move.promotion, {
              color: previousTurn,
              fen: previousFen
            })
          ) return rejectPuzzle(value, `illegal database move ${index + 1}`);
          const projected = lessonPositionAfterMove(position, move);
          const stored = boardMap(lineFen);
          if (!samePuzzlePosition(projected, stored)) {
            return rejectPuzzle(value, `line mismatch ${index + 1}`);
          }
          previousTurn = nextTurn;
          previousFen = lineFen;
        }
        return {
          id: String(value.id),
          rating: Math.max(0, Number(value.rating) || 0),
          themes: Array.isArray(value.themes)
            ? value.themes.map((theme) => String(theme || '')).filter(Boolean).slice(0, 16)
            : [],
          fen,
          color,
          solution,
          lineFens
        };
      }

      function compactPuzzleHistoryEntry(value) {
        const puzzle = compactPuzzle(value?.puzzle || value);
        if (!puzzle) return null;
        return {
          puzzle,
          solvedAt: Math.max(0, Number(value?.solvedAt) || 0),
          firstTry: value?.firstTry === true
        };
      }

      function normalizedPuzzleProgress(value = {}) {
        const levels = {};
        ['beginner', 'intermediate', 'advanced'].forEach((level) => {
          const stored = value?.levels?.[level] || {};
          levels[level] = {
            solved: Math.max(0, Number(stored.solved) || 0),
            attempted: Math.max(0, Number(stored.attempted) || 0),
            firstTry: Math.max(0, Number(stored.firstTry) || 0),
            rating: Math.max(100, Math.min(3200, Number(stored.rating) || defaultPuzzleRatings[level])),
            mistakes: (Array.isArray(stored.mistakes) ? stored.mistakes : [])
              .map(compactPuzzle)
              .filter(Boolean)
              .slice(-50),
            history: (Array.isArray(stored.history) ? stored.history : [])
              .map(compactPuzzleHistoryEntry)
              .filter(Boolean)
              .slice(-200)
          };
        });
        const dailyDate = value?.daily?.date === todayKey() ? value.daily.date : todayKey();
        const weeklyDate = value?.weekly?.week === weekKey() ? value.weekly.week : weekKey();
        return {
          schemaVersion: 2,
          levels,
          daily: {
            date: dailyDate,
            count: dailyDate === value?.daily?.date
              ? Math.max(0, Math.min(5, Number(value?.daily?.count) || 0))
              : 0
          },
          weekly: {
            week: weeklyDate,
            count: weeklyDate === value?.weekly?.week
              ? Math.max(0, Math.min(7, Number(value?.weekly?.count) || 0))
              : 0
          }
        };
      }

      function loadPuzzleProgress(targetSession = session) {
        let stored = {};
        try {
          stored = JSON.parse(localStorage.getItem(
            puzzleProgressStorageKeyForSession(targetSession)
          ) || 'null') || {};
        } catch {}
        puzzleProgress = normalizedPuzzleProgress(stored);
      }

      function savePuzzleProgress() {
        puzzleProgress ||= normalizedPuzzleProgress();
        try {
          localStorage.setItem(
            puzzleProgressStorageKeyForSession(),
            JSON.stringify(puzzleProgress)
          );
        } catch {}
        renderPuzzleLibrary();
      }

      function puzzleLevelProgress(level = activeLearnLevel) {
        puzzleProgress ||= normalizedPuzzleProgress();
        return puzzleProgress.levels[normalizedLearnLevel(level)];
      }

      function humanizePuzzleTheme(value) {
        return String(value || '')
          .replace(/([a-z])([A-Z])/g, '$1 $2')
          .replace(/([a-zA-Z])(\d)/g, '$1 $2')
          .replace(/[_-]+/g, ' ')
          .trim()
          .toLowerCase();
      }

      function puzzleHistoryTitle(puzzle) {
        const theme = (puzzle?.themes || []).find((value) => (
          ![
            'short', 'long', 'veryLong', 'master', 'masterVsMaster', 'oneMove',
            'opening', 'middlegame', 'endgame'
          ].includes(value)
        ));
        return theme ? humanizePuzzleTheme(theme) : 'best move';
      }

      function puzzleHistoryDate(value) {
        const timestamp = Number(value) || 0;
        if (!timestamp) return '';
        const solved = new Date(timestamp);
        const today = new Date();
        const day = new Date(solved.getFullYear(), solved.getMonth(), solved.getDate());
        const currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const daysAgo = Math.round((currentDay.getTime() - day.getTime()) / 86_400_000);
        if (daysAgo === 0) return 'today';
        if (daysAgo === 1) return 'yesterday';
        return solved.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
      }

      function renderPuzzleHistory() {
        if (!puzzleHistory) return;
        const entries = [...puzzleLevelProgress(activeLearnLevel).history].reverse();
        const visibleEntries = puzzleHistoryExpanded ? entries : entries.slice(0, 5);
        const fragment = document.createDocumentFragment();
        visibleEntries.forEach((entry) => {
          const row = document.createElement('li');
          const button = document.createElement('button');
          const title = document.createElement('span');
          const meta = document.createElement('span');
          row.className = 'osb-live__puzzle-history-item';
          button.type = 'button';
          button.className = 'osb-live__puzzle-history-button';
          title.textContent = puzzleHistoryTitle(entry.puzzle);
          meta.className = 'osb-live__puzzle-history-meta';
          meta.textContent = [
            entry.firstTry ? 'first try' : 'solved',
            puzzleHistoryDate(entry.solvedAt)
          ].filter(Boolean).join(' · ');
          button.setAttribute('aria-label', `revisit ${title.textContent}, ${meta.textContent}`);
          button.addEventListener('click', () => {
            startPuzzleSession('history', activeLearnLevel, entry.puzzle);
          });
          button.append(title, meta);
          row.appendChild(button);
          fragment.appendChild(row);
        });
        puzzleHistory.replaceChildren(fragment);
        if (puzzleHistoryEmpty) puzzleHistoryEmpty.hidden = entries.length > 0;
        if (puzzleHistoryMore) {
          puzzleHistoryMore.hidden = entries.length <= 5;
          puzzleHistoryMore.textContent = puzzleHistoryExpanded
            ? 'show recent'
            : `view all ${entries.length}`;
        }
      }

      function renderLearnModeButtons() {
        learnModeButtons.forEach((button) => {
          const requestedMode = button.dataset.osbLearnMode;
          const mode = ['courses', 'puzzles', 'review'].includes(requestedMode)
            ? requestedMode
            : 'courses';
          button.setAttribute('aria-pressed', mode === activeLearnMode ? 'true' : 'false');
        });
        if (courseLibrary) courseLibrary.hidden = activeLearnMode !== 'courses';
        if (puzzleLibrary) puzzleLibrary.hidden = activeLearnMode !== 'puzzles';
        if (reviewLibrary) reviewLibrary.hidden = activeLearnMode !== 'review';
      }

      function renderPuzzleLibrary() {
        const progress = puzzleLevelProgress(activeLearnLevel);
        const attempted = Math.max(0, progress.attempted);
        const dailyCount = puzzleProgress?.daily?.date === todayKey()
          ? Math.max(0, Number(puzzleProgress.daily.count) || 0)
          : 0;
        const weeklyCount = puzzleProgress?.weekly?.week === weekKey()
          ? Math.max(0, Number(puzzleProgress.weekly.count) || 0)
          : 0;
        if (puzzleSolved) puzzleSolved.textContent = String(progress.solved);
        if (puzzleAccuracy) {
          puzzleAccuracy.textContent = attempted
            ? `${Math.round((progress.firstTry / attempted) * 100)}%`
            : '—';
        }
        if (puzzleRating) puzzleRating.textContent = String(Math.round(progress.rating));
        if (puzzleDailyProgress) puzzleDailyProgress.textContent = `${dailyCount} of 5 today`;
        if (puzzleWeeklyProgress) puzzleWeeklyProgress.textContent = `${weeklyCount} of 7 this week`;
        if (puzzleMistakes) {
          puzzleMistakes.textContent = progress.mistakes.length
            ? `${progress.mistakes.length} waiting`
            : 'none waiting';
        }
        if (puzzleDailyButton) puzzleDailyButton.disabled = dailyCount >= 5;
        if (puzzleWeeklyButton) puzzleWeeklyButton.disabled = weeklyCount >= 7;
        if (puzzleReviewButton) puzzleReviewButton.disabled = !progress.mistakes.length;
        renderPuzzleHistory();
      }

      function reviewProgressStorageKeyForSession(targetSession = session) {
        const accountId = targetSession?.player?.kind === 'account'
          ? String(targetSession.player.id || '').trim()
          : '';
        return accountId
          ? `${reviewProgressStorageBaseKey}:account:${encodeURIComponent(accountId)}`
          : `${reviewProgressStorageBaseKey}:guest`;
      }

      function lessonForReviewId(id) {
        const item = allLearnLessons.find((lessonItem) => lessonItem.id === id);
        return item && !item.assessment ? item : null;
      }

      function normalizedGameAnalysis(value) {
        const compactAnalysisMove = (move) => ({
          ply: Math.max(1, Number(move?.ply) || 1),
          moveNumber: Math.max(1, Number(move?.moveNumber) || 1),
          color: move?.color === 'b' ? 'b' : 'w',
          phase: ['opening', 'middlegame', 'endgame'].includes(move?.phase) ? move.phase : 'middlegame',
          kind: ['turning-point', 'missed-opportunity', 'best-decision', 'improvement'].includes(move?.kind)
            ? move.kind
            : 'improvement',
          classification: ['best', 'good', 'improvement', 'inaccuracy', 'mistake', 'blunder'].includes(move?.classification)
            ? move.classification
            : 'improvement',
          theme: String(move?.theme || 'decision-making').slice(0, 40),
          lossCp: Math.max(0, Math.min(100000, Number(move?.lossCp) || 0)),
          accuracy: Math.max(0, Math.min(100, Number(move?.accuracy) || 0)),
          matchesBest: Boolean(move?.matchesBest),
          fen: String(move?.fen || '').slice(0, 140),
          played: {
            from: String(move?.played?.from || '').slice(0, 2),
            to: String(move?.played?.to || '').slice(0, 2),
            promotion: String(move?.played?.promotion || '').slice(0, 1),
            san: String(move?.played?.san || '').slice(0, 20),
            piece: String(move?.played?.piece || '').slice(0, 1),
            captured: String(move?.played?.captured || '').slice(0, 1)
          },
          best: {
            from: String(move?.best?.from || '').slice(0, 2),
            to: String(move?.best?.to || '').slice(0, 2),
            promotion: String(move?.best?.promotion || '').slice(0, 1),
            san: String(move?.best?.san || '').slice(0, 20),
            piece: String(move?.best?.piece || '').slice(0, 1),
            captured: String(move?.best?.captured || '').slice(0, 1)
          },
          explanation: {
            headline: String(move?.explanation?.headline || '').slice(0, 140),
            detail: String(move?.explanation?.detail || '').slice(0, 240)
          }
        });
        const moments = (Array.isArray(value?.moments) ? value.moments : [])
          .map(compactAnalysisMove)
          .filter((moment) => (
            moment.fen.split(/\s+/).length >= 4
            && /^[a-h][1-8]$/.test(moment.played.from)
            && /^[a-h][1-8]$/.test(moment.played.to)
            && /^[a-h][1-8]$/.test(moment.best.from)
            && /^[a-h][1-8]$/.test(moment.best.to)
          ))
          .slice(0, 8);
        const moves = (Array.isArray(value?.moves) ? value.moves : [])
          .map(compactAnalysisMove)
          .filter((move) => (
            move.fen.split(/\s+/).length >= 4
            && /^[a-h][1-8]$/.test(move.played.from)
            && /^[a-h][1-8]$/.test(move.played.to)
          ))
          .slice(0, 40);
        const timeline = (Array.isArray(value?.timeline) ? value.timeline : [])
          .map((frame) => ({
            ply: Math.max(1, Number(frame?.ply) || 1),
            moveNumber: Math.max(1, Number(frame?.moveNumber) || 1),
            color: frame?.color === 'b' ? 'b' : 'w',
            san: String(frame?.san || '').slice(0, 20),
            from: String(frame?.from || '').slice(0, 2),
            to: String(frame?.to || '').slice(0, 2),
            fenBefore: String(frame?.fenBefore || '').slice(0, 140),
            fenAfter: String(frame?.fenAfter || '').slice(0, 140)
          }))
          .filter((frame) => (
            frame.fenAfter.split(/\s+/).length >= 4
            && /^[a-h][1-8]$/.test(frame.from)
            && /^[a-h][1-8]$/.test(frame.to)
          ))
          .slice(0, 240);
        const compactPhase = (phase) => ({
          analysedMoves: Math.max(0, Number(phase?.analysedMoves) || 0),
          accuracy: phase?.accuracy !== null && phase?.accuracy !== undefined && Number.isFinite(Number(phase.accuracy))
            ? Math.max(0, Math.min(100, Math.round(Number(phase.accuracy))))
            : null,
          averageLossCp: phase?.averageLossCp !== null && phase?.averageLossCp !== undefined && Number.isFinite(Number(phase.averageLossCp))
            ? Math.max(0, Math.round(Number(phase.averageLossCp)))
            : null
        });
        return {
          schemaVersion: Math.max(0, Number(value?.schemaVersion) || 0),
          analysedMoves: Math.max(0, Number(value?.analysedMoves) || 0),
          overview: {
            accuracy: value?.overview?.accuracy !== null && value?.overview?.accuracy !== undefined && Number.isFinite(Number(value.overview.accuracy))
              ? Math.max(0, Math.min(100, Math.round(Number(value.overview.accuracy))))
              : null,
            verdict: String(value?.overview?.verdict || '').slice(0, 40),
            summary: String(value?.overview?.summary || '').slice(0, 240),
            bestPhase: ['opening', 'middlegame', 'endgame'].includes(value?.overview?.bestPhase)
              ? value.overview.bestPhase
              : '',
            focusPhase: ['opening', 'middlegame', 'endgame'].includes(value?.overview?.focusPhase)
              ? value.overview.focusPhase
              : ''
          },
          phases: {
            opening: compactPhase(value?.phases?.opening),
            middlegame: compactPhase(value?.phases?.middlegame),
            endgame: compactPhase(value?.phases?.endgame)
          },
          summary: {
            inaccuracies: Math.max(0, Number(value?.summary?.inaccuracies) || 0),
            mistakes: Math.max(0, Number(value?.summary?.mistakes) || 0),
            blunders: Math.max(0, Number(value?.summary?.blunders) || 0)
          },
          themes: (Array.isArray(value?.themes) ? value.themes : [])
            .map((theme) => ({
              id: String(theme?.id || '').slice(0, 40),
              label: String(theme?.label || '').slice(0, 60),
              count: Math.max(0, Number(theme?.count) || 0)
            }))
            .filter((theme) => theme.id && theme.label)
            .slice(0, 4),
          moments,
          moves,
          timeline
        };
      }

      function normalizedReviewProgress(value = {}) {
        const storedSchemaVersion = Math.max(0, Number(value?.schemaVersion) || 0);
        const lessons = {};
        Object.entries(value?.lessons || {}).forEach(([id, stored]) => {
          if (!lessonForReviewId(id)) return;
          lessons[id] = {
            misses: Math.max(0, Math.min(99, Number(stored?.misses) || 0)),
            strength: Math.max(0, Math.min(6, Number(stored?.strength) || 0)),
            dueAt: Math.max(0, Number(stored?.dueAt) || 0),
            lastAt: Math.max(0, Number(stored?.lastAt) || 0),
            reason: String(stored?.reason || 'review this lesson').slice(0, 120)
          };
        });
        const games = (Array.isArray(value?.games) ? value.games : [])
          .map((stored) => {
            const normalizedAnalysis = stored?.analysis ? normalizedGameAnalysis(stored.analysis) : null;
            const storedAnalysisStatus = ['queued', 'running', 'complete', 'error'].includes(stored?.analysisStatus)
              ? stored.analysisStatus
              : 'idle';
            const analysisStatus = storedAnalysisStatus === 'complete' && normalizedAnalysis?.schemaVersion < 2
              ? 'idle'
              : storedAnalysisStatus;
            return {
              gameId: String(stored?.gameId || '').slice(0, 100),
              createdAt: Math.max(0, Number(stored?.createdAt) || 0),
              endedAt: Math.max(0, Number(stored?.endedAt) || Number(stored?.createdAt) || 0),
              result: String(stored?.result || '').slice(0, 80),
              opponentName: String(stored?.opponentName || 'opponent').slice(0, 40),
              opponentId: String(stored?.opponentId || '').slice(0, 100),
              mode: String(stored?.mode || '').slice(0, 30),
              difficulty: String(stored?.difficulty || '').slice(0, 30),
              moveCount: Math.max(0, Number(stored?.moveCount) || 0),
              analysisStatus,
              analysisMessage: String(stored?.analysisMessage || '').slice(0, 100),
              analysis: analysisStatus === 'complete' ? normalizedAnalysis : null,
              momentReview: Object.fromEntries(
                Object.entries(stored?.momentReview || {})
                  .filter(([ply]) => Number.isInteger(Number(ply)) && Number(ply) > 0)
                  .map(([ply, review]) => [String(Number(ply)), {
                    strength: Math.max(0, Math.min(6, Number(review?.strength) || 0)),
                    dueAt: Math.max(0, Number(review?.dueAt) || 0),
                    lastAt: Math.max(0, Number(review?.lastAt) || 0)
                  }])
              ),
              recommendations: (Array.isArray(stored?.recommendations)
                ? stored.recommendations
                : [])
                .filter((recommendation) => lessonForReviewId(recommendation?.lessonId))
                .map((recommendation) => ({
                  lessonId: String(recommendation.lessonId),
                  reason: String(recommendation.reason || 'recommended from your game').slice(0, 140),
                  kind: recommendation.kind === 'opening' ? 'opening' : 'lesson'
                }))
                .slice(0, 3)
            };
          })
          .filter((stored) => (
            stored.gameId
            && !(storedSchemaVersion < 3 && stored.analysisStatus === 'error')
            && (
            stored.recommendations.length
            || stored.analysis?.moments?.length
            || stored.analysisStatus !== 'idle'
            )
          ))
          .slice(-20);
        return { schemaVersion: 4, lessons, games };
      }

      function loadReviewProgress(targetSession = session) {
        let stored = {};
        try {
          stored = JSON.parse(localStorage.getItem(
            reviewProgressStorageKeyForSession(targetSession)
          ) || 'null') || {};
        } catch {}
        reviewProgress = normalizedReviewProgress(stored);
        try {
          localStorage.setItem(
            reviewProgressStorageKeyForSession(targetSession),
            JSON.stringify(reviewProgress)
          );
        } catch {}
      }

      function saveReviewProgress() {
        reviewProgress ||= normalizedReviewProgress();
        try {
          localStorage.setItem(
            reviewProgressStorageKeyForSession(),
            JSON.stringify(reviewProgress)
          );
        } catch {}
        if (activeLearnMode === 'review') renderReviewLibrary();
      }

      function dueReviewLessons(level = activeLearnLevel) {
        reviewProgress ||= normalizedReviewProgress();
        const normalizedLevel = normalizedLearnLevel(level);
        const now = Date.now();
        return Object.entries(reviewProgress.lessons)
          .filter(([id, entry]) => (
            lessonLevelForId(id) === normalizedLevel
            && Number(entry.dueAt || 0) <= now
          ))
          .sort(([, first], [, second]) => (
            Number(first.dueAt || 0) - Number(second.dueAt || 0)
            || Number(second.misses || 0) - Number(first.misses || 0)
          ))
          .map(([id]) => id);
      }

      function dueGameMoments() {
        reviewProgress ||= normalizedReviewProgress();
        const now = Date.now();
        const due = [];
        [...reviewProgress.games].reverse().forEach((stored) => {
          (stored.analysis?.moments || []).forEach((moment, index) => {
            const review = stored.momentReview?.[String(moment.ply)];
            if (!review || Number(review.dueAt || 0) <= now) {
              due.push({ gameId: stored.gameId, index, moment });
            }
          });
        });
        return due.sort((first, second) => (
          Number(second.moment.lossCp || 0) - Number(first.moment.lossCp || 0)
        ));
      }

      function recordGameMomentReview(gameId, moment, hadMiss = false) {
        const stored = reviewProgress?.games?.find((gameItem) => gameItem.gameId === gameId);
        if (!stored || !moment) return;
        stored.momentReview ||= {};
        const key = String(moment.ply);
        const previous = stored.momentReview[key] || {};
        const previousStrength = Math.max(0, Number(previous.strength) || 0);
        const strength = hadMiss ? Math.max(0, previousStrength - 1) : Math.min(6, previousStrength + 1);
        const intervals = [1, 3, 7, 14, 30, 60];
        stored.momentReview[key] = {
          strength,
          lastAt: Date.now(),
          dueAt: Date.now() + (hadMiss ? 6 * 60 * 60 * 1000 : intervals[Math.max(0, strength - 1)] * 24 * 60 * 60 * 1000)
        };
        saveReviewProgress();
      }

      function puzzleMistakeCount(level = activeLearnLevel) {
        return puzzleLevelProgress(level).mistakes.length;
      }

      function recordLessonDifficulty(reason = 'missed move') {
        const item = currentLesson();
        if (!lessonState || !item || item.assessment || lessonState.reviewMistakeRecorded) return;
        lessonState.reviewMistakeRecorded = true;
        lessonState.hadMistake = true;
        reviewProgress ||= normalizedReviewProgress();
        const previous = reviewProgress.lessons[item.id] || {};
        reviewProgress.lessons[item.id] = {
          misses: Math.min(99, Math.max(0, Number(previous.misses) || 0) + 1),
          strength: Math.max(0, (Number(previous.strength) || 0) - 1),
          dueAt: Date.now(),
          lastAt: Date.now(),
          reason
        };
        saveReviewProgress();
      }

      function recordLessonCompletion(item) {
        if (!item || item.assessment) return;
        reviewProgress ||= normalizedReviewProgress();
        const previous = reviewProgress.lessons[item.id];
        if (!previous && !lessonState?.hadMistake) return;
        if (lessonState?.hadMistake) {
          reviewProgress.lessons[item.id] = {
            ...(previous || {}),
            misses: Math.max(1, Number(previous?.misses) || 1),
            strength: Math.max(0, Number(previous?.strength) || 0),
            dueAt: Date.now(),
            lastAt: Date.now(),
            reason: previous?.reason || 'review after a difficult lesson'
          };
        } else {
          const nextStrength = Math.min(6, Math.max(0, Number(previous?.strength) || 0) + 1);
          const intervals = [1, 3, 7, 14, 30, 60];
          reviewProgress.lessons[item.id] = {
            ...previous,
            misses: Math.max(0, Number(previous?.misses) || 0),
            strength: nextStrength,
            dueAt: Date.now() + (intervals[nextStrength - 1] * 24 * 60 * 60 * 1000),
            lastAt: Date.now(),
            reason: 'spaced review'
          };
        }
        saveReviewProgress();
      }

      function startRecommendedLesson(id) {
        const level = lessonLevelForId(id);
        const index = lessonIndexByLevel[level]?.get(id);
        if (!level || !Number.isInteger(index)) return false;
        if (!lessonIsUnlocked(index, level)) {
          if (reviewStatus) reviewStatus.textContent = 'complete the linked course or placement first.';
          return false;
        }
        startLesson(level, index);
        return true;
      }

      function analysisPieceName(piece = '') {
        return {
          p: 'pawn',
          n: 'knight',
          b: 'bishop',
          r: 'rook',
          q: 'queen',
          k: 'king'
        }[String(piece).toLowerCase()] || 'piece';
      }

      function analysisMovePhrase(move, { includeFrom = true } = {}) {
        const san = String(move?.san || '');
        if (/^O-O-O/.test(san)) return 'castle queenside';
        if (/^O-O/.test(san)) return 'castle kingside';
        const piece = analysisPieceName(move?.piece);
        const from = String(move?.from || '');
        const to = String(move?.to || '');
        const captured = Boolean(move?.captured || san.includes('x'));
        const destination = captured ? `takes on ${to}` : `to ${to}`;
        const source = includeFrom && from ? ` from ${from}` : '';
        const promotion = move?.promotion
          ? ` and promotes to a ${analysisPieceName(move.promotion)}`
          : '';
        const finish = san.includes('#') ? ', checkmate' : san.includes('+') ? ', check' : '';
        return `${piece}${source} ${destination}${promotion}${finish}`.replace(/\s+/g, ' ').trim();
      }

      function analysisMoveLabel(moment) {
        const moveNumber = Math.max(1, Number(moment?.moveNumber) || 1);
        const prefix = moment?.color === 'b' ? `${moveNumber}...` : `${moveNumber}.`;
        return `${prefix} ${analysisMovePhrase(moment?.played, { includeFrom: false })}`;
      }

      function gameHistoryDate(stored) {
        const timestamp = Number(stored?.endedAt || stored?.createdAt) || 0;
        if (!timestamp) return '';
        try {
          return new Intl.DateTimeFormat(undefined, {
            day: 'numeric', month: 'short', year: new Date(timestamp).getFullYear() === new Date().getFullYear() ? undefined : 'numeric'
          }).format(new Date(timestamp));
        } catch {
          return '';
        }
      }

      function analysisIdea(moment) {
        const bestSan = String(moment?.best?.san || '');
        const bestPiece = analysisPieceName(moment?.best?.piece);
        const capturedPiece = analysisPieceName(moment?.best?.captured);
        if (bestSan.includes('#')) return 'it ends the game.';
        if (bestSan.includes('+')) return 'the king has fewer replies.';
        if (bestSan.includes('x')) return `it wins a ${capturedPiece}.`;
        if (/^O-O/.test(bestSan)) return 'the king is safer and the rook joins the game.';
        if (/=[QRBN]/.test(bestSan)) return 'the pawn becomes a queen.';
        if (moment?.theme === 'king-safety') return 'the king is safer there.';
        if (moment?.theme === 'pawn-structure') return 'the pawns work better together.';
        return {
          rook: 'the rook joins the game.',
          bishop: 'the bishop joins the game.',
          knight: 'the knight finds a better square.',
          queen: 'the queen can do more from there.',
          king: 'the king is safer there.',
          pawn: 'the pawn helps the rest of the position.'
        }[bestPiece] || 'the pieces work better together.';
      }

      function analysisComparison(moment) {
        const played = analysisMovePhrase(moment?.played);
        const best = analysisMovePhrase(moment?.best);
        if (moment?.matchesBest) {
          return `best move\n${played}\n${analysisIdea(moment)}`;
        }
        return `your move\n${played}\n\none move better\n${best}\n${analysisIdea(moment)}`;
      }

      function analysisOverviewCopy(moment) {
        if (moment?.matchesBest) return analysisComparison(moment);
        return `your move\n${analysisMovePhrase(moment?.played)}`;
      }

      function analysisHeadline(moment) {
        if (moment?.matchesBest || moment?.kind === 'best-decision') {
          return `${analysisMovePhrase(moment?.played, { includeFrom: false })} worked well`;
        }
        if (moment?.kind === 'missed-opportunity') {
          return `${analysisMovePhrase(moment?.best, { includeFrom: false })} was worth finding`;
        }
        if (moment?.kind === 'turning-point') return 'the game changed here';
        return 'find one move better';
      }

      function analysisStatusLabel(stored) {
        if (stored.analysisStatus === 'queued') return 'waiting to analyse';
        if (stored.analysisStatus === 'running') return 'analysing your moves';
        if (stored.analysisStatus === 'error') return 'analysis paused';
        const count = stored.analysis?.moments?.length || 0;
        if (stored.analysisStatus === 'complete') {
          return count ? `${count} key ${count === 1 ? 'moment' : 'moments'}` : 'review complete';
        }
        return 'analysis ready';
      }

      function reviewPhaseLabel(phase) {
        return phase === 'middlegame' ? 'middle' : phase;
      }

      function renderReviewBoardPosition(boardElement, fen) {
        const position = boardMap(fen || startingFen);
        const fragment = document.createDocumentFragment();
        '87654321'.split('').forEach((rank, row) => {
          'abcdefgh'.split('').forEach((file, column) => {
            const square = `${file}${rank}`;
            const cell = document.createElement('span');
            const piece = position.get(square);
            cell.className = `osb-live__review-board-square${(row + column) % 2 ? ' is-dark' : ''}`;
            if (piece) {
              const pieceElement = document.createElement('span');
              pieceElement.className = `osb-live__review-board-piece osb-live__piece--${piece === piece.toUpperCase() ? 'white' : 'black'}`;
              setPieceGraphic(pieceElement, piece);
              cell.append(pieceElement);
            }
            fragment.append(cell);
          });
        });
        boardElement.replaceChildren(fragment);
      }

      function reviewTimeline(stored) {
        const timeline = stored.analysis?.timeline || [];
        const sectionElement = document.createElement('section');
        sectionElement.className = 'osb-live__review-timeline';
        sectionElement.setAttribute('aria-label', 'move by move review');
        if (!timeline.length) {
          const empty = document.createElement('p');
          empty.className = 'osb-live__review-game-note';
          empty.textContent = 'move-by-move positions need a full completed game.';
          sectionElement.append(empty);
          return sectionElement;
        }
        const boardElement = document.createElement('div');
        const controls = document.createElement('div');
        const play = document.createElement('button');
        const previous = document.createElement('button');
        const label = document.createElement('span');
        const next = document.createElement('button');
        const moves = document.createElement('div');
        boardElement.className = 'osb-live__review-board';
        boardElement.setAttribute('role', 'img');
        controls.className = 'osb-live__review-timeline-controls';
        play.type = 'button';
        play.textContent = 'play';
        previous.type = 'button';
        previous.textContent = 'previous';
        next.type = 'button';
        next.textContent = 'next';
        label.setAttribute('aria-live', 'polite');
        moves.className = 'osb-live__review-moves';
        const moveButtons = timeline.map((frame) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = `${frame.color === 'b' ? `${frame.moveNumber}...` : `${frame.moveNumber}.`} ${frame.san}`;
          button.setAttribute('aria-label', `move ${button.textContent}`);
          moves.append(button);
          return button;
        });
        let index = Math.max(-1, Math.min(timeline.length - 1, Number(reviewTimelineIndexes.get(stored.gameId) ?? -1)));
        let playbackTimer = null;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const playbackDelay = reducedMotion ? 220 : 720;
        const stopPlayback = () => {
          window.clearTimeout(playbackTimer);
          playbackTimer = null;
          play.textContent = 'play';
          play.setAttribute('aria-label', 'play game');
        };
        const renderFrame = (nextIndex) => {
          index = Math.max(-1, Math.min(timeline.length - 1, Number(nextIndex)));
          reviewTimelineIndexes.set(stored.gameId, index);
          const frame = index >= 0 ? timeline[index] : null;
          renderReviewBoardPosition(boardElement, frame?.fenAfter || startingFen);
          const moveLabel = frame
            ? `${frame.color === 'b' ? `${frame.moveNumber}...` : `${frame.moveNumber}.`} ${frame.san}`
            : 'start position';
          label.textContent = frame ? `after ${moveLabel}` : moveLabel;
          boardElement.setAttribute('aria-label', label.textContent);
          previous.disabled = index < 0;
          next.disabled = index >= timeline.length - 1;
          moveButtons.forEach((button, buttonIndex) => {
            button.classList.toggle('is-current', buttonIndex === index);
            if (buttonIndex === index) button.setAttribute('aria-current', 'step');
            else button.removeAttribute('aria-current');
          });
        };
        const playNextFrame = () => {
          if (index >= timeline.length - 1) {
            stopPlayback();
            return;
          }
          renderFrame(index + 1);
          playbackTimer = window.setTimeout(playNextFrame, playbackDelay);
        };
        play.addEventListener('click', () => {
          if (playbackTimer) {
            stopPlayback();
            return;
          }
          if (index >= timeline.length - 1) renderFrame(-1);
          play.textContent = 'pause';
          play.setAttribute('aria-label', 'pause game');
          playNextFrame();
        });
        previous.addEventListener('click', () => {
          stopPlayback();
          renderFrame(index - 1);
        });
        next.addEventListener('click', () => {
          stopPlayback();
          renderFrame(index + 1);
        });
        moveButtons.forEach((button, buttonIndex) => {
          button.addEventListener('click', () => {
            stopPlayback();
            renderFrame(buttonIndex);
          });
        });
        controls.append(play, previous, label, next);
        sectionElement.append(boardElement, controls, moves);
        play.setAttribute('aria-label', 'play game');
        renderFrame(index);
        return sectionElement;
      }

      function reviewGameDetail(stored) {
        const analysis = stored.analysis;
        const detail = document.createElement('div');
        const summary = document.createElement('p');
        const scores = document.createElement('dl');
        const focus = document.createElement('section');
        const moments = document.createElement('div');
        detail.className = 'osb-live__review-detail';
        summary.className = 'osb-live__review-summary';
        summary.textContent = analysis.overview?.summary || 'review the positions that shaped the game.';
        scores.className = 'osb-live__review-phase-scores';
        const scoreEntries = [
          ['overall', analysis.overview?.accuracy],
          ['opening', analysis.phases?.opening?.accuracy],
          ['middle', analysis.phases?.middlegame?.accuracy],
          ['endgame', analysis.phases?.endgame?.accuracy]
        ];
        scoreEntries.forEach(([name, accuracy]) => {
          if (accuracy === null || accuracy === undefined) return;
          const group = document.createElement('div');
          const term = document.createElement('dt');
          const value = document.createElement('dd');
          term.textContent = name;
          value.textContent = `${accuracy}`;
          group.append(term, value);
          scores.append(group);
        });
        focus.className = 'osb-live__review-focus';
        focus.setAttribute('aria-label', 'one move better');
        const focusMoment = [...(analysis.moments || [])]
          .filter((moment) => !moment.matchesBest)
          .sort((first, second) => Number(second.lossCp || 0) - Number(first.lossCp || 0))[0]
          || analysis.moments?.[0];
        if (focusMoment) {
          const focusLabel = document.createElement('p');
          const focusBody = document.createElement('div');
          const focusTitle = document.createElement('p');
          const focusCopy = document.createElement('p');
          const focusAction = document.createElement('button');
          const focusIndex = analysis.moments.indexOf(focusMoment);
          focusLabel.className = 'osb-live__review-focus-label';
          focusLabel.textContent = 'one move better';
          focusBody.className = 'osb-live__review-focus-body';
          focusTitle.className = 'osb-live__review-focus-title';
          focusTitle.textContent = analysisMoveLabel(focusMoment);
          focusCopy.className = 'osb-live__review-focus-copy';
          focusCopy.textContent = analysisOverviewCopy(focusMoment);
          focusAction.type = 'button';
          focusAction.className = 'osb-live__review-focus-action';
          focusAction.textContent = focusMoment.matchesBest
            ? 'review position'
            : 'find one move better';
          focusAction.addEventListener('click', () => startGameMistakeReview(stored.gameId, focusIndex));
          focusBody.append(focusTitle, focusCopy, focusAction);
          focus.append(focusLabel, focusBody);
        }
        moments.className = 'osb-live__review-moments';
        if (analysis.moments?.length) {
          const momentsLabel = document.createElement('p');
          momentsLabel.className = 'osb-live__review-detail-label';
          momentsLabel.textContent = 'key moments';
          moments.append(momentsLabel);
          analysis.moments.forEach((moment, index) => {
            const button = document.createElement('button');
            const title = document.createElement('span');
            const reason = document.createElement('span');
            button.type = 'button';
            button.className = 'osb-live__review-game-button osb-live__review-game-button--moment';
            button.addEventListener('click', () => startGameMistakeReview(stored.gameId, index));
            title.className = 'osb-live__review-game-title';
            title.textContent = analysisMoveLabel(moment);
            reason.className = 'osb-live__review-game-reason';
            reason.textContent = analysisHeadline(moment);
            button.append(title, reason);
            moments.append(button);
          });
        }
        const learning = document.createElement('div');
        learning.className = 'osb-live__review-detail-learning';
        if (analysis.moments?.length) {
          learning.append(moments, reviewTimeline(stored));
        }
        if (scores.childElementCount) detail.append(scores);
        if (focusMoment) detail.append(focus);
        detail.append(summary);
        if (analysis.moments?.length) detail.append(learning);
        return detail;
      }

      function renderReviewLibrary() {
        reviewProgress ||= normalizedReviewProgress();
        const lessonDue = dueReviewLessons(activeLearnLevel);
        const momentDue = dueGameMoments();
        const dueCount = lessonDue.length + momentDue.length;
        const reviewedGames = [...reviewProgress.games].reverse();
        const puzzleCount = puzzleMistakeCount(activeLearnLevel);
        if (reviewDueCount) reviewDueCount.textContent = String(dueCount);
        if (reviewGameCount) reviewGameCount.textContent = String(reviewedGames.length);
        if (reviewPuzzleCount) reviewPuzzleCount.textContent = String(puzzleCount);
        if (reviewDueButton) reviewDueButton.disabled = !dueCount;
        if (reviewDueLabel) {
          reviewDueLabel.textContent = momentDue.length
            ? analysisMoveLabel(momentDue[0].moment)
            : lessonDue.length
              ? lessonForReviewId(lessonDue[0])?.title || 'lesson ready'
            : 'nothing due';
        }
        if (reviewPuzzlesButton) reviewPuzzlesButton.disabled = !puzzleCount;
        if (reviewPuzzleLabel) {
          reviewPuzzleLabel.textContent = puzzleCount
            ? `${puzzleCount} waiting`
            : 'none waiting';
        }
        if (reviewStatus) reviewStatus.textContent = '';
        if (!reviewGames) return;
        if (!reviewedGames.length) {
          const empty = document.createElement('li');
          empty.className = 'osb-live__review-empty';
          empty.textContent = 'finish a game. its key moments and best next lesson will appear here.';
          reviewGames.replaceChildren(empty);
          return;
        }
        const visibleReviewedGames = showOlderReviewGames
          ? reviewedGames.slice(0, 20)
          : reviewedGames.slice(0, 5);
        const rows = visibleReviewedGames.map((stored) => {
          const row = document.createElement('li');
          const head = document.createElement('div');
          const gameLabel = document.createElement('span');
          const gameStatus = document.createElement('span');
          const body = document.createElement('div');
          row.className = 'osb-live__review-game';
          head.className = 'osb-live__review-game-head';
          gameLabel.className = 'osb-live__review-game-label';
          gameStatus.className = 'osb-live__review-game-state';
          body.className = 'osb-live__review-game-body';
          gameLabel.textContent = `vs ${stored.opponentName || 'opponent'}`;
          gameStatus.textContent = [stored.result || 'complete', gameHistoryDate(stored)]
            .filter(Boolean)
            .join(' · ');
          head.append(gameLabel, gameStatus);

          if (['queued', 'running'].includes(stored.analysisStatus)) {
            const waiting = document.createElement('p');
            waiting.className = 'osb-live__review-game-note';
            waiting.textContent = `${analysisStatusLabel(stored)}. you can keep learning while it finishes.`;
            body.append(waiting);
          } else if (stored.analysisStatus === 'error') {
            const retry = document.createElement('button');
            retry.type = 'button';
            retry.className = 'osb-live__review-game-button';
            retry.innerHTML = '<span>try analysis again</span><span>reopen this finished game</span>';
            retry.addEventListener('click', () => void requestStoredGameAnalysis(stored.gameId));
            body.append(retry);
          } else if (stored.analysisStatus === 'idle') {
            if (session?.player?.kind === 'account') {
              const analyse = document.createElement('button');
              analyse.type = 'button';
              analyse.className = 'osb-live__review-game-button';
              analyse.textContent = 'review game';
              analyse.addEventListener('click', () => void requestStoredGameAnalysis(stored.gameId));
              body.append(analyse);
            }
          } else if (stored.analysisStatus === 'complete') {
            const overview = document.createElement('p');
            const toggle = document.createElement('button');
            const title = document.createElement('span');
            const expanded = expandedReviewGameId === stored.gameId;
            const accuracy = stored.analysis?.overview?.accuracy;
            toggle.type = 'button';
            toggle.className = 'osb-live__review-game-button osb-live__review-game-button--open';
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            toggle.addEventListener('click', () => {
              expandedReviewGameId = expanded ? '' : stored.gameId;
              renderReviewLibrary();
            });
            title.className = 'osb-live__review-game-title';
            title.textContent = expanded ? 'close review' : 'open review';
            toggle.append(title);
            if (accuracy !== null && accuracy !== undefined) {
              overview.className = 'osb-live__review-game-note osb-live__review-game-overview';
              overview.textContent = `${accuracy} accuracy · ${stored.analysis.overview.verdict || 'review ready'}`;
              body.append(overview);
            }
            body.append(toggle);
            if (expanded) body.append(reviewGameDetail(stored));
          }

          const recommendation = stored.recommendations.find((item) => (
            item.kind === 'opening'
            || lessonLevelForId(item.lessonId) === normalizedLearnLevel(activeLearnLevel)
          )) || stored.recommendations[0];
          if (recommendation && expandedReviewGameId === stored.gameId) {
            const item = lessonForReviewId(recommendation.lessonId);
            const button = document.createElement('button');
            const title = document.createElement('span');
            button.type = 'button';
            button.className = 'osb-live__review-game-button osb-live__review-game-button--lesson';
            button.addEventListener('click', () => startRecommendedLesson(recommendation.lessonId));
            title.className = 'osb-live__review-game-title';
            title.textContent = `next lesson · ${item?.title || 'recommended lesson'}`;
            button.append(title);
            body.append(button);
          }
          row.append(head, body);
          return row;
        });
        if (reviewedGames.length > 5) {
          const olderRow = document.createElement('li');
          const olderButton = document.createElement('button');
          olderRow.className = 'osb-live__review-game osb-live__review-game--older';
          olderButton.type = 'button';
          olderButton.className = 'osb-live__review-game-button';
          olderButton.textContent = showOlderReviewGames ? 'latest games' : 'older games';
          olderButton.setAttribute('aria-expanded', showOlderReviewGames ? 'true' : 'false');
          olderButton.addEventListener('click', () => {
            showOlderReviewGames = !showOlderReviewGames;
            expandedReviewGameId = '';
            renderReviewLibrary();
          });
          olderRow.append(olderButton);
          rows.push(olderRow);
        }
        reviewGames.replaceChildren(...rows);
      }

      function learnProgressStorageKeyForSession(targetSession = session) {
        const accountId = targetSession?.player?.kind === 'account'
          ? String(targetSession.player.id || '').trim()
          : '';
        const curriculumKey = encodeURIComponent(learnCurriculumVersion);
        return accountId
          ? `${learnProgressStorageBaseKey}:${curriculumKey}:account:${encodeURIComponent(accountId)}`
          : `${learnProgressStorageBaseKey}:${curriculumKey}:guest`;
      }

      function loadLocalLearnProgressForSession(targetSession = session) {
        const nextIdentityKey = learnProgressStorageKeyForSession(targetSession);
        const identityChanged = Boolean(
          learnProgressIdentityKey
          && learnProgressIdentityKey !== nextIdentityKey
        );
        let storedProgress = {};
        try {
          storedProgress = JSON.parse(
            localStorage.getItem(nextIdentityKey) || 'null'
          ) || {};
        } catch {}
        learnProgressIdentityKey = nextIdentityKey;
        learnProgress = normalizedLearnProgress(storedProgress);
        loadPuzzleProgress(targetSession);
        loadReviewProgress(targetSession);
        if (targetSession?.player?.kind === 'account') void loadGameHistoryFromAccount();
        if (identityChanged && (lessonState || puzzleState)) {
          // A lesson belongs to the identity that opened it. Returning to the
          // library prevents its completion being written to another account.
          showLearnLibrary();
        } else if (puzzleState) {
          renderPuzzleNavigation();
        } else if (lessonState) {
          // Loading another device/account's progress must not move a lesson
          // that the learner has already opened.
          renderLessonNavigation();
        } else if (learnLibrary && !learnLibrary.hidden) {
          renderLearnLibrary();
        }
      }

      function saveLearnProgress({ syncAccount = true } = {}) {
        try {
          localStorage.setItem(
            learnProgressStorageKeyForSession(),
            JSON.stringify({
              ...learnProgress,
              curriculumVersion: learnCurriculumVersion
            })
          );
        } catch {}
        if (syncAccount) void persistLearnProgressToAccount();
      }

      function accountCanSyncLearnProgress() {
        return Boolean(serverUrl && session?.token && session?.player?.kind === 'account');
      }

      function learnProgressSessionIdentity(targetSession = session) {
        return {
          session: targetSession,
          token: String(targetSession?.token || ''),
          accountId: targetSession?.player?.kind === 'account'
            ? String(targetSession.player.id || '').trim()
            : ''
        };
      }

      function learnProgressSessionIsCurrent(identity) {
        return Boolean(
          identity?.session
          && identity.session === session
          && identity.token
          && identity.token === String(session?.token || '')
          && identity.accountId
          && identity.accountId === String(session?.player?.id || '').trim()
          && session?.player?.kind === 'account'
        );
      }

      function normalizedLearnProgress(progress = {}) {
        const completed = Array.from(new Set(
          (Array.isArray(progress.completed) ? progress.completed : [])
            .filter((id) => allLearnLessons.some((item) => item.id === id))
        ));
        const currentLessonId = allLearnLessons.some((item) => item.id === progress.currentLessonId)
          ? progress.currentLessonId
          : '';
        return { schemaVersion: 2, completed, currentLessonId };
      }

      async function persistLearnProgressToAccount() {
        if (!accountCanSyncLearnProgress()) return;
        try {
          const response = await fetch(`${serverUrl}/api/learn/progress`, {
            method: 'PUT',
            headers: {
              authorization: `Bearer ${session.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              curriculumVersion: learnCurriculumVersion,
              completedLessonIds: learnProgress.completed,
              currentLessonId: learnProgress.currentLessonId
            })
          });
          if (!response.ok && response.status !== 401 && response.status !== 404) {
            throw new Error('learn progress could not sync');
          }
        } catch {}
      }

      async function loadLearnProgressFromAccount() {
        if (!accountCanSyncLearnProgress()) return;
        const requestIdentity = learnProgressSessionIdentity();
        try {
          const response = await fetch(
            `${serverUrl}/api/learn/progress?curriculumVersion=${encodeURIComponent(learnCurriculumVersion)}`,
            { headers: { authorization: `Bearer ${requestIdentity.token}` } }
          );
          if (!learnProgressSessionIsCurrent(requestIdentity)) return;
          if (!response.ok) return;
          const serverProgress = await response.json();
          if (!learnProgressSessionIsCurrent(requestIdentity)) return;
          const mergedCompleted = Array.from(new Set([
            ...learnProgress.completed,
            ...(Array.isArray(serverProgress?.completedLessonIds)
              ? serverProgress.completedLessonIds
              : [])
          ]));
          const preferredCurrentLessonId = [
            learnProgress.currentLessonId,
            serverProgress?.currentLessonId
          ].find((id) => allLearnLessons.some((item) => item.id === id)) || '';
          const fallbackLevel = learnLevelIsUnlocked(lessonState?.level)
            ? lessonState.level
            : learnLevelIsUnlocked(activeLearnLevel)
              ? activeLearnLevel
              : recommendedLearnLevel();
          const firstIncompleteLesson = lessonsForLevel(fallbackLevel).find(
            (item) => !mergedCompleted.includes(item.id)
          ) || allLearnLessons.find(
            (item) => !mergedCompleted.includes(item.id)
          );
          const merged = normalizedLearnProgress({
            completed: mergedCompleted,
            currentLessonId: preferredCurrentLessonId || firstIncompleteLesson?.id || ''
          });
          if (!learnProgressSessionIsCurrent(requestIdentity)) return;
          learnProgress = merged;
          if (!learnProgressSessionIsCurrent(requestIdentity)) return;
          saveLearnProgress({ syncAccount: false });
          if (lessonState) {
            // Account sync may arrive after a learner has already opened a lesson.
            // Merge completion in place without interrupting that active lesson.
            renderLessonNavigation();
          } else if (learnLibrary && !learnLibrary.hidden) {
            renderLearnLibrary();
          }
          void persistLearnProgressToAccount();
        } catch {}
      }

      function firstIncompleteLessonIndex(level = activeLearnLevel) {
        return lessonsForLevel(level).findIndex(
          (item, index) => (
            lessonIsUnlocked(index, level)
            && !learnProgress.completed.includes(item.id)
          )
        );
      }

      function lessonIsUnlocked(index, level = lessonState?.level || activeLearnLevel) {
        const normalizedLevel = normalizedLearnLevel(level);
        const curriculum = learnCurricula[normalizedLevel];
        if (
          !curriculum
          || !Number.isInteger(index)
          || index < 0
          || index >= curriculum.lessons.length
        ) return false;
        if (learnProgress.completed.includes(curriculum.lessons[index].id)) return true;
        const course = courseForLessonIndex(index, normalizedLevel);
        const courseIndex = curriculum.courses.indexOf(course);
        if (!courseIsUnlocked(courseIndex, normalizedLevel)) return false;
        if (placementIsComplete(normalizedLevel)) return true;
        const indexes = courseLessonIndexes(course, normalizedLevel);
        const indexWithinCourse = indexes.indexOf(index);
        if (indexWithinCourse <= 0) return true;
        const previousLesson = curriculum.lessons[indexes[indexWithinCourse - 1]];
        return Boolean(previousLesson && learnProgress.completed.includes(previousLesson.id));
      }

      function libraryResumeLessonIndex(level = activeLearnLevel) {
        const lessons = lessonsForLevel(level);
        const storedIndex = lessons.findIndex(
          (item) => item.id === learnProgress.currentLessonId
        );
        const firstIncomplete = firstIncompleteLessonIndex(level);
        if (firstIncomplete >= 0) {
          const storedLessonIsAvailable = storedIndex >= 0
            && lessonIsUnlocked(storedIndex, level)
            && !learnProgress.completed.includes(lessons[storedIndex]?.id);
          return storedLessonIsAvailable ? storedIndex : firstIncomplete;
        }
        return storedIndex >= 0 ? storedIndex : 0;
      }

      function libraryResumeLessonIndexForCourses(courses, level = activeLearnLevel) {
        if (activeLearnTrack === 'core') return libraryResumeLessonIndex(level);
        const lessons = lessonsForLevel(level);
        const indexes = courses.flatMap((course) => courseLessonIndexes(course, level));
        const storedIndex = lessons.findIndex(
          (item) => item.id === learnProgress.currentLessonId
        );
        const storedLessonIsAvailable = indexes.includes(storedIndex)
          && lessonIsUnlocked(storedIndex, level)
          && !learnProgress.completed.includes(lessons[storedIndex]?.id);
        if (storedLessonIsAvailable) return storedIndex;
        const firstIncomplete = indexes.find(
          (index) => (
            lessonIsUnlocked(index, level)
            && !learnProgress.completed.includes(lessons[index]?.id)
          )
        );
        const firstUnlocked = indexes.find((index) => lessonIsUnlocked(index, level));
        return Number.isInteger(firstIncomplete)
          ? firstIncomplete
          : firstUnlocked;
      }

      function renderLessonLevelButtons() {
        lessonLevelButtons.forEach((button) => {
          const level = button.dataset.osbLessonLevel || 'beginner';
          const available = Boolean(learnCurricula[level]?.lessons?.length);
          const unlocked = available && learnLevelIsUnlocked(level);
          button.disabled = !unlocked;
          button.setAttribute('aria-disabled', unlocked ? 'false' : 'true');
          button.setAttribute('aria-pressed', level === activeLearnLevel ? 'true' : 'false');
        });
      }

      function renderLearnLibraryLevelButtons() {
        learnLibraryLevelButtons.forEach((button) => {
          const level = normalizedLearnLevel(
            button.dataset.osbLearnLibraryLevel || 'beginner'
          );
          const unlocked = ['puzzles', 'review'].includes(activeLearnMode)
            || learnLevelIsUnlocked(level);
          button.disabled = !unlocked;
          button.setAttribute('aria-disabled', unlocked ? 'false' : 'true');
          button.setAttribute('aria-pressed', level === activeLearnLevel ? 'true' : 'false');
          button.classList.toggle('is-complete', learnLevelIsComplete(level));
        });
      }

      function renderLearnLibraryTrackButtons() {
        learnLibraryTrackButtons.forEach((button) => {
          const track = normalizedLearnTrack(
            button.dataset.osbLearnLibraryTrack || 'core'
          );
          button.setAttribute('aria-pressed', track === activeLearnTrack ? 'true' : 'false');
        });
      }

      function renderLearnOpeningGroupButtons() {
        const openingMode = activeLearnTrack === 'openings';
        const openingCourses = coursesForLevel(activeLearnLevel).filter(
          (course) => course.track === 'openings'
        );
        const availableGroups = new Set(
          openingCourses.map((course) => course.openingGroup).filter(Boolean)
        );
        if (
          activeLearnOpeningGroup !== 'all'
          && !availableGroups.has(activeLearnOpeningGroup)
        ) {
          activeLearnOpeningGroup = 'all';
        }
        if (learnOpeningGroups) learnOpeningGroups.hidden = !openingMode;
        learnOpeningGroupButtons.forEach((button) => {
          const group = normalizedLearnOpeningGroup(
            button.dataset.osbLearnOpeningGroup || 'all'
          );
          const available = group === 'all' || availableGroups.has(group);
          button.hidden = !available;
          button.setAttribute(
            'aria-pressed',
            group === activeLearnOpeningGroup ? 'true' : 'false'
          );
        });
      }

      function renderLearnPlacementButton() {
        if (!learnPlacementButton) return;
        const passed = placementIsComplete(activeLearnLevel);
        learnPlacementButton.textContent = passed ? 'placement passed' : 'placement';
        learnPlacementButton.classList.toggle('is-passed', passed);
        learnPlacementButton.setAttribute(
          'aria-label',
          `${passed ? 'review' : 'take'} ${activeLearnLevel} placement`
        );
      }

      function renderLearnLibrary() {
        if (!learnLibrary || !learnLibraryCourses) return;
        learnLibrary.dataset.mode = activeLearnMode;
        const preferredLevel = normalizedLearnLevel(activeLearnLevel);
        activeLearnLevel = ['puzzles', 'review'].includes(activeLearnMode)
          || learnLevelIsUnlocked(preferredLevel)
          ? preferredLevel
          : recommendedLearnLevel();
        renderLearnModeButtons();
        renderLearnLibraryLevelButtons();
        if (activeLearnMode === 'puzzles') {
          if (learnLibraryProgress) learnLibraryProgress.textContent = '';
          if (learnPlacementButton) learnPlacementButton.hidden = true;
          renderPuzzleLibrary();
          return;
        }
        if (activeLearnMode === 'review') {
          if (learnLibraryProgress) learnLibraryProgress.textContent = '';
          if (learnPlacementButton) learnPlacementButton.hidden = true;
          renderReviewLibrary();
          void loadGameHistoryFromAccount();
          return;
        }
        if (learnPlacementButton) learnPlacementButton.hidden = false;
        activeLearnTrack = normalizedLearnTrack(activeLearnTrack);
        activeLearnOpeningGroup = normalizedLearnOpeningGroup(activeLearnOpeningGroup);
        const lessons = lessonsForLevel(activeLearnLevel);
        const allCourses = coursesForLevel(activeLearnLevel);
        renderLearnOpeningGroupButtons();
        const courses = coursesForTrack(activeLearnLevel, activeLearnTrack);
        const trackLessonIds = new Set(courses.flatMap((course) => course.lessonIds));
        const trackLessons = lessons.filter((item) => trackLessonIds.has(item.id));
        const completedCount = trackLessons.filter(
          (item) => learnProgress.completed.includes(item.id)
        ).length;
        const allComplete = Boolean(trackLessons.length && completedCount === trackLessons.length);
        const resumeIndex = libraryResumeLessonIndexForCourses(courses, activeLearnLevel);
        const resumeLesson = Number.isInteger(resumeIndex) ? lessons[resumeIndex] : null;
        const resumeCourse = courseForLessonIndex(resumeIndex, activeLearnLevel);
        const resumeAction = allComplete ? 'review' : completedCount > 0 ? 'continue' : 'start';

        if (learnLibraryProgress) {
          learnLibraryProgress.textContent = `${completedCount} of ${trackLessons.length}`;
        }
        if (learnResumeAction) learnResumeAction.textContent = resumeAction;
        if (learnResumeLabel) learnResumeLabel.textContent = resumeLesson?.title || 'your first move';
        if (learnResumeButton) {
          learnResumeButton.hidden = !resumeLesson;
          learnResumeButton.setAttribute(
            'aria-label',
            `${resumeAction} ${resumeLesson?.title || 'your first lesson'}`
          );
        }

        renderLearnLibraryTrackButtons();
        renderLearnOpeningGroupButtons();
        renderLearnPlacementButton();
        renderLessonLevelButtons();
        const rows = courses.map((course) => {
          const courseIndex = allCourses.indexOf(course);
          const indexes = courseLessonIndexes(course, activeLearnLevel);
          const courseCompletedCount = course.lessonIds.filter(
            (id) => learnProgress.completed.includes(id)
          ).length;
          const complete = courseIsComplete(course, activeLearnLevel);
          const unlocked = courseIsUnlocked(courseIndex, activeLearnLevel);
          const current = course.id === resumeCourse?.id;
          const unlockLabel = courseUnlockLabel(course, activeLearnLevel);
          const action = unlocked ? 'lessons' : `requires ${unlockLabel}`;
          const row = document.createElement('li');
          const button = document.createElement('button');
          const marker = document.createElement('span');
          const title = document.createElement('span');
          const progress = document.createElement('span');
          const statusLabel = document.createElement('span');
          const courseLessons = document.createElement('ol');
          const coursePanelId = `${section.id || 'osb-live'}-${activeLearnLevel}-${course.id}-lessons`
            .replace(/[^a-z0-9_-]+/gi, '-');

          row.className = 'osb-live__learn-library-course';
          row.classList.toggle('is-complete', complete);
          row.classList.toggle('is-current', current);
          row.classList.toggle('is-locked', !unlocked);

          button.className = 'osb-live__learn-library-course-button';
          button.type = 'button';
          button.disabled = !unlocked;
          button.setAttribute('aria-disabled', unlocked ? 'false' : 'true');
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-controls', coursePanelId);
          button.setAttribute(
            'aria-label',
            unlocked
              ? `${course.title}, ${courseCompletedCount} of ${indexes.length} lessons complete, open lessons`
              : `${course.title}, ${action}`
          );
          if (current) button.setAttribute('aria-current', 'step');
          if (unlocked) {
            button.addEventListener('click', () => {
              const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
              learnLibraryCourses
                .querySelectorAll('.osb-live__learn-library-course-button[aria-expanded="true"]')
                .forEach((openButton) => {
                  if (openButton === button) return;
                  openButton.setAttribute('aria-expanded', 'false');
                  const openPanel = document.getElementById(openButton.getAttribute('aria-controls'));
                  if (openPanel) openPanel.hidden = true;
                  const openStatus = openButton.querySelector('.osb-live__learn-library-course-status');
                  if (openStatus) openStatus.textContent = 'lessons';
                });
              button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
              courseLessons.hidden = !shouldOpen;
              statusLabel.textContent = shouldOpen ? 'close' : 'lessons';
              if (shouldOpen) {
                window.requestAnimationFrame(() => {
                  row.scrollIntoView({
                    block: 'nearest',
                    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
                      ? 'auto'
                      : 'smooth'
                  });
                });
              }
            });
          }

          marker.className = 'osb-live__learn-library-course-marker';
          marker.setAttribute('aria-hidden', 'true');
          title.className = 'osb-live__learn-library-course-title';
          title.textContent = course.title;
          progress.className = 'osb-live__learn-library-course-progress';
          progress.textContent = `${courseCompletedCount} of ${indexes.length}`;
          statusLabel.className = 'osb-live__learn-library-course-status';
          statusLabel.textContent = action;

          button.append(marker, title);
          if (unlocked) button.append(progress);
          button.append(statusLabel);
          courseLessons.id = coursePanelId;
          courseLessons.className = 'osb-live__learn-library-lessons';
          courseLessons.hidden = true;
          indexes.forEach((index, indexWithinCourse) => {
            const item = lessons[index];
            if (!item) return;
            const lessonComplete = learnProgress.completed.includes(item.id);
            const lessonUnlocked = lessonIsUnlocked(index, activeLearnLevel);
            const lessonCurrent = item.id === learnProgress.currentLessonId;
            const lessonAction = lessonComplete
              ? 'replay'
              : lessonCurrent
                ? 'continue'
                : lessonUnlocked ? 'start' : 'locked';
            const lessonRow = document.createElement('li');
            const lessonButton = document.createElement('button');
            const lessonMarker = document.createElement('span');
            const lessonTitle = document.createElement('span');
            const lessonStatus = document.createElement('span');

            lessonRow.className = 'osb-live__learn-library-lesson';
            lessonRow.classList.toggle('is-complete', lessonComplete);
            lessonRow.classList.toggle('is-current', lessonCurrent);
            lessonRow.classList.toggle('is-locked', !lessonUnlocked);
            lessonButton.className = 'osb-live__learn-library-lesson-button';
            lessonButton.type = 'button';
            lessonButton.disabled = !lessonUnlocked;
            lessonButton.setAttribute('aria-disabled', lessonUnlocked ? 'false' : 'true');
            lessonButton.setAttribute(
              'aria-label',
              `${indexWithinCourse + 1}. ${item.title}, ${lessonAction}`
            );
            if (lessonCurrent) lessonButton.setAttribute('aria-current', 'step');
            if (lessonUnlocked) {
              lessonButton.addEventListener('click', () => {
                startLesson(activeLearnLevel, index);
              });
            }
            lessonMarker.className = 'osb-live__learn-library-lesson-marker';
            lessonMarker.setAttribute('aria-hidden', 'true');
            lessonTitle.className = 'osb-live__learn-library-lesson-title';
            lessonTitle.textContent = `${indexWithinCourse + 1}. ${item.title}`;
            lessonStatus.className = 'osb-live__learn-library-lesson-status';
            lessonStatus.textContent = lessonAction;
            lessonButton.append(lessonMarker, lessonTitle, lessonStatus);
            lessonRow.append(lessonButton);
            courseLessons.append(lessonRow);
          });
          row.append(button, courseLessons);
          return row;
        });
        if (!rows.length) {
          const empty = document.createElement('li');
          empty.className = 'osb-live__learn-library-empty';
          empty.textContent = `no ${activeLearnTrack} courses at this level yet.`;
          rows.push(empty);
        }
        learnLibraryCourses.replaceChildren(...rows);
      }

      function showLearnLibrary(options = {}) {
        const requestedMode = options.mode
          || (puzzleState ? 'puzzles' : activeLearnMode);
        const requestedLevel = options.level
          || puzzleState?.level
          || lessonState?.level
          || lessonLevelForId(learnProgress.currentLessonId)
          || activeLearnLevel
          || recommendedLearnLevel();
        const normalizedLevel = normalizedLearnLevel(requestedLevel);
        activeLearnMode = ['puzzles', 'review'].includes(requestedMode)
          ? requestedMode
          : 'courses';
        activeLearnLevel = ['puzzles', 'review'].includes(activeLearnMode)
          || learnLevelIsUnlocked(normalizedLevel)
          ? normalizedLevel
          : recommendedLearnLevel();
        stopLesson({ restore: false });
        arena?.classList.remove('is-lobby', 'is-matching', 'is-game-active', 'is-game-ended', 'is-learning');
        arena?.classList.add('is-learn-library');
        if (learnLibrary) learnLibrary.hidden = false;
        if (lessonNav) lessonNav.hidden = true;
        if (lesson) lesson.hidden = true;
        if (controls) controls.hidden = true;
        setGameChatVisible(false);
        setStatus('');
        renderLearnLibrary();
      }

      function setLessonOutline(open) {
        if (!lessonOutline || !lessonPathTrigger) return;
        const shouldOpen = Boolean(open);
        lessonOutline.classList.toggle('is-open', shouldOpen);
        lessonPathTrigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        if (lessonPathAction) lessonPathAction.textContent = shouldOpen ? 'close' : 'lessons';
      }

      function currentLesson() {
        if (lessonState?.assessmentLesson) return lessonState.assessmentLesson;
        return lessonState
          ? lessonsForLevel(lessonState.level)[lessonState.lessonIndex]
          : null;
      }

      function currentLessonAttempt() {
        const item = currentLesson();
        const displayedIndex = Number(lessonState?.attemptIndex) || 0;
        const sourceIndex = Array.isArray(lessonState?.attemptSequence)
          ? lessonState.attemptSequence[displayedIndex]
          : displayedIndex;
        return item?.attempts?.[sourceIndex] || null;
      }

      function lessonAttemptCount() {
        return Array.isArray(lessonState?.attemptSequence)
          ? lessonState.attemptSequence.length
          : (currentLesson()?.attempts?.length || 0);
      }

      function shuffledAttemptIndexes(total, size) {
        const indexes = Array.from({ length: Math.max(0, total) }, (_, index) => index);
        for (let index = indexes.length - 1; index > 0; index -= 1) {
          const swapIndex = Math.floor(Math.random() * (index + 1));
          [indexes[index], indexes[swapIndex]] = [indexes[swapIndex], indexes[index]];
        }
        return indexes.slice(0, Math.max(1, Math.min(indexes.length, size)));
      }

      function fenTurn(fen) {
        return String(fen || '').trim().split(/\s+/)[1] === 'b' ? 'b' : 'w';
      }

      function oppositeColor(value) {
        return value === 'w' ? 'b' : 'w';
      }

      function clearLessonMovementGuide() {
        if (!lessonMovement) return;
        lessonMovement.replaceChildren();
        lessonMovement.setAttribute('hidden', '');
      }

      function lessonMovementPoint(square) {
        const coordinates = squareCoordinates(square);
        if (coordinates.file < 0 || !Number.isFinite(coordinates.rank)) return null;
        return color === 'b'
          ? {
              x: 7 - coordinates.file + 0.5,
              y: coordinates.rank - 1 + 0.5
            }
          : {
              x: coordinates.file + 0.5,
              y: 8 - coordinates.rank + 0.5
            };
      }

      function showLessonMovementGuide(guide) {
        clearLessonMovementGuide();
        const paths = Array.isArray(guide?.paths) ? guide.paths : [];
        if (!lessonMovement || !paths.length) return;
        const namespace = 'http://www.w3.org/2000/svg';
        paths.forEach((path, index) => {
          const points = (Array.isArray(path) ? path : [])
            .map(lessonMovementPoint)
            .filter(Boolean);
          if (points.length < 2) return;
          const polyline = document.createElementNS(namespace, 'polyline');
          polyline.setAttribute('points', points.map((point) => `${point.x},${point.y}`).join(' '));
          polyline.setAttribute('pathLength', '1');
          polyline.style.animationDelay = `${index * 90}ms`;
          lessonMovement.appendChild(polyline);
          const destination = points[points.length - 1];
          const endpoint = document.createElementNS(namespace, 'circle');
          endpoint.setAttribute('cx', String(destination.x));
          endpoint.setAttribute('cy', String(destination.y));
          endpoint.setAttribute('r', '0.09');
          lessonMovement.appendChild(endpoint);
        });
        if (lessonMovement.childElementCount) {
          lessonMovement.removeAttribute('hidden');
        } else {
          lessonMovement.setAttribute('hidden', '');
        }
      }

      function lessonUsesMovementGuide(item) {
        const geometryMovements = new Set(['straight', 'diagonal', 'knight', 'king-safe']);
        return Boolean(
          item?.example?.movementGuide
          && item?.attempts?.some((attempt) => geometryMovements.has(attempt?.rule?.movement))
        );
      }

      function lessonMoveMatches(move, candidate) {
        return Boolean(
          move
          && candidate
          && move.from === candidate.from
          && move.to === candidate.to
          && String(move.promotion || candidate.promotion || '') === String(candidate.promotion || '')
        );
      }

      function lessonAcceptedMoves() {
        return currentLessonAttempt()?.accepted || [];
      }

      function lessonSourceSquares() {
        const attempt = currentLessonAttempt();
        const ruleSources = Array.isArray(attempt?.rule?.from) ? attempt.rule.from : [];
        return Array.from(new Set([
          ...ruleSources,
          ...lessonAcceptedMoves().map((move) => move.from)
        ].filter(Boolean)));
      }

      function lessonAttemptColor() {
        const attempt = currentLessonAttempt();
        return attempt?.rule?.color || fenTurn(attempt?.fen);
      }

      function lessonCanSelectSquare(square) {
        const attempt = currentLessonAttempt();
        const sources = lessonSourceSquares();
        const advancedAttempt = normalizedLearnLevel(lessonState?.level) === 'advanced';
        return Boolean(
          lessonState?.stage === 'try'
          && pieceColor(renderedPosition.get(square)) === lessonAttemptColor()
          && (
            advancedAttempt
            ||
            attempt?.allowAnyLegalSource === true
            || !sources.length
            || sources.includes(square)
          )
        );
      }

      function lessonPositionAfterMove(position, move) {
        const nextPosition = new Map(position);
        const piece = nextPosition.get(move.from);
        if (!piece) return nextPosition;
        const target = nextPosition.get(move.to);
        nextPosition.delete(move.from);
        if (piece.toLowerCase() === 'p' && !target && move.from[0] !== move.to[0]) {
          nextPosition.delete(`${move.to[0]}${move.from[1]}`);
        }
        if (
          piece.toLowerCase() === 'k'
          && Math.abs(move.from.charCodeAt(0) - move.to.charCodeAt(0)) === 2
        ) {
          const rank = move.from[1];
          const kingSide = move.to[0] === 'g';
          const rookFrom = `${kingSide ? 'h' : 'a'}${rank}`;
          const rookTo = `${kingSide ? 'f' : 'd'}${rank}`;
          const rook = nextPosition.get(rookFrom);
          nextPosition.delete(rookFrom);
          if (rook) nextPosition.set(rookTo, rook);
        }
        const promoted = move.promotion
          ? (piece === piece.toUpperCase() ? move.promotion.toUpperCase() : move.promotion.toLowerCase())
          : piece;
        nextPosition.set(move.to, promoted);
        return nextPosition;
      }

      function lessonKingIsSafe(position, movingPiece) {
        const movingColor = pieceColor(movingPiece);
        const kingPiece = movingColor === 'w' ? 'K' : 'k';
        const kingSquare = Array.from(position).find(([, piece]) => piece === kingPiece)?.[0] || '';
        if (!kingSquare) return true;
        return !Array.from(position).some(([square, piece]) => (
          pieceColor(piece) !== movingColor
          && pieceAttacksSquare(position, square, piece, kingSquare)
        ));
      }

      function lessonRuleMatches(rule, position, from, to) {
        if (!rule || !from || !to || from === to) return false;
        if (Array.isArray(rule.from) && rule.from.length && !rule.from.includes(from)) return false;
        const piece = position.get(from);
        const target = position.get(to);
        if (!piece || pieceColor(piece) !== (rule.color || 'w')) return false;
        if (rule.piece && piece.toLowerCase() !== rule.piece) return false;
        if (target && (pieceColor(target) === pieceColor(piece) || target.toLowerCase() === 'k')) return false;

        const source = squareCoordinates(from);
        const destination = squareCoordinates(to);
        if (
          source.file < 0
          || destination.file < 0
          || !Number.isFinite(source.rank)
          || !Number.isFinite(destination.rank)
        ) return false;
        const fileDistance = Math.abs(destination.file - source.file);
        const rankDistance = Math.abs(destination.rank - source.rank);
        if (rule.movement === 'diagonal' && fileDistance !== rankDistance) return false;
        if (rule.movement === 'straight' && source.file !== destination.file && source.rank !== destination.rank) return false;
        if (rule.movement === 'knight' && !(
          (fileDistance === 1 && rankDistance === 2)
          || (fileDistance === 2 && rankDistance === 1)
        )) return false;
        if (rule.movement === 'king-safe' && Math.max(fileDistance, rankDistance) !== 1) return false;
        if (rule.sameFile && source.file !== destination.file) return false;
        if (rule.sameRank && source.rank !== destination.rank) return false;
        if (!pieceAttacksSquare(position, from, piece, to)) return false;

        const projected = lessonPositionAfterMove(position, { from, to });
        return lessonKingIsSafe(projected, piece);
      }

      function lessonMoveIsLegal(position, from, to, promotion = '', options = {}) {
        if (!from || !to || from === to) return false;
        const piece = position.get(from);
        const target = position.get(to);
        const movingColor = pieceColor(piece);
        const requiredColor = options.color || lessonAttemptColor();
        if (!piece || movingColor !== requiredColor) return false;
        if (target && (pieceColor(target) === movingColor || target.toLowerCase() === 'k')) return false;

        const source = squareCoordinates(from);
        const destination = squareCoordinates(to);
        if (
          source.file < 0
          || destination.file < 0
          || !Number.isFinite(source.rank)
          || !Number.isFinite(destination.rank)
        ) return false;

        const fileDistance = destination.file - source.file;
        const rankDistance = destination.rank - source.rank;
        const absoluteFileDistance = Math.abs(fileDistance);
        const absoluteRankDistance = Math.abs(rankDistance);
        const type = piece.toLowerCase();
        let legalGeometry = false;

        if (type === 'p') {
          const direction = movingColor === 'w' ? 1 : -1;
          const startRank = movingColor === 'w' ? 2 : 7;
          const enPassantSquare = String(
            options.fen
            || lessonState?.positionFen
            || currentLessonAttempt()?.fen
            || startingFen
          ).split(/\s+/)[3] || '-';
          if (fileDistance === 0 && !target) {
            const intermediate = `${from[0]}${source.rank + direction}`;
            legalGeometry = rankDistance === direction
              || (
                source.rank === startRank
                && rankDistance === direction * 2
                && !position.has(intermediate)
              );
          } else {
            legalGeometry = absoluteFileDistance === 1
              && rankDistance === direction
              && Boolean(
                (target && pieceColor(target) !== movingColor)
                || (!target && to === enPassantSquare)
              );
          }
        } else if (type === 'n') {
          legalGeometry = (
            absoluteFileDistance === 1
            && absoluteRankDistance === 2
          ) || (
            absoluteFileDistance === 2
            && absoluteRankDistance === 1
          );
        } else if (type === 'k') {
          legalGeometry = Math.max(absoluteFileDistance, absoluteRankDistance) === 1;
          if (!legalGeometry && absoluteFileDistance === 2 && rankDistance === 0) {
            const kingSide = fileDistance > 0;
            const homeRank = movingColor === 'w' ? 1 : 8;
            const homeSquare = `e${homeRank}`;
            const destinationSquare = `${kingSide ? 'g' : 'c'}${homeRank}`;
            const rookSquare = `${kingSide ? 'h' : 'a'}${homeRank}`;
            const rook = position.get(rookSquare);
            const step = kingSide ? 1 : -1;
            const pathIsClear = [1, 2, ...(kingSide ? [] : [3])].every((offset) => (
              !position.has(`${'abcdefgh'[source.file + (step * offset)]}${homeRank}`)
            ));
            const castlingRights = String(
              options.fen
              || lessonState?.positionFen
              || currentLessonAttempt()?.fen
              || startingFen
            )
              .split(/\s+/)[2] || '-';
            const requiredRight = movingColor === 'w'
              ? (kingSide ? 'K' : 'Q')
              : (kingSide ? 'k' : 'q');
            const transitSquare = `${kingSide ? 'f' : 'd'}${homeRank}`;
            const transitPosition = lessonPositionAfterMove(position, {
              from,
              to: transitSquare
            });
            legalGeometry = Boolean(
              from === homeSquare
              && to === destinationSquare
              && castlingRights.includes(requiredRight)
              && rook
              && rook.toLowerCase() === 'r'
              && pieceColor(rook) === movingColor
              && pathIsClear
              && lessonKingIsSafe(position, piece)
              && lessonKingIsSafe(transitPosition, piece)
            );
          }
        } else {
          legalGeometry = pieceAttacksSquare(position, from, piece, to);
        }
        if (!legalGeometry) return false;

        const reachesPromotionRank = type === 'p' && (to.endsWith('1') || to.endsWith('8'));
        const projected = lessonPositionAfterMove(position, {
          from,
          to,
          promotion: promotion || (reachesPromotionRank ? 'q' : '')
        });
        if (options.ignoreKingSafety === true) return true;
        return lessonKingIsSafe(projected, piece);
      }

      function resolveLessonMove(from, to) {
        const attempt = currentLessonAttempt();
        const exactMove = lessonAcceptedMoves().find((candidate) =>
          lessonMoveMatches({ from, to }, candidate)
        );
        if (exactMove) {
          return {
            ...exactMove,
            capture: Boolean(renderedPosition.get(to))
          };
        }
        if (!lessonRuleMatches(attempt?.rule, renderedPosition, from, to)) return null;
        return {
          from,
          to,
          capture: Boolean(renderedPosition.get(to))
        };
      }

      function evaluateLessonMove(from, to) {
        const geometryIsLegal = lessonMoveIsLegal(
          renderedPosition,
          from,
          to,
          '',
          { ignoreKingSafety: true }
        );
        if (!geometryIsLegal) {
          return { status: 'illegal', move: null };
        }
        if (!lessonMoveIsLegal(renderedPosition, from, to)) {
          return { status: 'self-check', move: null };
        }
        const objectiveMove = resolveLessonMove(from, to);
        if (!objectiveMove) {
          return {
            status: 'miss',
            move: {
              from,
              to,
              capture: Boolean(renderedPosition.get(to))
            }
          };
        }
        return { status: 'correct', move: objectiveMove };
      }

      function lessonPhaseLabel(value) {
        return {
          explain: 'concept',
          watch: 'example',
          review: 'review',
          try: 'guided',
          use: 'practice',
          apply: 'practice',
          independent: 'challenge',
          prove: 'challenge',
          feedback: 'result',
          result: 'result',
          complete: 'complete'
        }[value] || value;
      }

      function setLessonPhase(value) {
        if (lessonPhase) lessonPhase.textContent = lessonPhaseLabel(value);
      }

      function setLessonFeedback(
        kind = '',
        from = '',
        to = '',
        clearAfter = 0,
        restoreCopy = ''
      ) {
        window.clearTimeout(lessonFeedbackTimer);
        lessonFeedbackTimer = null;
        if (!lessonState) return;
        const runId = lessonState.runId;
        const attemptIndex = lessonState.attemptIndex;
        lessonState.feedback = kind ? { kind, from, to } : null;
        refreshSquareStates();
        if (kind && clearAfter > 0) {
          lessonFeedbackTimer = window.setTimeout(() => {
            if (
              !lessonState
              || lessonState.runId !== runId
              || lessonState.attemptIndex !== attemptIndex
              || lessonState.stage !== 'try'
            ) return;
            lessonState.feedback = null;
            setLessonStatus('');
            if (restoreCopy) setLessonCopy(restoreCopy);
            refreshSquareStates();
          }, clearAfter);
        }
      }

      function renderLessonNavigation() {
        if (!lessonState) return;
        if (lessonPathTrigger) {
          lessonPathTrigger.hidden = false;
          lessonPathTrigger.disabled = false;
          lessonPathTrigger.setAttribute('aria-disabled', 'false');
        }
        const level = lessonState.level;
        const lessons = lessonsForLevel(level);
        const activeItem = currentLesson();
        if (activeItem?.assessment?.kind === 'placement') {
          if (lessonProgress) {
            const currentPosition = Math.min(
              lessonAttemptCount(),
              (Number(lessonState.attemptIndex) || 0) + 1
            );
            lessonProgress.textContent = `${currentPosition} of ${lessonAttemptCount()}`;
          }
          if (lessonLevelTrigger) lessonLevelTrigger.textContent = level;
          activeLearnLevel = level;
          renderLessonLevelButtons();
          if (lessonTitle) lessonTitle.textContent = activeItem.title;
          if (lessonModule) lessonModule.textContent = 'placement';
          if (lessonPathLabel) lessonPathLabel.textContent = `${level} · placement`;
          lessonCourseList?.replaceChildren();
          lessonList?.replaceChildren();
          return;
        }
        if (activeItem?.assessment?.kind === 'practice') {
          const practiceCourse = currentCourse();
          if (lessonProgress) {
            const currentPosition = Math.min(
              lessonAttemptCount(),
              (Number(lessonState.attemptIndex) || 0) + 1
            );
            lessonProgress.textContent = `${currentPosition} of ${lessonAttemptCount()}`;
          }
          if (lessonLevelTrigger) lessonLevelTrigger.textContent = level;
          activeLearnLevel = level;
          renderLessonLevelButtons();
          if (lessonTitle) lessonTitle.textContent = activeItem.title;
          if (lessonModule) lessonModule.textContent = 'opening practice';
          if (lessonPathLabel) {
            lessonPathLabel.textContent = `${level} · ${practiceCourse.title} · practice`;
          }
          lessonCourseList?.replaceChildren();
          lessonList?.replaceChildren();
          return;
        }
        if (activeItem?.assessment?.kind === 'analysis') {
          if (lessonProgress) lessonProgress.textContent = analysisMoveLabel(activeItem.analysisMoment);
          if (lessonLevelTrigger) lessonLevelTrigger.textContent = level;
          activeLearnLevel = level;
          renderLessonLevelButtons();
          if (lessonTitle) lessonTitle.textContent = activeItem.title;
          if (lessonModule) lessonModule.textContent = 'game analysis';
          if (lessonPathLabel) lessonPathLabel.textContent = `review · game analysis · ${activeItem.title}`;
          lessonCourseList?.replaceChildren();
          lessonList?.replaceChildren();
          return;
        }
        const courses = coursesForLevel(level);
        const activeIndex = lessonState.lessonIndex;
        const activeCourse = currentCourse();
        const activeCourseIndex = Math.max(0, courses.indexOf(activeCourse));
        const activeCourseLessonIndexes = courseLessonIndexes(activeCourse, level);
        const activeCourseLessonIndex = lessonIndexWithinCourse(
          activeIndex,
          activeCourse,
          level
        );
        if (lessonProgress) {
          lessonProgress.textContent = activeItem?.assessment
            ? `${Math.min(lessonAttemptCount(), (Number(lessonState.attemptIndex) || 0) + 1)} of ${lessonAttemptCount()}`
            : `${activeCourseLessonIndex + 1} of ${activeCourseLessonIndexes.length}`;
        }
        if (lessonLevelTrigger) lessonLevelTrigger.textContent = lessonState.level;
        activeLearnLevel = level;
        renderLessonLevelButtons();
        const activeTitle = currentLesson()?.title || 'learn';
        if (lessonTitle) lessonTitle.textContent = activeTitle;
        if (lessonModule) lessonModule.textContent = activeCourse.title;
        if (lessonPathLabel) {
          lessonPathLabel.textContent = `${level} · ${activeCourse.title} · ${activeCourseLessonIndex + 1}. ${activeTitle}`;
        }

        if (lessonCourseList) {
          const courseFragment = document.createDocumentFragment();
          courses.forEach((course, courseIndex) => {
            const row = document.createElement('li');
            const button = document.createElement('button');
            const unlocked = courseIsUnlocked(courseIndex, level);
            button.type = 'button';
            button.textContent = course.title;
            button.classList.toggle('is-current', courseIndex === activeCourseIndex);
            button.classList.toggle('is-complete', courseIsComplete(course, level));
            button.classList.toggle('is-locked', !unlocked);
            button.disabled = !unlocked;
            button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
            if (courseIndex === activeCourseIndex) button.setAttribute('aria-current', 'true');
            button.addEventListener('click', () => {
              if (button.disabled) return;
              const targetIndex = firstAvailableLessonIndexForCourse(course, level);
              if (targetIndex === lessonState.lessonIndex) {
                setLessonOutline(false);
                return;
              }
              setLessonOutline(false);
              startLesson(level, targetIndex);
            });
            row.appendChild(button);
            courseFragment.appendChild(row);
          });
          lessonCourseList.replaceChildren(courseFragment);
        }

        if (!lessonList) return;
        const fragment = document.createDocumentFragment();
        activeCourseLessonIndexes.forEach((index, indexWithinCourse) => {
          const item = lessons[index];
          if (!item) return;
          const row = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = `${indexWithinCourse + 1}. ${item.title}`;
          button.classList.toggle('is-current', index === activeIndex);
          button.classList.toggle('is-complete', learnProgress.completed.includes(item.id));
          button.classList.toggle('is-locked', !lessonIsUnlocked(index, level));
          button.disabled = !lessonIsUnlocked(index, level);
          button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
          if (index === activeIndex) button.setAttribute('aria-current', 'step');
          button.addEventListener('click', () => {
            if (button.disabled) return;
            setLessonOutline(false);
            startLesson(level, index);
          });
          row.appendChild(button);
          fragment.appendChild(row);
        });
        lessonList.replaceChildren(fragment);
      }

      function setLessonActions({
        hint = false,
        secondaryLabel = '',
        explainLabel = '',
        continueLabel = ''
      } = {}) {
        if (lessonHintButton) {
          const label = secondaryLabel || (hint ? 'hint' : '');
          lessonHintButton.hidden = !label;
          lessonHintButton.textContent = label;
        }
        if (lessonExplainButton) {
          lessonExplainButton.hidden = !explainLabel;
          if (explainLabel) lessonExplainButton.textContent = explainLabel;
        }
        if (lessonContinueButton) {
          lessonContinueButton.hidden = !continueLabel;
          if (continueLabel) lessonContinueButton.textContent = continueLabel;
        }
      }

      function startLessonAttempt(index = 0) {
        if (!lessonState) return;
        clearLessonTimers();
        lessonState.runId = `${Date.now()}:${Math.random()}`;
        clearLessonMovementGuide();
        const item = currentLesson();
        lessonState.attemptIndex = index;
        const attempt = currentLessonAttempt();
        if (!attempt) return;
        const finalAttempt = index === lessonAttemptCount() - 1;
        lessonState.stage = 'try';
        lessonState.flowStage = finalAttempt
          ? 'independent'
          : item?.guided
            ? (attempt.phase || (index === 0 ? 'try' : 'use'))
            : (index === 0 ? 'try' : 'apply');
        lessonState.hintLevel = 0;
        lessonState.lastMove = null;
        lessonState.feedback = null;
        lessonState.retryCurrentAttempt = false;
        lessonState.highlightSquares = new Set();
        lessonState.positionFen = attempt.fen || startingFen;
        lessonState.turn = fenTurn(lessonState.positionFen);
        lessonState.outcomeCacheKey = '';
        lessonState.outcome = null;
        selectedSquare = null;
        syncBoard(boardMap(lessonState.positionFen));
        setLessonPhase(lessonState.flowStage);
        setLessonStatus('');
        setLessonCopy(attempt.prompt);
        setLessonActions({
          hint: (
            !finalAttempt
            || item?.assessment?.kind === 'analysis'
          ) && attempt.allowHint !== false
            && Array.isArray(attempt.hints)
            && attempt.hints.length > 0
        });
        if (item?.assessment) renderLessonNavigation();
      }

      function playLessonExample({ returnAttemptIndex = 0 } = {}) {
        if (!lessonState) return;
        clearLessonTimers();
        lessonState.runId = `${Date.now()}:${Math.random()}`;
        const item = currentLesson();
        const moves = item?.example?.moves || [];
        const runId = lessonState.runId;
        const boundedReturnAttempt = Math.max(
          0,
          Math.min((item?.attempts?.length || 1) - 1, Number(returnAttemptIndex) || 0)
        );
        lessonState.stage = 'watch';
        lessonState.flowStage = 'watch';
        lessonState.watchReturnAttemptIndex = boundedReturnAttempt;
        lessonState.lastMove = null;
        lessonState.feedback = null;
        lessonState.highlightSquares = new Set();
        lessonState.positionFen = item?.example?.fen || startingFen;
        lessonState.turn = fenTurn(lessonState.positionFen);
        lessonState.outcomeCacheKey = '';
        lessonState.outcome = null;
        selectedSquare = null;
        setLessonPhase('watch');
        setLessonStatus('');
        setLessonCopy(item?.example?.prompt || 'watch the idea.');
        setLessonActions();
        syncBoard(boardMap(lessonState.positionFen));
        showLessonMovementGuide(lessonUsesMovementGuide(item) ? item?.example?.movementGuide : null);

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const moveDelay = reducedMotion ? 220 : 1050;
        const finishDelay = reducedMotion ? 180 : 500;
        const initialDelay = reducedMotion ? 150 : 650;
        let moveIndex = 0;
        const playNext = () => {
          if (lessonState?.runId !== runId) return;
          if (moveIndex >= moves.length) {
            lessonResetTimer = window.setTimeout(() => {
              if (lessonState?.runId !== runId) return;
              const demonstratedMove = moves[moves.length - 1] || null;
              lessonState.stage = 'watch-complete';
              lessonState.flowStage = 'watch';
              lessonState.feedback = demonstratedMove
                ? { kind: 'correct', from: demonstratedMove.from, to: demonstratedMove.to }
                : null;
              setLessonCopy(item?.example?.after || 'look at what changed.');
              setLessonActions({
                secondaryLabel: 'watch again',
                continueLabel: boundedReturnAttempt > 0 ? 'back to lesson' : 'your turn'
              });
              refreshSquareStates();
            }, finishDelay);
            return;
          }
          const move = moves[moveIndex];
          lessonState.lastMove = move;
          lessonState.turn = oppositeColor(lessonState.turn);
          lessonState.outcomeCacheKey = '';
          lessonState.outcome = null;
          syncBoard(projectedPosition(move), move, true);
          moveIndex += 1;
          lessonDemonstrationTimer = window.setTimeout(playNext, moveDelay);
        };
        lessonDemonstrationTimer = window.setTimeout(playNext, initialDelay);
      }

      function finishAssessment() {
        if (!lessonState || !currentLesson()?.assessment) return;
        const item = currentLesson();
        if (item.assessment.kind === 'analysis') {
          const moment = item.analysisMoment;
          recordGameMomentReview(
            lessonState.analysisGameId,
            moment,
            Boolean(lessonState.analysisHadMiss)
          );
          const nextIndex = Number(lessonState.analysisMomentIndex) + 1;
          const stored = reviewProgress?.games?.find((gameItem) => (
            gameItem.gameId === lessonState.analysisGameId
          ));
          const hasNext = nextIndex < (stored?.analysis?.moments?.length || 0);
          lessonState.stage = 'analysis-result';
          lessonState.flowStage = 'result';
          lessonState.feedback = null;
          lessonState.highlightSquares = new Set();
          selectedSquare = null;
          setLessonPhase('result');
          setLessonStatus('moment reviewed.');
          setLessonCopy(analysisComparison(moment));
          setLessonActions({
            secondaryLabel: 'back to review',
            continueLabel: hasNext ? 'next moment' : 'finish review'
          });
          refreshSquareStates();
          return;
        }
        if (item.assessment.kind === 'practice') {
          const score = Math.max(0, Number(lessonState.assessmentCorrect) || 0);
          const total = lessonAttemptCount();
          lessonState.stage = 'practice-result';
          lessonState.flowStage = 'practice';
          lessonState.feedback = null;
          lessonState.highlightSquares = new Set();
          selectedSquare = null;
          setLessonPhase('practice');
          setLessonStatus(`${score} of ${total} correct.`);
          setLessonCopy(
            score === total
              ? 'repertoire recalled cleanly. use it in your next game.'
              : 'repeat the set until the opening decisions feel automatic.'
          );
          setLessonActions({
            secondaryLabel: 'courses',
            continueLabel: 'practice again'
          });
          refreshSquareStates();
          return;
        }
        const isPlacement = item.assessment.kind === 'placement';
        const required = Math.max(1, Number(item.assessment.pass) || 1);
        const score = Math.max(0, Number(lessonState.assessmentCorrect) || 0);
        if (score >= required) {
          completeLesson();
          return;
        }
        lessonState.stage = 'assessment-result';
        lessonState.flowStage = 'result';
        lessonState.feedback = null;
        lessonState.highlightSquares = new Set();
        selectedSquare = null;
        setLessonPhase('result');
        setLessonStatus(
          isPlacement ? 'placement not passed.' : 'checkpoint not passed.',
          { danger: true }
        );
        setLessonCopy(
          `${score} of ${lessonAttemptCount()}. ${item.assessment.recommendation || 'review, then try again.'}`
        );
        setLessonActions({ continueLabel: 'try again' });
        refreshSquareStates();
      }

      function completeLesson() {
        if (!lessonState) return;
        clearLessonMovementGuide();
        const item = currentLesson();
        const completedLevel = normalizedLearnLevel(lessonState.level);
        recordLessonCompletion(item);
        if (item && !learnProgress.completed.includes(item.id)) {
          learnProgress.completed.push(item.id);
        }
        if (item?.assessment?.kind === 'placement') {
          learnProgress.currentLessonId = item.id;
          saveLearnProgress();
          lessonState.nextLessonIndex = -1;
          lessonState.nextLessonLevel = completedLevel;
          lessonState.stage = 'complete';
          lessonState.flowStage = 'complete';
          lessonState.feedback = null;
          lessonState.highlightSquares = new Set();
          selectedSquare = null;
          setLessonPhase('complete');
          setLessonStatus('placement passed.');
          setLessonCopy(`${completedLevel} courses are now unlocked.`);
          setLessonActions({ continueLabel: 'courses' });
          renderLessonLevelButtons();
          renderLessonNavigation();
          refreshSquareStates();
          return;
        }
        let nextLessonLevel = completedLevel;
        let nextLessonIndex = firstIncompleteLessonIndex(completedLevel);
        if (nextLessonIndex < 0) {
          const nextLevel = learnLevelOrder[learnLevelOrder.indexOf(completedLevel) + 1];
          if (
            nextLevel
            && learnLevelIsUnlocked(nextLevel)
            && lessonsForLevel(nextLevel).length
          ) {
            nextLessonLevel = nextLevel;
            nextLessonIndex = firstIncompleteLessonIndex(nextLevel);
            if (nextLessonIndex < 0) nextLessonIndex = 0;
          }
        }
        const nextLesson = nextLessonIndex >= 0
          ? lessonsForLevel(nextLessonLevel)[nextLessonIndex]
          : null;
        const practiceCourse = openingPracticeCourseForLesson(item, completedLevel);
        learnProgress.currentLessonId = nextLesson?.id || item?.id || '';
        saveLearnProgress();
        lessonState.nextLessonIndex = nextLessonIndex;
        lessonState.nextLessonLevel = nextLessonLevel;
        lessonState.stage = 'complete';
        lessonState.flowStage = 'complete';
        lessonState.feedback = null;
        lessonState.highlightSquares = new Set();
        selectedSquare = null;
        setLessonPhase('complete');
        setLessonStatus('lesson complete.');
        setLessonCopy(
          nextLessonIndex < 0
            ? `${completedLevel} complete.`
            : nextLessonLevel !== completedLevel
              ? `continue to ${nextLessonLevel}.`
            : 'lesson complete.'
        );
        setLessonActions({
          secondaryLabel: practiceCourse ? 'practice opening' : '',
          continueLabel: nextLessonIndex < 0
            ? 'courses'
            : nextLessonLevel !== completedLevel
              ? 'next level'
              : 'next lesson'
        });
        renderLessonLevelButtons();
        renderLessonNavigation();
        refreshSquareStates();
      }

      function showLessonHint() {
        if (lessonState?.stage !== 'try') return;
        if (
          lessonState.attemptIndex === lessonAttemptCount() - 1
          && currentLesson()?.assessment?.kind !== 'analysis'
        ) return;
        const attempt = currentLessonAttempt();
        const hints = Array.isArray(attempt?.hints) ? attempt.hints : [];
        if (!attempt || attempt.allowHint === false || !hints.length) return;
        recordLessonDifficulty('used a hint');
        lessonState.feedback = null;
        window.clearTimeout(lessonFeedbackTimer);
        lessonFeedbackTimer = null;
        lessonState.hintLevel = Math.min(3, Number(lessonState.hintLevel || 0) + 1);
        const hintIndex = Math.min(lessonState.hintLevel - 1, hints.length - 1);
        setLessonStatus('hint.');
        setLessonCopy(hints[hintIndex]);
        const sources = lessonAcceptedMoves().map((move) => move.from);
        const targets = lessonAcceptedMoves().map((move) => move.to);
        lessonState.highlightSquares = new Set(
          lessonState.hintLevel === 2
            ? sources
            : lessonState.hintLevel >= 3
              ? targets
              : []
        );
        refreshSquareStates();
      }

      function stopLesson(options = {}) {
        const wasLearning = Boolean(lessonState || puzzleState || (learnLibrary && !learnLibrary.hidden));
        const restoreColor = lessonState?.previousColor || puzzleState?.previousColor || color;
        clearLessonTimers();
        clearLessonMovementGuide();
        setLessonStatus('');
        board?.classList.remove('is-terminal-muted');
        lessonState = null;
        puzzleState = null;
        selectedSquare = null;
        pendingMove = null;
        premove = null;
        closePromotion();
        lessonCopy?.classList.remove('is-changing');
        if (lesson) lesson.hidden = true;
        if (lessonNav) lessonNav.hidden = true;
        if (learnLibrary) learnLibrary.hidden = true;
        if (lessonLevels) lessonLevels.hidden = true;
        lessonLevelTrigger?.setAttribute('aria-expanded', 'false');
        setLessonOutline(false);
        setLessonActions();
        arena?.classList.remove('is-learning', 'is-learn-library');
        squareElements.forEach((element) => element.classList.remove(
          'is-lesson-target',
          'is-puzzle-hint-from',
          'is-puzzle-hint-to',
          'is-lesson-correct-from',
          'is-lesson-correct-to',
          'is-lesson-miss-from',
          'is-lesson-miss-to',
          'is-lesson-wrong-from',
          'is-lesson-wrong-to'
        ));
        if (!wasLearning || options.restore === false) return;
        color = restoreColor;
        syncBoard(boardMap(game?.fen || startingFen));
      }

      function startPlacement(level = activeLearnLevel) {
        const placementLevel = normalizedLearnLevel(level);
        const item = learnPlacements[placementLevel];
        if (!item?.attempts?.length) return;
        const previousColor = lessonState?.previousColor || color;
        stopLesson({ restore: false });
        clearLessonTimers();
        clearLessonMovementGuide();
        activeLearnLevel = placementLevel;
        const attemptSequence = shuffledAttemptIndexes(
          item.attempts.length,
          Number(item.assessment?.size) || 5
        );
        const startingAttempt = item.attempts[attemptSequence[0]];
        const startingLessonFen = startingAttempt?.fen || startingFen;
        lessonState = {
          level: placementLevel,
          lessonIndex: -1,
          assessmentLesson: item,
          attemptSequence,
          attemptIndex: 0,
          assessmentCorrect: 0,
          assessmentAnswered: 0,
          stage: 'assessment-intro',
          flowStage: 'placement',
          hintLevel: 0,
          highlightSquares: new Set(),
          runId: `${Date.now()}:${Math.random()}`,
          lastMove: null,
          feedback: null,
          hadMistake: false,
          reviewMistakeRecorded: false,
          retryCurrentAttempt: false,
          watchReturnAttemptIndex: 0,
          turn: fenTurn(startingLessonFen),
          positionFen: startingLessonFen,
          outcomeCacheKey: '',
          outcome: null,
          previousColor
        };
        selectedSquare = null;
        pendingMove = null;
        premove = null;
        color = 'w';
        arena?.classList.remove('is-lobby', 'is-matching', 'is-game-active', 'is-game-ended', 'is-learn-library');
        arena?.classList.add('is-learning');
        if (learnLibrary) learnLibrary.hidden = true;
        if (lessonNav) lessonNav.hidden = false;
        if (lessonPathTrigger) lessonPathTrigger.hidden = false;
        if (learnLibraryTrigger) learnLibraryTrigger.textContent = 'courses';
        if (lesson) lesson.hidden = false;
        if (controls) controls.hidden = true;
        renderLessonLevelButtons();
        setGameChatVisible(false);
        renderLessonNavigation();
        syncBoard(boardMap(startingLessonFen));
        setStatus('');
        setLessonPhase('placement');
        setLessonStatus('');
        setLessonCopy(item.intro);
        setLessonActions({ continueLabel: 'begin placement' });
      }

      function playAnalysisComparison({ revealBest = false } = {}) {
        if (!lessonState || currentLesson()?.assessment?.kind !== 'analysis') return;
        const item = currentLesson();
        const moment = item?.analysisMoment;
        if (!moment?.fen || !moment?.best?.from || !moment?.best?.to) return;
        clearLessonTimers();
        lessonState.runId = `${Date.now()}:${Math.random()}`;
        const runId = lessonState.runId;
        lessonState.stage = 'watch';
        lessonState.flowStage = 'watch';
        lessonState.feedback = null;
        lessonState.highlightSquares = new Set();
        lessonState.positionFen = moment.fen;
        lessonState.turn = fenTurn(moment.fen);
        lessonState.outcomeCacheKey = '';
        lessonState.outcome = null;
        selectedSquare = null;
        setLessonPhase('review');
        setLessonActions();
        const showBest = Boolean(revealBest || moment.matchesBest);
        lessonState.analysisRevealBest = showBest;
        const frames = showBest
          ? [{ label: moment.matchesBest ? 'best move' : 'one move better', move: moment.best }]
          : [{ label: 'your move', move: moment.played }];
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const startDelay = reducedMotion ? 120 : 620;
        const holdDelay = reducedMotion ? 260 : 1050;
        const finishDelay = reducedMotion ? 160 : 480;
        let frameIndex = 0;
        const playFrame = () => {
          if (lessonState?.runId !== runId) return;
          if (frameIndex >= frames.length) {
            lessonDemonstrationTimer = window.setTimeout(() => {
              if (lessonState?.runId !== runId) return;
              if (!showBest) {
                startLessonAttempt(0);
                return;
              }
              lessonState.stage = 'watch-complete';
              lessonState.flowStage = 'watch';
              lessonState.feedback = {
                kind: 'correct',
                from: moment.best.from,
                to: moment.best.to
              };
              setLessonStatus('');
              setLessonCopy(analysisComparison(moment));
              setLessonActions({
                secondaryLabel: 'watch again',
                continueLabel: 'try it'
              });
              refreshSquareStates();
            }, finishDelay);
            return;
          }
          const frame = frames[frameIndex];
          syncBoard(boardMap(moment.fen));
          lessonState.lastMove = null;
          setLessonStatus(frame.label);
          setLessonCopy(`${frame.label}\n${analysisMovePhrase(frame.move)}`);
          lessonResetTimer = window.setTimeout(() => {
            if (lessonState?.runId !== runId) return;
            lessonState.lastMove = frame.move;
            syncBoard(projectedPosition(frame.move), frame.move, true);
            frameIndex += 1;
            lessonDemonstrationTimer = window.setTimeout(playFrame, holdDelay);
          }, startDelay);
        };
        playFrame();
      }

      function startGameMistakeReview(gameId, momentIndex = 0) {
        reviewProgress ||= normalizedReviewProgress();
        const stored = reviewProgress.games.find((item) => item.gameId === gameId);
        const moments = stored?.analysis?.moments || [];
        const boundedIndex = Math.max(0, Math.min(moments.length - 1, Number(momentIndex) || 0));
        const moment = moments[boundedIndex];
        if (!stored || !moment) {
          showLearnLibrary({ mode: 'review' });
          return;
        }
        const recommendedLesson = stored.recommendations?.[0];
        const analysisLevel = lessonLevelForId(recommendedLesson?.lessonId)
          || activeLearnLevel
          || recommendedLearnLevel();
        const strongDecision = moment.matchesBest || moment.kind === 'best-decision';
        const playedPhrase = analysisMovePhrase(moment.played);
        const bestPhrase = analysisMovePhrase(moment.best);
        const item = {
          id: `analysis:${gameId}:${moment.ply}`,
          title: analysisMoveLabel(moment),
          intro: strongDecision
            ? `best move\n${playedPhrase}\nwatch it, then find it again.`
            : `your move\n${playedPhrase}`,
          assessment: { kind: 'analysis', size: 1 },
          analysisMoment: moment,
          attempts: [{
            fen: moment.fen,
            prompt: strongDecision
              ? 'find the best move again.'
              : 'find one move better.',
            accepted: [{
              from: moment.best.from,
              to: moment.best.to,
              ...(moment.best.promotion ? { promotion: moment.best.promotion } : {})
            }],
            allowAnyLegalSource: true,
            allowHint: false,
            hints: [
              'compare every check, capture and threat before choosing.',
              `start with the ${analysisPieceName(moment.best.piece)} on ${moment.best.from}.`,
              `move it to ${moment.best.to}.`
            ],
            illegal: 'that move is not legal in this position.',
            legalMiss: 'not quite. compare every check, capture and threat.',
            success: `one move better\n${bestPhrase}\n${analysisIdea(moment)}`
          }]
        };
        const previousColor = lessonState?.previousColor || color;
        stopLesson({ restore: false });
        clearLessonTimers();
        clearLessonMovementGuide();
        activeLearnLevel = normalizedLearnLevel(analysisLevel);
        lessonState = {
          level: activeLearnLevel,
          lessonIndex: -1,
          assessmentLesson: item,
          attemptSequence: [0],
          attemptIndex: 0,
          assessmentCorrect: 0,
          assessmentAnswered: 0,
          analysisGameId: gameId,
          analysisMomentIndex: boundedIndex,
          analysisHadMiss: false,
          stage: 'assessment-intro',
          flowStage: 'analysis',
          hintLevel: 0,
          highlightSquares: new Set(),
          runId: `${Date.now()}:${Math.random()}`,
          lastMove: null,
          feedback: null,
          hadMistake: false,
          reviewMistakeRecorded: false,
          retryCurrentAttempt: false,
          watchReturnAttemptIndex: 0,
          turn: fenTurn(moment.fen),
          positionFen: moment.fen,
          outcomeCacheKey: '',
          outcome: null,
          previousColor
        };
        selectedSquare = null;
        pendingMove = null;
        premove = null;
        color = fenTurn(moment.fen);
        arena?.classList.remove('is-lobby', 'is-matching', 'is-game-active', 'is-game-ended', 'is-learn-library');
        arena?.classList.add('is-learning');
        if (learnLibrary) learnLibrary.hidden = true;
        if (lessonNav) lessonNav.hidden = false;
        if (lessonPathTrigger) lessonPathTrigger.hidden = false;
        if (learnLibraryTrigger) learnLibraryTrigger.textContent = 'review';
        if (lesson) lesson.hidden = false;
        if (controls) controls.hidden = true;
        renderLessonLevelButtons();
        setGameChatVisible(false);
        renderLessonNavigation();
        syncBoard(boardMap(moment.fen));
        setStatus('');
        setLessonPhase('review');
        setLessonStatus('');
        setLessonCopy(item.intro);
        setLessonActions();
        playAnalysisComparison({ revealBest: strongDecision });
      }

      function startOpeningPractice(courseOrId, level = activeLearnLevel) {
        const practiceLevel = normalizedLearnLevel(level);
        const course = typeof courseOrId === 'string'
          ? coursesForLevel(practiceLevel).find((item) => item.id === courseOrId)
          : courseOrId;
        const item = openingPracticeItem(course, practiceLevel);
        if (!item?.attempts?.length) return;
        const previousColor = lessonState?.previousColor || color;
        stopLesson({ restore: false });
        clearLessonTimers();
        clearLessonMovementGuide();
        activeLearnLevel = practiceLevel;
        const startingLessonFen = item.attempts[0]?.fen || startingFen;
        lessonState = {
          level: practiceLevel,
          lessonIndex: -1,
          assessmentLesson: item,
          attemptSequence: item.attempts.map((_, index) => index),
          attemptIndex: 0,
          assessmentCorrect: 0,
          assessmentAnswered: 0,
          stage: 'assessment-intro',
          flowStage: 'practice',
          practiceCourseId: course.id,
          hintLevel: 0,
          highlightSquares: new Set(),
          runId: `${Date.now()}:${Math.random()}`,
          lastMove: null,
          feedback: null,
          hadMistake: false,
          reviewMistakeRecorded: false,
          retryCurrentAttempt: false,
          watchReturnAttemptIndex: 0,
          turn: fenTurn(startingLessonFen),
          positionFen: startingLessonFen,
          outcomeCacheKey: '',
          outcome: null,
          previousColor
        };
        selectedSquare = null;
        pendingMove = null;
        premove = null;
        color = fenTurn(startingLessonFen);
        arena?.classList.remove('is-lobby', 'is-matching', 'is-game-active', 'is-game-ended', 'is-learn-library');
        arena?.classList.add('is-learning');
        if (learnLibrary) learnLibrary.hidden = true;
        if (lessonNav) lessonNav.hidden = false;
        if (lessonPathTrigger) lessonPathTrigger.hidden = false;
        if (learnLibraryTrigger) learnLibraryTrigger.textContent = 'courses';
        if (lesson) lesson.hidden = false;
        if (controls) controls.hidden = true;
        renderLessonLevelButtons();
        setGameChatVisible(false);
        renderLessonNavigation();
        syncBoard(boardMap(startingLessonFen));
        setStatus('');
        setLessonPhase('practice');
        setLessonStatus('');
        setLessonCopy(item.intro);
        setLessonActions({ continueLabel: 'start practice' });
      }

      function startLesson(level = 'beginner', requestedIndex = null) {
        const previousColor = lessonState?.previousColor || color;
        stopLesson({ restore: false });
        clearLessonTimers();
        clearLessonMovementGuide();
        const requestedLevel = String(level || '');
        if (!learnCurricula[requestedLevel]?.lessons?.length) {
          showLearnLibrary({ level: recommendedLearnLevel() });
          return;
        }
        const lessonLevel = requestedLevel;
        const lessons = lessonsForLevel(lessonLevel);
        if (!lessons.length) {
          showLearnLibrary({ level: recommendedLearnLevel() });
          return;
        }
        activeLearnLevel = lessonLevel;
        const firstIncomplete = firstIncompleteLessonIndex(lessonLevel);
        const storedLessonIndex = lessons.findIndex(
          (item) => item.id === learnProgress.currentLessonId
        );
        const fallbackIndex = storedLessonIndex >= 0
          && lessonIsUnlocked(storedLessonIndex, lessonLevel)
          && !learnProgress.completed.includes(lessons[storedLessonIndex]?.id)
          ? storedLessonIndex
          : firstIncomplete >= 0 ? firstIncomplete : 0;
        const boundedRequestedIndex = Number.isInteger(requestedIndex)
          ? Math.max(0, Math.min(lessons.length - 1, requestedIndex))
          : fallbackIndex;
        const lessonIndex = lessonIsUnlocked(boundedRequestedIndex, lessonLevel)
          ? boundedRequestedIndex
          : fallbackIndex;
        if (!lessonIsUnlocked(lessonIndex, lessonLevel)) {
          showLearnLibrary({ level: lessonLevel });
          return;
        }
        const item = lessons[lessonIndex];
        learnProgress.currentLessonId = item?.id || '';
        saveLearnProgress();
        const runId = `${Date.now()}:${Math.random()}`;
        const attemptSequence = item?.assessment
          ? shuffledAttemptIndexes(
              item.attempts?.length || 0,
              Number(item.assessment.size) || 5
            )
          : null;
        const assessmentStartingAttempt = Array.isArray(attemptSequence)
          ? item?.attempts?.[attemptSequence[0]]
          : null;
        const startingLessonFen = assessmentStartingAttempt?.fen
          || item?.example?.fen
          || startingFen;
        lessonState = {
          level: lessonLevel,
          lessonIndex,
          attemptIndex: 0,
          attemptSequence,
          assessmentCorrect: 0,
          assessmentAnswered: 0,
          stage: item?.assessment ? 'assessment-intro' : 'explain',
          flowStage: item?.assessment ? item.assessment.kind : 'explain',
          hintLevel: 0,
          highlightSquares: new Set(),
          runId,
          lastMove: null,
          feedback: null,
          hadMistake: false,
          reviewMistakeRecorded: false,
          retryCurrentAttempt: false,
          watchReturnAttemptIndex: 0,
          turn: fenTurn(startingLessonFen),
          positionFen: startingLessonFen,
          outcomeCacheKey: '',
          outcome: null,
          previousColor
        };
        selectedSquare = null;
        pendingMove = null;
        premove = null;
        color = 'w';
        arena?.classList.remove('is-lobby', 'is-matching', 'is-game-active', 'is-game-ended', 'is-learn-library');
        arena?.classList.add('is-learning');
        if (learnLibrary) learnLibrary.hidden = true;
        if (lessonNav) lessonNav.hidden = false;
        if (lessonPathTrigger) lessonPathTrigger.hidden = false;
        if (learnLibraryTrigger) learnLibraryTrigger.textContent = 'courses';
        if (lesson) lesson.hidden = false;
        if (controls) controls.hidden = true;
        renderLessonLevelButtons();
        setGameChatVisible(false);
        renderLessonNavigation();
        syncBoard(boardMap(startingLessonFen));
        setStatus('');
        setLessonStatus('');
        if (item?.assessment) {
          setLessonPhase(item.assessment.kind);
          setLessonCopy(item.intro || 'solve the positions without help.');
          setLessonActions({ continueLabel: 'begin checkpoint' });
        } else {
          setLessonPhase('explain');
          setLessonCopy(item?.intro || '');
          setLessonActions({ continueLabel: 'show me' });
        }
      }

      function puzzleCanSelectSquare(square) {
        return Boolean(
          puzzleState?.stage === 'try'
          && pieceColor(renderedPosition.get(square)) === fenTurn(puzzleState.positionFen)
        );
      }

      function puzzleMove(value) {
        const move = String(value || '').toLowerCase();
        return {
          from: move.slice(0, 2),
          to: move.slice(2, 4),
          ...(move[4] ? { promotion: move[4] } : {})
        };
      }

      function puzzleMoveKey(move) {
        return `${move?.from || ''}${move?.to || ''}${move?.promotion || ''}`.toLowerCase();
      }

      function rememberPuzzleMistake() {
        const item = compactPuzzle(puzzleState?.puzzle);
        if (!item) return;
        const progress = puzzleLevelProgress(puzzleState.level);
        if (!progress.mistakes.some((puzzle) => puzzle.id === item.id)) {
          progress.mistakes.push(item);
          progress.mistakes = progress.mistakes.slice(-50);
          savePuzzleProgress();
        }
      }

      function rememberSolvedPuzzle() {
        const puzzle = compactPuzzle(puzzleState?.puzzle);
        if (!puzzle || puzzleState?.replay) return;
        const progress = puzzleLevelProgress(puzzleState.level);
        progress.history = progress.history.filter((entry) => entry.puzzle.id !== puzzle.id);
        progress.history.push({
          puzzle,
          solvedAt: Date.now(),
          firstTry: !puzzleState.hadMistake && !puzzleState.assisted
        });
        progress.history = progress.history.slice(-200);
      }

      function recordPuzzleResult() {
        if (!puzzleState?.puzzle || puzzleState.counted) return;
        puzzleState.counted = true;
        const progress = puzzleLevelProgress(puzzleState.level);
        const puzzleRatingValue = Number(puzzleState.puzzle.rating) || progress.rating;
        const expectedScore = 1 / (1 + (10 ** ((puzzleRatingValue - progress.rating) / 400)));
        const firstTryScore = puzzleState.hadMistake || puzzleState.assisted ? 0 : 1;
        progress.attempted += 1;
        progress.solved += 1;
        if (!puzzleState.hadMistake && !puzzleState.assisted) progress.firstTry += 1;
        progress.rating = Math.max(
          100,
          Math.min(3200, Math.round(progress.rating + (24 * (firstTryScore - expectedScore))))
        );
        if (puzzleState.mode === 'review') {
          progress.mistakes = progress.mistakes.filter(
            (puzzle) => puzzle.id !== puzzleState.puzzle.id
          );
        }
        if (puzzleState.mode === 'daily') {
          if (puzzleProgress.daily.date !== todayKey()) {
            puzzleProgress.daily = { date: todayKey(), count: 0 };
          }
          puzzleProgress.daily.count = Math.min(5, puzzleProgress.daily.count + 1);
        }
        if (puzzleState.mode === 'weekly') {
          if (puzzleProgress.weekly.week !== weekKey()) {
            puzzleProgress.weekly = { week: weekKey(), count: 0 };
          }
          puzzleProgress.weekly.count = Math.min(7, puzzleProgress.weekly.count + 1);
        }
        rememberSolvedPuzzle();
        savePuzzleProgress();
      }

      function puzzleThemesLabel(puzzle) {
        const themes = (puzzle?.themes || [])
          .filter((theme) => !['short', 'long', 'veryLong', 'master', 'masterVsMaster'].includes(theme))
          .slice(0, 3)
          .map(humanizePuzzleTheme);
        return themes.join(' · ');
      }

      function puzzleMoveSubject(puzzle, index = 0) {
        const move = puzzleMove(puzzle?.solution?.[index]);
        if (!move) return 'Your move';
        const positionFen = index > 0 ? puzzle?.lineFens?.[index - 1] : puzzle?.fen;
        const position = boardMap(positionFen || startingFen);
        const piece = position.get(move.from);
        const target = position.get(move.to);
        const pieceName = pieceNames[String(piece || '').toLowerCase()] || '';
        const targetName = pieceNames[String(target || '').toLowerCase()] || 'piece';
        if (move.promotion) {
          return `Turning your pawn into a ${pieceNames[move.promotion] || 'new piece'}`;
        }
        if (target) {
          return `Taking the ${targetName} with your ${pieceName || 'piece'}`;
        }
        return pieceName ? `Your ${pieceName} move` : 'Your move';
      }

      function puzzleExplanation(puzzle) {
        const themes = puzzle?.themes || [];
        const mateTheme = themes.find((theme) => /^mateIn\d+$/.test(theme));
        const mateMoves = Number(String(mateTheme || '').replace('mateIn', '')) || 0;
        const ideas = {
          backRankMate: [
            'The king is trapped behind its own pawns.',
            'checks the king and leaves nowhere safe to go.'
          ],
          fork: [
            'Two important pieces can be attacked at once.',
            'attacks both. The opponent can save only one.'
          ],
          pin: [
            'One piece cannot move without exposing something more valuable.',
            'uses that stuck piece, so it cannot help.'
          ],
          skewer: [
            'Two important pieces sit one behind the other.',
            'makes the first move away and leaves the second open.'
          ],
          discoveredAttack: [
            'One of your pieces is blocking another piece’s attack.',
            'moves the blocker and opens the attack behind it.'
          ],
          discoveredCheck: [
            'Moving one piece can uncover an attack on the king.',
            'opens that attack, so the king must respond.'
          ],
          doubleCheck: [
            'The king can be attacked by two pieces at once.',
            'creates both attacks, so the king has to move.'
          ],
          deflection: [
            'One piece is doing all the protecting.',
            'pulls it away, so the real target is no longer safe.'
          ],
          attraction: [
            'An enemy piece can be pulled onto a bad square.',
            'does that and sets up the next move.'
          ],
          clearance: [
            'One of your own pieces is blocking the route you need.',
            'gets it out of the way and opens that route.'
          ],
          interference: [
            'A protecting piece needs a clear route to help.',
            'blocks that route.'
          ],
          trappedPiece: [
            'The target has almost nowhere safe to go.',
            'closes the final way out.'
          ],
          hangingPiece: [
            'One piece can be taken without losing something back.',
            'takes it safely.'
          ],
          sacrifice: [
            'Giving up one piece opens a bigger win.',
            'offers it now so the next move can win more.'
          ],
          promotion: [
            'The pawn is close to becoming a new piece.',
            'keeps it moving before it can be stopped.'
          ],
          underPromotion: [
            'Choosing a queen would let the opponent escape.',
            'chooses the piece that keeps the win.'
          ],
          advancedPawn: [
            'The advanced pawn is the most urgent threat.',
            'pushes it on or protects its next step.'
          ],
          defensiveMove: [
            'Deal with the opponent’s immediate threat first.',
            'removes the danger and keeps your position safe.'
          ],
          quietMove: [
            'The strongest move does not need to take or check.',
            'sets up a threat the opponent cannot answer comfortably.'
          ],
          exposedKing: [
            'The king has little cover.',
            'keeps attacking before the opponent can recover.'
          ],
          kingsideAttack: [
            'Several of your pieces can reach the king.',
            'brings another one into the attack before the defence settles.'
          ],
          queensideAttack: [
            'There is an unprotected target on that side.',
            'adds more pressure than the opponent can meet.'
          ],
          capturingDefender: [
            'One piece is doing all the protecting.',
            'removes it, so the real target is no longer safe.'
          ],
          removeTheDefender: [
            'One piece is doing all the protecting.',
            'removes it, so the real target is no longer safe.'
          ],
          attackingF2F7: [
            'The pawn beside the king has very little protection.',
            'attacks it before help can arrive.'
          ],
          xRayAttack: [
            'A second target sits behind the first.',
            'attacks through the front piece, so the one behind stays in danger.'
          ],
          zugzwang: [
            'Every move makes the opponent’s position worse.',
            'waits in the right place and leaves no good choice.'
          ],
          opening: [
            'Bring another piece into the game before starting an attack.',
            'improves a piece while keeping the position safe.'
          ],
          development: [
            'One of your pieces is not helping yet.',
            'brings it into the game and helps the rest of your pieces.'
          ],
          center: [
            'The middle of the board is still up for grabs.',
            'takes more space there and gives your pieces room.'
          ],
          exchange: [
            'A trade can leave you with the better position.',
            'removes an important piece and improves what remains.'
          ],
          strategy: [
            'Look for the piece that can become more useful.',
            'puts it on a better square without creating a new weakness.'
          ],
          endgame: [
            'With fewer pieces left, every move has to do a clear job.',
            'improves your position while limiting the opponent.'
          ],
          rookEndgame: [
            'Keep your rook active and your king safe.',
            'does both while making the opponent defend.'
          ],
          queenEndgame: [
            'Checks and loose pieces matter most here.',
            'creates an immediate threat without leaving your king open.'
          ],
          crushing: [
            'There is a chance to win something now.',
            'takes it before the chance disappears.'
          ],
          advantage: [
            'There is a chance to win something now.',
            'takes it before the chance disappears.'
          ],
          equality: [
            'The opponent has a threat that must be stopped.',
            'removes that danger and keeps the game balanced.'
          ]
        };
        const knownTheme = Object.keys(ideas).find((theme) => themes.includes(theme));
        const subject = puzzleMoveSubject(puzzle);
        const idea = mateMoves === 1
          ? [
              'The king has nowhere safe to go.',
              'checks the king and ends the game.'
            ]
          : mateMoves > 1
            ? [
                'Keep the king under attack so it never gets a free move.',
                'keeps the attack going until the king is trapped.'
              ]
            : ideas[knownTheme] || [
                'Look for the move that gives the opponent the fewest good replies.',
                'keeps control and starts the winning idea.'
              ];
        return `${idea[0]}\n${subject} ${idea[1]}`;
      }

      function puzzleSessionIsComplete() {
        return Boolean(
          puzzleState
          && (
            puzzleState.mode === 'history'
            || (
              puzzleState.mode === 'daily'
              && puzzleProgress?.daily?.date === todayKey()
              && puzzleProgress.daily.count >= 5
            )
            || (
              puzzleState.mode === 'weekly'
              && puzzleProgress?.weekly?.week === weekKey()
              && puzzleProgress.weekly.count >= 7
            )
          )
        );
      }

      function renderPuzzleNavigation() {
        if (!puzzleState) return;
        activeLearnLevel = puzzleState.level;
        if (lessonLevelTrigger) lessonLevelTrigger.textContent = puzzleState.level;
        lessonLevelButtons.forEach((button) => {
          const level = normalizedLearnLevel(button.dataset.osbLessonLevel || 'beginner');
          button.disabled = false;
          button.setAttribute('aria-disabled', 'false');
          button.setAttribute('aria-pressed', level === puzzleState.level ? 'true' : 'false');
        });
        if (learnLibraryTrigger) learnLibraryTrigger.textContent = 'puzzles';
        if (lessonProgress) {
          const progress = puzzleLevelProgress(puzzleState.level);
          lessonProgress.textContent = `rating ${Math.round(progress.rating)}`;
        }
        if (lessonPathTrigger) {
          lessonPathTrigger.hidden = false;
          lessonPathTrigger.disabled = true;
          lessonPathTrigger.setAttribute('aria-disabled', 'true');
          lessonPathTrigger.setAttribute('aria-expanded', 'false');
        }
        if (lessonPathLabel) {
          lessonPathLabel.textContent = puzzleState.mode === 'weekly'
            ? 'weekly challenge · find the best move'
            : 'puzzles · find the best move';
        }
        setLessonOutline(false);
        if (lessonTitle) lessonTitle.textContent = 'puzzles';
      }

      function preparePuzzle(item, { replay = puzzleState?.mode === 'history' } = {}) {
        if (!puzzleState) return;
        const puzzle = compactPuzzle(item);
        if (!puzzle) {
          void nextPuzzle();
          return;
        }
        puzzleState.puzzle = puzzle;
        puzzleState.solutionIndex = 0;
        puzzleState.positionFen = puzzle.fen;
        puzzleState.stage = 'try';
        puzzleState.hadMistake = false;
        puzzleState.counted = replay;
        puzzleState.replay = replay;
        puzzleState.explanationVisible = false;
        puzzleState.hintLevel = 0;
        puzzleState.wrongAttempts = 0;
        puzzleState.canReveal = false;
        puzzleState.hintFrom = '';
        puzzleState.hintTo = '';
        puzzleState.disputeLogged = false;
        puzzleState.assisted = false;
        puzzleState.lastMove = null;
        puzzleState.feedback = null;
        puzzleState.highlightSquares = new Set();
        selectedSquare = null;
        color = puzzle.color;
        renderPuzzleNavigation();
        syncBoard(boardMap(puzzle.fen));
        setLessonPhase(`${puzzleState.level} · ${puzzle.rating}`);
        setLessonStatus('');
        setLessonCopy('find the best move.');
        setLessonActions({ secondaryLabel: 'hint' });
      }

      async function fetchPuzzleBatch(level) {
        if (!serverUrl) throw new Error('the next position is unavailable.');
        const response = await fetch(
          `${serverUrl}/api/puzzles?level=${encodeURIComponent(level)}&count=12`,
          { headers: { accept: 'application/json' } }
        );
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || 'we could not reach the next position.');
        return (Array.isArray(payload.puzzles) ? payload.puzzles : [])
          .map(compactPuzzle)
          .filter(Boolean);
      }

      async function nextPuzzle() {
        if (!puzzleState) return;
        window.clearTimeout(puzzleReplyTimer);
        puzzleReplyTimer = null;
        const runId = puzzleState.runId;
        if (
          puzzleState.mode === 'daily'
          && puzzleProgress?.daily?.date === todayKey()
          && puzzleProgress.daily.count >= 5
        ) {
          puzzleState.stage = 'complete';
          setLessonPhase('complete');
          setLessonStatus('daily five complete.');
          setLessonCopy('five positions solved. return tomorrow for a fresh set.');
          setLessonActions({ continueLabel: 'puzzles' });
          return;
        }
        if (
          puzzleState.mode === 'weekly'
          && puzzleProgress?.weekly?.week === weekKey()
          && puzzleProgress.weekly.count >= 7
        ) {
          puzzleState.stage = 'complete';
          setLessonPhase('complete');
          setLessonStatus('weekly challenge complete.');
          setLessonCopy('seven positions solved. a new challenge begins on monday.');
          setLessonActions({ continueLabel: 'puzzles' });
          return;
        }
        puzzleState.stage = 'loading';
        puzzleState.feedback = null;
        puzzleState.highlightSquares = new Set();
        puzzleState.hintFrom = '';
        puzzleState.hintTo = '';
        puzzleState.canReveal = false;
        selectedSquare = null;
        setLessonPhase(puzzleState.level);
        setLessonStatus('');
        setLessonCopy('loading puzzle.');
        setLessonActions();
        try {
          if (!puzzleState.queue.length) {
            if (puzzleState.mode === 'review') {
              puzzleState.queue = [...puzzleLevelProgress(puzzleState.level).mistakes];
            } else {
              puzzleState.queue = await fetchPuzzleBatch(puzzleState.level);
            }
          }
          if (!puzzleState || puzzleState.runId !== runId) return;
          const next = puzzleState.queue.shift();
          if (!next) {
            puzzleState.stage = 'complete';
            setLessonPhase('complete');
            setLessonStatus(puzzleState.mode === 'review' ? 'mistakes cleared.' : 'no puzzle loaded.');
            setLessonCopy(
              puzzleState.mode === 'review'
                ? 'nothing is waiting for review.'
                : 'the puzzle source did not return a position.'
            );
            setLessonActions({ continueLabel: 'puzzles' });
            return;
          }
          preparePuzzle(next, { replay: puzzleState.mode === 'history' });
        } catch (error) {
          if (!puzzleState || puzzleState.runId !== runId) return;
          puzzleState.stage = 'error';
          setLessonPhase('puzzles');
          setLessonStatus('could not load puzzle.', { danger: true });
          setLessonCopy(error.message || 'we could not reach the next position. try again.');
          setLessonActions({ continueLabel: 'try again' });
        }
      }

      function startPuzzleSession(mode = 'practice', level = activeLearnLevel, selectedPuzzle = null) {
        const puzzleLevel = normalizedLearnLevel(level);
        const historyPuzzle = mode === 'history' ? compactPuzzle(selectedPuzzle) : null;
        if (mode === 'history' && !historyPuzzle) return;
        const reviewQueue = mode === 'review'
          ? [...puzzleLevelProgress(puzzleLevel).mistakes]
          : [];
        if (mode === 'review' && !reviewQueue.length) {
          if (puzzleLibraryStatus) puzzleLibraryStatus.textContent = 'no mistakes waiting.';
          return;
        }
        if (
          mode === 'daily'
          && puzzleProgress?.daily?.date === todayKey()
          && puzzleProgress.daily.count >= 5
        ) {
          if (puzzleLibraryStatus) puzzleLibraryStatus.textContent = 'daily five complete.';
          return;
        }
        if (
          mode === 'weekly'
          && puzzleProgress?.weekly?.week === weekKey()
          && puzzleProgress.weekly.count >= 7
        ) {
          if (puzzleLibraryStatus) puzzleLibraryStatus.textContent = 'weekly challenge complete.';
          return;
        }
        const previousColor = puzzleState?.previousColor || lessonState?.previousColor || color;
        stopLesson({ restore: false });
        activeLearnMode = 'puzzles';
        activeLearnLevel = puzzleLevel;
        puzzleState = {
          mode,
          level: puzzleLevel,
          queue: historyPuzzle ? [historyPuzzle] : reviewQueue,
          stage: 'loading',
          runId: `${Date.now()}:${Math.random()}`,
          previousColor,
          highlightSquares: new Set(),
          feedback: null,
          lastMove: null,
          hintLevel: 0,
          wrongAttempts: 0,
          canReveal: false,
          hintFrom: '',
          hintTo: '',
          disputeLogged: false,
          assisted: false,
          replay: mode === 'history',
          explanationVisible: false
        };
        arena?.classList.remove('is-lobby', 'is-matching', 'is-game-active', 'is-game-ended', 'is-learn-library');
        arena?.classList.add('is-learning');
        if (learnLibrary) learnLibrary.hidden = true;
        if (lessonNav) lessonNav.hidden = false;
        if (lesson) lesson.hidden = false;
        if (controls) controls.hidden = true;
        setLessonOutline(false);
        setGameChatVisible(false);
        setStatus('');
        renderPuzzleNavigation();
        void nextPuzzle();
      }

      function applyPuzzleLineMove(index, feedback = '') {
        if (!puzzleState?.puzzle) return;
        const move = puzzleMove(puzzleState.puzzle.solution[index]);
        const nextFen = puzzleState.puzzle.lineFens[index];
        const capture = Boolean(renderedPosition.get(move.to));
        puzzleState.positionFen = nextFen;
        puzzleState.lastMove = move;
        puzzleState.feedback = feedback ? { kind: feedback, from: move.from, to: move.to } : null;
        syncBoard(boardMap(nextFen), move, true);
        playMoveFeedback(capture);
      }

      function finishPuzzle() {
        if (!puzzleState?.puzzle) return;
        puzzleState.stage = 'solved';
        selectedSquare = null;
        recordPuzzleResult();
        const themes = puzzleThemesLabel(puzzleState.puzzle);
        const dailyComplete = puzzleState.mode === 'daily'
          && puzzleProgress.daily.date === todayKey()
          && puzzleProgress.daily.count >= 5;
        const weeklyComplete = puzzleState.mode === 'weekly'
          && puzzleProgress.weekly.week === weekKey()
          && puzzleProgress.weekly.count >= 7;
        setLessonPhase('solved');
        setLessonStatus(
          dailyComplete
            ? 'daily five complete.'
            : weeklyComplete
              ? 'weekly challenge complete.'
              : 'correct move.'
        );
        setLessonCopy(
          dailyComplete
            ? 'five positions solved. return tomorrow for a fresh set.'
            : weeklyComplete
              ? 'seven positions solved. a new challenge begins on monday.'
            : themes || 'puzzle solved.'
        );
        setLessonActions({
          secondaryLabel: 'again',
          explainLabel: 'why?',
          continueLabel: puzzleSessionIsComplete() ? 'puzzles' : 'next puzzle'
        });
        feedbackCue('success');
        refreshSquareStates();
      }

      function retryPuzzle() {
        if (puzzleState?.stage !== 'solved' || !puzzleState.puzzle) return;
        const puzzle = puzzleState.puzzle;
        preparePuzzle(puzzle, { replay: true });
        setLessonStatus('try it again.');
      }

      function showPuzzleExplanation() {
        if (puzzleState?.stage !== 'solved' || !puzzleState.puzzle) return;
        puzzleState.explanationVisible = true;
        setLessonStatus('why it works.');
        setLessonCopy(puzzleExplanation(puzzleState.puzzle));
        setLessonActions({
          secondaryLabel: 'again',
          continueLabel: puzzleSessionIsComplete() ? 'puzzles' : 'next puzzle'
        });
      }

      function handlePuzzleMove(from, to, promotion = '') {
        if (puzzleState?.stage !== 'try' || !puzzleState.puzzle) return;
        const expected = puzzleMove(puzzleState.puzzle.solution[puzzleState.solutionIndex]);
        const supplied = {
          from,
          to,
          promotion: promotion || (
            from === expected.from && to === expected.to ? expected.promotion || '' : ''
          )
        };
        const exact = puzzleMoveKey(supplied) === puzzleMoveKey(expected);
        if (!exact) {
          const legal = lessonMoveIsLegal(
            renderedPosition,
            from,
            to,
            supplied.promotion,
            { color: fenTurn(puzzleState.positionFen), fen: puzzleState.positionFen }
          );
          puzzleState.hadMistake = true;
          puzzleState.wrongAttempts = Number(puzzleState.wrongAttempts || 0) + 1;
          puzzleState.canReveal = puzzleState.wrongAttempts >= 3
            || Number(puzzleState.hintLevel || 0) >= 2;
          puzzleState.highlightSquares = new Set();
          puzzleState.hintFrom = '';
          puzzleState.hintTo = '';
          puzzleState.feedback = { kind: legal ? 'incorrect' : 'illegal', from, to };
          selectedSquare = null;
          rememberPuzzleMistake();
          setLessonStatus(legal ? 'incorrect move.' : 'illegal move.', { danger: true });
          setLessonCopy(legal ? 'there is a stronger move. look again.' : 'that move is not legal here.');
          setLessonActions({ secondaryLabel: puzzleState.canReveal ? 'show move' : 'hint' });
          refreshSquareStates();
          feedbackCue('error');
          return;
        }

        puzzleState.stage = 'reply';
        puzzleState.highlightSquares = new Set();
        puzzleState.hintFrom = '';
        puzzleState.hintTo = '';
        puzzleState.canReveal = false;
        selectedSquare = null;
        applyPuzzleLineMove(puzzleState.solutionIndex, 'correct');
        puzzleState.solutionIndex += 1;
        setLessonStatus('correct move.');
        if (puzzleState.solutionIndex >= puzzleState.puzzle.solution.length) {
          finishPuzzle();
          return;
        }
        const runId = puzzleState.runId;
        puzzleReplyTimer = window.setTimeout(() => {
          if (!puzzleState || puzzleState.runId !== runId || puzzleState.stage !== 'reply') return;
          applyPuzzleLineMove(puzzleState.solutionIndex);
          puzzleState.solutionIndex += 1;
          if (puzzleState.solutionIndex >= puzzleState.puzzle.solution.length) {
            finishPuzzle();
            return;
          }
          puzzleState.stage = 'try';
          puzzleState.feedback = null;
          puzzleState.hintLevel = 0;
          puzzleState.wrongAttempts = 0;
          puzzleState.canReveal = false;
          puzzleState.hintFrom = '';
          puzzleState.hintTo = '';
          setLessonStatus('');
          setLessonCopy('find the next best move.');
          setLessonActions({ secondaryLabel: 'hint' });
          refreshSquareStates();
        }, 520);
      }

      function showPuzzleHint() {
        if (puzzleState?.stage !== 'try' || !puzzleState.puzzle) return;
        if (puzzleState.canReveal) {
          revealPuzzleMove();
          return;
        }
        const expected = puzzleMove(puzzleState.puzzle.solution[puzzleState.solutionIndex]);
        puzzleState.hadMistake = true;
        puzzleState.assisted = true;
        puzzleState.hintLevel = Math.min(2, Number(puzzleState.hintLevel || 0) + 1);
        puzzleState.hintFrom = expected.from;
        puzzleState.hintTo = puzzleState.hintLevel >= 2 ? expected.to : '';
        puzzleState.canReveal = puzzleState.hintLevel >= 2;
        puzzleState.highlightSquares = new Set();
        puzzleState.feedback = null;
        rememberPuzzleMistake();
        setLessonStatus('hint.');
        setLessonCopy(
          puzzleState.hintLevel === 1
            ? 'start with the highlighted piece.'
            : 'move it to the second highlighted square.'
        );
        setLessonActions({ secondaryLabel: puzzleState.canReveal ? 'show move' : 'hint' });
        refreshSquareStates();
      }

      function revealPuzzleMove() {
        if (puzzleState?.stage !== 'try' || !puzzleState.puzzle) return;
        const expected = puzzleMove(puzzleState.puzzle.solution[puzzleState.solutionIndex]);
        const startFen = puzzleState.positionFen;
        const runId = puzzleState.runId;
        puzzleState.hadMistake = true;
        puzzleState.assisted = true;
        puzzleState.stage = 'reveal';
        puzzleState.feedback = null;
        puzzleState.highlightSquares = new Set();
        puzzleState.hintFrom = '';
        puzzleState.hintTo = '';
        selectedSquare = null;
        rememberPuzzleMistake();
        setLessonStatus('one move better.');
        setLessonCopy('watch the move.');
        setLessonActions();
        applyPuzzleLineMove(puzzleState.solutionIndex);
        puzzleReplyTimer = window.setTimeout(() => {
          if (!puzzleState || puzzleState.runId !== runId || puzzleState.stage !== 'reveal') return;
          puzzleState.positionFen = startFen;
          puzzleState.lastMove = null;
          puzzleState.feedback = null;
          puzzleState.stage = 'try';
          puzzleState.hintFrom = expected.from;
          puzzleState.hintTo = expected.to;
          puzzleState.canReveal = false;
          syncBoard(boardMap(startFen));
          setLessonStatus('your turn.');
          setLessonCopy('make the move yourself.');
          setLessonActions();
          refreshSquareStates();
        }, 800);
      }

      function handleLessonMove(from, to) {
        if (lessonState?.stage !== 'try') return;
        const attempt = currentLessonAttempt();
        const evaluation = evaluateLessonMove(from, to);
        if (evaluation.status === 'self-check') {
          selectedSquare = null;
          lessonState.highlightSquares = new Set();
          setLessonCopy('your king is still in check.');
          setLessonFeedback(
            'illegal',
            from,
            to,
            0
          );
          setLessonStatus('illegal move.', { danger: true });
          feedbackCue('error');
          return;
        }
        if (evaluation.status === 'illegal') {
          selectedSquare = null;
          lessonState.highlightSquares = new Set();
          setLessonCopy(attempt?.illegal || 'that piece cannot move there.');
          setLessonFeedback('illegal', from, to);
          setLessonStatus('illegal move.', { danger: true });
          feedbackCue('error');
          return;
        }
        if (evaluation.status === 'miss') {
          recordLessonDifficulty('missed the lesson move');
          if (
            currentLesson()?.assessment
            && currentLesson()?.assessment?.kind !== 'analysis'
          ) {
            const missedMove = evaluation.move;
            lessonState.stage = 'feedback';
            lessonState.flowStage = 'feedback';
            lessonState.lastMove = missedMove;
            lessonState.feedback = {
              kind: 'miss',
              from: missedMove.from,
              to: missedMove.to
            };
            lessonState.retryCurrentAttempt = false;
            lessonState.assessmentAnswered = Number(lessonState.assessmentAnswered || 0) + 1;
            lessonState.highlightSquares = new Set();
            selectedSquare = null;
            lessonState.turn = oppositeColor(lessonState.turn);
            lessonState.outcomeCacheKey = '';
            lessonState.outcome = null;
            syncBoard(projectedPosition(missedMove), missedMove, true);
            playMoveFeedback(Boolean(missedMove.capture));
            setLessonPhase('result');
            setLessonStatus('incorrect move.', { danger: true });
            setLessonCopy(
              attempt?.legalMiss
              || attempt?.wrong
              || 'that misses the idea this position is testing.'
            );
            const hasAnotherAttempt = lessonState.attemptIndex < lessonAttemptCount() - 1;
            setLessonActions({
              continueLabel: hasAnotherAttempt ? 'next position' : 'see result'
            });
            feedbackCue('error');
            return;
          }
          if (
            currentLesson()?.assessment?.kind === 'analysis'
            || normalizedLearnLevel(lessonState.level) === 'advanced'
          ) {
            if (currentLesson()?.assessment?.kind === 'analysis') lessonState.analysisHadMiss = true;
            const missedMove = evaluation.move;
            lessonState.stage = 'feedback';
            lessonState.flowStage = 'feedback';
            lessonState.lastMove = missedMove;
            lessonState.feedback = {
              kind: 'miss',
              from: missedMove.from,
              to: missedMove.to
            };
            lessonState.retryCurrentAttempt = true;
            lessonState.highlightSquares = new Set();
            selectedSquare = null;
            lessonState.turn = oppositeColor(lessonState.turn);
            lessonState.outcomeCacheKey = '';
            lessonState.outcome = null;
            syncBoard(projectedPosition(missedMove), missedMove, true);
            playMoveFeedback(Boolean(missedMove.capture));
            setLessonPhase('result');
            setLessonStatus('incorrect move.', { danger: true });
            setLessonCopy(
              attempt?.legalMiss
              || attempt?.wrong
              || 'legal move. look again and find the stronger idea.'
            );
            setLessonActions({
              secondaryLabel: currentLesson()?.assessment?.kind === 'analysis'
                ? 'show one move better'
                : '',
              continueLabel: 'try again'
            });
            feedbackCue('error');
            return;
          }
          selectedSquare = null;
          lessonState.highlightSquares = new Set();
          setLessonCopy(
            attempt?.legalMiss
            || attempt?.wrong
            || 'legal move. now find the lesson idea.'
          );
          setLessonFeedback('miss', from, to);
          setLessonStatus('incorrect move.', { danger: true });
          feedbackCue('error');
          return;
        }
        const acceptedMove = evaluation.move;
        lessonState.stage = 'feedback';
        lessonState.flowStage = attempt?.phase || 'feedback';
        lessonState.lastMove = acceptedMove;
        lessonState.feedback = { kind: 'correct', from: acceptedMove.from, to: acceptedMove.to };
        lessonState.highlightSquares = new Set();
        selectedSquare = null;
        lessonState.turn = oppositeColor(lessonState.turn);
        lessonState.outcomeCacheKey = '';
        lessonState.outcome = null;
        syncBoard(projectedPosition(acceptedMove), acceptedMove, true);
        playMoveFeedback(false);
        setLessonPhase('result');
        setLessonStatus('correct move.');
        if (currentLesson()?.assessment) {
          lessonState.assessmentCorrect = Number(lessonState.assessmentCorrect || 0) + 1;
          lessonState.assessmentAnswered = Number(lessonState.assessmentAnswered || 0) + 1;
        }
        const explanation = [
          lessonReason(attempt?.success, 'that move solves the position.'),
          attempt?.phase === 'try' ? currentLesson()?.notice?.copy : ''
        ].filter(Boolean).join(' ');
        setLessonCopy(explanation);
        const hasAnotherAttempt = lessonState.attemptIndex < lessonAttemptCount() - 1;
        setLessonActions({
          continueLabel: hasAnotherAttempt
            ? 'next position'
            : currentLesson()?.assessment ? 'see result' : 'finish lesson'
        });
        feedbackCue('success');
      }

      function clearGame() {
        stopTableAudio(false);
        hideMatchOptions();
        computerLevelPromptGameId = '';
        game = null;
        clockState = null;
        connectionState = null;
        connectionStatusActive = false;
        activeRequestId = '';
        incomingRematch = null;
        rematchRequested = false;
        pendingMove = null;
        premove = null;
        if (controls) controls.hidden = true;
        if (drawButton) drawButton.hidden = true;
        if (resignButton) resignButton.hidden = true;
        if (computerEndButton) computerEndButton.hidden = true;
        if (liveEndButton) liveEndButton.hidden = true;
        if (humanTurnMarker) {
          humanTurnMarker.hidden = true;
          humanTurnMarker.classList.remove('is-live');
        }
        if (mobileHumanTurnMarker) {
          mobileHumanTurnMarker.hidden = true;
          mobileHumanTurnMarker.classList.remove('is-live');
        }
        if (chatPrototype) chatPrototype.hidden = true;
        if (chatPrototypeCommunication) chatPrototypeCommunication.hidden = true;
        resetLiveChatPrototype();
        if (gameLearningButton) {
          gameLearningButton.hidden = true;
          gameLearningButton.disabled = true;
        }
        if (gameShareButton) gameShareButton.hidden = true;
        if (rematchButton) {
          rematchButton.hidden = true;
          rematchButton.disabled = false;
          rematchButton.textContent = 'again';
        }
        if (opponent) {
          setOpponentIdentity('', '');
          opponent.disabled = true;
        }
        setComputerLevelMenu(false);
        if (you) you.textContent = liveChatDemoMode
          ? 'chess club'
          : session?.player?.kind === 'guest' ? 'guest' : playerLabel(session?.player, 'you');
        if (yourClock) yourClock.textContent = '05:00';
        if (opponentClock) opponentClock.textContent = '05:00';
        renderSignal(yourSignal, null);
        renderSignal(opponentSignal, null);
        arena?.classList.toggle('is-lobby', !automaticMatchmaking);
        arena?.classList.toggle('is-matching', automaticMatchmaking);
        arena?.classList.remove(
          'is-game-active',
          'is-game-ended',
          'has-live-chat-prototype',
          'is-live-chat-demo'
        );
        finder?.classList.remove('is-live-game-cleanup');
        yourClock?.classList.remove('is-time-loss');
        opponentClock?.classList.remove('is-time-loss');
        yourClock?.classList.remove('is-low-time');
        opponentClock?.classList.remove('is-low-time');
        setGameChatVisible(false);
        syncBoard(boardMap(startingFen));
        setStatus('');
        syncMatchmakingIdentity();
        renderLivePlayers();
        window.__osbActiveGamePresence = { active: false, started: false };
        try { window.sessionStorage.removeItem('osb-active-game-presence'); } catch {}
        document.dispatchEvent(new CustomEvent('osb:game-presence', {
          detail: window.__osbActiveGamePresence
        }));
      }

      function resetLiveChatPrototype() {
        if (chatPrototypeDraw) {
          chatPrototypeDraw.textContent = 'draw';
          chatPrototypeDraw.setAttribute('aria-pressed', 'false');
          chatPrototypeDraw.setAttribute('aria-label', 'offer draw, visual preview only');
        }
        if (chatPrototypeResign) {
          chatPrototypeResign.textContent = 'resign';
          chatPrototypeResign.setAttribute('aria-pressed', 'false');
          chatPrototypeResign.setAttribute('aria-label', 'resign, visual preview only');
        }
        if (chatPrototypeVoice) {
          chatPrototypeVoice.textContent = 'join voice';
          chatPrototypeVoice.setAttribute('aria-pressed', 'false');
          chatPrototypeVoice.setAttribute('aria-label', 'join voice, off, visual preview only');
        }
        if (chatPrototypeInput) chatPrototypeInput.value = '';
        chatPrototype?.classList.remove('is-voice-joined');
        chatPrototypeCommunication?.classList.remove('is-voice-joined');
      }

      function chatPrototypeIsAtLatest() {
        if (!chatPrototypeFeed) return true;
        return chatPrototypeFeed.scrollHeight
          - chatPrototypeFeed.scrollTop
          - chatPrototypeFeed.clientHeight <= 24;
      }

      function scrollChatPrototypeToLatest() {
        if (!chatPrototypeFeed) return;
        window.requestAnimationFrame(() => {
          chatPrototypeFeed.scrollTop = chatPrototypeFeed.scrollHeight;
        });
      }

      function showLiveChatDemo() {
        stopLesson();
        stopTableAudio(false);
        section.closest('.osb-finder__map')?.classList.add('is-showing-live');
        finder?.classList.add('is-live-game-cleanup');
        hideMatchOptions();
        closeChallengeHandover({ returnFocus: false });
        automaticMatchmaking = false;
        queueJoinPending = false;
        queued = false;
        pendingEntryMode = '';
        entryMode = 'live';
        game = null;
        clockState = null;
        connectionState = null;
        activeRequestId = '';
        if (controls) controls.hidden = true;
        if (drawButton) drawButton.hidden = true;
        if (resignButton) resignButton.hidden = true;
        if (computerEndButton) computerEndButton.hidden = true;
        if (liveEndButton) liveEndButton.hidden = true;
        if (chatPrototype) chatPrototype.hidden = false;
        if (chatPrototypeCommunication) chatPrototypeCommunication.hidden = false;
        resetLiveChatPrototype();
        setComputerLevelMenu(false);
        if (opponent) {
          setOpponentIdentity('opponent', '');
          opponent.disabled = true;
          opponent.setAttribute('aria-label', 'opponent');
        }
        if (you) you.textContent = 'chess club';
        if (opponentClock) opponentClock.textContent = '04:59';
        if (yourClock) yourClock.textContent = '04:58';
        renderSignal(opponentSignal, { connected: true, bars: 4 });
        renderSignal(yourSignal, { connected: true, bars: 4 });
        turnSquare?.classList.remove('is-live');
        if (humanTurnMarker) {
          humanTurnMarker.hidden = false;
          humanTurnMarker.classList.add('is-live');
        }
        if (mobileHumanTurnMarker) {
          mobileHumanTurnMarker.hidden = false;
          mobileHumanTurnMarker.classList.add('is-live');
        }
        arena?.classList.remove(
          'is-lobby',
          'is-matching',
          'is-game-ended',
          'is-learning',
          'is-learn-library'
        );
        arena?.classList.add('is-game-active', 'has-live-chat-prototype', 'is-live-chat-demo');
        scrollChatPrototypeToLatest();
        setGameChatVisible(false);
        setStatus('');
        syncBoard(boardMap('rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2'));
        window.__osbActiveGamePresence = { active: false, started: false, mode: 'preview' };
      }

      function peerForRequest(request) {
        const ownId = session?.player?.id;
        if (!request || !ownId) return null;
        if (request.requesterId === ownId) {
          return { id: request.recipientId, name: request.recipientName || 'player' };
        }
        if (request.recipientId === ownId) {
          return { id: request.requesterId, name: request.requesterName || 'player' };
        }
        if (request.peerId) return { id: request.peerId, name: request.peerName || 'player' };
        return null;
      }

      function desktopGameLayout() {
        return Boolean(embedded && desktopGameMedia.matches);
      }

      function setDesktopLiveExpanded(expanded) {
        desktopLiveExpanded = Boolean(expanded);
        if (desktopLiveToggle) {
          desktopLiveToggle.setAttribute('aria-expanded', desktopLiveExpanded ? 'true' : 'false');
        }
        arena?.classList.toggle('is-desktop-live-expanded', desktopLiveExpanded);
      }

      function setGameChatVisible(visible) {
        const activeGame = game?.status === 'active';
        const memberLayerAllowed = Boolean(session?.token && session.player?.kind === 'account');
        const hasIncomingRequest = Boolean(incomingChallenge || incomingRematch);
        const desktopDisclosure = desktopGameLayout();
        if (gameChat) gameChat.hidden = !visible;
        if (liveLobby) {
          liveLobby.hidden = !memberLayerAllowed
            || (!desktopDisclosure && !hasIncomingRequest && (visible || activeGame));
        }
        if (liveList) {
          liveList.hidden = !memberLayerAllowed
            || (!desktopDisclosure && activeGame && !visible && !hasIncomingRequest);
        }
        arena?.classList.toggle('has-game-chat', activeGame && visible);
        arena?.classList.remove('has-no-game-chat');
        if (!visible) chatMessages?.replaceChildren();
        updateChatLiveCount();
      }

      function updateChatLiveCount() {
        return;
      }

      function visibleGameChat() {
        return Boolean(gameChat && !gameChat.hidden);
      }

      function renderChatMessage(message) {
        if (!chatMessages || !message?.body) return;
        if (chatMessages.querySelector(`[data-message-id="${CSS.escape(String(message.id || ''))}"]`)) return;
        const line = document.createElement('p');
        line.className = 'osb-live__chat-message';
        if (message.id) line.dataset.messageId = message.id;
        const author = document.createElement('span');
        author.textContent = message.senderId === session?.player?.id
          ? 'you'
          : (opponentName?.textContent || opponent?.textContent || 'them');
        const body = document.createElement('span');
        body.textContent = message.body;
        line.append(author, body);
        chatMessages.appendChild(line);
        chatMessages.scrollTop = chatMessages.scrollHeight;
      }

      function openGameChat() {
        const humanOpponent = game
          ? game.players[color === 'w' ? 'b' : 'w']
          : null;
        const available = Boolean(
          game?.status === 'active'
          && activeRequestId
          && session?.player?.kind === 'account'
          && humanOpponent
          && !humanOpponent.id.startsWith('computer:')
        );
        setGameChatVisible(available);
        if (chatPeer) chatPeer.textContent = available ? (humanOpponent.name || 'game chat') : 'game chat';
        if (!available || socket?.readyState !== WebSocket.OPEN) return;
        try { send('conversation.open', { requestId: activeRequestId }); } catch (error) {}
      }

      function challengePeer(request) {
        return peerForRequest(request);
      }

      function challengeExpiryTime(request) {
        const timestamp = Date.parse(String(request?.expiresAt || ''));
        return Number.isFinite(timestamp) ? timestamp : 0;
      }

      function challengeExpired(request, now = Date.now()) {
        const expiry = challengeExpiryTime(request);
        return Boolean(expiry && expiry <= now);
      }

      function normalizedChallenge(request) {
        if (!request?.id) return null;
        const createdAt = Date.parse(String(request.createdAt || ''));
        return {
          ...request,
          expiresAt: request.expiresAt || (
            Number.isFinite(createdAt)
              ? new Date(createdAt + (5 * 60_000)).toISOString()
              : ''
          )
        };
      }

      function syncChallengesFromRequests(requests) {
        const ownId = session?.player?.id;
        if (!ownId) return;
        const pending = (Array.isArray(requests) ? requests : [])
          .filter((request) => request.kind === 'play' && request.status === 'pending')
          .map(normalizedChallenge)
          .filter((request) => request && !challengeExpired(request))
          .sort((left, right) => Date.parse(right.createdAt || '') - Date.parse(left.createdAt || ''));
        incomingChallenge = pending.find((request) => request.recipientId === ownId) || null;
        outgoingChallenge = incomingChallenge
          ? null
          : (pending.find((request) => request.requesterId === ownId) || null);
      }

      function handoverPlayerName(request = handoverRequest) {
        return playerLabel(challengePeer(request), 'player');
      }

      function handoverConfirmLabel(request = handoverRequest) {
        const action = isComputerGame(game) ? 'end + play' : 'resign + play';
        return `${action} ${handoverPlayerName(request)}`;
      }

      function setHandoverPending(pending) {
        handoverResponsePending = Boolean(pending);
        if (challengeHandoverConfirm) {
          challengeHandoverConfirm.disabled = handoverResponsePending;
          challengeHandoverConfirm.classList.toggle('is-pending', handoverResponsePending);
          challengeHandoverConfirm.textContent = handoverResponsePending
            ? 'starting'
            : handoverConfirmLabel();
        }
        if (challengeHandoverKeep) challengeHandoverKeep.disabled = handoverResponsePending;
      }

      function closeChallengeHandover({ returnFocus = true } = {}) {
        const previousTrigger = handoverTrigger;
        handoverRequest = null;
        handoverTrigger = null;
        handoverResponsePending = false;
        challengeHandoverConfirm?.classList.remove('is-pending');
        if (challengeHandover?.open && typeof challengeHandover.close === 'function') {
          challengeHandover.close();
        } else {
          challengeHandover?.removeAttribute('open');
        }
        if (challengeHandover) challengeHandover.hidden = true;
        if (returnFocus && previousTrigger?.isConnected) previousTrigger.focus();
      }

      function openChallengeHandover(request, trigger) {
        if (!request?.id || !game || game.status !== 'active') return;
        handoverRequest = request;
        handoverTrigger = trigger || null;
        const playerName = handoverPlayerName(request);
        if (challengeHandoverCopy) {
          challengeHandoverCopy.textContent = isComputerGame(game)
            ? `${playerName} wants to play. End the computer game to start now?`
            : `${playerName} wants to play. Resign this game to start now?`;
        }
        setHandoverPending(false);
        if (!challengeHandover) return;
        challengeHandover.hidden = false;
        if (!challengeHandover.open) {
          if (typeof challengeHandover.showModal === 'function') {
            challengeHandover.showModal();
          } else {
            challengeHandover.setAttribute('open', '');
          }
        }
        window.requestAnimationFrame(() => challengeHandoverConfirm?.focus());
      }

      function clearExpiredChallenges() {
        const now = Date.now();
        let changed = false;
        if (challengeExpired(incomingChallenge, now)) {
          if (handoverRequest?.id === incomingChallenge?.id) {
            closeChallengeHandover({ returnFocus: false });
          }
          incomingChallenge = null;
          changed = true;
        }
        if (challengeExpired(outgoingChallenge, now)) {
          outgoingChallenge = null;
          changed = true;
        }
        return changed;
      }

      function scheduleChallengeExpiry() {
        window.clearTimeout(challengeExpiryTimer);
        challengeExpiryTimer = null;
        const now = Date.now();
        const expiries = [incomingChallenge, outgoingChallenge]
          .map(challengeExpiryTime)
          .filter((value) => value > now);
        if (!expiries.length) return;
        challengeExpiryTimer = window.setTimeout(() => {
          challengeExpiryTimer = null;
          if (clearExpiredChallenges()) renderLivePlayers();
          else scheduleChallengeExpiry();
        }, Math.max(0, Math.min(...expiries) - now) + 50);
      }

      async function updateChallengeRequest(request, action, { endCurrentGame = false } = {}) {
        if (!session?.token || !request?.id) throw new Error('request is no longer available');
        const response = await fetch(
          `${serverUrl}/api/match-requests/${encodeURIComponent(request.id)}`,
          {
            method: 'PATCH',
            headers: {
              authorization: `Bearer ${session.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ action, endCurrentGame })
          }
        );
        const payload = await response.json().catch(() => ({}));
        if (response.status === 401) {
          document.dispatchEvent(new CustomEvent('osb:account-session-expired'));
          throw new Error('session expired. sign in again.');
        }
        if (!response.ok) throw new Error(payload.error || 'try again');
        return payload.request || null;
      }

      async function respondToChallenge(request, action, button) {
        if (!request?.id) return;
        if (action === 'accept' && game?.status === 'active') {
          openChallengeHandover(request, button);
          return;
        }
        button.disabled = true;
        button.classList.add('is-pending');
        button.setAttribute('aria-busy', 'true');
        try {
          await updateChallengeRequest(request, action);
          feedbackCue(action === 'accept' ? 'success' : 'selection');
          if (action === 'accept') {
            setStatus('starting');
          } else {
            incomingChallenge = null;
            setStatus('');
            renderLivePlayers();
          }
        } catch (error) {
          button.disabled = false;
          button.classList.remove('is-pending');
          button.removeAttribute('aria-busy');
          feedbackCue('error');
          setStatus(error.message || 'try again');
        }
      }

      function renderLivePlayers() {
        if (!livePlayers) return;
        clearExpiredChallenges();
        scheduleChallengeExpiry();
        const memberLayerAllowed = Boolean(session?.token && session.player?.kind === 'account');
        if (!memberLayerAllowed) {
          directoryPlayers = [];
          incomingChallenge = null;
          outgoingChallenge = null;
          window.clearTimeout(challengeExpiryTimer);
          challengeExpiryTimer = null;
          livePlayers.replaceChildren();
          if (liveMoreButton) liveMoreButton.hidden = true;
          if (desktopLiveCount) desktopLiveCount.textContent = '0';
          if (liveLobby) liveLobby.hidden = true;
          if (liveList) liveList.hidden = true;
          updateChatLiveCount();
          return;
        }
        const activeGame = game?.status === 'active';
        const hasIncomingRequest = Boolean(incomingChallenge || incomingRematch);
        const desktopDisclosure = desktopGameLayout();
        if (liveLobby) liveLobby.hidden = !desktopDisclosure && activeGame && !hasIncomingRequest;
        if (liveList) {
          liveList.hidden = !desktopDisclosure && activeGame && !hasIncomingRequest && !visibleGameChat();
        }
        const ownId = session?.player?.id;
        const available = directoryPlayers
          .filter((player) => player.active && player.id !== ownId)
          .sort((left, right) => (
            Number(left.playing) - Number(right.playing)
            || String(left.username || left.name || '').localeCompare(String(right.username || right.name || ''))
          ));
        if (desktopLiveCount) desktopLiveCount.textContent = String(available.length);
        if (desktopDisclosure && hasIncomingRequest) setDesktopLiveExpanded(true);
        const incomingPeer = challengePeer(incomingChallenge);
        const outgoingPeer = challengePeer(outgoingChallenge);
        const visible = ((activeGame && !desktopDisclosure)
          ? []
          : (livePlayersExpanded ? available : available.slice(0, 5)))
          .filter((player) => player.id !== incomingPeer?.id && player.id !== incomingRematch?.id);
        const hasMeaningfulLiveContent = Boolean(
          visible.length || incomingChallenge || incomingRematch
        );
        if (!hasMeaningfulLiveContent) {
          livePlayers.replaceChildren();
          if (liveMoreButton) liveMoreButton.hidden = true;
          if (liveLobby) liveLobby.hidden = true;
          if (liveList) liveList.hidden = true;
          updateChatLiveCount();
          return;
        }
        const fragment = document.createDocumentFragment();
        if (incomingRematch?.id) {
          const row = document.createElement('p');
          row.className = 'osb-live__live-player is-challenge is-rematch';
          const dot = document.createElement('span');
          dot.className = 'osb-live__live-dot';
          const name = document.createElement('span');
          name.className = 'osb-live__live-name';
          name.textContent = `${playerLabel(incomingRematch)} wants another game`;
          const responses = document.createElement('span');
          responses.className = 'osb-live__challenge-actions';
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = 'accept';
          button.addEventListener('click', () => requestRematch(button));
          responses.appendChild(button);
          row.append(dot, name, responses);
          fragment.appendChild(row);
        }
        if (incomingChallenge && incomingPeer) {
          const row = document.createElement('p');
          row.className = 'osb-live__live-player is-challenge';
          const dot = document.createElement('span');
          dot.className = 'osb-live__live-dot';
          const name = document.createElement('span');
          name.className = 'osb-live__live-name';
          name.textContent = `${playerLabel(incomingPeer)} wants to play`;
          const responses = document.createElement('span');
          responses.className = 'osb-live__challenge-actions';
          ['accept', 'pass'].forEach((action) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = action;
            button.addEventListener('click', () => respondToChallenge(incomingChallenge, action, button));
            responses.appendChild(button);
          });
          row.append(dot, name, responses);
          fragment.appendChild(row);
        }
        visible.forEach((player) => {
          const row = document.createElement('button');
          row.type = 'button';
          row.className = 'osb-live__live-player osb-live__live-player--button';
          const dot = document.createElement('span');
          dot.className = 'osb-live__live-dot';
          const name = document.createElement('span');
          name.className = 'osb-live__live-name';
          const playerName = playerLabel({ name: player.username || player.name || 'player' });
          const actionLabel = document.createElement('span');
          actionLabel.className = 'osb-live__live-action';
          const waiting = outgoingChallenge && outgoingPeer?.id === player.id;
          const anotherRequestIsPending = Boolean(outgoingChallenge && !waiting);
          const playing = player.playing === true;
          const activity = playerActivityLabel(player);
          const action = waiting ? 'cancel' : playing ? 'next game' : 'challenge';
          name.textContent = playerName;
          actionLabel.textContent = waiting ? 'cancel' : activity;
          actionLabel.dataset.action = action;
          row.disabled = Boolean(incomingChallenge || anotherRequestIsPending);
          dot.setAttribute('aria-hidden', 'true');
          row.setAttribute(
            'aria-label',
            waiting
              ? `cancel game request to ${playerName}`
              : playing
              ? `request the next game with ${playerName}, who is playing`
              : `challenge ${playerName}, who is ${activity}`
          );
          row.addEventListener('click', () => (
            waiting
              ? cancelLivePlayerRequest(row, actionLabel)
              : requestLivePlayer(player, row, actionLabel)
          ));
          row.append(dot, name, actionLabel);
          fragment.appendChild(row);
        });
        livePlayers.replaceChildren(fragment);
        if (liveMoreButton) {
          liveMoreButton.hidden = (!desktopDisclosure && activeGame) || available.length <= 5;
          liveMoreButton.textContent = livePlayersExpanded ? 'less' : 'more';
        }
        updateChatLiveCount();
      }

      function playerActivityLabel(player) {
        if (player?.playing === true) return 'playing';
        const normalized = String(player?.activity || '')
          .trim()
          .toLowerCase()
          .replace(/[ _]+/g, '-');
        const activityLabels = {
          puzzle: 'doing puzzles',
          puzzles: 'doing puzzles',
          'doing-puzzles': 'doing puzzles',
          learn: 'learning',
          learning: 'learning',
          lesson: 'learning',
          lessons: 'learning',
          game: 'playing',
          playing: 'playing',
          queue: 'waiting for a game',
          waiting: 'waiting for a game',
          'waiting-for-game': 'waiting for a game'
        };
        const updatedAt = Date.parse(player?.activityUpdatedAt || player?.activityAt || '');
        const expired = Number.isFinite(updatedAt) && Date.now() - updatedAt > 120_000;
        return !expired && activityLabels[normalized]
          ? activityLabels[normalized]
          : 'ready to play';
      }

      async function loadLivePlayers() {
        if (!serverUrl || !session?.token || session.player?.kind !== 'account') {
          directoryPlayers = [];
          renderLivePlayers();
          return;
        }
        try {
          const headers = { authorization: `Bearer ${session.token}` };
          const [response, requestResponse] = await Promise.all([
            fetch(`${serverUrl}/api/directory`, { headers }),
            fetch(`${serverUrl}/api/match-requests`, { headers })
          ]);
          const payload = await response.json();
          if (response.status === 401) {
            directoryPlayers = [];
            renderLivePlayers();
            document.dispatchEvent(new CustomEvent('osb:account-session-expired'));
            return;
          }
          if (!response.ok) return;
          directoryPlayers = Array.isArray(payload.players) ? payload.players : [];
          if (requestResponse.ok) {
            const requestPayload = await requestResponse.json().catch(() => ({}));
            syncChallengesFromRequests(requestPayload.requests);
          }
          renderLivePlayers();
        } catch (error) {}
      }

      async function requestLivePlayer(player, row, actionLabel) {
        if (!session?.token || !player?.id) return;
        row.disabled = true;
        actionLabel.textContent = 'sending';
        actionLabel.classList.add('is-pending');
        row.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${serverUrl}/api/match-requests`, {
            method: 'POST',
            headers: {
              authorization: `Bearer ${session.token}`,
              'content-type': 'application/json'
            },
            body: JSON.stringify({ recipientId: player.id, kind: 'play' })
          });
          const payload = await response.json().catch(() => ({}));
          if (response.status === 401) {
            document.dispatchEvent(new CustomEvent('osb:account-session-expired'));
            throw new Error('session expired. sign in again.');
          }
          if (!response.ok || !payload.request) throw new Error(payload.error || 'could not send');
          outgoingChallenge = normalizedChallenge(payload.request);
          incomingChallenge = null;
          renderLivePlayers();
          feedbackCue('success');
          setStatus('');
        } catch (error) {
          row.disabled = false;
          row.removeAttribute('aria-busy');
          actionLabel.textContent = playerActivityLabel(player);
          actionLabel.classList.remove('is-pending');
          feedbackCue('error');
          setStatus(error.message || 'could not send');
        }
      }

      async function cancelLivePlayerRequest(row, actionLabel) {
        if (!outgoingChallenge?.id) return;
        row.disabled = true;
        actionLabel.textContent = 'cancelling';
        actionLabel.classList.add('is-pending');
        row.setAttribute('aria-busy', 'true');
        try {
          await updateChallengeRequest(outgoingChallenge, 'cancel');
          outgoingChallenge = null;
          renderLivePlayers();
          feedbackCue('selection');
          setStatus('');
        } catch (error) {
          row.disabled = false;
          row.removeAttribute('aria-busy');
          actionLabel.textContent = 'cancel';
          actionLabel.classList.remove('is-pending');
          feedbackCue('error');
          setStatus(error.message || 'could not cancel');
        }
      }

      function accountSessionHasExpired(value) {
        if (value?.player?.kind !== 'account') return false;
        try {
          const encodedPayload = String(value.token || '').split('.')[0];
          const normalizedPayload = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
          const padding = '='.repeat((4 - (normalizedPayload.length % 4)) % 4);
          const bytes = Uint8Array.from(window.atob(normalizedPayload + padding), (character) => character.charCodeAt(0));
          const payload = JSON.parse(new TextDecoder().decode(bytes));
          return !Number.isFinite(payload.exp) || payload.exp <= Date.now();
        } catch {
          return true;
        }
      }

      function formatClock(milliseconds) {
        const seconds = Math.max(0, Math.ceil(Number(milliseconds || 0) / 1000));
        const minutes = Math.floor(seconds / 60);
        return `${String(minutes).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      }

      function boardMap(fen) {
        const result = new Map();
        const rows = String(fen || startingFen).split(' ')[0].split('/');
        rows.forEach((row, rowIndex) => {
          let file = 0;
          for (const character of row) {
            if (/\d/.test(character)) {
              file += Number(character);
            } else {
              result.set(`${'abcdefgh'[file]}${8 - rowIndex}`, character);
              file += 1;
            }
          }
        });
        return result;
      }

      function isComputerGame(activeGame) {
        return Object.values(activeGame?.players || {}).some((player) =>
          player?.kind === 'computer' || String(player?.id || '').startsWith('computer:')
        );
      }

      function resultPlayer(activeGame, result) {
        const directPlayer = Object.values(activeGame?.players || {}).find((player) => player?.id === result?.by);
        if (directPlayer) return directPlayer;
        if (result?.score === '0-1') return activeGame?.players?.w;
        if (result?.score === '1-0') return activeGame?.players?.b;
        return null;
      }

      function resultLabel(activeGame, computerGame = false) {
        const result = activeGame?.result;
        if (computerGame && result?.reason === 'resignation') return 'game ended';
        if (result?.reason === 'resignation') {
          return `${playerLabel(resultPlayer(activeGame, result))} resigned`;
        }
        return {
          checkmate: 'checkmate',
          stalemate: 'stalemate',
          time: 'out of time',
          'no move': 'no move',
          disconnect: 'connection lost',
          agreement: 'draw',
          repetition: 'draw',
          'insufficient material': 'draw',
          'fifty moves': 'draw',
          draw: 'draw'
        }[result?.reason] || 'game over';
      }

      function squareCoordinates(square) {
        return {
          file: 'abcdefgh'.indexOf(square?.[0]),
          rank: Number(square?.[1])
        };
      }

      function pieceAttacksSquare(position, from, piece, target) {
        const source = squareCoordinates(from);
        const destination = squareCoordinates(target);
        const fileDistance = destination.file - source.file;
        const rankDistance = destination.rank - source.rank;
        const absoluteFileDistance = Math.abs(fileDistance);
        const absoluteRankDistance = Math.abs(rankDistance);
        const type = piece.toLowerCase();

        if (type === 'p') {
          const direction = piece === piece.toUpperCase() ? 1 : -1;
          return absoluteFileDistance === 1 && rankDistance === direction;
        }
        if (type === 'n') {
          return (absoluteFileDistance === 1 && absoluteRankDistance === 2)
            || (absoluteFileDistance === 2 && absoluteRankDistance === 1);
        }
        if (type === 'k') return Math.max(absoluteFileDistance, absoluteRankDistance) === 1;

        const attacksDiagonally = absoluteFileDistance === absoluteRankDistance;
        const attacksStraight = fileDistance === 0 || rankDistance === 0;
        if (type === 'b' && !attacksDiagonally) return false;
        if (type === 'r' && !attacksStraight) return false;
        if (type === 'q' && !attacksDiagonally && !attacksStraight) return false;

        const steps = Math.max(absoluteFileDistance, absoluteRankDistance);
        const fileStep = Math.sign(fileDistance);
        const rankStep = Math.sign(rankDistance);
        for (let step = 1; step < steps; step += 1) {
          const file = 'abcdefgh'[source.file + (fileStep * step)];
          const rank = source.rank + (rankStep * step);
          if (position.has(`${file}${rank}`)) return false;
        }
        return steps > 0;
      }

      function threatHighlightsForPosition(position, threatenedColor, kind = 'check') {
        const kingPiece = threatenedColor === 'w' ? 'K' : 'k';
        const kingSquare = Array.from(position).find(([, piece]) => piece === kingPiece)?.[0] || '';
        const checkingSquares = [];
        if (kingSquare) {
          for (const [square, piece] of position) {
            if (
              pieceColor(piece) !== threatenedColor
              && pieceAttacksSquare(position, square, piece, kingSquare)
            ) {
              checkingSquares.push(square);
            }
          }
        }
        return {
          kind: kingSquare && checkingSquares.length ? kind : '',
          kingSquare,
          checkingSquares
        };
      }

      function lessonPositionKey(position, turn) {
        return `${turn}:${Array.from(position)
          .sort(([left], [right]) => left.localeCompare(right))
          .map(([square, piece]) => `${square}${piece}`)
          .join('')}`;
      }

      function lessonHasAnyLegalMove(position, movingColor, fen = '') {
        const destinations = [];
        for (const rank of '12345678') {
          for (const file of 'abcdefgh') destinations.push(`${file}${rank}`);
        }
        for (const [from, piece] of position) {
          if (pieceColor(piece) !== movingColor) continue;
          for (const to of destinations) {
            const promotion = piece.toLowerCase() === 'p' && (to.endsWith('1') || to.endsWith('8'))
              ? 'q'
              : '';
            if (lessonMoveIsLegal(position, from, to, promotion, {
              color: movingColor,
              fen
            })) {
              return true;
            }
          }
        }
        return false;
      }

      function explicitLessonOutcome() {
        const attempt = currentLessonAttempt();
        const example = currentLesson()?.example;
        const source = String(lessonState?.stage || '').startsWith('watch')
          ? example
          : attempt;
        const outcome = String(
          source?.outcome
          || source?.terminalOutcome
          || source?.terminalResult
          || ''
        ).trim().toLowerCase();
        return outcome === 'stalemate' || outcome === 'draw' ? outcome : '';
      }

      function deriveLessonPositionStatus(position) {
        const turn = lessonState?.turn || lessonAttemptColor();
        const explicitOutcome = explicitLessonOutcome();
        const cacheKey = `${lessonPositionKey(position, turn)}:${explicitOutcome}`;
        if (lessonState?.outcomeCacheKey === cacheKey && lessonState.outcome) {
          return lessonState.outcome;
        }

        const threat = threatHighlightsForPosition(position, turn);
        let kind = '';
        if (threat.kind) {
          kind = lessonHasAnyLegalMove(position, turn, lessonState?.positionFen)
            ? 'check'
            : 'checkmate';
        } else if (explicitOutcome) {
          kind = explicitOutcome;
        }
        const outcome = { ...threat, kind };
        if (lessonState) {
          lessonState.outcomeCacheKey = cacheKey;
          lessonState.outcome = outcome;
        }
        return outcome;
      }

      function kingThreatHighlights(activeGame, position) {
        const isCheck = activeGame?.status === 'active' && activeGame.check;
        const isCheckmate = activeGame?.status === 'ended' && activeGame.result?.reason === 'checkmate';
        if (!isCheck && !isCheckmate) {
          return { kind: '', kingSquare: '', checkingSquares: [] };
        }
        return threatHighlightsForPosition(
          position,
          activeGame.turn === 'w' ? 'w' : 'b',
          isCheckmate ? 'checkmate' : 'check'
        );
      }

      function moveKey(move) {
        return move ? `${move.from || ''}:${move.to || ''}:${move.promotion || ''}` : '';
      }

      function setPieceGraphic(container, piece) {
        const source = pieces[piece];
        if (!container || !source) return;
        const image = document.createElement('img');
        image.className = 'osb-live__piece-art';
        image.src = source;
        image.alt = '';
        image.draggable = false;
        image.decoding = 'async';
        container.replaceChildren(image);
      }

      function ensureBoardSquares() {
        if (!board || (squareElements.size === 64 && renderedColor === color)) return;
        const files = color === 'b' ? 'hgfedcba' : 'abcdefgh';
        const ranks = color === 'b' ? '12345678' : '87654321';
        const fragment = document.createDocumentFragment();
        squareElements.clear();

        for (const rank of ranks) {
          for (const file of files) {
            const square = `${file}${rank}`;
            const row = 8 - Number(rank);
            const column = 'abcdefgh'.indexOf(file);
            const button = document.createElement('button');
            button.type = 'button';
            button.className = `osb-live__square${(row + column) % 2 ? ' osb-live__square--dark' : ''}`;
            button.dataset.square = square;
            button.setAttribute('role', 'gridcell');
            button.setAttribute('aria-label', square);
            if (file === files[0]) {
              const rankCoordinate = document.createElement('span');
              rankCoordinate.className = 'osb-live__coordinate osb-live__coordinate--rank';
              rankCoordinate.textContent = rank;
              rankCoordinate.setAttribute('aria-hidden', 'true');
              button.appendChild(rankCoordinate);
            }
            if (rank === ranks[ranks.length - 1]) {
              const fileCoordinate = document.createElement('span');
              fileCoordinate.className = 'osb-live__coordinate osb-live__coordinate--file';
              fileCoordinate.textContent = file;
              fileCoordinate.setAttribute('aria-hidden', 'true');
              button.appendChild(fileCoordinate);
            }
            squareElements.set(square, button);
            fragment.appendChild(button);
          }
        }
        board.replaceChildren(fragment);
        renderedColor = color;
      }

      function syncPiece(square, piece) {
        const squareElement = squareElements.get(square);
        if (!squareElement) return;
        const existing = squareElement.querySelector('[data-osb-piece]');
        if (!piece) {
          existing?.remove();
          squareElement.setAttribute('aria-label', square);
          return;
        }
        const pieceColor = piece === piece.toUpperCase() ? 'white' : 'black';
        if (!existing || existing.dataset.piece !== piece) {
          const span = document.createElement('span');
          span.className = `osb-live__piece osb-live__piece--${pieceColor}`;
          span.dataset.osbPiece = '';
          span.dataset.piece = piece;
          span.setAttribute('aria-hidden', 'true');
          setPieceGraphic(span, piece);
          existing?.replaceWith(span);
          if (!existing) squareElement.appendChild(span);
        }
        squareElement.setAttribute('aria-label', `${pieceColor} ${pieceNames[piece.toLowerCase()]} on ${square}`);
      }

      function setSquareAccessibleLabel(square, element, suffix = '') {
        if (!element) return;
        const piece = renderedPosition.get(square);
        const base = piece
          ? `${pieceColor(piece) === 'w' ? 'white' : 'black'} ${pieceNames[piece.toLowerCase()]} on ${square}`
          : square;
        element.setAttribute('aria-label', suffix ? `${base}, ${suffix}` : base);
      }

      function animateMove(move, sourceRect) {
        if (!move || !sourceRect || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const destinationPiece = squareElements.get(move.to)?.querySelector('[data-osb-piece]');
        if (!destinationPiece) return;
        const destinationRect = destinationPiece.getBoundingClientRect();
        const duration = (
          lessonState?.stage === 'watch'
          || puzzleState?.stage === 'reply'
          || puzzleState?.stage === 'reveal'
        ) ? 620 : 145;
        destinationPiece.animate([
          { transform: `translate3d(${sourceRect.left - destinationRect.left}px, ${sourceRect.top - destinationRect.top}px, 0) scale(1.04)` },
          { transform: 'translate3d(0, 0, 0) scale(1)' }
        ], { duration, easing: 'cubic-bezier(.2,.75,.25,1)' });
      }

      function legalMovesFrom(square) {
        return Array.isArray(game?.legalMoves) ? game.legalMoves.filter((move) => move.from === square) : [];
      }

      function refreshSquareStates() {
        if (puzzleState) {
          const lastMove = puzzleState.lastMove;
          const canTry = puzzleState.stage === 'try';
          board?.classList.remove('is-terminal-muted');
          squareElements.forEach((element, square) => {
            element.classList.toggle('is-selected', canTry && selectedSquare === square);
            element.classList.toggle(
              'is-last',
              Boolean(lastMove && (lastMove.from === square || lastMove.to === square))
            );
            element.classList.remove(
              'is-premove',
              'is-legal',
              'is-capture',
              'is-checked-king',
              'is-checkmated-king',
              'is-checking-piece',
              'is-lesson-target',
              'is-puzzle-hint-from',
              'is-puzzle-hint-to',
              'is-lesson-correct-from',
              'is-lesson-correct-to',
              'is-lesson-miss-from',
              'is-lesson-miss-to',
              'is-lesson-wrong-from',
              'is-lesson-wrong-to'
            );
            setSquareAccessibleLabel(square, element);
          });
          if (canTry) {
            if (puzzleState.hintFrom) {
              squareElements.get(puzzleState.hintFrom)?.classList.add('is-puzzle-hint-from');
            }
            if (puzzleState.hintTo) {
              squareElements.get(puzzleState.hintTo)?.classList.add('is-puzzle-hint-to');
            }
            if (!puzzleState.hintFrom && !puzzleState.hintTo) {
              puzzleState.highlightSquares?.forEach((square) => {
                squareElements.get(square)?.classList.add('is-lesson-target');
              });
            }
          }
          const feedback = puzzleState.feedback;
          if (feedback?.from) {
            squareElements.get(feedback.from)?.classList.add(
              feedback.kind === 'correct'
                ? 'is-lesson-correct-from'
                : feedback.kind === 'incorrect'
                  ? 'is-lesson-miss-from'
                  : 'is-lesson-wrong-from'
            );
          }
          if (feedback?.to) {
            squareElements.get(feedback.to)?.classList.add(
              feedback.kind === 'correct'
                ? 'is-lesson-correct-to'
                : feedback.kind === 'incorrect'
                  ? 'is-lesson-miss-to'
                  : 'is-lesson-wrong-to'
            );
          }
          const turn = fenTurn(puzzleState.positionFen);
          const threats = threatHighlightsForPosition(renderedPosition, turn);
          if (threats.kingSquare) {
            squareElements.get(threats.kingSquare)?.classList.add('is-checked-king');
          }
          threats.checkingSquares.forEach((square) => {
            squareElements.get(square)?.classList.add('is-checking-piece');
          });
          return;
        }
        if (lessonState) {
          const lastMove = lessonState.lastMove;
          const canTry = lessonState.stage === 'try';
          board?.classList.remove('is-terminal-muted');
          squareElements.forEach((element, square) => {
            element.classList.toggle('is-selected', canTry && selectedSquare === square);
            element.classList.toggle(
              'is-last',
              Boolean(lastMove && (lastMove.from === square || lastMove.to === square))
            );
            element.classList.remove(
              'is-premove',
              'is-legal',
              'is-capture',
              'is-checked-king',
              'is-checkmated-king',
              'is-checking-piece',
              'is-lesson-target',
              'is-puzzle-hint-from',
              'is-puzzle-hint-to',
              'is-lesson-correct-from',
              'is-lesson-correct-to',
              'is-lesson-miss-from',
              'is-lesson-miss-to',
              'is-lesson-wrong-from',
              'is-lesson-wrong-to'
            );
            setSquareAccessibleLabel(square, element);
          });
          if (canTry) {
            lessonState.highlightSquares?.forEach((square) => {
              squareElements.get(square)?.classList.add('is-lesson-target');
            });
          }
          const feedback = lessonState.feedback;
          if (feedback?.from) {
            squareElements.get(feedback.from)?.classList.add(
              feedback.kind === 'correct'
                ? 'is-lesson-correct-from'
                : feedback.kind === 'miss'
                  ? 'is-lesson-miss-from'
                  : 'is-lesson-wrong-from'
            );
          }
          if (feedback?.to) {
            squareElements.get(feedback.to)?.classList.add(
              feedback.kind === 'correct'
                ? 'is-lesson-correct-to'
                : feedback.kind === 'miss'
                  ? 'is-lesson-miss-to'
                  : 'is-lesson-wrong-to'
            );
          }

          const outcome = deriveLessonPositionStatus(renderedPosition);
          const isDanger = outcome.kind === 'check' || outcome.kind === 'checkmate';
          const isTerminal = ['checkmate', 'stalemate', 'draw'].includes(outcome.kind);
          board?.classList.toggle('is-terminal-muted', isTerminal);

          if (isDanger && outcome.kingSquare) {
            const kingElement = squareElements.get(outcome.kingSquare);
            const kingClass = outcome.kind === 'checkmate'
              ? 'is-checkmated-king'
              : 'is-checked-king';
            kingElement?.classList.add(kingClass);
            setSquareAccessibleLabel(
              outcome.kingSquare,
              kingElement,
              outcome.kind === 'checkmate' ? 'checkmated' : 'in check'
            );
          }
          if (isDanger) {
            outcome.checkingSquares.forEach((square) => {
              squareElements.get(square)?.classList.add('is-checking-piece');
            });
          }
          if (feedback?.kind === 'correct') {
            setLessonStatus('correct move.');
          } else if (feedback?.kind === 'illegal') {
            setLessonStatus('illegal move.');
          } else if (feedback?.kind === 'miss' || feedback?.kind === 'incorrect') {
            setLessonStatus('incorrect move.');
          } else if (lessonState.stage === 'complete') {
            setLessonStatus('lesson complete.');
          } else if (isDanger || isTerminal) {
            setLessonStatus(`${outcome.kind}.`, { danger: isDanger });
          } else if (!String(lastLessonStatus).startsWith('hint')) {
            setLessonStatus('');
          }
          return;
        }
        board?.classList.remove('is-terminal-muted');
        setLessonStatus('');
        const lastMove = game?.lastMove;
        const gameIsActive = game?.status === 'active';
        squareElements.forEach((element, square) => {
          element.classList.toggle('is-selected', gameIsActive && selectedSquare === square);
          element.classList.toggle('is-last', Boolean(gameIsActive && lastMove && (lastMove.from === square || lastMove.to === square)));
          element.classList.toggle('is-premove', Boolean(gameIsActive && premove && (premove.from === square || premove.to === square)));
          element.classList.remove(
            'is-legal',
            'is-capture',
            'is-checked-king',
            'is-checkmated-king',
            'is-checking-piece',
            'is-lesson-target',
            'is-puzzle-hint-from',
            'is-puzzle-hint-to',
            'is-lesson-correct-from',
            'is-lesson-correct-to',
            'is-lesson-miss-from',
            'is-lesson-miss-to',
            'is-lesson-wrong-from',
            'is-lesson-wrong-to'
          );
        });
        if (selectedSquare && game?.turn === color) {
          legalMovesFrom(selectedSquare).forEach((move) => {
            const destination = squareElements.get(move.to);
            destination?.classList.add(move.capture ? 'is-capture' : 'is-legal');
          });
        }
        const highlights = kingThreatHighlights(game, renderedPosition);
        const kingClass = highlights.kind === 'checkmate' ? 'is-checkmated-king' : 'is-checked-king';
        if (highlights.kingSquare) squareElements.get(highlights.kingSquare)?.classList.add(kingClass);
        highlights.checkingSquares.forEach((square) => squareElements.get(square)?.classList.add('is-checking-piece'));
      }

      function syncBoard(position, move = null, animate = false) {
        ensureBoardSquares();
        const sourceRect = animate
          ? squareElements.get(move?.from)?.querySelector('[data-osb-piece]')?.getBoundingClientRect()
          : null;
        squareElements.forEach((element, square) => syncPiece(square, position.get(square) || ''));
        renderedPosition = new Map(position);
        refreshSquareStates();
        if (animate) animateMove(move, sourceRect);
      }

      function projectedPosition(move) {
        const position = new Map(renderedPosition);
        const piece = position.get(move.from);
        if (!piece) return position;
        const target = position.get(move.to);
        position.delete(move.from);
        if (piece.toLowerCase() === 'p' && !target && move.from[0] !== move.to[0]) {
          position.delete(`${move.to[0]}${move.from[1]}`);
        }
        if (piece.toLowerCase() === 'k' && Math.abs(move.from.charCodeAt(0) - move.to.charCodeAt(0)) === 2) {
          const rank = move.from[1];
          const kingSide = move.to[0] === 'g';
          const rookFrom = `${kingSide ? 'h' : 'a'}${rank}`;
          const rookTo = `${kingSide ? 'f' : 'd'}${rank}`;
          const rook = position.get(rookFrom);
          position.delete(rookFrom);
          if (rook) position.set(rookTo, rook);
        }
        const promoted = move.promotion
          ? (piece === piece.toUpperCase() ? move.promotion.toUpperCase() : move.promotion.toLowerCase())
          : piece;
        position.set(move.to, promoted);
        return position;
      }

      async function resumeGameplayAudio() {
        try {
          const Context = window.AudioContext || window.webkitAudioContext;
          if (!Context) return false;
          audioContext ||= new Context();
          if (audioContext.state === 'suspended') await audioContext.resume();
          return audioContext.state === 'running';
        } catch (error) {
          return false;
        }
      }

      async function playGameplayTone(capture = false) {
        if (!feedbackEnabled()) return;
        if (!await resumeGameplayAudio()) return;
        try {
          const oscillator = audioContext.createOscillator();
          const gain = audioContext.createGain();
          const now = audioContext.currentTime;
          oscillator.type = 'sine';
          oscillator.frequency.setValueAtTime(capture ? 220 : 520, now);
          gain.gain.setValueAtTime(0.0001, now);
          gain.gain.exponentialRampToValueAtTime(0.045, now + 0.006);
          gain.gain.exponentialRampToValueAtTime(0.0001, now + (capture ? 0.07 : 0.045));
          oscillator.connect(gain).connect(audioContext.destination);
          oscillator.start(now);
          oscillator.stop(now + 0.08);
        } catch (error) {}
      }

      function playMoveFeedback(capture = false) {
        feedbackHaptic(capture ? 12 : 6);
        playGameplayTone(capture);
      }

      function updateClocks() {
        if (!clockState || !game) return;
        const clocks = { ...clockState.clocks };
        if (clockState.status === 'active' && clockState.started) {
          clocks[clockState.turn] = Math.max(0, clocks[clockState.turn] - (Date.now() - clockState.receivedAt));
        }
        const otherColor = color === 'w' ? 'b' : 'w';
        const isLowTime = (remaining) =>
          clockState.status === 'active' && clockState.started && remaining > 0 && remaining <= 10000;

        if (yourClock) {
          yourClock.textContent = formatClock(clocks[color]);
          yourClock.classList.toggle('is-low-time', isLowTime(clocks[color]));
        }
        if (opponentClock) {
          opponentClock.textContent = formatClock(clocks[otherColor]);
          opponentClock.classList.toggle('is-low-time', isLowTime(clocks[otherColor]));
        }
      }

      function recommendedLevelForGame(activeGame = game) {
        const ownPlayer = activeGame?.players?.[color] || session?.player || {};
        const rating = Number(
          ownPlayer.rating
          || ownPlayer.elo
          || activeGame?.metadata?.rating
          || 0
        );
        if (rating >= 1700) return 'advanced';
        if (rating >= 1100) return 'intermediate';
        if (isComputerGame(activeGame)) {
          const difficulty = computerDifficulty(activeGame);
          if (difficulty === 'advanced') return 'advanced';
          if (difficulty === 'intermediate') return 'intermediate';
          return 'beginner';
        }
        return recommendedLearnLevel();
      }

      function gameResultForPlayer(activeGame, playerColor = color) {
        const score = activeGame?.result?.score;
        if (!score || score === '1/2-1/2') return score === '1/2-1/2' ? 'draw' : 'complete';
        const won = (score === '1-0' && playerColor === 'w')
          || (score === '0-1' && playerColor === 'b');
        return won ? 'win' : 'loss';
      }

      function openingRecommendationsFromGame(activeGame, playerColor = color) {
        const moves = Array.isArray(activeGame?.moves) ? activeGame.moves : [];
        const keys = moves.slice(0, 24).map((move) => `${move.from || ''}${move.to || ''}`);
        const has = (key) => keys.includes(key);
        const firstMove = keys[0] || '';
        if (playerColor === 'w' && firstMove === 'd2d4') {
          if (!has('c1f4')) {
            return [{
              lessonId: 'london-bishop-first',
              reason: 'you began with d4 but the london bishop did not reach f4 early',
              kind: 'opening'
            }];
          }
          if (has('d8b6')) {
            return [{
              lessonId: 'london-meet-qb6',
              reason: 'your game reached the london position where ...Qb6 pressures b2',
              kind: 'opening'
            }];
          }
          if (has('c7c5')) {
            return [{
              lessonId: 'london-meet-c5',
              reason: 'black challenged your london centre with ...c5',
              kind: 'opening'
            }];
          }
          if (has('g7g6') || has('f8g7')) {
            return [{
              lessonId: 'london-fianchetto',
              reason: 'black chose a kingside fianchetto against your london setup',
              kind: 'opening'
            }];
          }
          return [{
            lessonId: moves.length >= 16 ? 'london-enter-the-middlegame' : 'london-build-the-shell',
            reason: moves.length >= 16
              ? 'your london reached the point where the setup needs a middlegame plan'
              : 'your game used the london structure; reinforce its development sequence',
            kind: 'opening'
          }];
        }

        if (playerColor === 'b' && firstMove === 'e2e4') {
          if (!has('e7e5')) {
            return [{
              lessonId: 'black-e5-claim-the-centre',
              reason: 'white opened with e4; review the direct ...e5 repertoire reply',
              kind: 'opening'
            }];
          }
          if (has('f1c4')) {
            return [{
              lessonId: 'black-e5-italian',
              reason: 'your game entered an italian structure after e4 e5 and Bc4',
              kind: 'opening'
            }];
          }
          return [{
            lessonId: moves.length >= 16 ? 'black-e5-central-break' : 'black-e5-develop',
            reason: moves.length >= 16
              ? 'your e5 game reached the moment to prepare the freeing ...d5 break'
              : 'your game began e4 e5; complete the classical development plan',
            kind: 'opening'
          }];
        }

        if (playerColor === 'b' && firstMove === 'd2d4') {
          if (!has('d7d5')) {
            return [{
              lessonId: 'qgd-claim-with-d5',
              reason: 'white opened with d4; review the queen’s gambit declined ...d5 reply',
              kind: 'opening'
            }];
          }
          if (!has('e7e6')) {
            return [{
              lessonId: 'qgd-build-the-chain',
              reason: 'your d4 d5 game did not complete the queen’s gambit declined pawn chain',
              kind: 'opening'
            }];
          }
          return [{
            lessonId: has('c7c5') ? 'qgd-c5-break' : moves.length >= 14 ? 'qgd-c5-break' : 'qgd-finish-development',
            reason: has('c7c5')
              ? 'your queen’s gambit declined reached the active ...c5 break'
              : moves.length >= 14
                ? 'your queen’s gambit declined was ready for the freeing ...c5 break'
                : 'your game reached the queen’s gambit declined development phase',
            kind: 'opening'
          }];
        }
        return [];
      }

      function recommendationsFromGame(activeGame, playerColor = color) {
        if (!activeGame || activeGame.metadata?.mode === 'placement') return [];
        const level = recommendedLevelForGame(activeGame);
        const moves = Array.isArray(activeGame.moves) ? activeGame.moves : [];
        const ownMoves = moves.filter((move, index) => (
          (index % 2 === 0 ? 'w' : 'b') === playerColor
        ));
        const earlyOwnMoves = moves.slice(0, 16).filter((move, index) => (
          (index % 2 === 0 ? 'w' : 'b') === playerColor
        ));
        const castled = ownMoves.some((move) => (
          /^O-O/.test(String(move.san || ''))
          || (move.from === (playerColor === 'w' ? 'e1' : 'e8')
            && ['c1', 'g1', 'c8', 'g8'].includes(move.to))
        ));
        const homeMinorSquares = playerColor === 'w'
          ? new Set(['b1', 'g1', 'c1', 'f1'])
          : new Set(['b8', 'g8', 'c8', 'f8']);
        const developedPieces = new Set(
          earlyOwnMoves
            .filter((move) => homeMinorSquares.has(move.from))
            .map((move) => move.from)
        );
        const queenStart = playerColor === 'w' ? 'd1' : 'd8';
        const earlyQueenMoves = earlyOwnMoves.filter((move) => (
          move.from === queenStart || /^Q/.test(String(move.san || ''))
        )).length;
        const playerResult = gameResultForPlayer(activeGame, playerColor);
        const lostOnTime = activeGame.result?.reason === 'time' && playerResult === 'loss';
        const shortLoss = playerResult === 'loss' && moves.length <= 28;
        const longGame = moves.length >= 50;
        const candidates = [];
        const add = (lessonId, reason, kind = 'lesson') => {
          const lessonLevel = lessonLevelForId(lessonId);
          const index = lessonIndexByLevel[lessonLevel]?.get(lessonId);
          if (
            !lessonLevel
            || !Number.isInteger(index)
            || !lessonIsUnlocked(index, lessonLevel)
            || candidates.some((item) => item.lessonId === lessonId)
          ) return;
          candidates.push({ lessonId, reason, kind });
        };

        openingRecommendationsFromGame(activeGame, playerColor).forEach((recommendation) => {
          add(recommendation.lessonId, recommendation.reason, recommendation.kind);
        });

        if (!castled && moves.length >= 12) {
          add(
            { beginner: 'king-safety', intermediate: 'opening-to-middlegame', advanced: 'move-order-discipline' }[level],
            'your king stayed in the centre through the opening'
          );
        }
        if (developedPieces.size < 2 && moves.length >= 10) {
          add(
            { beginner: 'develop', intermediate: 'develop-with-purpose', advanced: 'opening-transpositions' }[level],
            'fewer than two minor pieces developed in the opening'
          );
        }
        if (earlyQueenMoves >= 2) {
          add(
            { beginner: 'opening-plan', intermediate: 'central-tension', advanced: 'prophylaxis' }[level],
            'the queen moved repeatedly before development was complete'
          );
        }
        if (shortLoss) {
          add(
            { beginner: 'answer-the-threat', intermediate: 'checks-captures-threats', advanced: 'calculate-the-branches' }[level],
            'the game was decided before move 15'
          );
        }
        if (lostOnTime) {
          add(
            { beginner: 'answer-the-threat', intermediate: 'candidate-moves', advanced: 'evaluate-the-result' }[level],
            'time decided the game'
          );
        }
        if (longGame) {
          add(
            { beginner: 'active-king', intermediate: 'rook-ending-basics', advanced: 'active-rook' }[level],
            'the game reached a long ending'
          );
        }
        add(
          { beginner: 'trade-when-ahead', intermediate: 'worst-placed-piece', advanced: 'read-the-imbalances' }[level],
          'use this as the next practical theme from your game'
        );
        if (!candidates.length) {
          const fallbackIndex = lessonsForLevel(level).findIndex((item, index) => (
            !item.assessment && lessonIsUnlocked(index, level)
          ));
          const fallbackLesson = lessonsForLevel(level)[fallbackIndex];
          if (fallbackLesson) {
            candidates.push({
              lessonId: fallbackLesson.id,
              reason: 'the best available next step in your current path'
            });
          }
        }
        return candidates.slice(0, 3);
      }

      function recommendationsFromAnalysis(analysis, level = activeLearnLevel) {
        if (!analysis) return [];
        const normalizedLevel = normalizedLearnLevel(level);
        const lessonByTheme = {
          calculation: {
            beginner: 'answer-the-threat', intermediate: 'checks-captures-threats', advanced: 'calculate-the-branches'
          },
          'opening-principles': {
            beginner: 'opening-plan', intermediate: 'develop-with-purpose', advanced: 'opening-decisions'
          },
          'king-safety': {
            beginner: 'king-safety', intermediate: 'opening-to-middlegame', advanced: 'prophylaxis'
          },
          'pawn-structure': {
            beginner: 'passed-pawn', intermediate: 'create-a-pawn-break', advanced: 'pawn-structure-transformations'
          },
          'piece-activity': {
            beginner: 'develop', intermediate: 'worst-placed-piece', advanced: 'read-the-imbalances'
          },
          'endgame-technique': {
            beginner: 'active-king', intermediate: 'rook-ending-basics', advanced: 'endgame-judgement'
          }
        };
        const recommendations = [];
        for (const theme of analysis.themes || []) {
          const lessonId = lessonByTheme[theme.id]?.[normalizedLevel];
          const lessonLevel = lessonLevelForId(lessonId);
          const index = lessonIndexByLevel[lessonLevel]?.get(lessonId);
          if (!lessonId || !lessonLevel || !Number.isInteger(index) || !lessonIsUnlocked(index, lessonLevel)) continue;
          recommendations.push({
            lessonId,
            reason: 'recommended from this game',
            kind: 'lesson'
          });
          if (recommendations.length >= 2) break;
        }
        return recommendations;
      }

      function mergeGameRecommendations(stored, analysis = stored?.analysis) {
        const analysisLevel = recommendedLearnLevel();
        const merged = [
          ...recommendationsFromAnalysis(analysis, analysisLevel),
          ...(stored?.recommendations || [])
        ];
        stored.recommendations = merged
          .filter((recommendation, index) => (
            lessonForReviewId(recommendation.lessonId)
            && merged.findIndex((candidate) => candidate.lessonId === recommendation.lessonId) === index
          ))
          .slice(0, 3);
        return stored;
      }

      function recordGameRecommendations(activeGame, playerColor = color) {
        if (!activeGame?.id || activeGame.status !== 'ended') return null;
        reviewProgress ||= normalizedReviewProgress();
        const existing = reviewProgress.games.find((stored) => stored.gameId === activeGame.id);
        if (existing) return existing;
        const recommendations = recommendationsFromGame(activeGame, playerColor);
        if (!recommendations.length) return null;
        const stored = {
          gameId: String(activeGame.id),
          createdAt: Date.now(),
          endedAt: Number(activeGame.result?.endedAt) || Date.now(),
          result: gameResultForPlayer(activeGame, playerColor),
          opponentName: playerLabel(activeGame.players?.[playerColor === 'w' ? 'b' : 'w'], 'opponent'),
          opponentId: String(activeGame.players?.[playerColor === 'w' ? 'b' : 'w']?.id || ''),
          mode: String(activeGame.metadata?.mode || ''),
          difficulty: String(activeGame.metadata?.difficulty || ''),
          moveCount: Array.isArray(activeGame.moves) ? activeGame.moves.length : 0,
          analysisStatus: 'idle',
          analysisMessage: '',
          analysis: null,
          momentReview: {},
          recommendations
        };
        reviewProgress.games.push(stored);
        reviewProgress.games = reviewProgress.games.slice(-20);
        saveReviewProgress();
        return stored;
      }

      function storedGameFromHistory(item) {
        const activeGame = {
          id: item?.id,
          status: 'ended',
          result: item?.result || null,
          players: item?.players || {},
          moves: Array.isArray(item?.moves) ? item.moves : [],
          metadata: item?.metadata || {}
        };
        const playerColor = item?.playerColor === 'b' ? 'b' : 'w';
        const stored = {
          gameId: String(item?.id || ''),
          createdAt: Math.max(0, Number(item?.createdAt) || 0),
          endedAt: Math.max(0, Number(item?.endedAt) || Number(item?.createdAt) || 0),
          result: gameResultForPlayer(activeGame, playerColor),
          opponentName: playerLabel(item?.opponent, 'opponent'),
          opponentId: String(item?.opponent?.id || ''),
          mode: String(item?.metadata?.mode || ''),
          difficulty: String(item?.metadata?.difficulty || ''),
          moveCount: activeGame.moves.length,
          analysisStatus: ['queued', 'running', 'complete', 'error'].includes(item?.analysisStatus)
            ? item.analysisStatus
            : 'idle',
          analysisMessage: '',
          analysis: item?.analysis ? normalizedGameAnalysis(item.analysis) : null,
          momentReview: {},
          recommendations: recommendationsFromGame(activeGame, playerColor)
        };
        return mergeGameRecommendations(stored);
      }

      function clearGameAnalysisPoll(gameId) {
        const timer = gameAnalysisPollTimers.get(gameId);
        if (timer) window.clearTimeout(timer);
        gameAnalysisPollTimers.delete(gameId);
      }

      function scheduleGameAnalysisPoll(gameId, delay = 1_500) {
        if (gameAnalysisPollTimers.has(gameId)) return;
        const timer = window.setTimeout(() => {
          gameAnalysisPollTimers.delete(gameId);
          void pollStoredGameAnalysis(gameId);
        }, delay);
        gameAnalysisPollTimers.set(gameId, timer);
      }

      async function pollStoredGameAnalysis(gameId) {
        const requestIdentity = learnProgressSessionIdentity();
        if (!requestIdentity.accountId || !serverUrl) return;
        try {
          const response = await fetch(
            `${serverUrl}/api/games/${encodeURIComponent(gameId)}/analysis`,
            {
              headers: {
                accept: 'application/json',
                authorization: `Bearer ${requestIdentity.token}`
              }
            }
          );
          if (!learnProgressSessionIsCurrent(requestIdentity)) return;
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || 'analysis is unavailable right now');
          const stored = reviewProgress?.games?.find((item) => item.gameId === gameId);
          if (!stored) return;
          stored.analysisStatus = payload.status || 'idle';
          stored.analysisMessage = '';
          if (payload.status === 'complete' && payload.analysis) {
            stored.analysis = normalizedGameAnalysis(payload.analysis);
            mergeGameRecommendations(stored);
            clearGameAnalysisPoll(gameId);
          } else if (['queued', 'running'].includes(payload.status)) {
            scheduleGameAnalysisPoll(gameId);
          }
          saveReviewProgress();
        } catch (error) {
          if (!learnProgressSessionIsCurrent(requestIdentity)) return;
          const stored = reviewProgress?.games?.find((item) => item.gameId === gameId);
          if (!stored) return;
          stored.analysisStatus = 'error';
          stored.analysisMessage = String(error?.message || 'analysis is unavailable right now').slice(0, 100);
          saveReviewProgress();
        }
      }

      async function loadGameHistoryFromAccount() {
        const requestIdentity = learnProgressSessionIdentity();
        if (!requestIdentity.accountId || !serverUrl) return;
        try {
          const response = await fetch(`${serverUrl}/api/game-history?limit=20`, {
            headers: { authorization: `Bearer ${requestIdentity.token}` }
          });
          if (!learnProgressSessionIsCurrent(requestIdentity) || !response.ok) return;
          const payload = await response.json();
          if (!learnProgressSessionIsCurrent(requestIdentity)) return;
          reviewProgress ||= normalizedReviewProgress();
          const previousGames = new Map(
            reviewProgress.games.map((stored) => [stored.gameId, stored])
          );
          reviewProgress.games = (Array.isArray(payload?.games) ? payload.games : [])
            .map((item) => {
              const stored = storedGameFromHistory(item);
              stored.momentReview = previousGames.get(stored.gameId)?.momentReview || {};
              return stored;
            })
            .filter((stored) => stored.gameId)
            .reverse();
          saveReviewProgress();
          reviewProgress.games.forEach((stored) => {
            if (['queued', 'running'].includes(stored.analysisStatus)) {
              scheduleGameAnalysisPoll(stored.gameId, 250);
            }
          });
        } catch {}
      }

      async function requestStoredGameAnalysis(gameId) {
        reviewProgress ||= normalizedReviewProgress();
        const stored = reviewProgress.games.find((item) => item.gameId === gameId);
        if (!stored || !serverUrl || !session?.token || session?.player?.kind !== 'account') return;
        if (['queued', 'running'].includes(stored.analysisStatus)) {
          scheduleGameAnalysisPoll(gameId, 250);
          return;
        }
        stored.analysisStatus = 'queued';
        stored.analysisMessage = '';
        saveReviewProgress();
        try {
          const response = await fetch(
            `${serverUrl}/api/games/${encodeURIComponent(gameId)}/analysis`,
            {
              method: 'POST',
              headers: {
                accept: 'application/json',
                authorization: `Bearer ${session.token}`
              }
            }
          );
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || 'analysis is unavailable right now');
          stored.analysisStatus = payload.status || (payload.analysis ? 'complete' : 'queued');
          stored.analysis = payload.analysis ? normalizedGameAnalysis(payload.analysis) : null;
          if (stored.analysis) mergeGameRecommendations(stored);
          stored.analysisMessage = '';
          if (stored.analysisStatus !== 'complete') scheduleGameAnalysisPoll(gameId, 350);
        } catch (error) {
          stored.analysisStatus = 'error';
          stored.analysisMessage = String(error?.message || 'analysis is unavailable right now').slice(0, 100);
        }
        saveReviewProgress();
      }

      function requestGameAnalysis(activeGame, playerColor = color) {
        const stored = recordGameRecommendations(activeGame, playerColor);
        if (!stored || stored.analysisStatus === 'complete' || session?.player?.kind !== 'account') return;
        void requestStoredGameAnalysis(stored.gameId);
      }

      function reviewForGame(activeGame = game) {
        reviewProgress ||= normalizedReviewProgress();
        return reviewProgress.games.find((stored) => stored.gameId === activeGame?.id) || null;
      }

      function gameShareSummary(activeGame = game) {
        const score = activeGame?.result?.score || '½-½';
        const won = (color === 'w' && score === '1-0') || (color === 'b' && score === '0-1');
        const lost = (color === 'w' && score === '0-1') || (color === 'b' && score === '1-0');
        const opponentColor = color === 'w' ? 'b' : 'w';
        const playerName = playerLabel(activeGame?.players?.[color], 'player');
        const opponentName = playerLabel(activeGame?.players?.[opponentColor], 'opponent');
        const reason = String(activeGame?.result?.reason || 'game over');
        let line = `${playerName} vs ${opponentName}`;

        if (won && reason === 'checkmate') {
          line = `${playerName} cooked ${opponentName} · checkmate`;
        } else if (won && reason === 'resignation') {
          line = `${playerName} beat ${opponentName} · resignation`;
        } else if (won && reason === 'time') {
          line = `${playerName} beat ${opponentName} on time`;
        } else if (won) {
          line = `${playerName} beat ${opponentName}`;
        } else if (lost && reason === 'checkmate') {
          line = `${playerName} vs ${opponentName} · checkmate`;
        } else if (lost && reason === 'resignation') {
          line = `${playerName} vs ${opponentName} · resignation`;
        } else if (lost && reason === 'time') {
          line = `${playerName} vs ${opponentName} · out of time`;
        } else if (['stalemate', 'repetition', 'insufficient material'].includes(reason)) {
          line = `${playerName} drew with ${opponentName} · ${reason}`;
        } else if (!won && !lost) {
          line = `${playerName} drew with ${opponentName}`;
        }

        return {
          result: won ? 'win' : lost ? 'loss' : 'draw',
          playerName,
          opponentName,
          reason,
          line
        };
      }

      function fitShareText(context, text, maxWidth, preferredSize = 42, minimumSize = 26) {
        const family = 'Helvetica Neue, Helvetica, Arial, sans-serif';
        let size = preferredSize;
        context.font = `400 ${size}px ${family}`;
        while (size > minimumSize && context.measureText(text).width > maxWidth) {
          size -= 1;
          context.font = `400 ${size}px ${family}`;
        }
        if (context.measureText(text).width <= maxWidth) return text;
        let shortened = text;
        while (shortened.length > 1 && context.measureText(`${shortened}…`).width > maxWidth) {
          shortened = shortened.slice(0, -1);
        }
        return `${shortened.trimEnd()}…`;
      }

      const sharePieceCache = new Map();
      const sharePieceGraphicCache = new Map();

      function loadSharePiece(source) {
        if (!source) return Promise.resolve(null);
        const resolvedSource = new URL(source, window.location.href).href;
        if (sharePieceCache.has(resolvedSource)) return sharePieceCache.get(resolvedSource);
        const request = fetch(resolvedSource, { credentials: 'omit', mode: 'cors' })
          .then((response) => {
            if (!response.ok) throw new Error('piece artwork is unavailable');
            return response.blob();
          })
          .then((blob) => new Promise((resolve, reject) => {
            const image = new Image();
            const objectUrl = URL.createObjectURL(blob);
            const timer = window.setTimeout(() => {
              URL.revokeObjectURL(objectUrl);
              reject(new Error('piece artwork took too long'));
            }, 6000);
            image.onload = () => {
              window.clearTimeout(timer);
              URL.revokeObjectURL(objectUrl);
              resolve(image);
            };
            image.onerror = () => {
              window.clearTimeout(timer);
              URL.revokeObjectURL(objectUrl);
              reject(new Error('piece artwork is unavailable'));
            };
            image.src = objectUrl;
          }));
        sharePieceCache.set(resolvedSource, request);
        request.catch(() => sharePieceCache.delete(resolvedSource));
        return request;
      }

      function loadSharePieceGraphic(piece) {
        const source = pieces[piece];
        if (!source) return Promise.resolve(null);
        const resolvedSource = new URL(source, window.location.href).href;
        const key = `${piece}:${resolvedSource}`;
        if (sharePieceGraphicCache.has(key)) return sharePieceGraphicCache.get(key);
        const request = loadSharePiece(source).then((image) => {
          if (!image) return null;
          const graphic = document.createElement('canvas');
          graphic.width = 512;
          graphic.height = 512;
          const graphicContext = graphic.getContext('2d', { willReadFrequently: true });
          if (!graphicContext) throw new Error('piece artwork is unavailable');
          graphicContext.drawImage(image, 0, 0, graphic.width, graphic.height);
          const pixels = graphicContext.getImageData(0, 0, graphic.width, graphic.height);
          const whitePiece = piece === piece.toUpperCase();
          const brightness = whitePiece ? 1.08 : 0.52;
          const contrast = whitePiece ? 1.08 : 1.3;
          for (let index = 0; index < pixels.data.length; index += 4) {
            const red = pixels.data[index];
            const green = pixels.data[index + 1];
            const blue = pixels.data[index + 2];
            const grey = (red * 0.2126) + (green * 0.7152) + (blue * 0.0722);
            const adjusted = Math.max(
              0,
              Math.min(255, ((grey * brightness) - 127.5) * contrast + 127.5)
            );
            pixels.data[index] = adjusted;
            pixels.data[index + 1] = adjusted;
            pixels.data[index + 2] = adjusted;
          }
          graphicContext.putImageData(pixels, 0, 0);
          return graphic;
        });
        sharePieceGraphicCache.set(key, request);
        request.catch(() => sharePieceGraphicCache.delete(key));
        return request;
      }

      async function resultCardBlob(activeGame = game) {
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1350;
        const context = canvas.getContext('2d');
        if (!context) throw new Error('result card is unavailable');

        const summary = gameShareSummary(activeGame);
        const position = boardMap(activeGame?.fen || startingFen);
        const pieceGraphics = new Map();
        const wordmarkSource = section.querySelector('.osb-live__header-art')?.currentSrc
          || section.querySelector('.osb-live__header-art')?.src;
        const [shareWordmark] = await Promise.all([
          loadSharePiece(wordmarkSource),
          ...Array.from(new Set(position.values())).map(async (piece) => {
            pieceGraphics.set(piece, await loadSharePieceGraphic(piece));
          })
        ]);
        if (Array.from(position.values()).some((piece) => !pieceGraphics.get(piece))) {
          throw new Error('piece artwork is unavailable');
        }
        if (!shareWordmark) throw new Error('wordmark artwork is unavailable');

        const stageLeft = 80;
        const stageWidth = 920;
        const boardLeft = stageLeft;
        const boardTop = 170;
        const boardSize = stageWidth;
        const panelLeft = stageLeft;
        const panelTop = boardTop + boardSize;
        const panelWidth = stageWidth;
        const panelHeight = 200;
        const panelPadding = 34;
        const squareSize = boardSize / 8;
        const files = color === 'b' ? 'hgfedcba' : 'abcdefgh';
        const ranks = color === 'b' ? '12345678' : '87654321';
        const lastMove = activeGame?.lastMove;
        const danger = kingThreatHighlights(activeGame, position);
        const opponentColor = color === 'w' ? 'b' : 'w';
        const playerName = playerLabel(activeGame?.players?.[color], summary.playerName);
        const opponentPlayerName = playerLabel(activeGame?.players?.[opponentColor], summary.opponentName);
        const playerTime = String(yourClock?.textContent || '00:00').trim();
        const opponentTime = String(opponentClock?.textContent || '00:00').trim();
        const level = isComputerGame(activeGame) ? String(computerLevel?.textContent || '').trim() : '';
        const resultCopy = resultLabel(activeGame, isComputerGame(activeGame));
        const terminalCheckmate = danger.kind === 'checkmate';
        const checkedKingSquare = danger.kingSquare;
        const checkingPieceSquares = new Set(danger.checkingSquares);

        context.fillStyle = '#fff';
        context.fillRect(0, 0, canvas.width, canvas.height);
        const wordmarkHeight = 60;
        const wordmarkWidth = wordmarkHeight * (2421 / 317.17);
        context.save();
        context.beginPath();
        context.rect(stageLeft, 55, wordmarkWidth, wordmarkHeight);
        context.clip();
        context.drawImage(
          shareWordmark,
          stageLeft,
          55,
          wordmarkHeight * (4569.22 / 317.17),
          wordmarkHeight
        );
        context.restore();
        context.fillStyle = '#3aaa35';
        context.fillRect(940, 55, 60, 60);

        context.fillStyle = '#fafafa';
        context.fillRect(panelLeft, panelTop, panelWidth, panelHeight);

        ranks.split('').forEach((rank, row) => {
          files.split('').forEach((file, column) => {
            const square = `${file}${rank}`;
            const x = boardLeft + column * squareSize;
            const y = boardTop + row * squareSize;
            const canonicalFile = 'abcdefgh'.indexOf(file);
            const isDark = (canonicalFile + Number(rank)) % 2 === 1;
            context.fillStyle = terminalCheckmate
              ? (isDark ? '#d7d7d3' : '#f7f7f5')
              : (isDark ? '#3aaa35' : '#fff');
            if (danger.kind && checkingPieceSquares.has(square)) {
              context.fillStyle = terminalCheckmate ? '#edaaa4' : '#f5d4d1';
            }
            if (danger.kind && checkedKingSquare === square) {
              context.fillStyle = terminalCheckmate ? '#c94f45' : '#edaaa4';
            }
            context.fillRect(x, y, squareSize, squareSize);

            if (lastMove && (lastMove.from === square || lastMove.to === square)) {
              context.strokeStyle = 'rgba(17, 17, 17, 0.28)';
              context.lineWidth = 5;
              context.strokeRect(x + 3, y + 3, squareSize - 6, squareSize - 6);
            }
            const piece = position.get(square);
            const graphic = pieceGraphics.get(piece);
            if (graphic) {
              const inset = 3;
              context.drawImage(
                graphic,
                x + inset,
                y + inset,
                squareSize - inset * 2,
                squareSize - inset * 2
              );
            }
          });
        });

        const panelTextLeft = panelLeft + panelPadding;
        const panelTextRight = panelLeft + panelWidth - panelPadding;
        context.textBaseline = 'alphabetic';
        context.textAlign = 'left';
        context.fillStyle = '#aaa';
        context.font = '400 32px Helvetica Neue, Helvetica, Arial, sans-serif';
        context.fillText(
          fitShareText(context, opponentPlayerName, panelWidth * 0.34, 32, 20),
          panelTextLeft,
          panelTop + 50
        );
        if (level) {
          context.fillStyle = '#666';
          context.font = '400 18px Helvetica Neue, Helvetica, Arial, sans-serif';
          context.fillText(level, panelTextLeft, panelTop + 78);
        }
        context.fillStyle = '#111';
        context.font = '400 32px Helvetica Neue, Helvetica, Arial, sans-serif';
        context.fillText(opponentTime, panelTextLeft, panelTop + 132);

        context.textAlign = 'right';
        context.fillStyle = '#aaa';
        context.font = '400 32px Helvetica Neue, Helvetica, Arial, sans-serif';
        context.fillText(
          fitShareText(context, playerName, panelWidth * 0.34, 32, 20),
          panelTextRight,
          panelTop + 50
        );
        context.fillStyle = '#111';
        context.font = '400 32px Helvetica Neue, Helvetica, Arial, sans-serif';
        context.fillText(playerTime, panelTextRight, panelTop + 132);

        context.textAlign = 'center';
        context.fillStyle = '#111';
        context.font = '400 30px Helvetica Neue, Helvetica, Arial, sans-serif';
        context.fillText(
          fitShareText(context, resultCopy, panelWidth * 0.42, 30, 22),
          panelLeft + panelWidth / 2,
          panelTop + 126
        );

        return new Promise((resolve, reject) => {
          let settled = false;
          const timer = window.setTimeout(() => {
            if (settled) return;
            settled = true;
            reject(new Error('result card took too long'));
          }, 6000);
          canvas.toBlob(
            (blob) => {
              if (settled) return;
              settled = true;
              window.clearTimeout(timer);
              if (blob) resolve(blob);
              else reject(new Error('result card is unavailable'));
            },
            'image/png'
          );
        });
      }

      async function shareGameResult() {
        if (!game || game.status !== 'ended') return;
        const summary = gameShareSummary(game);
        const previousLabel = gameShareButton?.textContent || 'share game';
        try {
          if (gameShareButton) {
            gameShareButton.disabled = true;
            gameShareButton.textContent = 'making card';
          }
          const blob = await resultCardBlob(game);
          const resultName = String(summary.reason || 'final-position')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
          const file = new File(
            [blob],
            `one-square-better-${resultName || 'final-position'}.png`,
            { type: 'image/png' }
          );
          const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
          if (
            coarsePointer &&
            navigator.share &&
            (!navigator.canShare || navigator.canShare({ files: [file] }))
          ) {
            await navigator.share({ files: [file] });
            return;
          }
          const download = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          download.href = objectUrl;
          download.download = file.name;
          download.click();
          window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
          setStatus('result card saved.');
        } catch (error) {
          if (error?.name !== 'AbortError') setStatus('could not share this game.');
        } finally {
          if (gameShareButton) {
            gameShareButton.disabled = false;
            gameShareButton.textContent = previousLabel;
          }
        }
      }

      function updateGame(nextGame, nextColor = color) {
        if (lessonState || puzzleState) stopLesson({ restore: false });
        const previousGame = game;
        const previousMove = moveKey(previousGame?.lastMove);
        const nextMove = moveKey(nextGame?.lastMove);
        const acknowledgedPending = Boolean(pendingMove && moveKey(pendingMove) === nextMove);
        const positionChanged = previousGame?.fen !== nextGame?.fen || renderedColor !== (nextColor || color);
        game = nextGame;
        color = nextColor || color;
        const hasPlayedMove = Boolean(game.moves?.length || game.lastMove);
        const gameHasStarted = hasPlayedMove && (game.clockStarted ?? true);
        window.__osbActiveGamePresence = {
          active: game.status === 'active' && gameHasStarted,
          started: game.status === 'active' && gameHasStarted,
          gameId: game.id,
          mode: game.metadata?.mode || 'live'
        };
        try {
          if (window.__osbActiveGamePresence.active) {
            window.sessionStorage.setItem(
              'osb-active-game-presence',
              JSON.stringify(window.__osbActiveGamePresence)
            );
          } else {
            window.sessionStorage.removeItem('osb-active-game-presence');
          }
        } catch {}
        document.dispatchEvent(new CustomEvent('osb:game-presence', {
          detail: window.__osbActiveGamePresence
        }));
        if (connectionState?.gameId !== game.id) connectionState = null;
        activeRequestId = game.metadata?.requestId || '';
        if (previousGame?.id !== game.id && game.metadata?.mode === 'direct') {
          incomingChallenge = null;
          outgoingChallenge = null;
          closeChallengeHandover({ returnFocus: false });
        } else if (game.status === 'ended' && handoverRequest && !handoverResponsePending) {
          closeChallengeHandover({ returnFocus: false });
        }
        if (game.status === 'active') {
          incomingRematch = null;
          rematchRequested = false;
        }
        automaticMatchmaking = false;
        arena?.classList.toggle('is-game-active', game.status === 'active');
        arena?.classList.toggle('is-game-ended', game.status === 'ended');
        arena?.classList.remove('is-lobby', 'is-matching');
        if (desktopGameLayout()) {
          const enteredActiveGame = game.status === 'active'
            && (previousGame?.id !== game.id || previousGame?.status !== 'active');
          const enteredEndedGame = game.status === 'ended'
            && (previousGame?.id !== game.id || previousGame?.status !== 'ended');
          if (enteredActiveGame || enteredEndedGame) setDesktopLiveExpanded(false);
        }
        const untouchedClock = Math.max(1, Number(game.seconds) || 300) * 1000;
        clockState = {
          clocks: hasPlayedMove
            ? { ...game.clocks }
            : { w: untouchedClock, b: untouchedClock },
          turn: game.turn,
          status: game.status,
          started: gameHasStarted,
          receivedAt: Date.now()
        };
        const own = game.players[color];
        const otherColor = color === 'w' ? 'b' : 'w';
        const other = game.players[otherColor];
        const computerGame = isComputerGame(game);
        const showLiveChatPrototype = Boolean(
          !computerGame
          && game.status === 'active'
          && gameHasStarted
          && game.metadata?.mode !== 'placement'
        );
        finder?.classList.toggle('is-live-game-cleanup', showLiveChatPrototype);
        arena?.classList.toggle('has-live-chat-prototype', showLiveChatPrototype);
        arena?.classList.remove('is-live-chat-demo');
        const chatPrototypeWasVisible = Boolean(chatPrototype && !chatPrototype.hidden);
        if (chatPrototype) chatPrototype.hidden = !showLiveChatPrototype;
        if (chatPrototypeCommunication) chatPrototypeCommunication.hidden = !showLiveChatPrototype;
        if (humanTurnMarker) {
          humanTurnMarker.hidden = !showLiveChatPrototype;
          humanTurnMarker.classList.toggle(
            'is-live',
            showLiveChatPrototype && game.status === 'active' && game.turn === color
          );
        }
        if (mobileHumanTurnMarker) {
          mobileHumanTurnMarker.hidden = !showLiveChatPrototype;
          mobileHumanTurnMarker.classList.toggle(
            'is-live',
            showLiveChatPrototype && game.status === 'active' && game.turn === color
          );
        }
        if (showLiveChatPrototype && !chatPrototypeWasVisible) scrollChatPrototypeToLatest();
        if (!showLiveChatPrototype) resetLiveChatPrototype();
        if (placementStatus && game.metadata?.mode !== 'placement') {
          placementStatus.hidden = true;
          placementStatus.textContent = '';
        }
        if (you) you.textContent = liveChatDemoMode
          ? 'chess club'
          : session?.player?.kind === 'guest' ? 'guest' : playerLabel(own, 'you');
        if (opponent) setOpponentIdentity(playerLabel(other), '');
        syncComputerLevelControl(game, computerGame, hasPlayedMove);
        const ownConnection = connectionState?.gameId === game.id ? connectionState.players?.[color] : null;
        const otherConnection = connectionState?.gameId === game.id ? connectionState.players?.[otherColor] : null;
        renderSignal(
          yourSignal,
          game.status === 'active' && !computerGame ? (ownConnection || { connected: true, bars: 4 }) : null
        );
        renderSignal(
          opponentSignal,
          game.status === 'active' && !computerGame ? (otherConnection || { connected: true, bars: 4 }) : null
        );
        updateClocks();
        yourClock?.classList.remove('is-time-loss');
        opponentClock?.classList.remove('is-time-loss');
        if (game.status === 'ended' && game.result?.reason === 'time') {
          const losingColor = game.result?.score === '0-1' ? 'w' : game.result?.score === '1-0' ? 'b' : '';
          const losingClock = losingColor === color ? yourClock : losingColor ? opponentClock : null;
          losingClock?.classList.add('is-time-loss');
        }
        if (turnSquare) {
          turnSquare.classList.toggle(
            'is-live',
            !showLiveChatPrototype && game.status === 'active' && game.turn === color
          );
        }
        if (controls) controls.hidden = false;
        hideMatchOptions();
        if (rematchButton) {
          rematchButton.hidden = game.status !== 'ended';
          if (game.status === 'active') {
            rematchButton.disabled = false;
            rematchButton.textContent = 'again';
          } else if (!incomingRematch && !rematchRequested) {
            rematchButton.disabled = false;
            rematchButton.textContent = 'again';
          }
        }
        if (drawButton) drawButton.hidden = game.status !== 'active' || computerGame || showLiveChatPrototype;
        if (resignButton) {
          resignButton.hidden = game.status !== 'active' || computerGame || showLiveChatPrototype;
        }
        if (resignButton) {
          resignButton.textContent = 'resign';
          resignButton.setAttribute('aria-label', 'resign game');
        }
        if (computerEndButton) {
          computerEndButton.hidden = !(
            computerGame
            && game.status === 'active'
            && gameHasStarted
          );
        }
        if (liveEndButton) liveEndButton.hidden = true;
        if (
          game.status === 'ended'
          && (previousGame?.id !== game.id || previousGame?.status !== 'ended')
        ) {
          requestGameAnalysis(game, color);
        }
        if (gameLearningButton) {
          const hasGameReview = Boolean(game.status === 'ended' && reviewForGame(game));
          gameLearningButton.hidden = !hasGameReview;
          gameLearningButton.disabled = !hasGameReview;
        }
        if (gameShareButton) gameShareButton.hidden = game.status !== 'ended' || !hasPlayedMove;
        updateVoiceControls();
        openGameChat();
        if (showLiveChatPrototype) setGameChatVisible(false);

        if (game.status === 'ended') {
          stopTableAudio(false);
          setGameChatVisible(false);
          renderLivePlayers();
          setResultStatus(game, computerGame);
        } else if (game.drawOfferedBy) {
          const drawPlayer = Object.values(game.players || {}).find((player) => player?.id === game.drawOfferedBy);
          setStatus(`${playerLabel(drawPlayer)} offered a draw`);
        } else {
          setStatus('');
        }
        if (positionChanged || squareElements.size !== 64) {
          const capture = Boolean(renderedPosition.get(game.lastMove?.to));
          syncBoard(boardMap(game.fen), game.lastMove, Boolean(previousGame && previousMove !== nextMove && !acknowledgedPending));
          if (previousGame && previousMove !== nextMove && !acknowledgedPending) playMoveFeedback(capture);
        } else {
          refreshSquareStates();
        }
        if (acknowledgedPending || (positionChanged && pendingMove && nextMove !== moveKey(pendingMove))) pendingMove = null;

        if (premove && game.status === 'active' && game.turn === color) {
          const queuedMove = premove;
          premove = null;
          refreshSquareStates();
          const legal = game.legalMoves?.find((move) => move.from === queuedMove.from && move.to === queuedMove.to);
          if (legal) window.setTimeout(() => requestMove(queuedMove.from, queuedMove.to, queuedMove.promotion || legal.promotion || ''), 55);
        }
      }

      function socketUrl(ticket) {
        const url = new URL(serverUrl);
        url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
        url.pathname = '/live';
        url.search = `?ticket=${encodeURIComponent(ticket)}`;
        return url.toString();
      }

      async function requestSocketTicket() {
        const response = await fetch(`${serverUrl}/api/socket-ticket`, {
          method: 'POST',
          headers: { authorization: `Bearer ${session.token}` }
        });
        const payload = await response.json().catch(() => ({}));
        if (response.status === 401) {
          const accountSession = session?.player?.kind === 'account';
          localStorage.removeItem(accountStorageKey);
          sessionStorage.removeItem(storageKey);
          session = null;
          if (accountSession) document.dispatchEvent(new CustomEvent('osb:account-session-expired'));
          throw new Error('session expired. sign in again.');
        }
        if (!response.ok || !payload.ticket) {
          const error = new Error(payload.error || 'live room is unavailable');
          error.status = response.status;
          error.retryAfter = Number(response.headers.get('retry-after') || 0);
          throw error;
        }
        return payload.ticket;
      }

      function scheduleReconnect() {
        if (
          intentionalClose
          || !session?.token
          || entryMode === 'learn'
          || (section.hidden && (!game || game.status !== 'active'))
        ) return;
        setStatus(
          entryMode === 'computer'
            ? 'starting computer'
            : entryMode === 'live'
              ? 'reconnecting'
              : 'reconnecting',
          { active: true }
        );
        window.clearTimeout(reconnectTimer);
        const wait = Math.min(15000, 750 * (2 ** reconnectAttempt));
        reconnectAttempt += 1;
        reconnectTimer = window.setTimeout(() => {
          connect().catch((error) => {
            if (!session?.token) {
              setStatus(error.message || 'sign in again');
              return;
            }
            if (error?.status === 429 || error?.message === 'try again shortly') {
              setStatus('reconnecting', { active: true });
              window.clearTimeout(reconnectTimer);
              reconnectTimer = window.setTimeout(() => {
                reconnectAttempt = 0;
                connect().catch(() => scheduleReconnect());
              }, Math.max(60_000, Number(error?.retryAfter || 0) * 1000));
              return;
            }
            scheduleReconnect();
          });
        }, wait);
      }

      function closeIdleConnection() {
        if (game?.status === 'active') return;
        window.clearTimeout(reconnectTimer);
        reconnectAttempt = 0;
        queued = false;
        queueJoinPending = false;
        resumeAutomaticQueue = false;
        window.clearTimeout(resumeQueueTimer);
        resumeQueueTimer = null;
        const closingSocket = socket;
        if (closingSocket) {
          intentionallyClosedSockets.add(closingSocket);
          closingSocket.close();
        }
        socket = null;
        delete section.dataset.socketReady;
        readyPromise = null;
        resolveReady = null;
        rejectReady = null;
      }

      function send(type, payload = {}) {
        if (!socket || socket.readyState !== WebSocket.OPEN) throw new Error('connecting to the live room');
        socket.send(JSON.stringify({ type, ...payload }));
      }

      function updateVoiceControls() {
        const opponentId = game ? game.players[color === 'w' ? 'b' : 'w']?.id : '';
        const available = Boolean(
          game?.status === 'active'
          && session?.player?.kind === 'account'
          && opponentId
          && !opponentId.startsWith('computer:')
        );
        if (voiceButton) voiceButton.hidden = !available || voiceJoined;
        if (voiceHearButton) voiceHearButton.hidden = !available || !voiceJoined || !voiceNeedsGesture;
        if (voiceMuteButton) {
          voiceMuteButton.hidden = !available || !voiceJoined;
          voiceMuteButton.textContent = voiceMuted ? 'unmute' : 'mute';
        }
        if (voiceLeaveButton) voiceLeaveButton.hidden = !available || !voiceJoined;
      }

      function closeVoicePeer() {
        pendingIceCandidates = [];
        voicePeer?.close();
        voicePeer = null;
        if (remoteAudio) remoteAudio.srcObject = null;
      }

      function stopTableAudio(notify = true) {
        if (notify && voiceJoined && socket?.readyState === WebSocket.OPEN) {
          try { send('audio.leave'); } catch (error) {}
        }
        voiceJoined = false;
        voiceMuted = false;
        voiceNeedsGesture = false;
        if (voiceButton) voiceButton.textContent = 'voice';
        closeVoicePeer();
        localVoiceStream?.getTracks().forEach((track) => track.stop());
        localVoiceStream = null;
        updateVoiceControls();
      }

      async function playRemoteVoice() {
        if (!remoteAudio?.srcObject) return;
        remoteAudio.muted = false;
        remoteAudio.volume = 1;
        try {
          await remoteAudio.play();
          voiceNeedsGesture = false;
        } catch {
          voiceNeedsGesture = true;
        }
        updateVoiceControls();
      }

      async function ensureVoiceStream() {
        if (localVoiceStream) return localVoiceStream;
        if (!navigator.mediaDevices?.getUserMedia) throw new Error('voice is unavailable on this device');
        localVoiceStream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
          video: false
        });
        return localVoiceStream;
      }

      async function ensureVoicePeer() {
        if (voicePeer) return voicePeer;
        await ensureVoiceStream();
        voicePeer = new RTCPeerConnection({ iceServers: rtcIceServers });
        localVoiceStream.getTracks().forEach((track) => voicePeer.addTrack(track, localVoiceStream));
        voicePeer.addEventListener('icecandidate', (event) => {
          if (event.candidate) send('audio.signal', { signalType: 'ice', signal: event.candidate.toJSON() });
        });
        voicePeer.addEventListener('track', (event) => {
          if (!remoteAudio) return;
          const stream = event.streams?.[0] || new MediaStream([event.track]);
          remoteAudio.srcObject = stream;
          playRemoteVoice();
        });
        voicePeer.addEventListener('connectionstatechange', () => {
          if (voicePeer?.connectionState === 'connected') setStatus('');
          if (['failed', 'closed'].includes(voicePeer?.connectionState)) {
            setStatus('voice ended');
            stopTableAudio(false);
          }
        });
        return voicePeer;
      }

      async function startTableAudio(initiator, configuredIceServers = null) {
        if (Array.isArray(configuredIceServers) && configuredIceServers.length) rtcIceServers = configuredIceServers;
        voiceJoined = true;
        updateVoiceControls();
        const peer = await ensureVoicePeer();
        if (!initiator) return;
        const offer = await peer.createOffer();
        await peer.setLocalDescription(offer);
        send('audio.signal', { signalType: 'offer', signal: peer.localDescription.toJSON() });
      }

      async function handleAudioSignal(message) {
        const peer = await ensureVoicePeer();
        if (message.signalType === 'offer') {
          await peer.setRemoteDescription(message.signal);
          const answer = await peer.createAnswer();
          await peer.setLocalDescription(answer);
          send('audio.signal', { signalType: 'answer', signal: peer.localDescription.toJSON() });
        } else if (message.signalType === 'answer') {
          await peer.setRemoteDescription(message.signal);
        } else if (message.signalType === 'ice') {
          if (peer.remoteDescription) await peer.addIceCandidate(message.signal);
          else pendingIceCandidates.push(message.signal);
        }
        if (peer.remoteDescription && pendingIceCandidates.length) {
          const candidates = pendingIceCandidates.splice(0);
          for (const candidate of candidates) await peer.addIceCandidate(candidate);
        }
      }

      async function connect() {
        if (!serverUrl || !session?.token) return Promise.reject(new Error('live server is not configured'));
        if (accountSessionHasExpired(session)) {
          localStorage.removeItem(accountStorageKey);
          session = null;
          document.dispatchEvent(new CustomEvent('osb:account-session-cleared'));
          return Promise.reject(new Error('session expired. sign in again.'));
        }
        if (socket?.readyState === WebSocket.OPEN) return Promise.resolve();
        if (readyPromise) return readyPromise;

        readyPromise = new Promise((resolve, reject) => {
          resolveReady = resolve;
          rejectReady = reject;
        });
        const pendingReady = readyPromise;
        intentionalClose = false;
        socketStateReady = false;
        socketStatePromise = new Promise((resolve) => {
          resolveSocketState = resolve;
        });
        try {
          socket = new WebSocket(socketUrl(await requestSocketTicket()));
        } catch (error) {
          rejectReady?.(error);
          readyPromise = null;
          resolveReady = null;
          rejectReady = null;
          return pendingReady;
        }

        socket.addEventListener('message', (event) => {
          let message;
          try {
            message = JSON.parse(event.data);
          } catch {
            return;
          }

          if (message.type === 'session.ready') {
            reconnectAttempt = 0;
            section.dataset.socketReady = 'true';
            if (Array.isArray(message.rtc?.iceServers) && message.rtc.iceServers.length) {
              rtcIceServers = message.rtc.iceServers;
            }
            setStatus('');
            resolveReady?.();
            resolveReady = null;
            rejectReady = null;
            readyPromise = null;
            loadLivePlayers();
            if (session?.player?.kind === 'account') {
              document.dispatchEvent(new CustomEvent('osb:live-account-ready'));
            }
          } else if (message.type === 'queue.joined') {
            matchCancelRequested = false;
            queueJoinPending = false;
            resumeAutomaticQueue = false;
            window.clearTimeout(resumeQueueTimer);
            resumeQueueTimer = null;
            socketStateReady = true;
            resolveSocketState?.();
            resolveSocketState = null;
            queued = true;
            if (automaticMatchmaking) {
              arena?.classList.add('is-matching');
              arena?.classList.remove('is-lobby');
              if (liveLobby) liveLobby.hidden = false;
              if (liveList) liveList.hidden = false;
            }
            if (controls) controls.hidden = false;
            if (matchCancelButton) matchCancelButton.hidden = false;
            syncMatchmakingIdentity();
            feedbackCue('selection');
            scheduleMatchOptions();
          } else if (message.type === 'queue.left') {
            const showCancelledState = matchCancelRequested && !pendingEntryMode;
            matchCancelRequested = false;
            queued = false;
            queueJoinPending = false;
            resumeAutomaticQueue = false;
            window.clearTimeout(resumeQueueTimer);
            resumeQueueTimer = null;
            automaticMatchmaking = false;
            matchCancelButton?.classList.remove('is-pending');
            matchCancelButton?.removeAttribute('aria-busy');
            if (matchCancelButton) matchCancelButton.disabled = false;
            arena?.classList.remove('is-matching');
            hideMatchOptions();
            if (showCancelledState && (!game || game.status !== 'active')) {
              showCancelledMatchState();
            } else {
              if (controls && (!game || game.status !== 'active')) controls.hidden = true;
              syncMatchmakingIdentity();
            }
            renderLivePlayers();
            if (pendingEntryMode) {
              const nextMode = pendingEntryMode;
              pendingEntryMode = '';
              window.setTimeout(() => enterQueue(entryOptions(nextMode)), 0);
            }
          } else if (message.type === 'game.start' || message.type === 'game.state' || message.type === 'game.clock') {
            const restoredGameMode = message.game?.metadata?.mode;
            const shouldRestoreActiveLiveGame = (
              entryMode === 'learn'
              && (message.type === 'game.start' || message.type === 'game.state')
              && message.game?.status === 'active'
              && restoredGameMode !== 'computer'
              && restoredGameMode !== 'placement'
            );
            if (shouldRestoreActiveLiveGame) {
              document.dispatchEvent(new CustomEvent('osb:match-lobby-open'));
            }
            if (entryMode === 'learn' && !shouldRestoreActiveLiveGame) return;
            socketStateReady = true;
            resolveSocketState?.();
            resolveSocketState = null;
            queued = false;
            queueJoinPending = false;
            resumeAutomaticQueue = false;
            window.clearTimeout(resumeQueueTimer);
            resumeQueueTimer = null;
            updateGame(message.game, message.color || color);
            if (message.type === 'game.start') {
              computerButton?.classList.remove('is-pending');
              computerButton?.removeAttribute('aria-busy');
              feedbackCue('success');
            }
            const currentMode = isComputerGame(message.game) ? 'computer' : 'live';
            entryMode = currentMode;
            if (pendingEntryMode && message.game?.status === 'active' && currentMode === pendingEntryMode) {
              pendingEntryMode = '';
            } else if (pendingEntryMode && message.game?.status === 'ended') {
              const nextMode = pendingEntryMode;
              pendingEntryMode = '';
              clearGame();
              window.setTimeout(() => enterQueue(entryOptions(nextMode)), 0);
            }
            if (message.type === 'game.start' && message.game?.metadata?.mode === 'direct') {
              document.dispatchEvent(new CustomEvent('osb:direct-game-start', {
                detail: { game: message.game }
              }));
              document.dispatchEvent(new CustomEvent('osb:match-requests-refresh'));
            }
          } else if (message.type === 'game.cleared') {
            socketStateReady = true;
            resolveSocketState?.();
            resolveSocketState = null;
            clearGame();
            if (resumeAutomaticQueue && automaticMatchmaking && entryMode === 'live') {
              window.clearTimeout(resumeQueueTimer);
              resumeQueueTimer = window.setTimeout(() => {
                resumeQueueTimer = null;
                if (
                  !resumeAutomaticQueue
                  || queued
                  || queueJoinPending
                  || socket?.readyState !== WebSocket.OPEN
                ) return;
                queueJoinPending = true;
                syncMatchmakingIdentity();
                try { send('queue.join', { seconds: 300 }); }
                catch (error) {
                  queueJoinPending = false;
                  setStatus(error.message || 'could not resume search');
                }
              }, 180);
            }
            if (pendingEntryMode) {
              const nextMode = pendingEntryMode;
              pendingEntryMode = '';
              window.setTimeout(() => enterQueue(entryOptions(nextMode)), 0);
            }
          } else if (message.type === 'connection.state') {
            connectionState = message;
            updateConnectionUi();
          } else if (message.type === 'challenge.sent') {
            outgoingChallenge = message.request || null;
            incomingChallenge = null;
            renderLivePlayers();
            setStatus('');
          } else if (message.type === 'match.requested') {
            if (handoverRequest?.id && handoverRequest.id !== message.request?.id) {
              closeChallengeHandover({ returnFocus: false });
            }
            incomingChallenge = message.request || null;
            outgoingChallenge = null;
            renderLivePlayers();
            document.dispatchEvent(new CustomEvent('osb:match-request-received', {
              detail: { request: message.request || null }
            }));
          } else if (message.type === 'challenge.received') {
            if (handoverRequest?.id && handoverRequest.id !== message.request?.id) {
              closeChallengeHandover({ returnFocus: false });
            }
            incomingChallenge = message.request || null;
            outgoingChallenge = null;
            renderLivePlayers();
            setStatus('');
            document.dispatchEvent(new CustomEvent('osb:match-request-received', {
              detail: { request: message.request || null }
            }));
          } else if (message.type === 'challenge.declined') {
            outgoingChallenge = null;
            renderLivePlayers();
            setStatus('not this time');
          } else if (message.type === 'challenge.cancelled') {
            outgoingChallenge = null;
            renderLivePlayers();
            setStatus('');
          } else if (message.type === 'challenge.cleared') {
            if (!message.request?.id || handoverRequest?.id === message.request.id) {
              closeChallengeHandover({ returnFocus: false });
            }
            incomingChallenge = null;
            renderLivePlayers();
            setStatus('');
          } else if (message.type === 'challenge.starting') {
            activeRequestId = message.request?.id || activeRequestId;
            closeChallengeHandover({ returnFocus: false });
            incomingChallenge = null;
            outgoingChallenge = null;
            renderLivePlayers();
            setStatus('starting');
          } else if (message.type === 'placement.progress') {
            if (message.session?.token) {
              session = message.session;
              saveSession(message.session);
              document.dispatchEvent(new CustomEvent('osb:account-session', { detail: message.session }));
            }
            const placement = message.placement;
            if (placementStatus) {
              placementStatus.hidden = !placement;
              placementStatus.textContent = placement?.complete
                ? 'placement complete'
                : placement
                  ? `placement ${placement.completed} of ${placement.total}`
                  : '';
            }
            document.dispatchEvent(new CustomEvent('osb:placement-progress', {
              detail: { placement, session: message.session || null }
            }));
          } else if (message.type === 'game.analysis.ready') {
            clearGameAnalysisPoll(message.gameId);
            void loadGameHistoryFromAccount();
          } else if (message.type === 'game.rematch.requested') {
            const requester = Object.values(game?.players || {})
              .find((player) => player?.id === message.by);
            incomingRematch = {
              id: message.by || requester?.id || '',
              name: requester?.name || 'opponent'
            };
            rematchRequested = false;
            if (rematchButton) {
              rematchButton.hidden = false;
              rematchButton.disabled = false;
              rematchButton.textContent = 'accept';
            }
            setStatus(`${playerLabel(incomingRematch)} wants another game`);
            renderLivePlayers();
          } else if (message.type === 'conversation.history') {
            if (message.conversation?.requestId && message.conversation.requestId !== activeRequestId) return;
            chatMessages?.replaceChildren();
            (message.messages || []).forEach(renderChatMessage);
          } else if (message.type === 'conversation.message') {
            if (message.conversation?.requestId && message.conversation.requestId !== activeRequestId) return;
            renderChatMessage(message.message);
          } else if (message.type === 'audio.waiting') {
            voiceJoined = true;
            updateVoiceControls();
            setStatus('voice connecting', { active: true });
          } else if (message.type === 'audio.invited') {
            if (voiceButton) voiceButton.textContent = 'join voice?';
            setStatus(`${message.by || 'opponent'} opened voice`);
          } else if (message.type === 'audio.start') {
            startTableAudio(message.initiator, message.iceServers).then(() => setStatus('')).catch((error) => {
              setStatus(error.message || 'voice could not start');
              stopTableAudio();
            });
          } else if (message.type === 'audio.signal') {
            handleAudioSignal(message).catch((error) => {
              setStatus(error.message || 'voice could not connect');
              stopTableAudio();
            });
          } else if (message.type === 'audio.left') {
            stopTableAudio(false);
            setStatus('voice ended');
          } else if (message.type === 'error') {
            const errorMessage = String(message.message || 'something went wrong');
            if (/available during a live player game/i.test(errorMessage)) {
              setGameChatVisible(false);
              return;
            }
            if (pendingMove) {
              pendingMove = null;
              syncBoard(boardMap(game?.fen || startingFen));
              feedbackCue('error');
            }
            if (queueJoinPending) {
              queueJoinPending = false;
              queued = false;
              resumeAutomaticQueue = false;
              automaticMatchmaking = false;
              arena?.classList.remove('is-matching');
              arena?.classList.add('is-lobby');
            }
            if (message.code === 'rate_limited' || message.message === 'slow down') return;
            const challengeError = Boolean(incomingChallenge || outgoingChallenge) && (
              message.code === 410
              || message.code === '410'
              || String(message.code || '').startsWith('challenge_')
              || /challenge|request.*expired|expired.*request/i.test(errorMessage)
            );
            if (challengeError) {
              incomingChallenge = null;
              outgoingChallenge = null;
              window.clearTimeout(challengeExpiryTimer);
              challengeExpiryTimer = null;
            }
            if (handoverResponsePending) {
              if (challengeError) closeChallengeHandover({ returnFocus: false });
              else setHandoverPending(false);
            }
            setStatus(errorMessage);
            if (challengeError) renderLivePlayers();
          }
        });

        socket.addEventListener('close', (event) => {
          const closedIntentionally = intentionallyClosedSockets.has(event.currentTarget);
          rejectReady?.(new Error('live room disconnected'));
          if (socket === event.currentTarget) socket = null;
          delete section.dataset.socketReady;
          stopTableAudio(false);
          readyPromise = null;
          resolveReady = null;
          rejectReady = null;
          socketStateReady = false;
          const shouldResumeSearch = Boolean(
            automaticMatchmaking
            && entryMode === 'live'
            && (queued || queueJoinPending)
          );
          resumeAutomaticQueue = shouldResumeSearch;
          queued = false;
          queueJoinPending = false;
          resolveSocketState?.();
          resolveSocketState = null;
          if (
            closedIntentionally
            || intentionalClose
            || !session?.token
            || (section.hidden && (!game || game.status !== 'active'))
          ) return;
          if (pendingMove) {
            pendingMove = null;
            syncBoard(boardMap(game?.fen || startingFen));
          }
          scheduleReconnect();
        });

        socket.addEventListener('error', () => {
          rejectReady?.(new Error('live room is offline'));
          setStatus('live room is offline');
        });
        return pendingReady;
      }

      function saveSession(payload) {
        if (payload?.player?.kind === 'account') {
          localStorage.setItem(accountStorageKey, JSON.stringify(payload));
          sessionStorage.removeItem(storageKey);
        } else {
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
        }
      }

      async function createPlayerSession(mode = 'guest', credential = '') {
        const response = await fetch(`${serverUrl}/api/session`, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ mode, credential })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'could not enter the live room');
        session = payload;
        loadLocalLearnProgressForSession(session);
        if (you) you.textContent = liveChatDemoMode
          ? 'chess club'
          : session.player?.kind === 'guest' ? 'guest' : playerLabel(session.player, 'you');
        saveSession(payload);
      }

      async function enterQueue(options = {}) {
        try {
          if (liveChatDemoMode && !options.computer) {
            showLiveChatDemo();
            return;
          }
          if (!serverUrl) return;
          if (options.credential) await createPlayerSession('google', options.credential);
          else if (options.mode === 'guest') await createPlayerSession('guest');
          else if (options.mode === 'account') {
            try {
              const storedAccount = JSON.parse(localStorage.getItem(accountStorageKey) || 'null');
              if (storedAccount?.player?.kind === 'account') {
                session = storedAccount;
                loadLocalLearnProgressForSession(session);
              }
            } catch (error) {}
          }
          else if (!session) await createPlayerSession('guest');
          if (!session) await createPlayerSession('guest');
          await connect();
          if (!socketStateReady) {
            await Promise.race([
              socketStatePromise,
              new Promise((resolve) => window.setTimeout(resolve, 1200))
            ]);
          }
          const nextMode = options.computer ? 'computer' : 'live';
          entryMode = nextMode;
          if (game?.status === 'active') {
            const currentMode = isComputerGame(game) ? 'computer' : 'live';
            if (currentMode === nextMode) {
              pendingEntryMode = '';
              setStatus('');
              return;
            }
            pendingEntryMode = nextMode;
            setStatus(nextMode === 'computer' ? 'starting computer' : 'finding a player', { active: true });
            send('game.resign');
            return;
          }
          if (queued) {
            if (nextMode === 'live') {
              pendingEntryMode = '';
              syncMatchmakingIdentity();
              return;
            }
            pendingEntryMode = nextMode;
            setStatus('starting computer', { active: true });
            send('queue.leave');
            return;
          }
          if (queueJoinPending && nextMode === 'live') {
            syncMatchmakingIdentity();
            return;
          }
          pendingEntryMode = '';
          if (options.computer) {
            automaticMatchmaking = false;
            arena?.classList.remove('is-lobby', 'is-matching');
            setStatus('starting computer', { active: true });
            send('computer.start', { difficulty: selectedComputerDifficulty });
          } else {
            automaticMatchmaking = options.mode === 'account';
            arena?.classList.toggle('is-matching', automaticMatchmaking);
            arena?.classList.toggle('is-lobby', !automaticMatchmaking);
            queueJoinPending = true;
            resumeAutomaticQueue = automaticMatchmaking;
            if (automaticMatchmaking) {
              if (liveLobby) liveLobby.hidden = false;
              if (liveList) liveList.hidden = false;
              loadLivePlayers();
            }
            if (automaticMatchmaking) syncMatchmakingIdentity();
            else setStatus('joining live room', { active: true });
            send('queue.join', { seconds: 300 });
          }
        } catch (error) {
          queueJoinPending = false;
          setStatus(error.message);
        }
      }

      function entryOptions(mode) {
        return {
          mode: mode === 'computer'
            ? (localStorage.getItem(accountStorageKey) ? 'account' : 'guest')
            : 'account',
          computer: mode === 'computer'
        };
      }

      const revealLiveChess = (event) => {
        const detail = event?.detail || {};
        const learning = detail.mode === 'learn';
        if (!learning) stopLesson();
        entryMode = learning
          ? 'learn'
          : detail.mode === 'computer'
            ? 'computer'
            : detail.mode === 'account'
              ? 'live'
              : '';
        automaticMatchmaking = Boolean(detail.autoStart && detail.mode === 'account');
        setStatus('');
        if (detail.autoStart && game?.status === 'ended') clearGame();
        if (detail.mode === 'account' && (!game || game.status === 'ended')) {
          arena?.classList.toggle('is-lobby', !automaticMatchmaking);
          arena?.classList.toggle('is-matching', automaticMatchmaking);
          arena?.classList.remove('is-game-active');
          setGameChatVisible(false);
          if (!liveChatDemoMode) loadLivePlayers();
        }

        window.clearTimeout(revealTimer);
        revealTimer = window.setTimeout(() => {
          revealTimer = null;
          section.hidden = false;
          section.setAttribute('aria-hidden', 'false');
          if (!embedded) window.scrollTo({ top: 0, behavior: 'auto' });
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => section.classList.add('is-visible'));
            if (learning) {
              closeIdleConnection();
              showLearnLibrary();
            } else if (detail.autoStart) {
              enterQueue(entryOptions(entryMode));
            } else if (detail.mode === 'account') {
              connect().then(loadLivePlayers).catch((error) => {
                setStatus(
                  error?.status === 429 || error?.message === 'try again shortly'
                    ? 'reconnecting'
                    : (error.message || 'live room is offline'),
                  { active: error?.status === 429 || error?.message === 'try again shortly' }
                );
              });
            }
          });
        }, Number(detail.delay || 0));
      };

      const hideLiveChess = () => {
        window.clearTimeout(revealTimer);
        revealTimer = null;
        const wasLearning = Boolean(lessonState || (learnLibrary && !learnLibrary.hidden));
        if (wasLearning) stopLesson();
        if (queued) {
          try { send('queue.leave'); } catch (error) {}
        }
        closeChallengeHandover({ returnFocus: false });
        if (!game || game.status !== 'active') {
          automaticMatchmaking = false;
          entryMode = '';
          pendingEntryMode = '';
          arena?.classList.remove('is-lobby', 'is-game-active', 'is-matching', 'is-learning', 'is-learn-library');
          setGameChatVisible(false);
          closeIdleConnection();
        }
        section.classList.remove('is-visible');
        window.setTimeout(() => {
          if (!section.classList.contains('is-visible')) {
            section.hidden = true;
            section.setAttribute('aria-hidden', 'true');
          }
        }, 430);
      };

      const handleDocumentVisibility = () => {
        window.clearTimeout(idleConnectionTimer);
        idleConnectionTimer = null;
        if (document.hidden) {
          idleConnectionTimer = window.setTimeout(() => {
            idleConnectionTimer = null;
            if (
              !document.hidden
              || game?.status === 'active'
              || queued
              || queueJoinPending
              || incomingChallenge
              || outgoingChallenge
              || incomingRematch
              || rematchRequested
            ) return;
            closeIdleConnection();
          }, 30_000);
          return;
        }
        if (section.hidden || entryMode === 'learn' || !session?.token) return;
        connect().then(loadLivePlayers).catch((error) => {
          setStatus(
            error?.status === 429 || error?.message === 'try again shortly'
              ? 'reconnecting'
              : (error.message || 'live room is offline'),
            { active: error?.status === 429 || error?.message === 'try again shortly' }
          );
        });
      };

      document.addEventListener('osb:live-chess-open', revealLiveChess);
      document.addEventListener('osb:live-chess-close', hideLiveChess);
      document.addEventListener('osb:match-requests-refresh', loadLivePlayers);
      document.addEventListener('visibilitychange', handleDocumentVisibility);
      if (liveChatDemoMode) {
        // Unpublished-theme visual QA route. This stages a local-only human
        // match without opening a socket, joining a queue or requesting media.
        revealLiveChess({ detail: { preview: true, delay: 0, mode: 'account', autoStart: true } });
      } else if (window.location.hash === '#learn') {
        // The finder can restore this route before this deferred asset has
        // attached its event listener. Replaying the route here keeps Learn
        // refreshable and shareable instead of leaving an empty map state.
        revealLiveChess({ detail: { preview: true, delay: 0, mode: 'learn' } });
      }
      const handleAccountSession = (event) => {
        const nextSession = event.detail;
        if (!nextSession?.token || nextSession?.player?.kind !== 'account') return;
        if (session?.player?.id === nextSession.player.id) {
          session = nextSession;
          saveSession(nextSession);
          if (you) you.textContent = liveChatDemoMode ? 'chess club' : playerLabel(nextSession.player, 'you');
          setGameChatVisible(false);
          void loadLearnProgressFromAccount();
          void loadGameHistoryFromAccount();
          loadLivePlayers();
          return;
        }
        intentionalClose = true;
        socket?.close();
        socket = null;
        session = nextSession;
        loadLocalLearnProgressForSession(session);
        saveSession(nextSession);
        if (you) you.textContent = liveChatDemoMode ? 'chess club' : playerLabel(nextSession.player, 'you');
        setGameChatVisible(false);
        void loadLearnProgressFromAccount();
        void loadGameHistoryFromAccount();
        intentionalClose = false;
        if (!section.hidden && entryMode !== 'learn') {
          connect().then(loadLivePlayers).catch((error) => setStatus(error.message || 'live room is offline'));
        } else {
          renderLivePlayers();
        }
      };

      const handleAccountSessionCleared = () => {
        for (const gameId of gameAnalysisPollTimers.keys()) clearGameAnalysisPoll(gameId);
        stopTableAudio();
        intentionalClose = true;
        socket?.close();
        socket = null;
        delete section.dataset.socketReady;
        session = null;
        activeRequestId = '';
        closeChallengeHandover({ returnFocus: false });
        incomingChallenge = null;
        outgoingChallenge = null;
        window.clearTimeout(challengeExpiryTimer);
        challengeExpiryTimer = null;
        directoryPlayers = [];
        loadLocalLearnProgressForSession(null);
        renderLivePlayers();
        setGameChatVisible(false);
        localStorage.removeItem(accountStorageKey);
        intentionalClose = false;
      };

      document.addEventListener('osb:account-session', handleAccountSession);
      document.addEventListener('osb:account-session-cleared', handleAccountSessionCleared);

      const setLessonLevelMenu = (open) => {
        if (!lessonLevels || !lessonLevelTrigger) return;
        const shouldOpen = Boolean(open);
        if (shouldOpen) setLessonOutline(false);
        lessonLevels.hidden = !shouldOpen;
        lessonLevelTrigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      };

      const closeLessonLevelsOnPointerDown = (event) => {
        if (event.target.closest('[data-osb-lesson-nav]')) return;
        setLessonLevelMenu(false);
        setLessonOutline(false);
      };

      const closeLessonLevelsOnEscape = (event) => {
        if (event.key !== 'Escape') return;
        const levelsWereOpen = !lessonLevels?.hidden;
        const outlineWasOpen = Boolean(lessonOutline?.classList.contains('is-open'));
        if (!levelsWereOpen && !outlineWasOpen) return;
        setLessonLevelMenu(false);
        setLessonOutline(false);
        (levelsWereOpen ? lessonLevelTrigger : lessonPathTrigger)?.focus();
      };

      lessonLevelTrigger?.addEventListener('click', () => {
        setLessonLevelMenu(Boolean(lessonLevels?.hidden));
      });

      lessonPathTrigger?.addEventListener('click', () => {
        setLessonLevelMenu(false);
        setLessonOutline(!lessonOutline?.classList.contains('is-open'));
      });

      learnResumeButton?.addEventListener('click', () => {
        const resumeIndex = libraryResumeLessonIndexForCourses(
          coursesForTrack(activeLearnLevel, activeLearnTrack),
          activeLearnLevel
        );
        if (Number.isInteger(resumeIndex)) startLesson(activeLearnLevel, resumeIndex);
      });

      learnLibraryTrigger?.addEventListener('click', () => {
        showLearnLibrary();
      });

      lessonLevelButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
          setLessonLevelMenu(false);
          const level = button.dataset.osbLessonLevel || 'beginner';
          if (puzzleState) startPuzzleSession(puzzleState.mode || 'practice', level);
          else startLesson(level);
        });
      });

      learnModeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const requestedMode = button.dataset.osbLearnMode;
          activeLearnMode = ['courses', 'puzzles', 'review'].includes(requestedMode)
            ? requestedMode
            : 'courses';
          if (puzzleLibraryStatus) puzzleLibraryStatus.textContent = '';
          renderLearnLibrary();
        });
      });

      learnLibraryLevelButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
          activeLearnLevel = normalizedLearnLevel(
            button.dataset.osbLearnLibraryLevel || 'beginner'
          );
          renderLearnLibrary();
        });
      });

      learnLibraryTrackButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeLearnTrack = normalizedLearnTrack(
            button.dataset.osbLearnLibraryTrack || 'core'
          );
          renderLearnLibrary();
        });
      });

      learnOpeningGroupButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.hidden) return;
          activeLearnOpeningGroup = normalizedLearnOpeningGroup(
            button.dataset.osbLearnOpeningGroup || 'all'
          );
          renderLearnLibrary();
        });
      });

      learnPlacementButton?.addEventListener('click', () => {
        startPlacement(activeLearnLevel);
      });

      puzzlePracticeButton?.addEventListener('click', () => {
        startPuzzleSession('practice', activeLearnLevel);
      });

      puzzleDailyButton?.addEventListener('click', () => {
        startPuzzleSession('daily', activeLearnLevel);
      });

      puzzleWeeklyButton?.addEventListener('click', () => {
        startPuzzleSession('weekly', activeLearnLevel);
      });

      puzzleReviewButton?.addEventListener('click', () => {
        startPuzzleSession('review', activeLearnLevel);
      });

      puzzleHistoryMore?.addEventListener('click', () => {
        puzzleHistoryExpanded = !puzzleHistoryExpanded;
        renderPuzzleHistory();
      });

      reviewDueButton?.addEventListener('click', () => {
        const [gameMoment] = dueGameMoments();
        if (gameMoment) {
          startGameMistakeReview(gameMoment.gameId, gameMoment.index);
          return;
        }
        const [lessonId] = dueReviewLessons(activeLearnLevel);
        if (!lessonId) return;
        startRecommendedLesson(lessonId);
      });

      reviewPuzzlesButton?.addEventListener('click', () => {
        startPuzzleSession('review', activeLearnLevel);
      });

      gameLearningButton?.addEventListener('click', () => {
        showLearnLibrary({ mode: 'review', level: recommendedLevelForGame(game) });
      });

      gameShareButton?.addEventListener('click', () => {
        void shareGameResult();
      });

      lessonHintButton?.addEventListener('click', () => {
        if (puzzleState) {
          if (puzzleState.stage === 'solved') {
            retryPuzzle();
            return;
          }
          showPuzzleHint();
          return;
        }
        if (!lessonState) return;
        if (
          lessonState.stage === 'feedback'
          && currentLesson()?.assessment?.kind === 'analysis'
          && lessonState.retryCurrentAttempt
        ) {
          playAnalysisComparison({ revealBest: true });
          return;
        }
        if (lessonState.stage === 'analysis-result') {
          showLearnLibrary({ mode: 'review', level: lessonState.level });
          return;
        }
        if (lessonState.stage === 'complete') {
          const course = openingPracticeCourseForLesson(currentLesson(), lessonState.level);
          if (course) startOpeningPractice(course, lessonState.level);
          return;
        }
        if (lessonState.stage === 'practice-result') {
          activeLearnTrack = 'openings';
          showLearnLibrary({ level: lessonState.level });
          return;
        }
        if (lessonState.stage === 'watch-complete') {
          if (currentLesson()?.assessment?.kind === 'analysis') {
            playAnalysisComparison({ revealBest: true });
          } else {
            playLessonExample({
              returnAttemptIndex: lessonState.watchReturnAttemptIndex || 0
            });
          }
          return;
        }
        showLessonHint();
      });

      lessonExplainButton?.addEventListener('click', () => {
        if (!puzzleState) return;
        showPuzzleExplanation();
      });

      lessonContinueButton?.addEventListener('click', () => {
        if (puzzleState) {
          if (puzzleState.stage === 'solved' && puzzleSessionIsComplete()) {
            showLearnLibrary({ mode: 'puzzles', level: puzzleState.level });
          } else if (['solved', 'error'].includes(puzzleState.stage)) {
            void nextPuzzle();
          } else if (puzzleState.stage === 'complete') {
            showLearnLibrary({ mode: 'puzzles', level: puzzleState.level });
          }
          return;
        }
        if (!lessonState) return;
        if (lessonState.stage === 'analysis-result') {
          const stored = reviewProgress?.games?.find((item) => (
            item.gameId === lessonState.analysisGameId
          ));
          const nextIndex = Number(lessonState.analysisMomentIndex) + 1;
          if (nextIndex < (stored?.analysis?.moments?.length || 0)) {
            startGameMistakeReview(lessonState.analysisGameId, nextIndex);
          } else {
            showLearnLibrary({ mode: 'review', level: lessonState.level });
          }
          return;
        }
        if (lessonState.stage === 'practice-result') {
          startOpeningPractice(lessonState.practiceCourseId, lessonState.level);
          return;
        }
        if (lessonState.stage === 'assessment-intro') {
          startLessonAttempt(0);
          return;
        }
        if (lessonState.stage === 'explain') {
          playLessonExample();
          return;
        }
        if (lessonState.stage === 'watch-complete') {
          startLessonAttempt(lessonState.watchReturnAttemptIndex || 0);
          return;
        }
        if (lessonState.stage === 'feedback') {
          if (lessonState.retryCurrentAttempt) {
            startLessonAttempt(lessonState.attemptIndex);
            return;
          }
          const nextAttempt = lessonState.attemptIndex + 1;
          if (nextAttempt < lessonAttemptCount()) {
            startLessonAttempt(nextAttempt);
          } else if (currentLesson()?.assessment) {
            finishAssessment();
          } else {
            completeLesson();
          }
          return;
        }
        if (lessonState.stage === 'assessment-result') {
          if (currentLesson()?.assessment?.kind === 'placement') {
            startPlacement(lessonState.level);
          } else {
            startLesson(lessonState.level, lessonState.lessonIndex);
          }
          return;
        }
        if (lessonState.stage === 'complete') {
          const nextLessonIndex = Number.isInteger(lessonState.nextLessonIndex)
            ? lessonState.nextLessonIndex
            : firstIncompleteLessonIndex(lessonState.level);
          const nextLessonLevel = lessonState.nextLessonLevel || lessonState.level;
          if (nextLessonIndex < 0) {
            showLearnLibrary({ level: lessonState.level });
          } else {
            startLesson(nextLessonLevel, nextLessonIndex);
          }
        }
      });

      document.addEventListener('pointerdown', closeLessonLevelsOnPointerDown);
      document.addEventListener('keydown', closeLessonLevelsOnEscape);

      chatForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        const body = String(chatInput?.value || '').trim();
        if (!body || !activeRequestId || gameChat?.hidden) return;
        try {
          send('conversation.message', { requestId: activeRequestId, body });
          chatInput.value = '';
          chatInput.blur();
        } catch (error) {
          setStatus(error.message || 'message not sent');
        }
      });

      opponent?.addEventListener('click', () => {
        if (opponent.disabled) return;
        setComputerLevelMenu(!computerLevelMenu?.classList.contains('is-open'));
        if (computerLevelMenu?.classList.contains('is-open')) {
          computerLevelOptions.find((option) => option.getAttribute('aria-selected') === 'true')?.focus();
        }
      });

      computerLevelOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const difficulty = option.dataset.osbComputerLevelOption;
          if (!['beginner', 'intermediate', 'advanced'].includes(difficulty)) return;
          selectedComputerDifficulty = difficulty;
          try { localStorage.setItem(computerLevelStorageKey, difficulty); } catch {}
          computerLevelOptions.forEach((levelOption) => {
            levelOption.setAttribute(
              'aria-selected',
              levelOption.dataset.osbComputerLevelOption === difficulty ? 'true' : 'false'
            );
          });
          if (opponent && game?.metadata?.mode !== 'placement') {
            setOpponentIdentity('computer', difficulty);
          }
          opponent?.setAttribute('aria-label', `computer level: ${difficulty}`);
          setComputerLevelMenu(false);
          try {
            send('computer.difficulty', { difficulty });
          } catch (error) {
            selectedComputerDifficulty = computerDifficulty(game);
            syncComputerLevelControl(game, isComputerGame(game), Boolean(game?.moves?.length || game?.lastMove));
            setStatus(error.message || 'level not changed');
          }
        });
      });

      const closeComputerLevelOnEscape = (event) => {
        if (event.key !== 'Escape' || !computerLevelMenu?.classList.contains('is-open')) return;
        setComputerLevelMenu(false);
        opponent?.focus();
      };
      document.addEventListener('keydown', closeComputerLevelOnEscape);

      const closeComputerLevelOnPointerDown = (event) => {
        if (!computerLevelMenu?.classList.contains('is-open')) return;
        if (computerLevelMenu.contains(event.target) || opponent?.contains(event.target)) return;
        setComputerLevelMenu(false);
      };
      document.addEventListener('pointerdown', closeComputerLevelOnPointerDown);

      liveMoreButton?.addEventListener('click', () => {
        livePlayersExpanded = !livePlayersExpanded;
        renderLivePlayers();
      });

      desktopLiveToggle?.addEventListener('click', () => {
        setDesktopLiveExpanded(!desktopLiveExpanded);
      });

      const handleDesktopGameLayoutChange = () => {
        if (!desktopGameLayout()) setDesktopLiveExpanded(false);
        syncMatchmakingIdentity();
        setGameChatVisible(visibleGameChat());
        renderLivePlayers();
      };
      desktopGameMedia.addEventListener?.('change', handleDesktopGameLayoutChange);

      matchCancelButton?.addEventListener('click', () => {
        if (!queued && !queueJoinPending) return;
        matchCancelRequested = true;
        matchCancelButton.classList.add('is-pending');
        matchCancelButton.disabled = true;
        matchCancelButton.setAttribute('aria-busy', 'true');
        resumeAutomaticQueue = false;
        try {
          send('queue.leave');
        } catch (error) {
          matchCancelRequested = false;
          matchCancelButton.classList.remove('is-pending');
          matchCancelButton.disabled = false;
          matchCancelButton.removeAttribute('aria-busy');
          feedbackCue('error');
          setStatus(error.message || 'could not cancel');
        }
      });

      matchContinueButton?.addEventListener('click', async () => {
        if (!queued) {
          if (matchContinueButton.dataset.matchRetry !== 'true') return;
          hideMatchOptions();
          automaticMatchmaking = true;
          entryMode = 'live';
          arena?.classList.add('is-matching');
          arena?.classList.remove('is-lobby');
          setStatus('finding a player', { active: true });
          await enterQueue(entryOptions('live'));
          if (!queued && !queueJoinPending && (!game || game.status !== 'active')) {
            showCancelledMatchState();
          }
          return;
        }
        matchContinueButton.classList.add('is-pending');
        matchContinueButton.setAttribute('aria-busy', 'true');
        window.setTimeout(() => {
          matchContinueButton.classList.remove('is-pending');
          matchContinueButton.removeAttribute('aria-busy');
          if (!queued) return;
          syncMatchmakingIdentity();
          scheduleMatchOptions();
        }, 180);
      });

      computerButton?.addEventListener('click', () => {
        computerButton.classList.add('is-pending');
        computerButton.setAttribute('aria-busy', 'true');
        setStatus('starting');
        try {
          if (queued) send('queue.leave');
          window.setTimeout(() => {
            try { send('computer.start', { difficulty: selectedComputerDifficulty }); }
            catch (error) {
              computerButton.classList.remove('is-pending');
              computerButton.removeAttribute('aria-busy');
              feedbackCue('error');
              setStatus(error.message);
            }
          }, 80);
        } catch (error) {
          computerButton.classList.remove('is-pending');
          computerButton.removeAttribute('aria-busy');
          feedbackCue('error');
          setStatus(error.message);
        }
      });

      voiceButton?.addEventListener('click', async () => {
        try {
          await ensureVoiceStream();
          voiceJoined = true;
          updateVoiceControls();
          await connect();
          send('audio.join');
          setStatus('voice connecting', { active: true });
        } catch (error) {
          stopTableAudio(false);
          setStatus(error.message || 'microphone permission is needed');
        }
      });
      voiceMuteButton?.addEventListener('click', () => {
        voiceMuted = !voiceMuted;
        localVoiceStream?.getAudioTracks().forEach((track) => { track.enabled = !voiceMuted; });
        updateVoiceControls();
      });
      voiceHearButton?.addEventListener('click', () => {
        playRemoteVoice();
      });
      voiceLeaveButton?.addEventListener('click', () => {
        stopTableAudio();
        setStatus('voice ended');
      });
      if (secretEntrance) {
        const desktopHoldDuration = 5000;
  const touchHoldDuration = 3000;
        let holdTimer = null;
        let opened = false;
        let activePointerId = null;

        const cancelSecretHold = (event) => {
          if (event?.type.startsWith('pointer') && activePointerId !== null && event.pointerId !== activePointerId) return;
          if (holdTimer) window.clearTimeout(holdTimer);
          holdTimer = null;
          if (activePointerId !== null && secretEntrance.hasPointerCapture?.(activePointerId)) {
            try { secretEntrance.releasePointerCapture(activePointerId); } catch (error) {}
          }
          activePointerId = null;
          secretEntrance.classList.remove('is-holding');
        };

        const startSecretHold = (event) => {
          if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
          if (event.type === 'pointerdown' && event.button !== 0) return;
          if (event.cancelable) event.preventDefault();
          if (holdTimer || opened) return;
          if (event.type === 'pointerdown') {
            activePointerId = event.pointerId;
            try { secretEntrance.setPointerCapture(event.pointerId); } catch (error) {}
          }
          const isTouchHold = event.pointerType === 'touch' || event.pointerType === 'pen'
            || window.matchMedia('(pointer: coarse)').matches;
          const holdDuration = isTouchHold ? touchHoldDuration : desktopHoldDuration;
          if (isTouchHold) feedbackHaptic(8);
          secretEntrance.classList.add('is-holding');
          holdTimer = window.setTimeout(() => {
            opened = true;
            holdTimer = null;
            feedbackHaptic([20, 35, 20]);
            window.location.assign(secretEntrance.href);
          }, holdDuration);
        };

        secretEntrance.addEventListener('click', (event) => event.preventDefault());
        secretEntrance.addEventListener('contextmenu', (event) => event.preventDefault());
        secretEntrance.addEventListener('dragstart', (event) => event.preventDefault());
        secretEntrance.addEventListener('pointerdown', startSecretHold);
        secretEntrance.addEventListener('pointerup', cancelSecretHold);
        secretEntrance.addEventListener('pointercancel', cancelSecretHold);
        secretEntrance.addEventListener('selectstart', (event) => event.preventDefault());
        secretEntrance.addEventListener('keydown', startSecretHold);
        secretEntrance.addEventListener('keyup', cancelSecretHold);
        secretEntrance.addEventListener('blur', cancelSecretHold);
      }

      function closePromotion() {
        promotionMove = null;
        promotionPanel?.classList.remove('is-white');
        if (promotionPanel) promotionPanel.hidden = true;
      }

      function openPromotion(from, to, moves) {
        promotionMove = { from, to };
        const ownWhite = color === 'w';
        promotionPanel?.classList.toggle('is-white', ownWhite);
        promotionButtons.forEach((button) => {
          const choice = button.dataset.osbPromote;
          const piece = ownWhite ? choice.toUpperCase() : choice;
          button.classList.toggle('osb-live__piece--white', ownWhite);
          button.classList.toggle('osb-live__piece--black', !ownWhite);
          setPieceGraphic(button, piece);
          button.hidden = !moves.some((move) => move.promotion === choice);
        });
        if (promotionPanel) promotionPanel.hidden = false;
        promotionButtons.find((button) => !button.hidden)?.focus();
      }

      function requestMove(from, to, promotion = '') {
        if (puzzleState) {
          handlePuzzleMove(from, to, promotion);
          return;
        }
        if (lessonState) {
          handleLessonMove(from, to);
          return;
        }
        if (!game || game.status !== 'active' || pendingMove || (promotionMove && !promotion)) return;
        if (game.turn !== color) {
          const piece = renderedPosition.get(from);
          const reachesLastRank = piece?.toLowerCase() === 'p' && (to.endsWith('1') || to.endsWith('8'));
          premove = { from, to, promotion: promotion || (reachesLastRank ? 'q' : '') };
          selectedSquare = null;
          refreshSquareStates();
          feedbackHaptic(5);
          return;
        }
        const legal = legalMovesFrom(from).filter((move) => move.to === to);
        if (!legal.length) {
          selectedSquare = null;
          refreshSquareStates();
          feedbackHaptic([10, 25, 10]);
          return;
        }
        const promotionMoves = legal.filter((move) => move.promotion);
        if (promotionMoves.length && !promotion) {
          openPromotion(from, to, promotionMoves);
          return;
        }
        const chosen = promotion || legal[0].promotion || '';
        const move = { from, to, promotion: chosen, capture: Boolean(legal.find((item) => item.promotion === chosen)?.capture ?? legal[0].capture) };
        closePromotion();
        selectedSquare = null;
        premove = null;
        pendingMove = move;
        syncBoard(projectedPosition(move), move, true);
        playMoveFeedback(move.capture);
        try {
          send('game.move', { from, to, promotion: chosen });
        } catch (error) {
          pendingMove = null;
          syncBoard(boardMap(game.fen));
          setStatus(error.message);
        }
      }

      function pieceColor(piece) {
        return piece ? (piece === piece.toUpperCase() ? 'w' : 'b') : null;
      }

      function handleSquare(square) {
        if (puzzleState) {
          if (puzzleState.stage !== 'try') return;
          if (!selectedSquare) {
            if (!puzzleCanSelectSquare(square)) {
              setLessonStatus('choose the side to move.', { danger: true });
              feedbackCue('error');
              return;
            }
            selectedSquare = square;
            puzzleState.feedback = null;
            puzzleState.highlightSquares = new Set();
            setLessonStatus('');
            setLessonCopy('choose the destination.');
            refreshSquareStates();
            return;
          }
          if (selectedSquare === square) {
            selectedSquare = null;
            puzzleState.feedback = null;
            setLessonStatus('');
            setLessonCopy('find the best move.');
            refreshSquareStates();
            return;
          }
          if (puzzleCanSelectSquare(square)) {
            selectedSquare = square;
            puzzleState.feedback = null;
            setLessonStatus('');
            setLessonCopy('choose the destination.');
            refreshSquareStates();
            return;
          }
          const from = selectedSquare;
          selectedSquare = null;
          requestMove(from, square);
          return;
        }
        if (lessonState) {
          if (lessonState.stage !== 'try') return;
          if (!selectedSquare) {
            if (!lessonCanSelectSquare(square)) {
              setLessonCopy(currentLessonAttempt()?.wrong || 'look at the idea, then try again.');
              setLessonFeedback('incorrect', square, '');
              feedbackCue('error');
              return;
            }
            selectedSquare = square;
            lessonState.feedback = null;
            window.clearTimeout(lessonFeedbackTimer);
            lessonFeedbackTimer = null;
            setLessonStatus('');
            setLessonCopy('choose the destination.');
            refreshSquareStates();
            return;
          }
          if (selectedSquare === square) {
            selectedSquare = null;
            lessonState.feedback = null;
            setLessonStatus('');
            setLessonCopy(currentLessonAttempt()?.prompt || 'your turn.');
            refreshSquareStates();
            return;
          }
          if (lessonCanSelectSquare(square)) {
            selectedSquare = square;
            lessonState.feedback = null;
            setLessonStatus('');
            setLessonCopy('choose the destination.');
            refreshSquareStates();
            return;
          }
          const from = selectedSquare;
          selectedSquare = null;
          requestMove(from, square);
          return;
        }
        if (!game || game.status !== 'active' || pendingMove || promotionMove) return;
        const piece = renderedPosition.get(square);
        const ownPiece = pieceColor(piece) === color;
        if (!selectedSquare) {
          if (!ownPiece) return;
          selectedSquare = square;
          premove = null;
          refreshSquareStates();
          return;
        }
        if (selectedSquare === square) {
          selectedSquare = null;
          refreshSquareStates();
          return;
        }
        if (ownPiece) {
          selectedSquare = square;
          premove = null;
          refreshSquareStates();
          return;
        }
        const from = selectedSquare;
        selectedSquare = null;
        requestMove(from, square);
      }

      function moveDragGhost(event) {
        if (!dragState?.ghost) return;
        dragState.ghost.style.setProperty('--osb-drag-x', `${event.clientX}px`);
        dragState.ghost.style.setProperty('--osb-drag-y', `${event.clientY}px`);
        if (!dragState.moved && Math.hypot(event.clientX - dragState.startX, event.clientY - dragState.startY) > 5) {
          dragState.moved = true;
          selectedSquare = dragState.from;
          premove = null;
          refreshSquareStates();
        }
      }

      function finishDrag(event, cancelled = false) {
        if (!dragState || event.pointerId !== dragState.pointerId) return;
        const current = dragState;
        dragState = null;
        current.original?.classList.remove('is-dragging');
        current.ghost?.remove();
        try { board?.releasePointerCapture(event.pointerId); } catch (error) {}
        if (!cancelled && !current.moved) {
          handledPointerClick = { square: current.from, until: Date.now() + 500 };
          handleSquare(current.from);
          return;
        }
        if (!cancelled && current.moved) {
          handledPointerClick = null;
          ignoreClickUntil = Date.now() + 350;
          const destination = document.elementFromPoint(event.clientX, event.clientY)?.closest('[data-square]');
          if (destination) requestMove(current.from, destination.dataset.square);
          else {
            selectedSquare = null;
            refreshSquareStates();
          }
        }
      }

      board?.addEventListener('pointerdown', (event) => {
        resumeGameplayAudio();
        const lessonCanMove = lessonState?.stage === 'try';
        const puzzleCanMove = puzzleState?.stage === 'try';
        const learningCanMove = lessonCanMove || puzzleCanMove;
        if (
          event.button !== 0
          || ((lessonState || puzzleState) && !learningCanMove)
          || (!learningCanMove && (!game || game.status !== 'active'))
          || pendingMove
          || promotionMove
        ) return;
        const squareElement = event.target.closest('[data-square]');
        const pieceElement = event.target.closest('[data-osb-piece]');
        const square = squareElement?.dataset.square;
        if (
          !square
          || !pieceElement
          || (
            puzzleCanMove
              ? !puzzleCanSelectSquare(square)
              : lessonCanMove
                ? !lessonCanSelectSquare(square)
                : pieceColor(renderedPosition.get(square)) !== color
          )
        ) return;
        event.preventDefault();
        const rect = squareElement.getBoundingClientRect();
        const ghost = pieceElement.cloneNode(true);
        ghost.classList.add('osb-live__drag-piece');
        ghost.style.setProperty('--osb-drag-size', `${rect.width}px`);
        section.appendChild(ghost);
        pieceElement.classList.add('is-dragging');
        dragState = {
          pointerId: event.pointerId,
          from: square,
          original: pieceElement,
          ghost,
          startX: event.clientX,
          startY: event.clientY,
          moved: false
        };
        moveDragGhost(event);
        try { board.setPointerCapture(event.pointerId); } catch (error) {}
      });
      board?.addEventListener('pointermove', (event) => moveDragGhost(event));
      board?.addEventListener('pointerup', (event) => finishDrag(event));
      board?.addEventListener('pointercancel', (event) => finishDrag(event, true));

      board?.addEventListener('click', (event) => {
        if (Date.now() < ignoreClickUntil) return;
        const squareElement = event.target.closest('[data-square]');
        const square = squareElement?.dataset.square;
        if (!square) return;
        if (
          handledPointerClick
          && handledPointerClick.square === square
          && Date.now() < handledPointerClick.until
        ) {
          handledPointerClick = null;
          return;
        }
        handledPointerClick = null;
        handleSquare(square);
      });

      promotionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!promotionMove) return;
          const { from, to } = promotionMove;
          requestMove(from, to, button.dataset.osbPromote);
        });
      });

      drawButton?.addEventListener('click', () => {
        if (!game) return;
        const accepting = game.drawOfferedBy && game.drawOfferedBy !== session?.player?.id;
        send(accepting ? 'game.draw.accept' : 'game.draw.offer');
        if (!accepting) setStatus(`${playerLabel(game.players?.[color])} offered a draw`);
      });
      function endCurrentGame(event) {
        if (!game) return;
        const compactEndControl = isComputerGame(game) || event?.currentTarget === liveEndButton;
        if (isComputerGame(game) && computerEndButton) computerEndButton.hidden = true;
        if (event?.currentTarget === liveEndButton && liveEndButton) liveEndButton.hidden = true;
        setStatus(compactEndControl ? 'ending' : 'resigning');
        send('game.resign');
      }
      resignButton?.addEventListener('click', endCurrentGame);
      computerEndButton?.addEventListener('click', endCurrentGame);
      liveEndButton?.addEventListener('click', endCurrentGame);
      chatPrototypeDraw?.addEventListener('click', () => {
        const offered = chatPrototypeDraw.getAttribute('aria-pressed') !== 'true';
        chatPrototypeDraw.setAttribute('aria-pressed', offered ? 'true' : 'false');
        chatPrototypeDraw.setAttribute(
          'aria-label',
          offered ? 'draw offered locally, visual preview only' : 'offer draw, visual preview only'
        );
        chatPrototypeDraw.textContent = offered ? 'draw offered' : 'draw';
      });
      chatPrototypeResign?.addEventListener('click', () => {
        const confirming = chatPrototypeResign.getAttribute('aria-pressed') !== 'true';
        chatPrototypeResign.setAttribute('aria-pressed', confirming ? 'true' : 'false');
        chatPrototypeResign.setAttribute(
          'aria-label',
          confirming ? 'cancel resignation confirmation, visual preview only' : 'resign, visual preview only'
        );
        chatPrototypeResign.textContent = confirming ? 'confirm resign' : 'resign';
      });
      chatPrototypeVoice?.addEventListener('click', () => {
        const joined = chatPrototypeVoice.getAttribute('aria-pressed') !== 'true';
        chatPrototypeVoice.setAttribute('aria-pressed', joined ? 'true' : 'false');
        chatPrototypeVoice.setAttribute(
          'aria-label',
          joined
            ? 'leave voice, joined locally, visual preview only'
            : 'join voice, off, visual preview only'
        );
        chatPrototypeVoice.textContent = joined ? 'leave voice' : 'join voice';
        chatPrototype?.classList.toggle('is-voice-joined', joined);
        chatPrototypeCommunication?.classList.toggle('is-voice-joined', joined);
      });
      chatPrototypeInput?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        const message = chatPrototypeInput.value.trim();
        if (!message || !chatPrototypeFeed) return;
        const followLatest = chatPrototypeIsAtLatest();
        const row = document.createElement('p');
        const speaker = document.createElement('span');
        const copy = document.createElement('span');
        speaker.textContent = 'you';
        copy.textContent = message;
        row.append(speaker, copy);
        chatPrototypeFeed.appendChild(row);
        chatPrototypeInput.value = '';
        if (followLatest) scrollChatPrototypeToLatest();
      });
      challengeHandoverKeep?.addEventListener('click', () => {
        if (handoverResponsePending) return;
        closeChallengeHandover();
      });
      challengeHandoverConfirm?.addEventListener('click', async () => {
        if (!handoverRequest?.id || handoverResponsePending) return;
        const request = handoverRequest;
        if (!game || game.status !== 'active') {
          closeChallengeHandover({ returnFocus: false });
          respondToChallenge(request, 'accept', challengeHandoverConfirm);
          return;
        }
        setHandoverPending(true);
        setStatus('ending + starting', { active: true });
        try {
          await updateChallengeRequest(request, 'accept', { endCurrentGame: true });
        } catch (error) {
          setHandoverPending(false);
          setStatus(error.message || 'try again');
        }
      });
      challengeHandover?.addEventListener('cancel', (event) => {
        event.preventDefault();
        if (!handoverResponsePending) closeChallengeHandover();
      });
      function requestRematch(button = rematchButton) {
        if (!game || game.status !== 'ended' || rematchRequested) return;
        const accepting = Boolean(incomingRematch);
        send('game.rematch');
        rematchRequested = true;
        incomingRematch = null;
        if (button) {
          button.disabled = true;
          button.textContent = accepting ? 'starting' : 'requested';
        }
        if (rematchButton && button !== rematchButton) {
          rematchButton.disabled = true;
          rematchButton.textContent = accepting ? 'starting' : 'requested';
        }
        setStatus(accepting ? 'starting another game' : 'rematch requested');
        renderLivePlayers();
      }

      rematchButton?.addEventListener('click', () => requestRematch(rematchButton));

      let squareCursorFrame = null;
      let squareCursorPoint = null;
      const hideSquareCursor = () => {
        squareCursorPoint = null;
        if (squareCursorFrame) window.cancelAnimationFrame(squareCursorFrame);
        squareCursorFrame = null;
        cursor?.classList.remove('is-visible');
      };
      const paintSquareCursor = () => {
        squareCursorFrame = null;
        if (!cursor || !squareCursorPoint) return;
        cursor.style.transform = `translate3d(${squareCursorPoint.x}px, ${squareCursorPoint.y}px, 0) translate(-50%, -50%)`;
        cursor.classList.add('is-visible');
      };
      if (cursor && boardShell && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        boardShell.addEventListener('pointermove', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') {
            hideSquareCursor();
            return;
          }
          squareCursorPoint = { x: event.clientX, y: event.clientY };
          if (!squareCursorFrame) squareCursorFrame = window.requestAnimationFrame(paintSquareCursor);
        }, { passive: true });
        boardShell.addEventListener('pointerleave', hideSquareCursor);
        boardShell.addEventListener('pointercancel', hideSquareCursor);
        window.addEventListener('blur', hideSquareCursor);
      }

      try {
        const storedAccount = JSON.parse(localStorage.getItem(accountStorageKey) || 'null');
        const storedGuest = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (accountSessionHasExpired(storedAccount)) {
          localStorage.removeItem(accountStorageKey);
          session = storedGuest;
        } else {
          session = storedAccount || storedGuest;
        }
      } catch { session = null; }
      loadLocalLearnProgressForSession(session);
      if (session?.player) {
        if (you) you.textContent = liveChatDemoMode
          ? 'chess club'
          : session.player.kind === 'guest' ? 'guest' : playerLabel(session.player, 'you');
        setGameChatVisible(false);
        renderLivePlayers();
        void loadLearnProgressFromAccount();
      } else {
        renderLivePlayers();
        setGameChatVisible(false);
      }
      directoryRefreshTimer = window.setInterval(() => {
        if (!document.hidden && !section.hidden) loadLivePlayers();
      }, 15000);
      syncBoard(boardMap(startingFen));

      const shopifySectionRoot =
        section.closest('[id^="shopify-section-"].shopify-section') || section;
      shopifySectionRoot.addEventListener('shopify:section:unload', () => {
        intentionalClose = true;
        stopTableAudio();
        window.clearTimeout(revealTimer);
        window.clearTimeout(computerOfferTimer);
        window.clearTimeout(computerLevelMenuTimer);
        window.clearTimeout(statusTransitionTimer);
        window.clearTimeout(challengeExpiryTimer);
        clearLessonTimers();
        for (const gameId of gameAnalysisPollTimers.keys()) clearGameAnalysisPoll(gameId);
        window.clearInterval(clockTimer);
        window.clearInterval(directoryRefreshTimer);
        window.clearTimeout(idleConnectionTimer);
        document.removeEventListener('osb:live-chess-open', revealLiveChess);
        document.removeEventListener('osb:live-chess-close', hideLiveChess);
        document.removeEventListener('osb:match-requests-refresh', loadLivePlayers);
        document.removeEventListener('visibilitychange', handleDocumentVisibility);
        document.removeEventListener('osb:account-session', handleAccountSession);
        document.removeEventListener('osb:account-session-cleared', handleAccountSessionCleared);
        document.removeEventListener('keydown', closeComputerLevelOnEscape);
        document.removeEventListener('pointerdown', closeComputerLevelOnPointerDown);
        document.removeEventListener('pointerdown', closeLessonLevelsOnPointerDown);
        document.removeEventListener('keydown', closeLessonLevelsOnEscape);
        hideSquareCursor();
        window.removeEventListener('blur', hideSquareCursor);
        desktopGameMedia.removeEventListener?.('change', handleDesktopGameLayoutChange);
        socket?.close();
      }, { once: true });
    });
  }

  window.OSBLiveChess = window.OSBLiveChess || {};
  window.OSBLiveChess.init = initOsbLiveChess;
  if (!window.OSBLiveChess.bootstrapped) {
    window.OSBLiveChess.bootstrapped = true;
    const boot = () => window.OSBLiveChess.init(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener(
      'shopify:section:load',
      (event) => window.OSBLiveChess.init(event.target)
    );
  }
